var _defs, _g, _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _rect5, _path30, _rect6, _path31, _rect7, _path32, _rect8, _path33, _rect9, _path34, _rect0, _path35, _rect1, _path36, _rect10, _path37, _rect11, _path38, _rect12, _path39, _rect13, _path40, _rect14, _path41, _rect15, _path42, _rect16, _path43, _rect17, _path44, _rect18, _path45, _rect19, _path46, _rect20, _path47, _rect21, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _rect22, _path134, _rect23, _path135, _rect24, _path136, _rect25, _path137, _g2, _g3, _rect26, _path138, _rect27, _path139, _rect28, _path140, _rect29, _path141, _rect30, _rect31, _path142, _rect32, _path143, _rect33, _path144, _rect34, _path145, _rect35, _path146, _rect36, _path147, _rect37, _path148, _rect38, _path149, _rect39, _path150, _g4, _path151, _path152, _path153, _path154, _rect40, _path155, _rect41, _path156, _rect42, _path157, _rect43, _path158, _g5, _rect44, _path159, _g6, _g7, _rect45, _path160, _rect46, _path161, _g8, _rect47, _path162, _rect48, _path163, _g9, _rect49, _path164, _g0, _rect50, _path165, _g1, _rect51, _path166, _rect52, _path167, _rect53, _path168, _rect54, _path169, _g10, _rect55, _rect56, _g11, _rect57, _path170, _rect58, _path171, _rect59, _path172, _rect60, _path173, _rect61, _path174, _rect62, _path175, _rect63, _path176, _rect64, _path177, _rect65, _path178, _rect66, _g12, _rect67, _path179, _rect68, _path180, _rect69, _path181, _rect70, _path182, _rect71, _path183, _rect72, _path184, _rect73, _path185, _rect74, _path186, _rect75, _path187, _rect76, _path188, _g13, _rect77, _path189, _rect78, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _rect79, _path265, _rect80, _path266, _rect81, _path267, _rect82, _path268, _rect83, _path269, _rect84, _path270, _rect85, _path271, _rect86, _path272, _rect87, _path273, _rect88, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _rect89, _path297, _rect90, _path298, _rect91, _path299, _rect92, _path300, _rect93, _path301, _rect94, _path302, _rect95, _path303, _rect96, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _rect97, _path323, _path324, _path325, _path326, _path327, _rect98, _path328, _rect99, _path329, _rect100, _path330, _rect101, _path331, _rect102, _path332, _rect103, _path333, _rect104, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _rect105, _path356, _rect106, _path357, _rect107, _path358, _rect108, _path359, _rect109, _path360, _path361, _path362, _rect110, _path363, _g14, _path364, _path365, _rect111, _path366, _g15, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _g16, _g17, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _g18, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _g19, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _g20, _path873, _path874, _path875, _path876, _rect112, _path877, _rect113, _path878, _rect114, _path879, _rect115, _path880, _g21, _g22, _rect116, _path881, _rect117, _path882, _rect118, _path883, _rect119, _path884, _rect120, _rect121, _path885, _rect122, _path886, _rect123, _path887, _rect124, _path888, _rect125, _path889, _rect126, _path890, _rect127, _path891, _rect128, _path892, _rect129, _path893, _g23, _path894, _path895, _path896, _path897, _rect130, _path898, _rect131, _path899, _rect132, _path900, _rect133, _path901, _g24, _rect134, _path902, _g25, _g26, _rect135, _path903, _rect136, _path904, _g27, _rect137, _path905, _rect138, _path906, _g28, _rect139, _path907, _g29, _rect140, _path908, _g30, _rect141, _path909, _rect142, _path910, _rect143, _path911, _rect144, _path912, _g31, _rect145, _rect146, _g32, _rect147, _path913, _rect148, _path914, _rect149, _path915, _rect150, _path916, _rect151, _path917, _rect152, _path918, _rect153, _path919, _rect154, _path920, _rect155, _path921, _rect156, _g33, _rect157, _path922, _rect158, _path923, _rect159, _path924, _rect160, _path925, _rect161, _path926, _rect162, _path927, _rect163, _path928, _rect164, _path929, _rect165, _path930, _rect166, _path931, _g34, _rect167, _path932, _rect168, _path933;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtectedBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1429.423,
    height: 356.073,
    viewBox: "0 0 1429.423 356.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24840",
    "data-name": "Rectangle 24840",
    width: 329.053,
    height: 328.333,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24391",
    "data-name": "Rectangle 24391",
    width: 990,
    height: 240.745,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24079",
    "data-name": "Rectangle 24079",
    width: 989.997,
    height: 240.745,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24076",
    "data-name": "Rectangle 24076",
    width: 36.373,
    height: 24.997,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24078",
    "data-name": "Rectangle 24078",
    width: 18.596,
    height: 28.102,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24095",
    "data-name": "Rectangle 24095",
    width: 43.77,
    height: 4.653,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24111",
    "data-name": "Rectangle 24111",
    width: 43.77,
    height: 1.914,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24175",
    "data-name": "Rectangle 24175",
    width: 57.248,
    height: 117.736,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24200",
    "data-name": "Rectangle 24200",
    width: 30.038,
    height: 41.027,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24202",
    "data-name": "Rectangle 24202",
    width: 10.216,
    height: 44.15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24215",
    "data-name": "Rectangle 24215",
    width: 36.786,
    height: 17.409,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24207",
    "data-name": "Rectangle 24207",
    width: 36.786,
    height: 3.969,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24214",
    "data-name": "Rectangle 24214",
    width: 36.786,
    height: 0.678,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24226",
    "data-name": "Rectangle 24226",
    width: 34.424,
    height: 11.832,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24220",
    "data-name": "Rectangle 24220",
    width: 34.424,
    height: 3.969,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24225",
    "data-name": "Rectangle 24225",
    width: 34.424,
    height: 0.678,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24230",
    "data-name": "Rectangle 24230",
    width: 4.751,
    height: 28.052,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24234",
    "data-name": "Rectangle 24234",
    width: 32.748,
    height: 23.184,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24241",
    "data-name": "Rectangle 24241",
    width: 11.552,
    height: 2.207,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24254",
    "data-name": "Rectangle 24254",
    width: 35.944,
    height: 9.222,
    fill: "#86e9b9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24272",
    "data-name": "Rectangle 24272",
    width: 42.368,
    height: 23.268,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24285",
    "data-name": "Rectangle 24285",
    width: 26.597,
    height: 0.06,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24321",
    "data-name": "Rectangle 24321",
    width: 20.481,
    height: 4.811,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24323",
    "data-name": "Rectangle 24323",
    width: 0.001,
    height: 4.806,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24325",
    "data-name": "Rectangle 24325",
    width: 20.48,
    height: 4.795,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24327",
    "data-name": "Rectangle 24327",
    width: 0.001,
    height: 4.795,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24329",
    "data-name": "Rectangle 24329",
    width: 20.48,
    height: 4.811,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24331",
    "data-name": "Rectangle 24331",
    width: 0.001,
    height: 4.811,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24333",
    "data-name": "Rectangle 24333",
    width: 20.48,
    height: 4.81,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24335",
    "data-name": "Rectangle 24335",
    width: 0.001,
    height: 4.81,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24357",
    "data-name": "Rectangle 24357",
    width: 20.48,
    height: 0.053,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24359",
    "data-name": "Rectangle 24359",
    width: 0.001,
    height: 0.053,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24379",
    "data-name": "Rectangle 24379",
    width: 39.952,
    height: 86.138,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24381",
    "data-name": "Rectangle 24381",
    width: 63.272,
    height: 240.437,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24383",
    "data-name": "Rectangle 24383",
    width: 20.947,
    height: 158.478,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24385",
    "data-name": "Rectangle 24385",
    width: 36.716,
    height: 194.291,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24387",
    "data-name": "Rectangle 24387",
    width: 36.716,
    height: 203.291,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-78"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24389",
    "data-name": "Rectangle 24389",
    width: 11.193,
    height: 31.337,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24623",
    "data-name": "Rectangle 24623",
    width: 439.423,
    height: 141.214,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24410",
    "data-name": "Rectangle 24410",
    width: 40.784,
    height: 28.029,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24412",
    "data-name": "Rectangle 24412",
    width: 20.852,
    height: 31.51,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-84"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24429",
    "data-name": "Rectangle 24429",
    width: 49.079,
    height: 5.217,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-92"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24445",
    "data-name": "Rectangle 24445",
    width: 49.079,
    height: 2.146,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-94"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24509",
    "data-name": "Rectangle 24509",
    width: 64.191,
    height: 132.016,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-96"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24534",
    "data-name": "Rectangle 24534",
    width: 33.681,
    height: 46.003,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-97"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24536",
    "data-name": "Rectangle 24536",
    width: 11.455,
    height: 49.504,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-99"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24549",
    "data-name": "Rectangle 24549",
    width: 41.247,
    height: 19.52,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-100"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24541",
    "data-name": "Rectangle 24541",
    width: 41.247,
    height: 4.45,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-103"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24548",
    "data-name": "Rectangle 24548",
    width: 41.247,
    height: 0.761,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-105"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24560",
    "data-name": "Rectangle 24560",
    width: 38.599,
    height: 13.267,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-106"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24554",
    "data-name": "Rectangle 24554",
    width: 38.599,
    height: 4.45,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-108"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24559",
    "data-name": "Rectangle 24559",
    width: 38.599,
    height: 0.76,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-110"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24564",
    "data-name": "Rectangle 24564",
    width: 5.327,
    height: 31.454,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-112"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24568",
    "data-name": "Rectangle 24568",
    width: 36.72,
    height: 25.996,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-114"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24575",
    "data-name": "Rectangle 24575",
    width: 12.953,
    height: 2.474,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-119"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24588",
    "data-name": "Rectangle 24588",
    width: 40.303,
    height: 10.341,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-121"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24606",
    "data-name": "Rectangle 24606",
    width: 47.506,
    height: 26.09,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-123"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24619",
    "data-name": "Rectangle 24619",
    width: 29.823,
    height: 0.067,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85466",
    "data-name": "Group 85466",
    transform: "translate(31 -410)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_85094",
    "data-name": "Group 85094",
    transform: "translate(822 410)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85093",
    "data-name": "Group 85093",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241004",
    "data-name": "Path 241004",
    d: "M228.322,314.738a.4.4,0,0,1-.347-.2l-2.312-4.158a.4.4,0,1,1,.693-.386l2.312,4.157a.4.4,0,0,1-.347.59m1.153-3.4a.428.428,0,0,1-.08-.008.4.4,0,0,1-.308-.469l.959-4.66a.4.4,0,0,1,.777.16l-.959,4.66a.4.4,0,0,1-.388.318m-5.778-4.92a.394.394,0,0,1-.347-.2l-2.312-4.158a.4.4,0,1,1,.693-.386l2.312,4.159a.4.4,0,0,1-.154.538.384.384,0,0,1-.193.049m7.7-4.4a.424.424,0,0,1-.079-.008.4.4,0,0,1-.309-.468l.959-4.659a.4.4,0,1,1,.777.16l-.959,4.659a.4.4,0,0,1-.388.317m-12.321-3.913a.4.4,0,0,1-.347-.2l-2.312-4.157a.4.4,0,0,1,.693-.387l2.312,4.158a.4.4,0,0,1-.154.54.407.407,0,0,1-.193.049m14.24-5.406a.413.413,0,0,1-.079-.008.4.4,0,0,1-.309-.467l.96-4.66a.4.4,0,1,1,.777.16l-.96,4.66a.4.4,0,0,1-.388.316m-18.864-2.911a.4.4,0,0,1-.348-.2l-2.311-4.159a.4.4,0,1,1,.692-.385l2.312,4.158a.4.4,0,0,1-.154.538.381.381,0,0,1-.192.049M99.994,288.031a.4.4,0,0,1-.239-.713l3.8-2.863a.4.4,0,0,1,.477.635l-3.8,2.86a.4.4,0,0,1-.238.08m.121-2.629a.388.388,0,0,1-.123-.021.4.4,0,0,1-.255-.5l1.473-4.525a.4.4,0,0,1,.754.245l-1.473,4.524a.4.4,0,0,1-.376.275m135.116-2.019a.536.536,0,0,1-.08-.008.4.4,0,0,1-.308-.468l.959-4.661a.4.4,0,0,1,.777.16l-.959,4.66a.4.4,0,0,1-.388.318m-127.636-1.076a.4.4,0,0,1-.239-.714l3.8-2.861a.4.4,0,1,1,.477.632l-3.8,2.863a.4.4,0,0,1-.238.079m102.229-.83a.4.4,0,0,1-.348-.2l-2.312-4.158a.4.4,0,1,1,.693-.386l2.312,4.159a.4.4,0,0,1-.154.539.4.4,0,0,1-.192.049M115.2,276.583a.392.392,0,0,1-.317-.158.4.4,0,0,1,.077-.556l3.8-2.861a.4.4,0,1,1,.477.632l-3.8,2.862a.4.4,0,0,1-.238.08m-12.136-.229a.4.4,0,0,1-.376-.521l1.473-4.524a.4.4,0,0,1,.754.245l-1.473,4.524a.4.4,0,0,1-.378.275m134.09-2.29a.428.428,0,0,1-.08-.009.4.4,0,0,1-.308-.468l.959-4.66a.4.4,0,1,1,.777.16l-.959,4.66a.4.4,0,0,1-.388.318m-31.951-.9a.4.4,0,0,1-.347-.2L202.54,268.8a.4.4,0,0,1,.693-.386l2.312,4.159a.4.4,0,0,1-.154.538.388.388,0,0,1-.193.051m-82.4-2.3a.4.4,0,0,1-.238-.713l3.8-2.862a.4.4,0,0,1,.477.634l-3.8,2.861a.4.4,0,0,1-.238.079m-16.79-3.552a.4.4,0,0,1-.376-.52l1.473-4.524a.4.4,0,1,1,.754.245l-1.473,4.525a.4.4,0,0,1-.378.273m24.391-2.172a.389.389,0,0,1-.317-.158.4.4,0,0,1,.077-.555l3.8-2.861a.4.4,0,1,1,.477.633l-3.8,2.861a.4.4,0,0,1-.238.079m70.177-.289a.4.4,0,0,1-.347-.2l-2.312-4.159a.4.4,0,1,1,.693-.385l2.312,4.157a.4.4,0,0,1-.347.589m38.494-.1a.355.355,0,0,1-.08-.008.4.4,0,0,1-.308-.467l.959-4.661a.4.4,0,0,1,.777.16l-.959,4.661a.4.4,0,0,1-.388.316M138,259.411a.392.392,0,0,1-.317-.158.4.4,0,0,1,.078-.556l3.8-2.861a.4.4,0,0,1,.478.634l-3.8,2.861a.4.4,0,0,1-.238.079m-29.046-1.153a.388.388,0,0,1-.123-.019.4.4,0,0,1-.255-.5l1.473-4.524a.4.4,0,1,1,.755.245l-1.473,4.524a.4.4,0,0,1-.378.273m87-1.728a.4.4,0,0,1-.347-.2l-2.312-4.159a.4.4,0,0,1,.693-.386l2.312,4.158a.4.4,0,0,1-.347.589m45.038-1.107a.424.424,0,0,1-.08-.007.4.4,0,0,1-.308-.469l.959-4.659a.4.4,0,1,1,.777.16l-.959,4.66a.4.4,0,0,1-.388.316M145.6,253.687a.4.4,0,0,1-.239-.713l3.8-2.861a.4.4,0,1,1,.477.633l-3.8,2.861a.4.4,0,0,1-.238.079m-33.7-4.476a.387.387,0,0,1-.123-.02.4.4,0,0,1-.255-.5l1.473-4.524a.4.4,0,1,1,.754.244l-1.473,4.524a.4.4,0,0,1-.376.273m79.427-1a.4.4,0,0,1-.347-.2l-2.312-4.157a.4.4,0,1,1,.693-.387l2.312,4.158a.4.4,0,0,1-.347.589m-38.126-.252a.392.392,0,0,1-.317-.158.4.4,0,0,1,.078-.556l3.8-2.861a.4.4,0,0,1,.478.633l-3.8,2.861a.384.384,0,0,1-.238.08M242.9,246.1a.361.361,0,0,1-.08-.008.4.4,0,0,1-.308-.467l.959-4.661a.4.4,0,0,1,.777.16l-.959,4.661a.4.4,0,0,1-.388.316M160.8,242.239a.4.4,0,0,1-.238-.713l3.8-2.861a.4.4,0,1,1,.478.633l-3.8,2.861a.394.394,0,0,1-.238.079m-45.956-2.075a.453.453,0,0,1-.123-.019.4.4,0,0,1-.255-.5l1.473-4.525a.4.4,0,0,1,.754.246l-1.473,4.524a.4.4,0,0,1-.376.274M186.7,239.9a.4.4,0,0,1-.347-.2l-2.312-4.158a.4.4,0,0,1,.693-.386l2.312,4.159a.4.4,0,0,1-.154.538.385.385,0,0,1-.193.051m58.124-3.116a.421.421,0,0,1-.079-.007.4.4,0,0,1-.308-.469l.958-4.659a.4.4,0,1,1,.777.16l-.959,4.659a.4.4,0,0,1-.388.317m-76.424-.269a.4.4,0,0,1-.239-.714l3.8-2.861a.4.4,0,0,1,.478.633l-3.8,2.861a.381.381,0,0,1-.237.08m13.676-4.93a.4.4,0,0,1-.348-.2L179.844,228l-3.607,2.717a.4.4,0,0,1-.477-.633l3.7-2.782-.04-.073a.4.4,0,1,1,.692-.385L182.421,231a.4.4,0,0,1-.154.54.4.4,0,0,1-.192.049m-64.288-.469a.4.4,0,0,1-.376-.52l1.473-4.524a.4.4,0,0,1,.754.247l-1.473,4.524a.4.4,0,0,1-.377.273m165.8-3.252h0c-1.383-.013-2.991-.042-4.781-.08a.4.4,0,1,1,.016-.793c1.787.039,3.392.066,4.772.08a.4.4,0,0,1,0,.793m4.759-.009a.4.4,0,0,1-.01-.793c.851-.022,1.382-.054,1.714-.085a13.538,13.538,0,0,1-.9-1.383.4.4,0,0,1,.682-.4,5.944,5.944,0,0,0,1.1,1.58.47.47,0,0,1,.272.421c0,.473-.335.6-2.849.662l-.009,0m-14.312-.191h-.011q-2.257-.06-4.772-.14a.4.4,0,0,1,.025-.793q2.511.079,4.769.141a.4.4,0,0,1-.01.792m-27.294-.2a.369.369,0,0,1-.08-.008.4.4,0,0,1-.308-.467l.96-4.661a.4.4,0,0,1,.777.16l-.96,4.661a.4.4,0,0,1-.388.316m17.755-.1h-.013q-2.3-.079-4.768-.168a.4.4,0,0,1,.029-.792q2.461.09,4.766.169a.4.4,0,0,1-.013.791m-9.531-.344h-.016q-2.325-.087-4.765-.183a.4.4,0,0,1,.031-.793l4.764.185a.4.4,0,0,1-.014.791m-9.527-.373h-.016q-2.339-.094-4.762-.195a.4.4,0,0,1-.381-.413.408.408,0,0,1,.413-.38l4.762.195a.4.4,0,0,1-.015.792m-9.524-.393H235.9l-4.762-.2a.4.4,0,0,1-.379-.414.4.4,0,0,1,.413-.378l4.761.2a.4.4,0,0,1-.017.792m-9.521-.409h-.018l-4.76-.209a.4.4,0,1,1,.035-.791l4.76.208a.4.4,0,0,1-.018.792m-9.519-.42h-.019l-4.759-.214a.4.4,0,1,1,.035-.792l4.759.214a.4.4,0,0,1-.017.793m-33.274-.358a.4.4,0,0,1-.238-.714l.6-.449-.414-.019a.4.4,0,0,1-.378-.416.4.4,0,0,1,.416-.378l1.367.065,2.212-1.666a.4.4,0,1,1,.478.632l-1.449,1.092,2.149.1a.4.4,0,0,1,.377.415.4.4,0,0,1-.415.379l-3.1-.147-1.359,1.023a.4.4,0,0,1-.238.08m23.756-.073h-.019l-4.758-.219a.4.4,0,0,1-.379-.414.4.4,0,0,1,.415-.377l4.758.218a.4.4,0,0,1-.018.792m-9.517-.438h-.02l-4.758-.222a.4.4,0,0,1,.037-.792l4.758.222a.4.4,0,0,1-.018.792m86.831-.8a.393.393,0,0,1-.266-.1l-3.523-3.2a.4.4,0,0,1,.532-.587l3.523,3.2a.4.4,0,0,1-.266.69m-105.863-.092h-.02l-4.758-.227a.4.4,0,0,1,.038-.792l2.877.138-2.153-3.87a.4.4,0,0,1,.693-.385l2.312,4.157a.409.409,0,0,1,.046.14l.982.048a.4.4,0,0,1-.019.791m103.863-.337a.4.4,0,0,1-.164-.037l-4.367-1.991a.4.4,0,1,1,.329-.722l4.367,1.992a.4.4,0,0,1-.165.758m-113.378-.12h-.02l-4.758-.23a.4.4,0,1,1,.038-.792l4.758.231a.4.4,0,0,1-.019.792m-9.516-.461h-.02l-4.767-.233a.4.4,0,0,1,.038-.793l4.768.233a.4.4,0,0,1-.02.793m-9.524-.466h-.02l-4.747-.235a.4.4,0,0,1-.376-.416.385.385,0,0,1,.416-.376l4.747.234a.4.4,0,0,1-.02.793m-29.518-.207a.4.4,0,0,1-.376-.52l.243-.75-3.66-.184a.4.4,0,1,1,.04-.792l3.875.2.974-2.993a.4.4,0,1,1,.755.245l-.909,2.788.063,0a.4.4,0,0,1-.04.792l-.276-.014-.31.955a.4.4,0,0,1-.377.273m20.015-.262h-.02l-4.758-.238a.4.4,0,0,1-.376-.416.389.389,0,0,1,.416-.375l4.758.236a.4.4,0,0,1-.02.793m146.452-.238a.4.4,0,0,1-.353-.215c-.632-1.225-1.357-2.666-2.155-4.284a.4.4,0,0,1,.712-.35c.8,1.61,1.517,3.047,2.147,4.27a.4.4,0,0,1-.352.578m-155.966-.235-.021,0-4.757-.237a.4.4,0,1,1,.039-.792l4.757.238a.4.4,0,0,1-.019.793m-19.031-.958h-.021l-4.758-.242a.4.4,0,0,1-.375-.416.4.4,0,0,1,.416-.375l4.758.242a.4.4,0,0,1-.02.791m-9.516-.484h-.021l-4.758-.243a.4.4,0,1,1,.04-.791l4.758.242a.4.4,0,0,1-.02.792m-9.517-.486h-.021l-4.76-.244a.4.4,0,1,1,.041-.791l4.759.244a.4.4,0,0,1-.02.791m180.778-.058a.4.4,0,0,1-.164-.035l-4.349-1.978a.4.4,0,0,1,.328-.722l4.349,1.978a.4.4,0,0,1-.164.757m-82.746,0a.4.4,0,0,1-.239-.713l3.8-2.862a.4.4,0,0,1,.478.634l-3.8,2.861a.4.4,0,0,1-.238.079m-107.55-.427H83.63l-4.759-.246a.4.4,0,1,1,.04-.791l4.76.246a.4.4,0,0,1-.02.791m-9.521-.491H74.11l-4.761-.249a.4.4,0,1,1,.041-.791l4.761.246a.4.4,0,0,1-.021.793m174.531-.28a.424.424,0,0,1-.08-.007.4.4,0,0,1-.308-.469l.959-4.659a.4.4,0,0,1,.777.16l-.959,4.659a.4.4,0,0,1-.388.317M64.609,217.93h-.021l-4.763-.249a.4.4,0,1,1,.041-.791l4.763.249a.4.4,0,0,1-.021.792m-9.528-.5-.021,0-4.766-.25a.4.4,0,0,1-.375-.416.386.386,0,0,1,.417-.375l4.766.249a.4.4,0,0,1-.021.794m222.542-.076a.39.39,0,0,1-.266-.1l-3.523-3.2a.4.4,0,1,1,.533-.587l3.523,3.2a.4.4,0,0,1-.267.69m-232.079-.426h-.021l-4.775-.251a.4.4,0,0,1-.375-.418.393.393,0,0,1,.417-.373l4.775.251a.4.4,0,0,1-.021.792m-9.563-.505H35.96l-3.271-.174a.4.4,0,0,1-.368-.469l.284-1.508a.4.4,0,0,1,.779.145l-.2,1.064,2.817.151a.4.4,0,0,1-.021.791m229.27-1.031a.4.4,0,0,1-.163-.035l-4.345-1.972a.4.4,0,1,1,.327-.722l4.345,1.971a.4.4,0,0,1-.164.758m-92.425-.439a.4.4,0,0,1-.347-.205l-2.312-4.157a.4.4,0,1,1,.693-.387l2.312,4.158a.4.4,0,0,1-.347.591m25.975-1.337a.392.392,0,0,1-.317-.158.4.4,0,0,1,.078-.555l3.8-2.861a.4.4,0,1,1,.478.633l-3.8,2.861a.394.394,0,0,1-.238.079m-75.122-.6a.392.392,0,0,1-.123-.021.4.4,0,0,1-.255-.5l1.473-4.524a.4.4,0,1,1,.754.247l-1.472,4.523a.4.4,0,0,1-.377.274M282.955,213a.4.4,0,0,1-.358-.225q-.981-2.034-2.062-4.309a.4.4,0,0,1,.717-.34q1.078,2.27,2.06,4.307a.4.4,0,0,1-.186.529.39.39,0,0,1-.171.038m-26.393-1.542a.421.421,0,0,1-.164-.034l-4.343-1.968a.4.4,0,0,1,.327-.722l4.344,1.967a.4.4,0,0,1-.164.757m14.015-.49a.392.392,0,0,1-.266-.1l-3.523-3.2a.4.4,0,0,1-.027-.561.393.393,0,0,1,.559-.026l3.523,3.2a.4.4,0,0,1-.266.689m-236.7-.894a.449.449,0,0,1-.073-.006.4.4,0,0,1-.317-.464l.88-4.675a.4.4,0,0,1,.779.147l-.88,4.676a.4.4,0,0,1-.389.322m216.705-1.242a.354.354,0,0,1-.08-.008.4.4,0,0,1-.308-.467l.959-4.661a.4.4,0,0,1,.777.16l-.959,4.661a.4.4,0,0,1-.388.316M206.4,207.9a.4.4,0,0,1-.239-.714l3.8-2.861a.4.4,0,1,1,.477.633l-3.8,2.862a.391.391,0,0,1-.238.079m41.472-.375a.4.4,0,0,1-.163-.035l-4.343-1.964a.4.4,0,1,1,.326-.722l4.344,1.965a.4.4,0,0,1-.164.756M168.2,206.64a.4.4,0,0,1-.347-.2l-2.312-4.157a.4.4,0,1,1,.693-.387l2.312,4.159a.4.4,0,0,1-.154.538.388.388,0,0,1-.193.051m95.329-2.069a.4.4,0,0,1-.266-.1l-3.523-3.2a.4.4,0,0,1,.533-.588l3.523,3.2a.4.4,0,0,1-.267.691m15.325-.2a.4.4,0,0,1-.359-.229q-.979-2.087-2.022-4.323a.4.4,0,1,1,.719-.334q1.04,2.234,2.021,4.32a.4.4,0,0,1-.191.527.39.39,0,0,1-.168.039m-152.231-.4a.387.387,0,0,1-.123-.02.4.4,0,0,1-.255-.5l1.473-4.524a.4.4,0,1,1,.754.245L127,203.7a.4.4,0,0,1-.376.273m112.562-.378a.364.364,0,0,1-.162-.037l-4.344-1.96a.4.4,0,1,1,.326-.722l4.344,1.961a.394.394,0,0,1,.2.523.4.4,0,0,1-.362.235M214,202.172a.4.4,0,0,1-.239-.713l3.8-2.861a.4.4,0,1,1,.478.633l-3.8,2.861a.4.4,0,0,1-.238.079M35.634,200.718a.353.353,0,0,1-.073-.007.4.4,0,0,1-.317-.462l.88-4.674a.4.4,0,1,1,.779.146l-.88,4.674a.4.4,0,0,1-.389.323M230.5,199.678a.4.4,0,0,1-.163-.035l-4.344-1.957a.4.4,0,0,1,.326-.724l4.344,1.958a.4.4,0,0,1-.163.758m22-.17a.353.353,0,0,1-.08-.007.4.4,0,0,1-.308-.469l.813-3.949-.227-.205a.611.611,0,1,1,1.15-.344l-.055.267,2.96,2.687a.4.4,0,1,1-.532.587L253.6,195.7l-.719,3.49a.4.4,0,0,1-.388.317m-88.922-1.183a.4.4,0,0,1-.347-.2l-2.312-4.158a.4.4,0,1,1,.693-.386l2.312,4.158a.4.4,0,0,1-.347.59m58.027-1.876a.4.4,0,0,1-.239-.714l.109-.083-4.172-1.875a.4.4,0,0,1,.325-.723l4.346,1.954a.4.4,0,0,1,.168.142l3.024-2.276a.4.4,0,1,1,.476.633l-3.8,2.861a.386.386,0,0,1-.238.08m53.222-.724a.4.4,0,0,1-.36-.23q-.979-2.113-2-4.33a.4.4,0,0,1,.72-.331q1.02,2.214,2,4.328a.4.4,0,0,1-.193.526.382.382,0,0,1-.166.037m-145.255-.8a.385.385,0,0,1-.123-.019.4.4,0,0,1-.255-.5l1.473-4.524a.4.4,0,0,1,.754.245l-1.473,4.524a.4.4,0,0,1-.376.273m83.547-3.065a.406.406,0,0,1-.161-.034l-4.347-1.949a.4.4,0,0,1,.325-.725l4.346,1.95a.4.4,0,0,1-.163.758m36.321-.078a.4.4,0,0,1-.266-.1l-3.523-3.2a.4.4,0,1,1,.533-.587l3.523,3.2a.4.4,0,0,1-.267.691m-212.044-.414a.294.294,0,0,1-.073-.008A.4.4,0,0,1,37,190.9l.88-4.675a.4.4,0,0,1,.779.146l-.88,4.675a.4.4,0,0,1-.389.324m191.81-.645a.4.4,0,0,1-.239-.713l3.8-2.862a.4.4,0,0,1,.477.634l-3.8,2.861a.4.4,0,0,1-.238.079m25.213-.535a.426.426,0,0,1-.08-.008.4.4,0,0,1-.308-.468l.959-4.66a.4.4,0,0,1,.777.16l-.959,4.661a.4.4,0,0,1-.388.316m-95.466-.179a.4.4,0,0,1-.347-.2l-2.312-4.159a.4.4,0,0,1,.693-.385l2.312,4.157a.4.4,0,0,1-.154.54.4.4,0,0,1-.193.05m45.473-2.046a.392.392,0,0,1-.162-.035l-4.347-1.945a.4.4,0,1,1,.323-.724l4.348,1.946a.4.4,0,0,1-.162.758m66.413-.9a.4.4,0,0,1-.361-.232q-.976-2.129-1.983-4.335a.4.4,0,0,1,.722-.329q1.006,2.2,1.982,4.334a.4.4,0,0,1-.195.527.393.393,0,0,1-.165.035M132.515,185.88a.4.4,0,0,1-.376-.52l1.473-4.524a.4.4,0,0,1,.754.244l-1.473,4.524a.4.4,0,0,1-.377.275m109.878-.493a.393.393,0,0,1-.266-.1l-2.525-2.291-2.559,1.927a.4.4,0,0,1-.478-.633L239,182.451l-.4-.363a.4.4,0,0,1,.533-.588l.512.466.718-.54a.4.4,0,1,1,.477.633l-.6.449,2.412,2.19a.4.4,0,0,1-.266.69m-46.665-1.314a.377.377,0,0,1-.161-.036l-4.348-1.942a.4.4,0,1,1,.323-.724l4.349,1.942a.4.4,0,0,1-.163.76M39.153,182.017a.439.439,0,0,1-.073-.006.4.4,0,0,1-.317-.463l.88-4.675a.4.4,0,1,1,.779.146l-.88,4.676a.4.4,0,0,1-.389.322m115.174-.322a.4.4,0,0,1-.348-.205l-2.312-4.158a.4.4,0,0,1,.693-.386l2.312,4.158a.4.4,0,0,1-.346.591m102.008-.826a.309.309,0,0,1-.08-.008.4.4,0,0,1-.308-.468l.959-4.659a.4.4,0,0,1,.777.16l-.959,4.659a.4.4,0,0,1-.388.317m-69.306-.679a.376.376,0,0,1-.161-.036l-4.351-1.938a.4.4,0,1,1,.323-.725l4.351,1.939a.4.4,0,0,1-.162.76m57.376-.914a.4.4,0,0,1-.239-.713l3.8-2.862a.4.4,0,0,1,.477.634l-3.8,2.861a.4.4,0,0,1-.238.079m-9.059-.283a.394.394,0,0,1-.266-.1l-3.523-3.2a.4.4,0,0,1,.533-.587l3.523,3.2a.4.4,0,0,1-.267.689m31.531-.6a.4.4,0,0,1-.362-.231l-1.971-4.339a.4.4,0,1,1,.722-.329q1,2.2,1.971,4.339a.4.4,0,0,1-.36.56M135.46,176.832a.4.4,0,0,1-.123-.019.4.4,0,0,1-.255-.5l1.473-4.525a.4.4,0,0,1,.755.245l-1.473,4.524a.4.4,0,0,1-.377.274m42.867-.519a.387.387,0,0,1-.161-.035l-4.353-1.934a.4.4,0,0,1,.323-.725l4.352,1.936a.4.4,0,0,1-.161.758m73.678-2.76a.39.39,0,0,1-.317-.159.4.4,0,0,1,.077-.555l3.8-2.861a.4.4,0,1,1,.477.633l-3.8,2.861a.4.4,0,0,1-.238.08m-102.3-.174a.4.4,0,0,1-.348-.2l-2.311-4.157a.4.4,0,1,1,.692-.387l2.312,4.159a.4.4,0,0,1-.154.538.382.382,0,0,1-.192.051m-108.789-.713a.6.6,0,0,1-.074-.005.4.4,0,0,1-.316-.464l.88-4.675a.4.4,0,1,1,.779.148l-.88,4.674a.4.4,0,0,1-.389.323M228.3,172.6a.4.4,0,0,1-.266-.1l-3.523-3.2a.4.4,0,0,1,.533-.587l3.522,3.2a.4.4,0,0,1-.266.689m-58.678-.154a.414.414,0,0,1-.16-.033l-4.355-1.932a.4.4,0,0,1,.322-.725l4.354,1.932a.4.4,0,0,1-.161.758m88.631-.9a.532.532,0,0,1-.079-.007.4.4,0,0,1-.308-.469l.958-4.659a.4.4,0,1,1,.777.159l-.089.433,1.454-1.094-.351-.778a.4.4,0,1,1,.722-.327l.279.616,1.551-1.17a.4.4,0,1,1,.478.633l-1.695,1.276,1.35,2.988a.4.4,0,0,1-.722.325l-1.277-2.823-1.457,1.1a.4.4,0,0,1-.484-.005l-.718,3.489a.4.4,0,0,1-.389.317m-97.341-2.963a.389.389,0,0,1-.16-.035l-4.356-1.926a.4.4,0,1,1,.321-.725l4.356,1.926a.4.4,0,0,1-.161.76m-22.506-.8a.4.4,0,0,1-.376-.519l1.473-4.523a.4.4,0,1,1,.754.244l-1.473,4.524a.4.4,0,0,1-.378.273m82.847-1.579a.4.4,0,0,1-.266-.1l-3.523-3.2a.4.4,0,0,1,.533-.588l3.523,3.2a.4.4,0,0,1-.267.69m-76.176-1.142a.4.4,0,0,1-.348-.2l-2.312-4.158a.4.4,0,0,1-.044-.257l-3.419-1.5a.4.4,0,1,1,.319-.725l4.37,1.92a.4.4,0,0,1-.211.756l1.992,3.581a.394.394,0,0,1-.154.538.382.382,0,0,1-.192.051m7.123-.327a.415.415,0,0,1-.16-.033l-4.358-1.923a.4.4,0,0,1,.32-.725l4.358,1.921a.4.4,0,0,1-.16.76m-109.528-1.42a.36.36,0,0,1-.074-.007.4.4,0,0,1-.316-.462l.879-4.676a.4.4,0,0,1,.78.146l-.88,4.675a.4.4,0,0,1-.389.324m217.5-1.085a.317.317,0,0,1-.08-.009.4.4,0,0,1-.307-.468l.959-4.659a.4.4,0,0,1,.777.16l-.959,4.659a.4.4,0,0,1-.389.318m7.034-.127a.392.392,0,0,1-.317-.158.4.4,0,0,1,.077-.555l3.8-2.861a.4.4,0,1,1,.477.633l-3.8,2.861a.4.4,0,0,1-.238.079m-8.187-1.082a.4.4,0,0,1-.362-.233q-.972-2.155-1.956-4.346a.4.4,0,1,1,.723-.325q.984,2.189,1.956,4.346a.4.4,0,0,1-.361.558m-44.811-1.211a.4.4,0,0,1-.266-.1l-3.523-3.2a.4.4,0,1,1,.533-.587l3.522,3.2a.4.4,0,0,1-.266.69m-72.856-1.075a.391.391,0,0,1-.123-.02.4.4,0,0,1-.255-.5l1.473-4.525a.4.4,0,1,1,.755.245l-1.473,4.524a.4.4,0,0,1-.378.273m-6.6-1.675a.4.4,0,0,1-.159-.034l-4.355-1.905a.4.4,0,1,1,.318-.727l4.356,1.906a.4.4,0,0,1-.16.76m5.7-.314a.4.4,0,0,1-.347-.2l-2.312-4.159a.4.4,0,1,1,.693-.385l2.312,4.157a.4.4,0,0,1-.154.54.41.41,0,0,1-.193.049m134.354-.367a.4.4,0,0,1-.238-.714l3.8-2.861a.4.4,0,1,1,.478.633l-3.8,2.862a.387.387,0,0,1-.238.079M44.432,153.966a.455.455,0,0,1-.074-.008.4.4,0,0,1-.316-.463l.879-4.674a.4.4,0,1,1,.78.146l-.88,4.674a.4.4,0,0,1-.389.325m162.73-.549a.4.4,0,0,1-.267-.1l-3.523-3.2a.4.4,0,0,1,.533-.587l3.523,3.2a.4.4,0,0,1-.266.689m-81.114-.163a.4.4,0,0,1-.159-.033l-4.364-1.9a.4.4,0,0,1,.317-.727l4.365,1.9a.4.4,0,0,1-.159.76m136.043-.343a.533.533,0,0,1-.08-.007.4.4,0,0,1-.308-.469l.959-4.659a.4.4,0,1,1,.777.16l-.959,4.659a.4.4,0,0,1-.388.317m-6.98-.581a.4.4,0,0,1-.362-.233l-1.948-4.348a.4.4,0,1,1,.723-.325l1.949,4.348a.4.4,0,0,1-.362.558m27.3-1.674a.4.4,0,0,1-.238-.713l3.8-2.862a.4.4,0,0,1,.478.634l-3.8,2.861a.394.394,0,0,1-.238.079M144.3,149.69a.388.388,0,0,1-.123-.021.4.4,0,0,1-.255-.5l1.473-4.524a.4.4,0,0,1,.754.247l-1.473,4.523a.4.4,0,0,1-.376.274m-26.981-.24a.391.391,0,0,1-.158-.033l-4.369-1.9a.4.4,0,0,1,.316-.727l4.369,1.9a.4.4,0,0,1-.158.76m18.511-1.016a.4.4,0,0,1-.347-.2l-2.312-4.159a.4.4,0,0,1,.693-.385l2.312,4.157a.4.4,0,0,1-.347.591m64.288-1.411a.4.4,0,0,1-.266-.1l-3.523-3.2a.4.4,0,0,1,.533-.588l3.522,3.2a.4.4,0,0,1-.266.69m-91.538-1.364a.391.391,0,0,1-.158-.033q-2.194-.95-4.372-1.889a.4.4,0,1,1,.315-.727l4.373,1.889a.4.4,0,0,1-.158.76m181.43-.726a.4.4,0,0,1-.238-.714l3.8-2.861a.4.4,0,1,1,.478.634l-3.8,2.86a.382.382,0,0,1-.238.08m-243.817-.318a.361.361,0,0,1-.073-.007.4.4,0,0,1-.317-.464l.881-4.674a.4.4,0,0,1,.779.146l-.88,4.674a.4.4,0,0,1-.39.325m205.026-.981a.4.4,0,0,1-.362-.235l-1.944-4.351a.4.4,0,0,1,.724-.322l1.944,4.349a.4.4,0,0,1-.2.523.376.376,0,0,1-.162.035m12.794-.042a.355.355,0,0,1-.08-.008.4.4,0,0,1-.308-.469l.959-4.659a.4.4,0,0,1,.777.16l-.959,4.659a.4.4,0,0,1-.388.318M99.83,141.885a.4.4,0,0,1-.156-.033q-2.2-.947-4.376-1.88a.4.4,0,1,1,.313-.729l4.377,1.882a.4.4,0,0,1-.158.76m47.413-1.243a.388.388,0,0,1-.123-.02.4.4,0,0,1-.255-.5l1.473-4.524a.4.4,0,0,1,.754.247l-1.473,4.524a.4.4,0,0,1-.376.273m45.827-.012a.4.4,0,0,1-.267-.1l-3.523-3.2a.4.4,0,0,1,.533-.587l3.523,3.2a.4.4,0,0,1,.027.56.4.4,0,0,1-.293.13m-61.867-.512a.4.4,0,0,1-.347-.2l-2.312-4.158a.4.4,0,0,1,.693-.387l2.312,4.158a.4.4,0,0,1-.347.591m166.405-.91a.4.4,0,0,1-.238-.713l3.8-2.861a.4.4,0,1,1,.478.633l-3.8,2.861a.394.394,0,0,1-.238.079m-206.532-1.08a.392.392,0,0,1-.156-.031q-2.2-.944-4.38-1.872a.4.4,0,1,1,.311-.729q2.175.927,4.38,1.872a.4.4,0,0,1-.156.76M47.95,135.264a.449.449,0,0,1-.073-.006.4.4,0,0,1-.317-.463l.88-4.676a.4.4,0,0,1,.779.146l-.879,4.676a.4.4,0,0,1-.39.323m199.382-.329a.4.4,0,0,1-.362-.235l-1.94-4.353a.4.4,0,0,1,.724-.323l1.94,4.353a.4.4,0,0,1-.2.523.39.39,0,0,1-.161.035m-165.02-.54a.376.376,0,0,1-.155-.033q-2.212-.938-4.387-1.857a.4.4,0,0,1,.309-.731l4.387,1.859a.4.4,0,0,1-.155.762m183.617-.122a.426.426,0,0,1-.08-.007.4.4,0,0,1-.308-.468l.959-4.66a.4.4,0,1,1,.777.16l-.959,4.66a.4.4,0,0,1-.388.316m-79.9-.036a.4.4,0,0,1-.266-.1l-3.523-3.2a.4.4,0,0,1,.533-.587l3.523,3.2a.4.4,0,0,1-.267.691m119.186-.751a.4.4,0,0,1-.239-.714l3.8-2.861a.4.4,0,0,1,.477.634l-3.8,2.86a.381.381,0,0,1-.237.08M126.578,131.8a.4.4,0,0,1-.347-.2l-2.312-4.157a.4.4,0,1,1,.693-.387l2.312,4.159a.4.4,0,0,1-.154.538.383.383,0,0,1-.193.051m23.61-.206a.43.43,0,0,1-.123-.02.4.4,0,0,1-.254-.5l1.473-4.524a.4.4,0,0,1,.754.244l-1.473,4.524a.4.4,0,0,1-.377.275m-76.653-.912a.368.368,0,0,1-.154-.033q-2.219-.933-4.393-1.843a.4.4,0,1,1,.306-.731q2.174.911,4.394,1.845a.4.4,0,0,1-.154.762m105.443-2.843a.4.4,0,0,1-.267-.1l-3.522-3.2a.4.4,0,1,1,.532-.587l3.523,3.2a.4.4,0,0,1-.266.691m133.831-.08a.4.4,0,0,1-.238-.712l3.8-2.862a.4.4,0,1,1,.478.633l-3.8,2.861a.387.387,0,0,1-.238.079M64.746,127a.394.394,0,0,1-.152-.031q-2.228-.927-4.4-1.827a.4.4,0,1,1,.3-.732q2.172.9,4.4,1.828a.4.4,0,0,1-.153.762m178.712-.766A.4.4,0,0,1,243.1,126l-1.938-4.359a.4.4,0,1,1,.725-.322l1.937,4.357a.4.4,0,0,1-.362.558M49.71,125.914a.3.3,0,0,1-.073-.008.4.4,0,0,1-.317-.463l.88-4.674a.4.4,0,0,1,.779.146L50.1,125.59a.4.4,0,0,1-.39.324m218.137-.96a.356.356,0,0,1-.08-.008.4.4,0,0,1-.308-.469l.959-4.659a.4.4,0,0,1,.777.16l-.959,4.659a.4.4,0,0,1-.388.318m-145.893-1.467a.4.4,0,0,1-.348-.2l-2.312-4.158a.4.4,0,1,1,.693-.385L122.3,122.9a.4.4,0,0,1-.154.539.391.391,0,0,1-.192.05m-66.015-.129a.411.411,0,0,1-.151-.029q-2.239-.921-4.409-1.8a.4.4,0,0,1,.3-.735q2.169.886,4.41,1.807a.4.4,0,0,1-.151.762m97.194-.81a.4.4,0,0,1-.376-.52l1.472-4.524a.4.4,0,0,1,.755.246l-1.473,4.522a.4.4,0,0,1-.378.275m167.277-.511a.4.4,0,0,1-.239-.714l3.4-2.557a.373.373,0,0,1,.02-.084.4.4,0,0,1,.506-.24l.136.051a.4.4,0,0,1,.105.689l-3.686,2.775a.394.394,0,0,1-.237.08m-148.479-.59a.4.4,0,0,1-.266-.1l-3.523-3.2a.4.4,0,1,1,.533-.587l3.523,3.2a.4.4,0,0,1-.267.691M47.113,119.762a.391.391,0,0,1-.147-.029q-2.259-.911-4.424-1.776a.4.4,0,1,1,.295-.736Q45,118.085,47.261,119a.4.4,0,0,1-.149.765m272.369-2.152a.407.407,0,0,1-.134-.023l-4.478-1.6a.4.4,0,1,1,.267-.747l4.478,1.6a.4.4,0,0,1-.133.769m-79.9-.1a.4.4,0,0,1-.363-.236l-1.932-4.355a.4.4,0,1,1,.725-.322l1.932,4.355a.4.4,0,0,1-.362.558m-188.111-.947a.441.441,0,0,1-.073-.007.4.4,0,0,1-.317-.462l.88-4.675a.4.4,0,1,1,.78.145l-.881,4.676a.4.4,0,0,1-.389.323m-13.212-.336a.381.381,0,0,1-.145-.029q-2.284-.9-4.44-1.734a.4.4,0,0,1,.287-.741q2.157.837,4.444,1.737a.4.4,0,0,1-.145.766m231.508-.593a.518.518,0,0,1-.079-.007.4.4,0,0,1-.309-.469l.96-4.659a.4.4,0,0,1,.777.16l-.96,4.66a.4.4,0,0,1-.388.316m-152.436-.461a.4.4,0,0,1-.348-.2l-2.311-4.159a.4.4,0,1,1,.692-.385l2.312,4.157a.4.4,0,0,1-.154.54.4.4,0,0,1-.192.051m47.556-.12a.394.394,0,0,1-.267-.1l-3.522-3.2a.4.4,0,0,1,.532-.587l3.523,3.2a.4.4,0,0,1-.266.689m145.638-.651a.363.363,0,0,1-.134-.025l-4.478-1.6a.4.4,0,0,1,.267-.747l4.478,1.6a.4.4,0,0,1-.133.769m-154.444-.9a.39.39,0,0,1-.123-.019.4.4,0,0,1-.255-.5l1.473-4.524a.392.392,0,0,1,.106-.167l-3.231-2.932a.4.4,0,0,1,.533-.587l3.523,3.2a.4.4,0,0,1,.027.56.389.389,0,0,1-.19.116.366.366,0,0,1-.014.058l-1.472,4.524a.4.4,0,0,1-.377.273m-126.72-.716a.4.4,0,0,1-.14-.027q-2.33-.883-4.467-1.668a.4.4,0,1,1,.273-.745q2.14.788,4.474,1.672a.4.4,0,0,1-.14.767m272.206-1.591a.4.4,0,0,1-.133-.023l-4.479-1.6a.4.4,0,1,1,.267-.745l4.479,1.6a.4.4,0,0,1-.134.769M20.4,109.494a.421.421,0,0,1-.132-.022c-1.631-.574-3.15-1.092-4.516-1.539a.4.4,0,0,1,.247-.754c1.372.448,2.9.967,4.533,1.545a.4.4,0,0,1-.132.769m215.321-.7a.4.4,0,0,1-.363-.234l-1.929-4.357a.4.4,0,0,1,.725-.322l1.929,4.357a.4.4,0,0,1-.2.522.373.373,0,0,1-.161.034m56.891-.814a.4.4,0,0,1-.134-.023l-4.479-1.6a.4.4,0,0,1,.267-.747l4.479,1.6a.4.4,0,0,1-.133.769m-239.38-.774a.585.585,0,0,1-.073-.005.4.4,0,0,1-.317-.464l.88-4.674a.4.4,0,1,1,.779.146l-.88,4.674a.4.4,0,0,1-.389.323m59.475-.354a.4.4,0,0,1-.347-.2l-2.313-4.158a.4.4,0,0,1,.693-.386l2.312,4.157a.4.4,0,0,1-.346.591m-101.409-.3a.384.384,0,0,1-.106-.015,28.376,28.376,0,0,0-4.261-.921c-.135-.013-.261-.029-.375-.046a.4.4,0,0,1,.119-.785c.1.015.216.029.337.042a28.9,28.9,0,0,1,4.393.947.4.4,0,0,1-.106.779m260.388-.238a.362.362,0,0,1-.08-.008.4.4,0,0,1-.308-.469l.959-4.659a.384.384,0,0,1,.4-.316l-2.572-.921a.4.4,0,1,1,.267-.747l4.478,1.6a.4.4,0,1,1-.267.747l-1.673-.6a.394.394,0,0,1,.144.392L272.071,106a.4.4,0,0,1-.388.318m11.968-1.538a.362.362,0,0,1-.134-.025l-4.478-1.6a.4.4,0,1,1,.267-.747l4.478,1.6a.4.4,0,0,1-.133.769m-124.626-.325a.387.387,0,0,1-.123-.02.394.394,0,0,1-.255-.5l1.473-4.524a.4.4,0,1,1,.754.244l-1.473,4.524a.4.4,0,0,1-.376.273M8.532,103.434a.4.4,0,0,1-.14-.766c1.165-.445,2.7-.96,4.567-1.532a.4.4,0,1,1,.233.757c-1.848.567-3.369,1.077-4.519,1.516a.4.4,0,0,1-.141.025m142.262-1.17a.394.394,0,0,1-.267-.1L147,98.966a.4.4,0,0,1,.533-.589l3.522,3.2a.4.4,0,0,1,.027.56.392.392,0,0,1-.293.129m-133.127-1.7a.4.4,0,0,1-.107-.778c1.407-.394,2.959-.819,4.615-1.26a.4.4,0,1,1,.2.766c-1.652.44-3.2.862-4.6,1.258a.431.431,0,0,1-.107.013m214.2-.481a.4.4,0,0,1-.364-.235l-1.926-4.359a.4.4,0,0,1,.725-.321l1.927,4.359a.4.4,0,0,1-.2.523.4.4,0,0,1-.16.033M108.08,98.542a.4.4,0,0,1-.347-.205l-2.312-4.157a.4.4,0,1,1,.693-.387l2.312,4.159a.4.4,0,0,1-.154.538.39.39,0,0,1-.193.052m157.656-.183a.4.4,0,0,1-.133-.023l-4.479-1.6a.4.4,0,0,1,.267-.747l4.479,1.6a.4.4,0,0,1-.134.769M26.9,98.1a.4.4,0,0,1-.1-.781q2.219-.572,4.628-1.174a.4.4,0,0,1,.193.769q-2.406.6-4.623,1.172a.409.409,0,0,1-.1.013m28.093-.238a.438.438,0,0,1-.073-.006.4.4,0,0,1-.317-.463l.88-4.676a.4.4,0,0,1,.779.146l-.88,4.676a.4.4,0,0,1-.389.323M273.6,97a.528.528,0,0,1-.079-.007.4.4,0,0,1-.308-.469l.959-4.659a.4.4,0,0,1,.777.16l-.959,4.659A.4.4,0,0,1,273.6,97M143.747,95.872a.4.4,0,0,1-.266-.1l-3.523-3.2a.4.4,0,1,1,.533-.587l3.523,3.2a.4.4,0,0,1-.267.691m-107.6-.093A.4.4,0,0,1,36.057,95q2.253-.551,4.636-1.125a.4.4,0,1,1,.186.769q-2.381.574-4.633,1.127a.488.488,0,0,1-.095.011m125.82-.373a.388.388,0,0,1-.123-.021.394.394,0,0,1-.255-.5l1.473-4.525a.4.4,0,0,1,.754.247l-1.473,4.523a.4.4,0,0,1-.376.274m94.808-.254a.4.4,0,0,1-.134-.023l-4.479-1.6a.4.4,0,0,1,.267-.747l4.479,1.6a.4.4,0,0,1-.133.769M45.423,93.542a.4.4,0,0,1-.092-.782q2.273-.54,4.641-1.1a.4.4,0,1,1,.182.771q-2.367.557-4.639,1.1a.464.464,0,0,1-.092.01m202.4-1.6a.41.41,0,0,1-.134-.025l-4.478-1.6a.4.4,0,1,1,.267-.747l4.478,1.6a.4.4,0,0,1-.133.771m-19.809-.573a.4.4,0,0,1-.363-.236l-1.924-4.359a.4.4,0,1,1,.726-.32l1.923,4.359a.4.4,0,0,1-.2.523.419.419,0,0,1-.16.033M54.7,91.362a.4.4,0,0,1-.09-.782Q56.9,90.049,59.26,89.5a.4.4,0,0,1,.177.774q-2.358.543-4.642,1.074a.443.443,0,0,1-.09.01m48.75-1.136a.4.4,0,0,1-.347-.2L100.8,85.865a.4.4,0,1,1,.693-.387l2.312,4.159a.4.4,0,0,1-.347.589m33.247-.749a.4.4,0,0,1-.266-.1l-3.523-3.2a.4.4,0,0,1,.533-.587l3.522,3.2a.4.4,0,0,1-.266.69m-72.709-.254a.4.4,0,0,1-.088-.785q2.294-.523,4.648-1.056a.4.4,0,1,1,.175.774l-4.647,1.056a.374.374,0,0,1-.089.011m174.87-.489a.407.407,0,0,1-.134-.023l-4.478-1.6a.4.4,0,0,1,.267-.747l4.478,1.6a.4.4,0,0,1-.133.769M56.748,88.51a.447.447,0,0,1-.073-.006.4.4,0,0,1-.317-.463l.88-4.674a.4.4,0,1,1,.779.146l-.88,4.675a.394.394,0,0,1-.389.322m218.773-.833a.305.305,0,0,1-.08-.009.4.4,0,0,1-.308-.468l.959-4.658a.4.4,0,0,1,.777.159l-.959,4.659a.4.4,0,0,1-.388.318M73.288,87.114a.4.4,0,0,1-.087-.783q2.3-.517,4.65-1.043a.4.4,0,0,1,.173.774q-2.349.524-4.649,1.043a.368.368,0,0,1-.088.009m91.628-.756a.4.4,0,0,1-.376-.52l1.473-4.524a.4.4,0,0,1,.754.247l-1.473,4.524a.4.4,0,0,1-.377.273m64.989-.831a.4.4,0,0,1-.133-.023l-4.479-1.6a.4.4,0,0,1,.267-.747l4.479,1.6a.4.4,0,0,1-.134.769M82.586,85.034a.4.4,0,0,1-.086-.785q2.307-.514,4.652-1.031a.4.4,0,1,1,.171.774l-4.651,1.033a.413.413,0,0,1-.087.009m47.069-1.95a.4.4,0,0,1-.266-.1l-3.523-3.2a.4.4,0,1,1,.533-.587l3.523,3.2a.4.4,0,0,1-.267.691m-37.765-.11a.4.4,0,0,1-.086-.785q2.311-.507,4.654-1.022a.4.4,0,1,1,.169.774q-2.339.515-4.652,1.024a.41.41,0,0,1-.086.009m132.277-.321a.4.4,0,0,1-.363-.237l-1.922-4.359a.4.4,0,0,1,.725-.321l1.922,4.361a.4.4,0,0,1-.362.556m-3.218-.333a.359.359,0,0,1-.134-.025l-4.479-1.6a.4.4,0,1,1,.267-.747l4.479,1.6a.4.4,0,0,1-.133.771M98.83,81.911a.4.4,0,0,1-.347-.2l-2.312-4.159a.4.4,0,0,1,.693-.385l2.312,4.157a.4.4,0,0,1-.154.54.41.41,0,0,1-.193.05m2.366-.981a.4.4,0,0,1-.085-.785l4.655-1.014a.4.4,0,0,1,.169.775l-4.655,1.015a.337.337,0,0,1-.085.009M58.508,79.16a.439.439,0,0,1-.073-.006.4.4,0,0,1-.317-.464L59,74.015a.4.4,0,1,1,.779.146l-.88,4.674a.4.4,0,0,1-.389.324m153.483-.051a.382.382,0,0,1-.134-.023l-4.478-1.6a.4.4,0,0,1,.267-.747l4.478,1.6a.4.4,0,0,1-.133.768M110.5,78.9a.4.4,0,0,1-.084-.785l4.656-1.008a.4.4,0,1,1,.167.775l-4.655,1.009a.4.4,0,0,1-.085.009m166.935-.546a.426.426,0,0,1-.08-.008.4.4,0,0,1-.308-.469l.959-4.659a.4.4,0,1,1,.777.16l-.959,4.66a.4.4,0,0,1-.388.317M167.861,77.312a.4.4,0,0,1-.376-.521l1.472-4.523a.4.4,0,0,1,.755.245l-1.473,4.524a.4.4,0,0,1-.378.274m-48.045-.423a.4.4,0,0,1-.083-.783l1.68-.362-2.594-2.356a.4.4,0,1,1,.533-.587l3.015,2.736,2.023-.434a.4.4,0,1,1,.166.775L123,76.213a.4.4,0,0,1-.655.373l-.206-.187-2.236.481a.4.4,0,0,1-.085.008m83.217-.987a.406.406,0,0,1-.134-.023l-4.478-1.6a.4.4,0,0,1,.267-.747l4.478,1.6a.4.4,0,0,1-.133.769m-73.9-1.014a.4.4,0,0,1-.081-.784l4.658-1a.4.4,0,0,1,.47.306.4.4,0,0,1-.305.469l-4.658,1a.386.386,0,0,1-.084.01m91.2-.956a.4.4,0,0,1-.363-.237l-1.919-4.362a.4.4,0,0,1,.725-.32l1.919,4.362a.4.4,0,0,1-.2.522.366.366,0,0,1-.159.035M94.2,73.6a.4.4,0,0,1-.347-.2l-2.312-4.159a.4.4,0,0,1,.693-.385l2.312,4.157a.4.4,0,0,1-.154.54.4.4,0,0,1-.193.051m44.241-.7a.4.4,0,0,1-.081-.785l4.659-.991a.4.4,0,1,1,.164.776l-4.658.991a.384.384,0,0,1-.084.009m55.628-.2a.4.4,0,0,1-.133-.024l-4.479-1.6a.4.4,0,0,1,.267-.747l4.479,1.6a.4.4,0,0,1-.134.769m-46.309-1.778a.4.4,0,0,1-.083-.784l4.672-.99a.4.4,0,1,1,.164.776l-4.671.99a.572.572,0,0,1-.083.008m-32.2-.622a.4.4,0,0,1-.267-.1L111.773,67a.4.4,0,1,1,.533-.587l3.523,3.2a.4.4,0,0,1-.266.689m-55.3-.485a.438.438,0,0,1-.073-.006.4.4,0,0,1-.317-.463l.88-4.676a.4.4,0,0,1,.779.146l-.88,4.676a.4.4,0,0,1-.389.323m124.851-.325a.4.4,0,0,1-.134-.022l-4.478-1.6a.4.4,0,1,1,.267-.746l4.478,1.6a.4.4,0,0,1-.133.768m94.24-.447a.362.362,0,0,1-.08-.008.4.4,0,0,1-.308-.469l.959-4.658a.4.4,0,0,1,.777.159l-.959,4.659a.4.4,0,0,1-.388.318m-122.26-.1a.4.4,0,0,1-.081-.783l4.653-.982a.4.4,0,1,1,.163.776l-4.652.982a.447.447,0,0,1-.083.007m13.709-.676a.387.387,0,0,1-.123-.02.4.4,0,0,1-.255-.5l.56-1.718-4.5.945a.4.4,0,0,1-.163-.777l4.662-.98a.392.392,0,0,1,.251.031l.21-.645a.4.4,0,0,1-.145-.458.411.411,0,0,1,.38-.262l.215-.659a.4.4,0,1,1,.754.245l-.215.66,3.851,1.38a.4.4,0,1,1-.267.746L172.2,64.881l-1.012,3.108a.394.394,0,0,1-.376.275M89.581,65.281a.4.4,0,0,1-.348-.2l-2.312-4.158a.4.4,0,0,1,.693-.386l2.312,4.158a.394.394,0,0,1-.154.538.383.383,0,0,1-.192.052m126.906-.073a.4.4,0,0,1-.363-.238l-1.917-4.362a.4.4,0,1,1,.727-.32l1.916,4.364a.4.4,0,0,1-.2.522.4.4,0,0,1-.16.034m-40.752-.187a.4.4,0,0,1-.08-.785l4.662-.975a.4.4,0,0,1,.163.777l-4.662.976a.445.445,0,0,1-.083.007M108.517,63.9a.393.393,0,0,1-.266-.1l-3.523-3.2a.4.4,0,0,1,.533-.587l3.522,3.2a.4.4,0,0,1,.027.56.392.392,0,0,1-.293.13m76.544-.828a.4.4,0,0,1-.08-.785l4.663-.973a.4.4,0,0,1,.162.777l-4.663.973a.445.445,0,0,1-.081.008m-17.859,0a.383.383,0,0,1-.134-.024l-4.478-1.6a.4.4,0,0,1,.267-.746l4.478,1.6a.4.4,0,0,1-.133.769m27.186-1.94a.4.4,0,0,1-.08-.783l4.664-.97a.4.4,0,0,1,.162.777l-4.665.969a.354.354,0,0,1-.08.007M62.027,60.459a.353.353,0,0,1-.073-.007.4.4,0,0,1-.317-.463l.88-4.675a.4.4,0,0,1,.779.146l-.88,4.675a.4.4,0,0,1-.389.324m96.218-.6a.4.4,0,0,1-.133-.023l-4.479-1.6a.4.4,0,0,1,.267-.747l4.479,1.6a.4.4,0,0,1-.134.769m123.032-.141a.531.531,0,0,1-.08-.008.4.4,0,0,1-.308-.468l.959-4.66a.4.4,0,1,1,.777.16l-.959,4.66a.4.4,0,0,1-.388.317m-107.524-.5a.387.387,0,0,1-.123-.02.4.4,0,0,1-.255-.5l1.473-4.523a.4.4,0,1,1,.754.245l-1.473,4.524a.4.4,0,0,1-.376.273m29.965-.023a.4.4,0,0,1-.079-.786l4.665-.965a.4.4,0,1,1,.16.777l-4.664.966a.446.446,0,0,1-.081.008M101.471,57.507a.392.392,0,0,1-.267-.1l-3.522-3.2a.4.4,0,1,1,.532-.587l3.523,3.2a.4.4,0,0,1-.266.691m111.577-.244a.4.4,0,0,1-.079-.785l4.666-.964a.4.4,0,0,1,.16.778l-4.666.963a.426.426,0,0,1-.08.008m-128.092-.3a.4.4,0,0,1-.348-.2L82.3,52.6a.4.4,0,1,1,.692-.386L85.3,56.376a.4.4,0,0,1-.154.538.383.383,0,0,1-.192.052m64.331-.314a.379.379,0,0,1-.134-.024l-4.478-1.6a.4.4,0,1,1,.267-.747l4.478,1.6a.4.4,0,0,1-.133.769m63.367-.172a.4.4,0,0,1-.364-.237l-1.915-4.366a.4.4,0,0,1,.727-.317l1.915,4.364a.4.4,0,0,1-.363.556m9.727-1.143a.4.4,0,0,1-.079-.785l4.668-.96a.4.4,0,1,1,.159.777l-4.667.96a.355.355,0,0,1-.08.008M140.33,53.444a.383.383,0,0,1-.134-.024l-4.478-1.6a.4.4,0,1,1,.267-.745l4.478,1.6a.4.4,0,0,1-.133.77m91.388-.026a.4.4,0,0,1-.079-.785l4.669-.958a.4.4,0,1,1,.159.776l-4.668.959a.435.435,0,0,1-.08.008m9.338-1.915a.4.4,0,0,1-.079-.786l4.671-.954a.4.4,0,1,1,.159.777l-4.671.955a.407.407,0,0,1-.079.008m-146.632-.39a.392.392,0,0,1-.266-.1l-3.523-3.2a.4.4,0,0,1,.533-.587l3.522,3.2a.4.4,0,0,1-.266.689m-30.638,0a.363.363,0,0,1-.074-.007.4.4,0,0,1-.316-.463l.88-4.675a.4.4,0,0,1,.779.147l-.88,4.673a.4.4,0,0,1-.389.325M283.2,50.4a.367.367,0,0,1-.08-.008.4.4,0,0,1-.308-.468l.96-4.659a.393.393,0,0,1,.468-.308.4.4,0,0,1,.308.468l-.96,4.658a.4.4,0,0,1-.388.318m-151.823-.163a.4.4,0,0,1-.133-.024l-4.479-1.6a.4.4,0,0,1,.267-.747l4.479,1.6a.4.4,0,0,1-.134.77m45.326-.067a.4.4,0,0,1-.376-.519l1.473-4.524a.4.4,0,1,1,.754.245l-1.473,4.523a.4.4,0,0,1-.377.274m73.7-.576a.4.4,0,0,1-.078-.785L255,47.853a.4.4,0,0,1,.159.779l-4.674.953a.406.406,0,0,1-.079.008M80.331,48.65a.4.4,0,0,1-.347-.2l-2.312-4.158a.4.4,0,1,1,.693-.386l2.311,4.158a.4.4,0,0,1-.154.539.391.391,0,0,1-.192.05m128.493-.9a.4.4,0,0,1-.363-.237l-1.914-4.367a.4.4,0,1,1,.727-.319l1.913,4.367a.4.4,0,0,1-.2.522.411.411,0,0,1-.159.034m50.924-.063a.4.4,0,0,1-.078-.785l4.677-.951a.4.4,0,1,1,.159.777l-4.679.951a.346.346,0,0,1-.079.008m-137.334-.66a.378.378,0,0,1-.133-.024L117.8,45.4a.4.4,0,1,1,.267-.747l4.478,1.6a.4.4,0,0,1-.134.769m146.693-1.241a.4.4,0,0,1-.078-.785l4.686-.95a.4.4,0,0,1,.157.778l-4.685.948a.426.426,0,0,1-.079.009M87.379,44.719a.4.4,0,0,1-.267-.1l-3.522-3.2a.4.4,0,1,1,.532-.587l3.523,3.2a.4.4,0,0,1-.266.69m191.109-.831a.4.4,0,0,1-.078-.786l4.72-.952a.4.4,0,0,1,.156.778l-4.718.952a.533.533,0,0,1-.079.008m-165.03-.069a.379.379,0,0,1-.134-.024l-4.478-1.6a.4.4,0,1,1,.267-.747l4.478,1.6a.4.4,0,0,1-.133.77M65.546,41.758a.3.3,0,0,1-.074-.008.394.394,0,0,1-.316-.462l.879-4.675a.4.4,0,0,1,.78.147l-.88,4.674a.4.4,0,0,1-.389.324m114.1-.636a.466.466,0,0,1-.123-.019.4.4,0,0,1-.254-.5l1.473-4.524a.4.4,0,0,1,.754.245l-1.473,4.523a.4.4,0,0,1-.378.274M104.5,40.611a.408.408,0,0,1-.134-.024l-4.478-1.6a.4.4,0,0,1,.267-.747l4.478,1.6a.4.4,0,0,1-.133.77m-28.793-.275a.4.4,0,0,1-.347-.2l-2.312-4.158a.4.4,0,1,1,.693-.386l2.312,4.157a.4.4,0,0,1-.347.591M205,39.015a.4.4,0,0,1-.364-.237l-1.912-4.37a.4.4,0,1,1,.726-.318l1.913,4.369a.4.4,0,0,1-.363.556m-124.665-.69a.393.393,0,0,1-.266-.1l-3.523-3.2a.4.4,0,0,1,.533-.589l3.522,3.2a.4.4,0,0,1-.266.69M95.542,37.4a.4.4,0,0,1-.133-.023l-4.479-1.6a.4.4,0,0,1,.267-.747l4.479,1.6a.4.4,0,0,1-.134.769m-8.958-3.208a.379.379,0,0,1-.133-.025l-4.478-1.6a.4.4,0,1,1,.267-.747l4.478,1.6a.4.4,0,0,1-.134.771M67.306,32.407a.362.362,0,0,1-.074-.007.4.4,0,0,1-.316-.462l.879-4.676a.4.4,0,0,1,.738-.116.44.44,0,0,1,.043-.027.4.4,0,0,1,.539.154l.414.745a.4.4,0,0,1,.5.027l3.523,3.2a.4.4,0,0,1-.533.587l-2.767-2.511,1.176,2.113a.4.4,0,0,1-.693.386L68.5,27.8l-.807,4.286a.4.4,0,0,1-.389.323m115.283-.332a.4.4,0,0,1-.376-.52l1.473-4.524a.4.4,0,1,1,.754.245L182.966,31.8a.4.4,0,0,1-.377.274M77.627,30.986a.4.4,0,0,1-.134-.024l-4.478-1.6a.4.4,0,1,1,.267-.747l4.478,1.6a.4.4,0,0,1-.133.769m123.546-.711a.4.4,0,0,1-.363-.238L198.9,25.664a.4.4,0,1,1,.726-.319l1.912,4.374a.4.4,0,0,1-.2.521.381.381,0,0,1-.159.035m-15.638-7.248a.4.4,0,0,1-.376-.52l1.472-4.525a.4.4,0,0,1,.755.247l-1.473,4.524a.4.4,0,0,1-.377.274m11.814-1.5a.4.4,0,0,1-.363-.238l-1.913-4.38a.4.4,0,0,1,.727-.317l1.912,4.38a.4.4,0,0,1-.2.521.377.377,0,0,1-.159.034M188.48,13.98a.391.391,0,0,1-.123-.02.4.4,0,0,1-.255-.5l1.473-4.524a.4.4,0,1,1,.754.245l-1.472,4.523a.4.4,0,0,1-.377.274m5.042-1.225a.4.4,0,0,1-.363-.237l-1.922-4.408a.4.4,0,0,1,.727-.316l1.921,4.407a.394.394,0,0,1-.363.554",
    transform: "translate(0.195 0.237)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241005",
    "data-name": "Path 241005",
    d: "M228.662,319.884a.409.409,0,0,1-.092-.011l-.077-.019a.4.4,0,0,1-.046-.757l2.5-3.713a.4.4,0,1,1,.658.442l-2.612,3.882a.4.4,0,0,1-.329.175m-4.7-1.127a.357.357,0,0,1-.093-.011l-4.627-1.109a.4.4,0,0,1,.185-.77l4.627,1.109a.4.4,0,0,1-.092.782m-9.253-2.218a.355.355,0,0,1-.093-.011l-4.627-1.109a.4.4,0,1,1,.186-.771l4.626,1.109a.4.4,0,0,1-.092.782m-9.253-2.217a.358.358,0,0,1-.093-.011l-4.627-1.109a.4.4,0,1,1,.186-.77l4.626,1.109a.4.4,0,0,1-.092.782M196.2,312.1a.358.358,0,0,1-.093-.011l-4.627-1.108a.4.4,0,0,1,.186-.771l4.626,1.109a.4.4,0,0,1-.092.782m37.726-.051a.4.4,0,0,1-.328-.618l2.655-3.947a.4.4,0,0,1,.658.442l-2.655,3.948a.4.4,0,0,1-.33.174m-46.979-2.167a.406.406,0,0,1-.093-.01l-4.627-1.109a.4.4,0,1,1,.186-.771l4.626,1.109a.4.4,0,0,1-.092.782m-9.253-2.218a.406.406,0,0,1-.093-.01l-4.627-1.109a.4.4,0,1,1,.186-.772l4.626,1.109a.4.4,0,0,1-.092.782m-9.253-2.218a.406.406,0,0,1-.093-.01l-4.627-1.109a.4.4,0,0,1,.186-.772l4.626,1.109a.4.4,0,0,1-.092.782m70.794-1.292a.4.4,0,0,1-.328-.618l2.655-3.948a.4.4,0,0,1,.658.442l-2.655,3.948a.4.4,0,0,1-.33.175m-80.047-.925a.406.406,0,0,1-.093-.01l-4.627-1.109a.4.4,0,1,1,.186-.771l4.626,1.109a.4.4,0,0,1-.092.782m-9.253-2.217a.409.409,0,0,1-.093-.011l-4.627-1.109a.4.4,0,0,1,.186-.771l4.626,1.109a.4.4,0,0,1-.092.783m-9.253-2.218a.409.409,0,0,1-.093-.011l-4.627-1.109a.4.4,0,0,1,.186-.771l4.626,1.109a.4.4,0,0,1-.092.783m-9.253-2.218a.407.407,0,0,1-.093-.011l-4.625-1.109a.4.4,0,1,1,.184-.77l4.626,1.108a.4.4,0,0,1-.092.783m113.116-.319a.4.4,0,0,1-.329-.618l2.655-3.948a.4.4,0,0,1,.658.442l-2.655,3.948a.4.4,0,0,1-.329.175m-122.369-1.9a.39.39,0,0,1-.092-.011l-4.627-1.109a.4.4,0,1,1,.186-.77l4.626,1.108a.4.4,0,0,1-.093.783m-9.253-2.218a.407.407,0,0,1-.093-.011l-4.627-1.109a.4.4,0,1,1,.187-.77l4.626,1.109a.4.4,0,0,1-.093.782m-9.253-2.217a.411.411,0,0,1-.093-.011l-4.626-1.109a.4.4,0,1,1,.185-.77l4.627,1.109a.4.4,0,0,1-.093.782m146.184-1.562a.386.386,0,0,1-.221-.068.4.4,0,0,1-.108-.55l2.655-3.948a.4.4,0,0,1,.658.442l-2.655,3.948a.4.4,0,0,1-.329.175M95.65,285.493a.392.392,0,0,1-.277-.115l-3.392-3.336a.4.4,0,0,1,.556-.565l3.393,3.336a.4.4,0,0,1-.28.68m159.518-5.021a.389.389,0,0,1-.221-.068.4.4,0,0,1-.108-.55l2.655-3.948a.4.4,0,0,1,.658.442L255.5,280.3a.4.4,0,0,1-.329.175m-166.3-1.651a.4.4,0,0,1-.28-.113L85.2,275.372a.4.4,0,1,1,.556-.565l3.392,3.336a.4.4,0,0,1-.277.679m171.61-6.244a.392.392,0,0,1-.221-.068.4.4,0,0,1-.108-.55l2.656-3.947a.4.4,0,1,1,.658.443l-2.656,3.947a.4.4,0,0,1-.329.175M82.082,272.15a.392.392,0,0,1-.277-.115L78.413,268.7a.4.4,0,0,1,.556-.565l3.391,3.336a.4.4,0,0,1-.277.68M75.3,265.478a.4.4,0,0,1-.28-.113l-3.391-3.337a.4.4,0,1,1,.556-.565l3.391,3.337a.4.4,0,0,1,.005.56.391.391,0,0,1-.282.119m190.487-.8a.392.392,0,0,1-.22-.067.4.4,0,0,1-.109-.551l2.655-3.947a.4.4,0,1,1,.658.442l-2.654,3.947a.4.4,0,0,1-.33.175M68.514,258.806a.39.39,0,0,1-.276-.115l-3.393-3.336a.4.4,0,1,1,.557-.565l3.391,3.336a.4.4,0,0,1-.278.68M271.1,256.786a.4.4,0,0,1-.329-.618l2.654-3.947a.4.4,0,1,1,.659.442l-2.655,3.947a.4.4,0,0,1-.329.175M61.73,252.134a.4.4,0,0,1-.277-.113l-3.391-3.337a.4.4,0,1,1,.556-.565l3.391,3.337a.4.4,0,0,1,0,.56.39.39,0,0,1-.283.119m214.676-3.244a.4.4,0,0,1-.328-.618l2.655-3.947a.4.4,0,1,1,.658.442l-2.655,3.947a.4.4,0,0,1-.33.175M54.947,245.463a.392.392,0,0,1-.277-.115l-3.392-3.336a.4.4,0,0,1,.556-.565l3.392,3.336a.4.4,0,0,1-.278.68m226.77-4.468a.4.4,0,0,1-.329-.618l2.655-3.947a.4.4,0,0,1,.658.443l-2.655,3.947a.4.4,0,0,1-.329.175m-233.553-2.2a.4.4,0,0,1-.278-.113l-3.391-3.337a.4.4,0,1,1,.556-.565l3.392,3.337a.4.4,0,0,1-.278.679M287.026,233.1a.4.4,0,0,1-.329-.617l2.655-3.948a.4.4,0,0,1,.658.442l-2.655,3.948a.4.4,0,0,1-.329.174M41.38,232.12a.4.4,0,0,1-.278-.114l-3.39-3.336a.4.4,0,1,1,.556-.565l3.39,3.336a.4.4,0,0,1,.006.561.4.4,0,0,1-.284.119M34.6,225.447a.4.4,0,0,1-.28-.113l-1.875-1.845a.4.4,0,0,1-.11-.2l-.452-2.077a.4.4,0,1,1,.774-.169l.429,1.962,1.792,1.763a.4.4,0,0,1,0,.56.391.391,0,0,1-.282.119m256.99-.6a.421.421,0,0,1-.118-.018.4.4,0,0,1-.262-.5l1.4-4.546a.4.4,0,0,1,.758.233l-1.4,4.546a.4.4,0,0,1-.379.281m-260.336-7.97a.4.4,0,0,1-.387-.312l-1.014-4.648a.4.4,0,1,1,.775-.169l1.014,4.649a.4.4,0,0,1-.3.471.379.379,0,0,1-.085.009m263.138-1.123a.389.389,0,0,1-.118-.019.4.4,0,0,1-.262-.5l1.4-4.546a.4.4,0,0,1,.758.234l-1.4,4.545a.4.4,0,0,1-.379.281M29.222,207.581a.4.4,0,0,1-.387-.312l-1.014-4.649a.4.4,0,1,1,.774-.169l1.016,4.649a.4.4,0,0,1-.3.471.378.378,0,0,1-.085.009m267.968-.92a.42.42,0,0,1-.117-.018.4.4,0,0,1-.262-.5l1.4-4.546a.4.4,0,0,1,.758.233l-1.4,4.546a.4.4,0,0,1-.38.281m-270-8.376a.4.4,0,0,1-.387-.311l-1.016-4.649a.4.4,0,0,1,.776-.169l1.014,4.649a.4.4,0,0,1-.3.471.409.409,0,0,1-.085.009m272.8-.717a.422.422,0,0,1-.118-.018.4.4,0,0,1-.262-.5l1.4-4.546a.4.4,0,0,1,.758.233l-1.4,4.548a.4.4,0,0,1-.379.279M25.165,188.99a.4.4,0,0,1-.387-.313l-1.015-4.648a.4.4,0,1,1,.776-.169l1.013,4.648a.4.4,0,0,1-.387.482m277.629-.515a.42.42,0,0,1-.117-.018.4.4,0,0,1-.262-.5l1.4-4.546a.4.4,0,0,1,.758.234l-1.4,4.545a.4.4,0,0,1-.38.281M23.136,179.694a.4.4,0,0,1-.387-.313l-1.014-4.648a.4.4,0,1,1,.774-.169l1.014,4.648a.4.4,0,0,1-.3.472.409.409,0,0,1-.085.009m282.46-.311a.421.421,0,0,1-.118-.018.4.4,0,0,1-.262-.5l1.4-4.546a.4.4,0,1,1,.758.234l-1.4,4.546a.4.4,0,0,1-.379.28M21.106,170.4a.4.4,0,0,1-.387-.312l-1.014-4.648a.4.4,0,0,1,.774-.169l1.016,4.648a.4.4,0,0,1-.3.472.38.38,0,0,1-.085.009m287.291-.108a.421.421,0,0,1-.117-.018.4.4,0,0,1-.262-.5l1.4-4.547a.4.4,0,0,1,.758.234l-1.4,4.546a.4.4,0,0,1-.38.28m2.8-9.093a.427.427,0,0,1-.118-.018.4.4,0,0,1-.262-.5l1.4-4.546a.4.4,0,0,1,.758.234l-1.4,4.546a.4.4,0,0,1-.379.279M19.077,161.1a.4.4,0,0,1-.387-.311l-1.014-4.649a.4.4,0,1,1,.774-.169l1.015,4.649a.4.4,0,0,1-.388.481M314,152.1a.42.42,0,0,1-.117-.018.4.4,0,0,1-.262-.5l1.4-4.546a.4.4,0,0,1,.758.234l-1.4,4.546a.4.4,0,0,1-.38.28m-296.951-.3a.4.4,0,0,1-.387-.311l-1.016-4.649a.4.4,0,0,1,.776-.169l1.014,4.649a.4.4,0,0,1-.3.471.408.408,0,0,1-.085.009M316.8,143.011a.408.408,0,0,1-.117-.018.4.4,0,0,1-.263-.5l1.4-4.546a.4.4,0,1,1,.758.234l-1.4,4.546a.4.4,0,0,1-.379.28m-301.784-.5a.4.4,0,0,1-.387-.313l-1.015-4.648a.4.4,0,1,1,.775-.169l1.014,4.648a.4.4,0,0,1-.3.472.409.409,0,0,1-.085.009M319.6,133.918a.408.408,0,0,1-.116-.018.4.4,0,0,1-.263-.5l1.4-4.546a.4.4,0,0,1,.758.234l-1.4,4.546a.4.4,0,0,1-.38.28m-306.615-.7a.4.4,0,0,1-.387-.313l-1.013-4.648a.4.4,0,1,1,.774-.169l1.014,4.648a.4.4,0,0,1-.388.482m309.417-8.39a.387.387,0,0,1-.118-.018.4.4,0,0,1-.262-.5l1.4-4.546a.4.4,0,0,1,.758.234l-1.4,4.546a.4.4,0,0,1-.378.28m-311.446-.907a.4.4,0,0,1-.387-.313L9.56,118.958a.4.4,0,1,1,.774-.169l1.014,4.648a.4.4,0,0,1-.3.472.379.379,0,0,1-.085.009m311.434-7.94a.4.4,0,0,1-.353-.216l-2.171-4.233a.4.4,0,1,1,.705-.362l2.171,4.233a.4.4,0,0,1-.172.534.391.391,0,0,1-.18.043M8.932,114.622a.4.4,0,0,1-.387-.311l-1.015-4.649a.4.4,0,0,1,.775-.169l1.015,4.649a.4.4,0,0,1-.3.471.411.411,0,0,1-.086.009m309.121-7.111a.4.4,0,0,1-.353-.216l-2.17-4.233a.4.4,0,1,1,.705-.362l2.17,4.233a.4.4,0,0,1-.172.534.391.391,0,0,1-.181.043M6.9,105.326a.4.4,0,0,1-.387-.311l-.605-2.778a.389.389,0,0,1,.083-.337l1.22-1.475a.4.4,0,0,1,.612.505l-1.1,1.326.565,2.589a.4.4,0,0,1-.3.471.4.4,0,0,1-.086.009m306.81-6.281a.4.4,0,0,1-.353-.216l-2.17-4.233a.4.4,0,1,1,.707-.362l2.169,4.233a.4.4,0,0,1-.172.534.391.391,0,0,1-.181.043M10.552,97.41a.4.4,0,0,1-.3-.65L13.282,93.1a.4.4,0,1,1,.61.505l-3.034,3.665a.394.394,0,0,1-.305.144m298.82-6.832a.4.4,0,0,1-.354-.216l-2.17-4.233a.4.4,0,1,1,.705-.362L309.724,90a.4.4,0,0,1-.171.533.391.391,0,0,1-.18.043m-292.751-.5a.392.392,0,0,1-.254-.092.4.4,0,0,1-.053-.558l3.033-3.665a.4.4,0,1,1,.612.506l-3.034,3.665a.4.4,0,0,1-.3.143m6.066-7.329a.391.391,0,0,1-.251-.091.4.4,0,0,1-.054-.559l3.034-3.664a.4.4,0,1,1,.61.505l-3.032,3.665a.4.4,0,0,1-.307.143m282.345-.641a.4.4,0,0,1-.353-.216l-2.171-4.233a.4.4,0,0,1,.706-.362l2.17,4.234a.4.4,0,0,1-.172.533.391.391,0,0,1-.18.043M28.755,75.422a.4.4,0,0,1-.306-.649l3.034-3.665a.4.4,0,1,1,.611.505L29.06,75.279a.4.4,0,0,1-.305.143M300.69,73.644a.4.4,0,0,1-.353-.216l-2.17-4.233a.4.4,0,1,1,.7-.362l2.171,4.234a.4.4,0,0,1-.353.577M34.822,68.093a.4.4,0,0,1-.305-.649l3.034-3.665a.4.4,0,0,1,.612.505l-3.034,3.665a.4.4,0,0,1-.306.143m261.527-2.915a.4.4,0,0,1-.354-.217l-2.17-4.233a.4.4,0,0,1,.706-.362L296.7,64.6a.4.4,0,0,1-.172.533.388.388,0,0,1-.179.044M40.89,60.764a.4.4,0,0,1-.3-.649L43.62,56.45a.4.4,0,0,1,.611.505L41.2,60.62a.4.4,0,0,1-.306.143m251.118-4.052a.4.4,0,0,1-.354-.217l-2.17-4.233a.4.4,0,0,1,.705-.362l2.17,4.234a.4.4,0,0,1-.172.533.388.388,0,0,1-.179.044M46.959,53.434a.4.4,0,0,1-.306-.649l3.033-3.665a.4.4,0,1,1,.612.505l-3.034,3.665a.393.393,0,0,1-.3.143m240.708-5.19a.4.4,0,0,1-.353-.216l-2.171-4.234a.4.4,0,0,1,.705-.362l2.171,4.234a.4.4,0,0,1-.172.533.389.389,0,0,1-.181.044M53.024,46.105a.385.385,0,0,1-.251-.091.4.4,0,0,1-.054-.558l3.034-3.665a.4.4,0,1,1,.61.505l-3.032,3.665a.4.4,0,0,1-.307.143m228.75-4.6a.4.4,0,0,1-.141-.027l-4.443-1.7a.4.4,0,1,1,.284-.741l4.442,1.7a.4.4,0,0,1-.141.767M59.093,38.777a.4.4,0,0,1-.306-.65l3.034-3.665a.4.4,0,1,1,.611.505L59.4,38.633a.4.4,0,0,1-.306.144m213.8-.672a.409.409,0,0,1-.142-.027l-4.441-1.7a.4.4,0,1,1,.283-.741l4.443,1.7a.4.4,0,0,1-.142.767M264,34.7a.4.4,0,0,1-.141-.026l-4.443-1.7a.4.4,0,0,1,.284-.741l4.443,1.7A.4.4,0,0,1,264,34.7M65.16,31.448a.4.4,0,0,1-.305-.65l3.034-3.665A.393.393,0,0,1,68.127,27l2.927-.5a.4.4,0,0,1,.135.782l-2.784.478L65.465,31.3a.393.393,0,0,1-.305.144M255.117,31.3a.4.4,0,0,1-.141-.026l-4.443-1.7a.4.4,0,0,1,.284-.741l4.442,1.7a.4.4,0,0,1-.141.766m-8.886-3.4a.4.4,0,0,1-.142-.026l-4.442-1.7a.4.4,0,1,1,.284-.741l4.442,1.7a.4.4,0,0,1-.141.766M75.81,26.474a.4.4,0,0,1-.066-.787l4.688-.806a.4.4,0,0,1,.134.782l-4.689.806a.5.5,0,0,1-.067.005m9.377-1.611a.4.4,0,0,1-.066-.787l4.69-.806a.4.4,0,0,1,.133.782l-4.688.806a.4.4,0,0,1-.069.005M237.345,24.5a.4.4,0,0,1-.142-.026l-4.442-1.7a.4.4,0,1,1,.283-.741l4.443,1.7a.4.4,0,0,1-.141.766M94.564,23.252a.4.4,0,0,1-.067-.787l4.689-.806a.4.4,0,1,1,.134.782l-4.689.806a.36.36,0,0,1-.067.005m9.378-1.61a.4.4,0,0,1-.066-.788l4.689-.806a.4.4,0,1,1,.133.782l-4.689.806a.353.353,0,0,1-.067.006M228.459,21.1a.4.4,0,0,1-.141-.026l-4.443-1.7a.4.4,0,0,1,.284-.741l4.443,1.7a.4.4,0,0,1-.142.766M113.321,20.031a.4.4,0,0,1-.068-.788l4.689-.806a.4.4,0,0,1,.135.782l-4.69.806a.374.374,0,0,1-.066.006M122.7,18.42a.4.4,0,0,1-.066-.787l4.688-.806a.4.4,0,1,1,.134.781l-4.689.806a.377.377,0,0,1-.067.006m96.876-.726a.4.4,0,0,1-.142-.026l-4.442-1.7a.4.4,0,1,1,.284-.741l4.442,1.7a.4.4,0,0,1-.141.766m-87.5-.885a.4.4,0,0,1-.066-.787l4.689-.806a.4.4,0,1,1,.134.781l-4.689.806a.38.38,0,0,1-.068.006m9.378-1.611a.4.4,0,0,1-.066-.787l4.689-.806a.4.4,0,1,1,.133.781l-4.689.806a.368.368,0,0,1-.067.006m69.236-.906a.4.4,0,0,1-.142-.026l-4.442-1.7a.4.4,0,1,1,.283-.741l4.443,1.7a.4.4,0,0,1-.141.766m-59.858-.705a.4.4,0,0,1-.067-.787l4.689-.806a.4.4,0,1,1,.134.782l-4.689.8a.378.378,0,0,1-.067.006m9.378-1.611a.4.4,0,0,1-.067-.787l4.689-.806a.4.4,0,0,1,.134.782l-4.689.806a.5.5,0,0,1-.067.005M201.8,10.891a.4.4,0,0,1-.141-.026l-4.443-1.7a.4.4,0,1,1,.284-.74l4.443,1.7a.4.4,0,0,1-.142.766m-32.216-.526a.4.4,0,0,1-.067-.787l4.689-.806a.4.4,0,1,1,.134.782l-4.689.806a.5.5,0,0,1-.067.005m9.377-1.611a.4.4,0,0,1-.066-.787l4.689-.806a.4.4,0,0,1,.134.782l-4.689.806a.379.379,0,0,1-.068.005m13.954-1.265a.378.378,0,0,1-.141-.027l-1.94-.742-2.428.417a.4.4,0,0,1-.133-.782l2.534-.435a.388.388,0,0,1,.208.021l2.041.782a.4.4,0,0,1-.141.766",
    transform: "translate(0.185 0.186)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241006",
    "data-name": "Path 241006",
    d: "M190.426,6.485a6.1,6.1,0,1,1-6.1-6.1,6.1,6.1,0,0,1,6.1,6.1",
    transform: "translate(5.599 0.012)",
    fill: "#ffeedc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241007",
    "data-name": "Path 241007",
    d: "M184.338,12.994a6.5,6.5,0,1,1,6.5-6.5,6.5,6.5,0,0,1-6.5,6.5m0-12.2a5.7,5.7,0,1,0,5.7,5.7,5.71,5.71,0,0,0-5.7-5.7",
    transform: "translate(5.587)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241008",
    "data-name": "Path 241008",
    d: "M72.961,27.108a6.1,6.1,0,1,1-6.1-6.1,6.1,6.1,0,0,1,6.1,6.1",
    transform: "translate(1.909 0.66)",
    fill: "#ffeedc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241009",
    "data-name": "Path 241009",
    d: "M66.873,33.617a6.5,6.5,0,1,1,6.5-6.5,6.5,6.5,0,0,1-6.5,6.5m0-12.2a5.7,5.7,0,1,0,5.7,5.7,5.711,5.711,0,0,0-5.7-5.7",
    transform: "translate(1.897 0.648)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241010",
    "data-name": "Path 241010",
    d: "M12.585,99.141a6.1,6.1,0,1,1-6.1-6.1,6.1,6.1,0,0,1,6.1,6.1",
    transform: "translate(0.012 2.923)",
    fill: "#ffeedc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241011",
    "data-name": "Path 241011",
    d: "M6.5,105.65a6.5,6.5,0,1,1,6.5-6.5,6.5,6.5,0,0,1-6.5,6.5m0-12.2a5.7,5.7,0,1,0,5.7,5.7,5.711,5.711,0,0,0-5.7-5.7",
    transform: "translate(0 2.911)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241012",
    "data-name": "Path 241012",
    d: "M103.149,279.373a6.1,6.1,0,1,1-6.1-6.1,6.1,6.1,0,0,1,6.1,6.1",
    transform: "translate(2.857 8.585)",
    fill: "#ffeedc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241013",
    "data-name": "Path 241013",
    d: "M97.061,285.882a6.5,6.5,0,1,1,6.5-6.5,6.5,6.5,0,0,1-6.5,6.5m0-12.2a5.7,5.7,0,1,0,5.7,5.7,5.71,5.71,0,0,0-5.7-5.7",
    transform: "translate(2.845 8.573)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241014",
    "data-name": "Path 241014",
    d: "M35.2,210.827a6.1,6.1,0,1,1-6.1-6.1,6.1,6.1,0,0,1,6.1,6.1",
    transform: "translate(0.723 6.431)",
    fill: "#ffeedc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241015",
    "data-name": "Path 241015",
    d: "M29.113,217.336a6.5,6.5,0,1,1,6.5-6.5,6.5,6.5,0,0,1-6.5,6.5m0-12.2a5.7,5.7,0,1,0,5.7,5.7,5.711,5.711,0,0,0-5.7-5.7",
    transform: "translate(0.71 6.419)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241016",
    "data-name": "Path 241016",
    d: "M228.385,308.963a6.1,6.1,0,1,1-6.1-6.1,6.1,6.1,0,0,1,6.1,6.1",
    transform: "translate(6.791 9.514)",
    fill: "#ffeedc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241017",
    "data-name": "Path 241017",
    d: "M222.3,315.472a6.5,6.5,0,1,1,6.5-6.5,6.5,6.5,0,0,1-6.5,6.5m0-12.2a5.7,5.7,0,1,0,5.7,5.7,5.711,5.711,0,0,0-5.7-5.7",
    transform: "translate(6.779 9.502)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241018",
    "data-name": "Path 241018",
    d: "M288.164,220.491a6.1,6.1,0,1,1-6.1-6.1,6.1,6.1,0,0,1,6.1,6.1",
    transform: "translate(8.669 6.735)",
    fill: "#ffeedc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241019",
    "data-name": "Path 241019",
    d: "M282.075,227a6.5,6.5,0,1,1,6.5-6.5,6.5,6.5,0,0,1-6.5,6.5m0-12.2a5.7,5.7,0,1,0,5.7,5.7,5.71,5.71,0,0,0-5.7-5.7",
    transform: "translate(8.657 6.723)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241020",
    "data-name": "Path 241020",
    d: "M281.762,41.5a6.1,6.1,0,1,1-6.1-6.1,6.1,6.1,0,0,1,6.1,6.1",
    transform: "translate(8.468 1.112)",
    fill: "#ffeedc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241021",
    "data-name": "Path 241021",
    d: "M275.673,48.007a6.5,6.5,0,1,1,6.5-6.5,6.5,6.5,0,0,1-6.5,6.5m0-12.2a5.7,5.7,0,1,0,5.7,5.7,5.71,5.71,0,0,0-5.7-5.7",
    transform: "translate(8.456 1.1)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241022",
    "data-name": "Path 241022",
    d: "M319.019,115.928a6.1,6.1,0,1,1-6.1-6.1,6.1,6.1,0,0,1,6.1,6.1",
    transform: "translate(9.638 3.45)",
    fill: "#ffeedc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241023",
    "data-name": "Path 241023",
    d: "M312.93,122.437a6.5,6.5,0,1,1,6.5-6.5,6.5,6.5,0,0,1-6.5,6.5m0-12.2a5.7,5.7,0,1,0,5.7,5.7,5.711,5.711,0,0,0-5.7-5.7",
    transform: "translate(9.626 3.438)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241024",
    "data-name": "Path 241024",
    d: "M103.942,279.587a95.722,95.722,0,0,0,9.45,8.639l49.047,35.867,49.046-35.867c25-19.938,39.363-52.332,35.465-81.627l-10.917-68.01-73.594-16.24-73.6,16.24L77.926,206.6c-3.376,25.374,6.947,53.071,26.015,72.988",
    transform: "translate(2.428 3.844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241025",
    "data-name": "Path 241025",
    d: "M162.45,324.5a.4.4,0,0,1-.234-.076L113.17,288.558a96.421,96.421,0,0,1-9.5-8.685c-19.429-20.292-29.439-48.385-26.122-73.315l10.918-68.021a.4.4,0,0,1,.306-.324l73.595-16.24a.4.4,0,0,1,.171,0l73.595,16.24a.4.4,0,0,1,.306.324l10.917,68.01c1.915,14.4-.479,29.8-6.924,44.544a98.477,98.477,0,0,1-28.686,37.457l-49.059,35.877a.4.4,0,0,1-.234.076M89.2,138.93,78.33,206.674c-3.284,24.686,6.643,52.529,25.91,72.651a95.543,95.543,0,0,0,9.411,8.6l48.8,35.687,48.813-35.7c24.932-19.885,39.126-52.542,35.306-81.256L235.7,138.93,162.45,122.767Z",
    transform: "translate(2.416 3.831)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241026",
    "data-name": "Path 241026",
    d: "M162.033,136.074l-62.083,13.7-9.208,57.37c-3.288,24.714,8.827,52.039,29.917,68.859l41.374,30.257Z",
    transform: "translate(2.834 4.275)",
    fill: "#ffe4c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241027",
    "data-name": "Path 241027",
    d: "M159.845,306.258,201.219,276c21.09-16.819,33.205-44.146,29.917-68.858l-9.208-57.371-62.083-13.7Z",
    transform: "translate(5.021 4.275)",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241028",
    "data-name": "Path 241028",
    d: "M165.044,261.548l-40.019-53.785L138,198.1l26.25,35.28,37.56-56.878,13.5,8.924Z",
    transform: "translate(3.928 5.545)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241029",
    "data-name": "Path 241029",
    d: "M155.829,260.03l-40.019-53.785,12.979-9.665,26.249,35.279,42.509-64.373,13.5,8.923Z",
    transform: "translate(3.638 5.261)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241030",
    "data-name": "Path 241030",
    d: "M155.842,260.439a.4.4,0,0,1-.319-.16l-40.018-53.784a.4.4,0,0,1,.079-.555l12.98-9.665a.4.4,0,0,1,.555.082l25.912,34.826,42.2-63.9a.4.4,0,0,1,.55-.112l13.5,8.923a.4.4,0,0,1,.113.55l-55.219,83.621a.4.4,0,0,1-.321.177h-.01m-39.464-54.1,39.443,53.014,54.69-82.818-12.839-8.485-42.29,64.042a.394.394,0,0,1-.32.177.373.373,0,0,1-.329-.159L128.72,197.147Z",
    transform: "translate(3.626 5.249)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241031",
    "data-name": "Path 241031",
    d: "M165.589,56.756a8.424,8.424,0,1,1-8.424-8.424,8.424,8.424,0,0,1,8.424,8.424",
    transform: "translate(4.673 1.518)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241032",
    "data-name": "Path 241032",
    d: "M178.38,59.067a8.425,8.425,0,1,1-8.425-8.424,8.424,8.424,0,0,1,8.425,8.424",
    transform: "translate(5.074 1.591)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241033",
    "data-name": "Path 241033",
    d: "M191.17,61.379a8.424,8.424,0,1,1-8.424-8.424,8.424,8.424,0,0,1,8.424,8.424",
    transform: "translate(5.476 1.664)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24835",
    "data-name": "Rectangle 24835",
    width: 6.636,
    height: 8.577,
    transform: "translate(155.353 60.662)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241034",
    "data-name": "Path 241034",
    d: "M157.257,61.33V58.813H150.62v5.554a6.251,6.251,0,0,0,3.164-.182,6.45,6.45,0,0,0,3.473-2.856",
    transform: "translate(4.732 1.848)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241035",
    "data-name": "Path 241035",
    d: "M158.466,57.093a5.364,5.364,0,1,1-5.338-5.9,5.64,5.64,0,0,1,5.338,5.9",
    transform: "translate(4.643 1.608)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241036",
    "data-name": "Path 241036",
    d: "M152.963,51.089a5,5,0,0,0-1.595.262,10.133,10.133,0,0,0,6.807,7.689,6.657,6.657,0,0,0,.273-1.886,5.8,5.8,0,0,0-5.486-6.065",
    transform: "translate(4.755 1.605)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241037",
    "data-name": "Path 241037",
    d: "M155.383,59.474a3.359,3.359,0,0,1-5.522-1.622Z",
    transform: "translate(4.708 1.817)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24836",
    "data-name": "Rectangle 24836",
    width: 23.302,
    height: 37.879,
    transform: "translate(43.428 165.028) rotate(-8.825)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241038",
    "data-name": "Path 241038",
    d: "M25.141,210.692l9.553-8.43,7.279-15.117L57,189.076a11.5,11.5,0,0,0,8.867-2.606l.424-.357a8.449,8.449,0,0,0,2.744-8.566l-.2-.793a1.565,1.565,0,0,1,2.648-1.47l21.2,22.224-7.4,7.107a53.262,53.262,0,0,1-13.283,9.329l-1.956.967a130.732,130.732,0,0,1-37.717,11.974l-9.407,1.474-3.887-3.237-.153-.307a8.5,8.5,0,0,1-.224-7.042l.013-.031a8.473,8.473,0,0,1,2.06-2.952Z",
    transform: "translate(0.565 5.491)",
    fill: "#ffeedc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241039",
    "data-name": "Path 241039",
    d: "M47.84,187.589l-6.377-.82-7.279,15.118,5.864-2.9a9.8,9.8,0,0,0,4.481-4.528Z",
    transform: "translate(1.074 5.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241040",
    "data-name": "Path 241040",
    d: "M34.2,202.3a.4.4,0,0,1-.358-.568l7.28-15.117a.4.4,0,0,1,.407-.222l6.377.82a.4.4,0,0,1,.3.2.4.4,0,0,1,.008.361l-3.311,6.87a10.24,10.24,0,0,1-4.663,4.71l-5.864,2.9a.391.391,0,0,1-.175.041m7.512-15.084-6.655,13.822,4.83-2.39a9.44,9.44,0,0,0,4.3-4.344l3.073-6.375Z",
    transform: "translate(1.062 5.855)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241041",
    "data-name": "Path 241041",
    d: "M60.029,201.818l1.768,3.574,10.1-13.134,3.449,6.408,5.783-13.54,2.147-.462,10.732,11.38-8.836,8.4a53.293,53.293,0,0,1-13.076,9.131L70.008,214.6a130.733,130.733,0,0,1-37.717,11.974l-9.406,1.474L19,224.814l4.61-1.289C40.492,218.6,49.3,208.236,49.3,208.236l1.337,2.9Z",
    transform: "translate(0.597 5.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241042",
    "data-name": "Path 241042",
    d: "M22.9,228.46a.393.393,0,0,1-.254-.092l-3.886-3.238a.4.4,0,0,1,.146-.686l4.61-1.29c16.574-4.835,25.412-15.06,25.5-15.163a.4.4,0,0,1,.663.091l1.1,2.383,8.988-8.916a.4.4,0,0,1,.636.106l1.484,3,9.712-12.631a.4.4,0,0,1,.663.055l3.06,5.683,5.459-12.783a.394.394,0,0,1,.281-.232l2.147-.462a.4.4,0,0,1,.371.116l10.732,11.38a.4.4,0,0,1-.015.56l-8.836,8.395a53.607,53.607,0,0,1-13.174,9.2L70.2,214.97a130.968,130.968,0,0,1-37.831,12.011l-9.408,1.474a.38.38,0,0,1-.061.005M19.843,225l3.167,2.639,9.23-1.447a130.2,130.2,0,0,0,37.6-11.938l2.086-1.031a52.784,52.784,0,0,0,12.978-9.064l8.55-8.123L83.152,185.11l-1.729.372-5.7,13.352a.4.4,0,0,1-.714.032L71.848,193l-9.725,12.648a.4.4,0,0,1-.671-.066l-1.522-3.08-9,8.926a.395.395,0,0,1-.638-.116L49.2,208.957A58.615,58.615,0,0,1,23.73,223.917Z",
    transform: "translate(0.585 5.789)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24837",
    "data-name": "Rectangle 24837",
    width: 23.302,
    height: 25.218,
    transform: "translate(85.132 229.823)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241043",
    "data-name": "Path 241043",
    d: "M52.96,245.653l12.3-3.321,13.227-10.323L91.1,240.4a11.493,11.493,0,0,0,9.1,1.6l.538-.132A8.448,8.448,0,0,0,107,235.4l.169-.8a1.564,1.564,0,0,1,3.024-.143l9.153,29.321-9.784,3.09a53.275,53.275,0,0,1-16.043,2.473H91.334a130.759,130.759,0,0,1-39.116-5.989l-9.085-2.85-2.049-4.624v-.344A8.5,8.5,0,0,1,44,249.123l.026-.022a8.5,8.5,0,0,1,3.154-1.733Z",
    transform: "translate(1.291 7.288)",
    fill: "#ffeedc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241044",
    "data-name": "Path 241044",
    d: "M83.1,235.571l-5.352-3.561L64.523,242.332h6.542a9.8,9.8,0,0,0,6.023-2.071Z",
    transform: "translate(2.027 7.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241045",
    "data-name": "Path 241045",
    d: "M71.077,242.741H64.536a.4.4,0,0,1-.244-.71L77.52,231.708a.4.4,0,0,1,.463-.018l5.353,3.563a.4.4,0,0,1,.024.643l-6.013,4.69a10.24,10.24,0,0,1-6.269,2.156m-5.389-.793h5.389a9.444,9.444,0,0,0,5.781-1.988l5.58-4.353-4.657-3.1Z",
    transform: "translate(2.015 7.276)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241046",
    "data-name": "Path 241046",
    d: "M88.058,252.975v3.986l14.875-7.3.251,7.274,11.187-9.573,2.13.537,4.573,14.959-11.642,3.608a53.291,53.291,0,0,1-15.769,2.387H91.335a130.726,130.726,0,0,1-39.116-5.989l-9.085-2.849-2.049-4.625,4.7.888c17.318,3.071,29.809-2.311,29.809-2.311l-.086,3.189Z",
    transform: "translate(1.291 7.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241047",
    "data-name": "Path 241047",
    d: "M93.673,269.268H91.346a130.975,130.975,0,0,1-39.235-6.008l-9.085-2.849a.4.4,0,0,1-.243-.219l-2.049-4.624a.4.4,0,0,1,.436-.551l4.7.888c17,3.015,29.455-2.232,29.579-2.286a.4.4,0,0,1,.554.374l-.071,2.623,12.01-4.006a.4.4,0,0,1,.522.376v3.35l14.3-7.015a.4.4,0,0,1,.57.342l.223,6.45,10.562-9.037a.393.393,0,0,1,.355-.084l2.129.538a.4.4,0,0,1,.283.268l4.573,14.958a.4.4,0,0,1-.262.494l-11.642,3.608a53.6,53.6,0,0,1-15.887,2.406m-50.239-9.56,8.913,2.8a130.173,130.173,0,0,0,39,5.972h2.328a52.806,52.806,0,0,0,15.652-2.37l11.265-3.49L116.2,248.248l-1.714-.433-11.031,9.44a.4.4,0,0,1-.654-.288l-.23-6.661L88.243,257.33a.4.4,0,0,1-.57-.356v-3.437l-12.024,4.011a.4.4,0,0,1-.522-.387l.07-2.591a58.63,58.63,0,0,1-29.466,2.115l-3.967-.749Z",
    transform: "translate(1.279 7.759)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241048",
    "data-name": "Path 241048",
    d: "M140.914,107.381H46.371a14.937,14.937,0,0,0-14.7,17.577l8.918,49.678h31.02L66.22,139.389h54.754a19.94,19.94,0,0,0,19.94-19.939Z",
    transform: "translate(0.987 3.373)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241049",
    "data-name": "Path 241049",
    d: "M161.781,121.483l4.465-17.608H130.392L85.736,138.328a24.3,24.3,0,0,0-9.454,19.234v74.118h35.6V163l23.879-23.645,3.228-.021a23.669,23.669,0,0,0,22.8-17.852",
    transform: "translate(2.396 3.263)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241050",
    "data-name": "Path 241050",
    d: "M111.889,232.436H76.3a.4.4,0,0,1-.4-.4V157.574a24.849,24.849,0,0,1,9.608-19.547l44.656-34.453a.4.4,0,0,1,.242-.083h35.854a.4.4,0,0,1,.384.494l-4.464,17.608A24.074,24.074,0,0,1,139,139.744l-3.065.019-23.648,23.415v68.861a.4.4,0,0,1-.4.4m-35.2-.793h34.8v-68.63a.4.4,0,0,1,.118-.283l23.879-23.644a.4.4,0,0,1,.276-.116l3.228-.02A23.276,23.276,0,0,0,161.408,121.4l4.34-17.115H130.539L85.99,138.655a24.047,24.047,0,0,0-9.3,18.919Z",
    transform: "translate(2.384 3.251)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241051",
    "data-name": "Path 241051",
    d: "M103.368,86.583,90.946,82.419a4.711,4.711,0,0,0-4.929,1.239l-2.883,3.066a7.412,7.412,0,0,0-1.626,2.719l-.784,2.338a1.907,1.907,0,0,0,1.2,2.414l.251.085a1.908,1.908,0,0,0,2.415-1.2l.512-1.526A7.222,7.222,0,0,1,86.692,88.9l1.5-1.59a2.457,2.457,0,0,1,2.569-.647l11.316,3.793Z",
    transform: "translate(2.533 2.581)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241052",
    "data-name": "Path 241052",
    d: "M99,88.234l-7.189-2.41a4.711,4.711,0,0,0-4.929,1.239L84,90.129a7.412,7.412,0,0,0-1.626,2.719l-.784,2.338a1.907,1.907,0,0,0,1.2,2.414l.251.085a1.908,1.908,0,0,0,2.415-1.2l.512-1.526A7.222,7.222,0,0,1,87.559,92.3l1.5-1.59a2.455,2.455,0,0,1,2.569-.647L97.707,92.1Z",
    transform: "translate(2.56 2.688)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241053",
    "data-name": "Path 241053",
    d: "M100.168,91.293l-7.189-2.41a4.711,4.711,0,0,0-4.929,1.239l-2.883,3.066a7.412,7.412,0,0,0-1.626,2.719l-.784,2.338a1.907,1.907,0,0,0,1.2,2.414l.251.085a1.909,1.909,0,0,0,2.415-1.2l.512-1.526a7.222,7.222,0,0,1,1.587-2.655l1.5-1.59a2.455,2.455,0,0,1,2.569-.647l6.083,2.039Z",
    transform: "translate(2.597 2.784)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241054",
    "data-name": "Path 241054",
    d: "M117.533,96.006V84.787L98.5,84.805l-4.924-1.517L90.45,92.6l6.858,2.3-.136.157a2.987,2.987,0,0,1-2.255,1.028H91.076a1.856,1.856,0,0,0-1.856,1.856v.127a1.856,1.856,0,0,0,1.847,1.856c1.684.007,4.973.012,5.364-.01a4.922,4.922,0,0,0,.626-.077Z",
    transform: "translate(2.803 2.616)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241055",
    "data-name": "Path 241055",
    d: "M96.819,99.447a4.988,4.988,0,0,0,1.767-.7l5.032-3.127h13.677Z",
    transform: "translate(3.041 3.004)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241056",
    "data-name": "Path 241056",
    d: "M84.829,101.25a2.28,2.28,0,0,1-.73-.12l-.252-.084A2.3,2.3,0,0,1,82.4,98.13l.782-2.337a7.779,7.779,0,0,1,1.714-2.864l2.882-3.066a5.123,5.123,0,0,1,5.344-1.344l1.158.388a.4.4,0,0,1-.254.752l-1.156-.388a4.328,4.328,0,0,0-4.515,1.136l-2.883,3.066a6.947,6.947,0,0,0-1.538,2.573l-.784,2.337a1.511,1.511,0,0,0,.953,1.912l.25.084a1.514,1.514,0,0,0,1.913-.952l.511-1.526a7.7,7.7,0,0,1,1.675-2.8l1.5-1.591a2.86,2.86,0,0,1,2.984-.75l4.5,1.509a.4.4,0,0,1-.251.752l-4.5-1.509a2.061,2.061,0,0,0-2.154.541l-1.5,1.59a6.894,6.894,0,0,0-1.5,2.509l-.513,1.526a2.305,2.305,0,0,1-2.185,1.572",
    transform: "translate(2.585 2.772)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241057",
    "data-name": "Path 241057",
    d: "M82.972,98.063a.378.378,0,0,1-.126-.021l-.166-.056a2.306,2.306,0,0,1-1.451-2.916l.783-2.337a7.852,7.852,0,0,1,1.713-2.864L86.607,86.8a5.123,5.123,0,0,1,5.344-1.344l2.125.713a.4.4,0,1,1-.253.751L91.7,86.211a4.324,4.324,0,0,0-4.513,1.135L84.3,90.412a7.047,7.047,0,0,0-1.539,2.573l-.783,2.337a1.511,1.511,0,0,0,.952,1.912l.165.056a.4.4,0,0,1-.126.773",
    transform: "translate(2.548 2.676)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241058",
    "data-name": "Path 241058",
    d: "M94.557,100.393c-.478,0-.99-.006-1.542-.012-.517-.006-1.071-.012-1.668-.015a2.257,2.257,0,0,1-2.241-2.252v-.128a2.255,2.255,0,0,1,2.252-2.252H95.2a2.589,2.589,0,0,0,1.956-.891l.136-.157a.4.4,0,0,1,.6.52l-.137.157A3.382,3.382,0,0,1,95.2,96.527H91.358A1.46,1.46,0,0,0,89.9,97.985v.128a1.461,1.461,0,0,0,1.452,1.458c.6,0,1.154.009,1.673.015,2.983.035,4.625.055,5.87-.74l5.035-3.13a.4.4,0,0,1,.209-.06h13.28V85.267l-18.5-.018a.4.4,0,0,1-.116-.018l-7.963-2.421a4.33,4.33,0,0,0-4.525,1.131l-2.883,3.066A7.061,7.061,0,0,0,81.9,89.582l-.783,2.337a1.512,1.512,0,0,0,.952,1.912.4.4,0,0,1-.252.752,2.306,2.306,0,0,1-1.452-2.916l.783-2.337a7.857,7.857,0,0,1,1.713-2.865L85.74,83.4a5.122,5.122,0,0,1,5.344-1.344l7.9,2.4,18.835.019a.4.4,0,0,1,.4.4V96.054a.4.4,0,0,1-.4.4H104.252l-4.935,3.068c-1.178.751-2.617.874-4.76.874",
    transform: "translate(2.521 2.569)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241059",
    "data-name": "Path 241059",
    d: "M139.268,69.934l-10.554,11.9a7.507,7.507,0,0,1-5.615,2.526H105.275V99.548l22.3-.01a11.661,11.661,0,0,0,8.747-3.955l17.181-19.513L145.92,69.5a4.742,4.742,0,0,0-6.652.438",
    transform: "translate(3.307 2.147)",
    fill: "#ffeedc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241060",
    "data-name": "Path 241060",
    d: "M167.59,112.085H124.355l.145-5.181h10.17l1.424-30.035c.331-5.9,4.65-10.385,10.384-10.385h12.894Z",
    transform: "translate(3.907 2.089)",
    fill: "#ffeedc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241061",
    "data-name": "Path 241061",
    d: "M92.388,107.47H48.3L27.57,71.955H71.656Z",
    transform: "translate(0.866 2.26)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24838",
    "data-name": "Rectangle 24838",
    width: 79.265,
    height: 4.485,
    transform: "translate(49.169 109.732)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241062",
    "data-name": "Path 241062",
    d: "M55.79,90.463a3.026,3.026,0,1,1,3.754,2.266,3.1,3.1,0,0,1-3.754-2.266",
    transform: "translate(1.749 2.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24839",
    "data-name": "Rectangle 24839",
    width: 16.473,
    height: 13.471,
    transform: "translate(117.795 97.477)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241063",
    "data-name": "Path 241063",
    d: "M99.93,98.628l-1.462,1.579a2.286,2.286,0,0,0-.177,2.888l1.436,1.993,3.479-3.882h21.86V96.631H104.5a6.226,6.226,0,0,0-4.569,2",
    transform: "translate(3.074 3.036)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241064",
    "data-name": "Path 241064",
    d: "M100.564,95.883l-.827.893a2.286,2.286,0,0,0-.177,2.888l1.436,1.993,3.48-3.882h20.551V94.592h-3.488c-1.443,0-4.016-1.392-7.273-1.392H106.7a8.365,8.365,0,0,0-6.138,2.683",
    transform: "translate(3.114 2.928)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241065",
    "data-name": "Path 241065",
    d: "M98.3,103.5a.394.394,0,0,1-.322-.165,2.69,2.69,0,0,1,.207-3.388l1.463-1.58a6.642,6.642,0,0,1,4.859-2.124h4.024a.4.4,0,1,1,0,.793H104.51a5.846,5.846,0,0,0-4.277,1.87l-1.463,1.579a1.894,1.894,0,0,0-.145,2.387.4.4,0,0,1-.322.628",
    transform: "translate(3.062 3.023)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241066",
    "data-name": "Path 241066",
    d: "M99.444,101.6l-1.753,1.895a2.286,2.286,0,0,0-.177,2.888l1.436,1.993,3.479-3.882h13.544V99.917H103.292a5.243,5.243,0,0,0-3.848,1.682",
    transform: "translate(3.05 3.139)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241067",
    "data-name": "Path 241067",
    d: "M98.084,107.567a.394.394,0,0,1-.322-.165l-.559-.776a2.692,2.692,0,0,1,.207-3.389l1.754-1.895a5.657,5.657,0,0,1,4.139-1.809H108.6a.4.4,0,0,1,0,.793H103.3a4.868,4.868,0,0,0-3.558,1.554l-1.753,1.895a1.9,1.9,0,0,0-.145,2.388l.559.776a.4.4,0,0,1-.322.628",
    transform: "translate(3.038 3.127)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241068",
    "data-name": "Path 241068",
    d: "M100.067,104.83l-1.83,1.976a2.1,2.1,0,1,0,3.1,2.827l.992-1.108a2.5,2.5,0,0,1,1.863-.832h11.372c2.974,0,5.066-.17,7.931-4.578l-19.514,0a5.338,5.338,0,0,0-3.917,1.712",
    transform: "translate(3.068 3.239)",
    fill: "#fecb8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241069",
    "data-name": "Path 241069",
    d: "M99.791,110.74c-.045,0-.09,0-.135,0a2.5,2.5,0,0,1-1.7-4.188l1.831-1.976A5.748,5.748,0,0,1,104,102.734h4.4a.4.4,0,0,1,0,.793H104a4.955,4.955,0,0,0-3.625,1.584l-1.831,1.977a1.7,1.7,0,1,0,2.518,2.292l.992-1.108a2.9,2.9,0,0,1,2.159-.963h12.577a6.2,6.2,0,0,0,5.132-2.723.4.4,0,1,1,.656.445,6.988,6.988,0,0,1-5.788,3.071H104.208a2.111,2.111,0,0,0-1.568.7l-.993,1.108a2.481,2.481,0,0,1-1.856.83",
    transform: "translate(3.056 3.227)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241070",
    "data-name": "Path 241070",
    d: "M131.166,108.433H112.4a.4.4,0,0,1,0-.793h18.371V94.961H122.2a12.56,12.56,0,0,1-3.558-.6,16.464,16.464,0,0,0-4.872-.749h-7.058a7.992,7.992,0,0,0-5.847,2.555l-.828.894a1.878,1.878,0,0,0-.323,2.084.4.4,0,0,1-.718.337,2.671,2.671,0,0,1,.459-2.96l.828-.894a8.786,8.786,0,0,1,6.429-2.81h7.058a17.368,17.368,0,0,1,5.083.778,11.777,11.777,0,0,0,3.348.576h8.962a.4.4,0,0,1,.4.4v13.472a.4.4,0,0,1-.4.4",
    transform: "translate(3.102 2.916)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241071",
    "data-name": "Path 241071",
    d: "M160.182,66.485H159.17l-6.413,25.3a3.7,3.7,0,0,1-3.59,2.792l-23.345-.019-.013,16.142,27.657.023a14.252,14.252,0,0,0,13.826-10.747l4.66-18.361a12.142,12.142,0,0,0-11.769-15.13",
    transform: "translate(3.952 2.089)",
    fill: "#ffeedc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241072",
    "data-name": "Path 241072",
    d: "M153.49,111.132h-.012l-27.657-.023a.4.4,0,0,1-.4-.4l.013-16.143a.4.4,0,0,1,.4-.4l23.345.019h0a3.3,3.3,0,0,0,3.2-2.493l3.163-12.48a.4.4,0,1,1,.768.194l-3.163,12.481a4.094,4.094,0,0,1-3.972,3.091h0l-22.949-.019-.012,15.35,27.261.022h.011a13.841,13.841,0,0,0,13.43-10.447l4.66-18.362a11.747,11.747,0,0,0-11.386-14.636h-1.933a.4.4,0,0,1,0-.793h1.933a12.54,12.54,0,0,1,12.154,15.624l-4.66,18.362a14.634,14.634,0,0,1-14.2,11.045",
    transform: "translate(3.94 2.076)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84475",
    "data-name": "Group 84475",
    transform: "translate(-31 524.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84351",
    "data-name": "Group 84351",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84350",
    "data-name": "Group 84350",
    clipPath: "url(#clip-path-2)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24035",
    "data-name": "Rectangle 24035",
    width: 24.811,
    height: 64.741,
    transform: "translate(660.344 176.004)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_237409",
    "data-name": "Path 237409",
    d: "M367.081,196.773v65.256h-1.03V197.8H342.27v64.225h-1.03V196.773Z",
    transform: "translate(318.588 -21.284)",
    fill: "#515255"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24036",
    "data-name": "Rectangle 24036",
    width: 24.811,
    height: 30.327,
    transform: "translate(813.95 210.418)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237410",
    "data-name": "Path 237410",
    d: "M194.846,235.361V266.2h-1.03V236.391H170.035V266.2H169V235.361Z",
    transform: "translate(644.43 -25.458)",
    fill: "#515255"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24037",
    "data-name": "Rectangle 24037",
    width: 24.811,
    height: 51.165,
    transform: "translate(644.53 189.58)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237411",
    "data-name": "Path 237411",
    d: "M384.814,212v51.679h-1.03V213.027H360v50.649h-1.03V212Z",
    transform: "translate(285.041 -22.931)",
    fill: "#515255"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24038",
    "data-name": "Rectangle 24038",
    width: 24.811,
    height: 48.15,
    transform: "translate(623.867 192.594)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237412",
    "data-name": "Path 237412",
    d: "M407.983,215.376v48.665h-1.03V216.406H383.172v47.635h-1.03V215.376Z",
    transform: "translate(241.21 -23.296)",
    fill: "#515255"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237413",
    "data-name": "Path 237413",
    d: "M609.516,164.678v92.873h-9.163V155.382Z",
    transform: "translate(-154.932 -16.807)",
    fill: "#ffded7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237414",
    "data-name": "Path 237414",
    d: "M637.612,257.556H610.628V156.466l26.983-1.039Z",
    transform: "translate(-192.192 -16.812)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237415",
    "data-name": "Path 237415",
    d: "M638.065,257.492h-1.03V155.9l-25.954,1V257.492h-1.03V155.905l28.014-1.078Z",
    transform: "translate(-192.13 -16.747)",
    fill: "#515255"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237416",
    "data-name": "Path 237416",
    d: "M639.676,257.644h-9.959V156.616l9.959-.383Z",
    transform: "translate(-211.281 -16.899)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237417",
    "data-name": "Path 237417",
    d: "M640.13,257.579H639.1V156.7l-8.929.343V257.579h-1.03V156.056l10.989-.423Z",
    transform: "translate(-211.22 -16.834)",
    fill: "#515255"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237418",
    "data-name": "Path 237418",
    d: "M637.612,165.029l-26.984.907v-1.48l26.984-.93Z",
    transform: "translate(-192.192 -17.688)",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237419",
    "data-name": "Path 237419",
    d: "M610.05,166.4l28.013-.941v-2.536l-28.013.965Zm26.982-1.938-25.953.873v-.45l25.953-.9Z",
    transform: "translate(-192.128 -17.623)",
    fill: "#515255"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237420",
    "data-name": "Path 237420",
    d: "M637.612,175.344l-26.984.767v-1.48l26.984-.79Z",
    transform: "translate(-192.192 -18.803)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237421",
    "data-name": "Path 237421",
    d: "M610.05,176.577l28.013-.8v-2.534l-28.013.82Zm26.982-1.8-25.953.738v-.45l25.953-.76Z",
    transform: "translate(-192.128 -18.739)",
    fill: "#515255"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237422",
    "data-name": "Path 237422",
    d: "M637.612,185.66l-26.984.628v-1.481l26.984-.65Z",
    transform: "translate(-192.192 -19.919)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237423",
    "data-name": "Path 237423",
    d: "M610.05,186.751l28.013-.651v-2.534l-28.013.675Zm26.982-1.657-25.953.6v-.451l25.953-.625Z",
    transform: "translate(-192.128 -19.855)",
    fill: "#515255"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237424",
    "data-name": "Path 237424",
    d: "M637.612,195.976l-26.984.488v-1.48l26.984-.511Z",
    transform: "translate(-192.192 -21.035)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237425",
    "data-name": "Path 237425",
    d: "M610.05,196.925l28.013-.507v-2.534l-28.013.53Zm26.982-1.518-25.953.469v-.451l25.953-.491Z",
    transform: "translate(-192.128 -20.972)",
    fill: "#515255"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237426",
    "data-name": "Path 237426",
    d: "M637.612,206.292l-26.984.348v-1.48l26.984-.371Z",
    transform: "translate(-192.192 -22.151)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237427",
    "data-name": "Path 237427",
    d: "M610.05,207.1l28.013-.361V204.2l-28.013.385Zm26.982-1.378-25.953.335v-.451l25.953-.357Z",
    transform: "translate(-192.128 -22.088)",
    fill: "#515255"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237428",
    "data-name": "Path 237428",
    d: "M637.612,216.608l-26.984.209v-1.48l26.984-.232Z",
    transform: "translate(-192.192 -23.267)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237429",
    "data-name": "Path 237429",
    d: "M610.05,217.272l28.013-.217v-2.534l-28.013.24Zm26.982-1.239-25.953.2v-.451l25.953-.222Z",
    transform: "translate(-192.128 -23.204)",
    fill: "#515255"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237430",
    "data-name": "Path 237430",
    d: "M637.612,226.924l-26.984.069v-1.48l26.984-.092Z",
    transform: "translate(-192.192 -24.383)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237431",
    "data-name": "Path 237431",
    d: "M610.05,227.446l28.013-.071v-2.534l-28.013.1Zm26.982-1.1-25.953.066v-.45l25.953-.088Z",
    transform: "translate(-192.128 -24.32)",
    fill: "#515255"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237432",
    "data-name": "Path 237432",
    d: "M637.612,237.234l-26.984-.07v-1.48l26.984.047Z",
    transform: "translate(-192.192 -25.493)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237433",
    "data-name": "Path 237433",
    d: "M638.063,237.688v-2.533l-28.013-.05v2.51Zm-1.031-1.505v.473l-25.953-.068v-.45Z",
    transform: "translate(-192.128 -25.43)",
    fill: "#515255"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237434",
    "data-name": "Path 237434",
    d: "M637.612,247.533l-26.984-.21v-1.48l26.984.187Z",
    transform: "translate(-192.192 -26.591)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237435",
    "data-name": "Path 237435",
    d: "M638.063,247.989v-2.533l-28.013-.2v2.511Zm-1.031-1.511v.473l-25.953-.2V246.3Z",
    transform: "translate(-192.128 -26.529)",
    fill: "#515255"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237436",
    "data-name": "Path 237436",
    d: "M637.612,257.832l-26.984-.35V256l26.984.326Z",
    transform: "translate(-192.192 -27.69)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237437",
    "data-name": "Path 237437",
    d: "M638.063,258.291v-2.534l-28.013-.339v2.51Zm-1.031-1.516v.473l-25.953-.336v-.451Z",
    transform: "translate(-192.128 -27.627)",
    fill: "#515255"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237438",
    "data-name": "Path 237438",
    d: "M637.612,268.131l-26.984-.49v-1.48l26.984.466Z",
    transform: "translate(-192.192 -28.789)",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237439",
    "data-name": "Path 237439",
    d: "M637.034,267.07l-25.953-.449v.451l25.953.47Zm1.03-1.012v2.533l-28.013-.507v-2.511Z",
    transform: "translate(-192.13 -28.726)",
    fill: "#515255"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24039",
    "data-name": "Rectangle 24039",
    width: 4.954,
    height: 9.09,
    transform: "translate(443.003 231.654)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237440",
    "data-name": "Path 237440",
    d: "M613.189,259.173v9.605h-1.03V260.2h-3.924v8.575h-1.029v-9.605Z",
    transform: "translate(-164.717 -28.033)",
    fill: "#515255"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24040",
    "data-name": "Rectangle 24040",
    width: 14.906,
    height: 59.477,
    transform: "translate(447.957 181.267)",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237441",
    "data-name": "Path 237441",
    d: "M606.428,202.674v59.993H605.4V203.7H591.522v58.963h-1.03V202.674Z",
    transform: "translate(-143.05 -21.922)",
    fill: "#515255"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24041",
    "data-name": "Rectangle 24041",
    width: 10.943,
    height: 59.491,
    transform: "translate(462.864 181.254)",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237442",
    "data-name": "Path 237442",
    d: "M590.194,202.66v60.005h-1.03V203.69h-9.913v58.975h-1.029V202.66Z",
    transform: "translate(-115.873 -21.921)",
    fill: "#515255"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24042",
    "data-name": "Rectangle 24042",
    width: 2.061,
    height: 2.18,
    transform: "translate(460.803 190.785)",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237443",
    "data-name": "Path 237443",
    d: "M590.492,216.556h3.091v-3.21h-3.091Zm2.062-1.029h-1.032v-1.15h1.032Z",
    transform: "translate(-130.205 -23.077)",
    fill: "#515255"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24043",
    "data-name": "Rectangle 24043",
    width: 2.061,
    height: 2.181,
    transform: "translate(460.803 195.047)",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237444",
    "data-name": "Path 237444",
    d: "M590.492,221.336h3.091v-3.21h-3.091Zm2.062-1.029h-1.032v-1.15h1.032Z",
    transform: "translate(-130.205 -23.594)",
    fill: "#515255"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24044",
    "data-name": "Rectangle 24044",
    width: 2.061,
    height: 2.18,
    transform: "translate(460.803 199.311)",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237445",
    "data-name": "Path 237445",
    d: "M590.492,226.117h3.091v-3.21h-3.091Zm2.062-1.03h-1.032v-1.15h1.032Z",
    transform: "translate(-130.205 -24.111)",
    fill: "#515255"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24045",
    "data-name": "Rectangle 24045",
    width: 2.061,
    height: 2.181,
    transform: "translate(460.803 203.574)",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237446",
    "data-name": "Path 237446",
    d: "M590.492,230.9h3.091v-3.21h-3.091Zm2.062-1.03h-1.032v-1.15h1.032Z",
    transform: "translate(-130.205 -24.628)",
    fill: "#515255"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24046",
    "data-name": "Rectangle 24046",
    width: 2.061,
    height: 2.18,
    transform: "translate(460.803 207.838)",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237447",
    "data-name": "Path 237447",
    d: "M590.492,235.677h3.091v-3.21h-3.091Zm2.062-1.03h-1.032V233.5h1.032Z",
    transform: "translate(-130.205 -25.145)",
    fill: "#515255"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24047",
    "data-name": "Rectangle 24047",
    width: 2.061,
    height: 2.181,
    transform: "translate(460.803 212.1)",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237448",
    "data-name": "Path 237448",
    d: "M590.492,240.457h3.091v-3.21h-3.091Zm2.062-1.029h-1.032v-1.15h1.032Z",
    transform: "translate(-130.205 -25.662)",
    fill: "#515255"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24048",
    "data-name": "Rectangle 24048",
    width: 2.061,
    height: 2.18,
    transform: "translate(460.803 216.364)",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237449",
    "data-name": "Path 237449",
    d: "M590.492,245.238h3.091v-3.21h-3.091Zm2.062-1.03h-1.032v-1.15h1.032Z",
    transform: "translate(-130.205 -26.179)",
    fill: "#515255"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24049",
    "data-name": "Rectangle 24049",
    width: 2.061,
    height: 2.18,
    transform: "translate(460.803 220.627)",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237450",
    "data-name": "Path 237450",
    d: "M590.492,250.018h3.091v-3.21h-3.091Zm2.062-1.03h-1.032v-1.15h1.032Z",
    transform: "translate(-130.205 -26.696)",
    fill: "#515255"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24050",
    "data-name": "Rectangle 24050",
    width: 2.061,
    height: 2.181,
    transform: "translate(460.803 224.89)",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237451",
    "data-name": "Path 237451",
    d: "M590.492,254.8h3.091v-3.21h-3.091Zm2.062-1.03h-1.032v-1.15h1.032Z",
    transform: "translate(-130.205 -27.213)",
    fill: "#515255"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24051",
    "data-name": "Rectangle 24051",
    width: 2.061,
    height: 2.18,
    transform: "translate(460.803 229.153)",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237452",
    "data-name": "Path 237452",
    d: "M590.492,259.578h3.091v-3.21h-3.091Zm2.062-1.03h-1.032V257.4h1.032Z",
    transform: "translate(-130.205 -27.73)",
    fill: "#515255"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24052",
    "data-name": "Rectangle 24052",
    width: 2.061,
    height: 2.181,
    transform: "translate(460.803 233.416)",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237453",
    "data-name": "Path 237453",
    d: "M590.492,264.358h3.091v-3.21h-3.091Zm2.062-1.03h-1.032v-1.15h1.032Z",
    transform: "translate(-130.205 -28.247)",
    fill: "#515255"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24053",
    "data-name": "Rectangle 24053",
    width: 2.062,
    height: 2.18,
    transform: "translate(460.802 237.679)",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237454",
    "data-name": "Path 237454",
    d: "M592.554,266.958h-1.031v1.15h1.031Zm1.029,2.18h-3.091v-3.21h3.091Z",
    transform: "translate(-130.205 -28.764)",
    fill: "#515255"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24054",
    "data-name": "Rectangle 24054",
    width: 8.539,
    height: 5.837,
    transform: "translate(460.378 175.417)",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237455",
    "data-name": "Path 237455",
    d: "M583.7,202.981h9.569v-6.866H583.7Zm8.539-1.029h-7.509v-4.807h7.509Z",
    transform: "translate(-123.84 -21.213)",
    fill: "#515255"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24055",
    "data-name": "Rectangle 24055",
    width: 8.539,
    height: 5.837,
    transform: "translate(451.839 175.417)",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237456",
    "data-name": "Path 237456",
    d: "M593.279,202.981h9.568v-6.866h-9.568Zm8.539-1.029h-7.509v-4.807h7.509Z",
    transform: "translate(-141.955 -21.213)",
    fill: "#515255"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24056",
    "data-name": "Rectangle 24056",
    width: 3.223,
    height: 9.09,
    transform: "translate(439.781 231.654)",
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237457",
    "data-name": "Path 237457",
    d: "M617.014,259.173v9.605h-1.03V260.2h-2.193v8.575h-1.03v-9.605Z",
    transform: "translate(-173.495 -28.033)",
    fill: "#515255"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24057",
    "data-name": "Rectangle 24057",
    width: 3.97,
    height: 52.077,
    transform: "translate(494.554 188.668)",
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237458",
    "data-name": "Path 237458",
    d: "M555.506,210.973v52.592h-1.03V212h-2.94v51.561h-1.03V210.973Z",
    transform: "translate(-56.468 -22.82)",
    fill: "#515255"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237459",
    "data-name": "Path 237459",
    d: "M577.855,263.638H557.531V212.652l20.324-1Z",
    transform: "translate(-85.081 -22.893)",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237460",
    "data-name": "Path 237460",
    d: "M578.307,263.572h-1.03V212.126l-19.295.951v50.5h-1.029V212.1l21.354-1.053Z",
    transform: "translate(-85.018 -22.827)",
    fill: "#515255"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237461",
    "data-name": "Path 237461",
    d: "M577.855,218.809l-20.324.93V216.25l20.324-.968Z",
    transform: "translate(-85.081 -23.286)",
    fill: "#fff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237462",
    "data-name": "Path 237462",
    d: "M556.953,220.212l21.354-.977v-4.558l-21.354,1.017Zm20.324-1.96-19.295.883v-2.459l19.295-.919Z",
    transform: "translate(-85.018 -23.22)",
    fill: "#515255"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237463",
    "data-name": "Path 237463",
    d: "M577.855,226.312l-20.324.858v-3.488l20.324-.9Z",
    transform: "translate(-85.081 -24.098)",
    fill: "#fff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237464",
    "data-name": "Path 237464",
    d: "M556.953,227.642l21.354-.9v-4.557l-21.354.941Zm20.324-1.889-19.295.815v-2.459l19.295-.851Z",
    transform: "translate(-85.018 -24.032)",
    fill: "#515255"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237465",
    "data-name": "Path 237465",
    d: "M577.855,233.814l-20.324.787v-3.488l20.324-.825Z",
    transform: "translate(-85.081 -24.909)",
    fill: "#fff"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237466",
    "data-name": "Path 237466",
    d: "M556.953,235.071l21.354-.827v-4.558l-21.354.867Zm20.324-1.818L557.982,234v-2.458l19.295-.783Z",
    transform: "translate(-85.018 -24.844)",
    fill: "#515255"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237467",
    "data-name": "Path 237467",
    d: "M577.855,241.317l-20.324.715v-3.488l20.324-.754Z",
    transform: "translate(-85.081 -25.721)",
    fill: "#fff"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237468",
    "data-name": "Path 237468",
    d: "M556.953,242.5l21.354-.751v-4.557l-21.354.791Zm20.324-1.745-19.295.679v-2.459l19.295-.714Z",
    transform: "translate(-85.018 -25.656)",
    fill: "#515255"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237469",
    "data-name": "Path 237469",
    d: "M577.855,248.82l-20.324.644v-3.488l20.324-.682Z",
    transform: "translate(-85.081 -26.532)",
    fill: "#fff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237470",
    "data-name": "Path 237470",
    d: "M556.953,249.93l21.354-.676V244.7l-21.354.716Zm20.324-1.674-19.295.611v-2.459l19.295-.647Z",
    transform: "translate(-85.018 -26.468)",
    fill: "#515255"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237471",
    "data-name": "Path 237471",
    d: "M577.855,256.323l-20.324.573v-3.489l20.324-.61Z",
    transform: "translate(-85.081 -27.344)",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237472",
    "data-name": "Path 237472",
    d: "M556.953,257.36l21.354-.6V252.2l-21.354.641Zm20.324-1.6-19.295.543v-2.459l19.295-.58Z",
    transform: "translate(-85.018 -27.279)",
    fill: "#515255"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237473",
    "data-name": "Path 237473",
    d: "M577.855,263.826l-20.324.5v-3.488l20.324-.539Z",
    transform: "translate(-85.081 -28.155)",
    fill: "#fff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237474",
    "data-name": "Path 237474",
    d: "M556.953,264.79l21.354-.526v-4.557l-21.354.565Zm20.324-1.531-19.295.475v-2.459l19.295-.512Z",
    transform: "translate(-85.018 -28.091)",
    fill: "#515255"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237475",
    "data-name": "Path 237475",
    d: "M577.855,269.712H557.531v-1.442l20.324-.466Z",
    transform: "translate(-85.081 -28.967)",
    fill: "#fff"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237476",
    "data-name": "Path 237476",
    d: "M578.307,269.647h-1.03v-1.382l-19.295.443v.939h-1.029V267.7l21.354-.491Z",
    transform: "translate(-85.018 -28.903)",
    fill: "#515255"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237477",
    "data-name": "Path 237477",
    d: "M582.836,263.759H580.32V212.9l2.516-.125Z",
    transform: "translate(-110.386 -23.015)",
    fill: "#fff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237478",
    "data-name": "Path 237478",
    d: "M583.289,263.694h-1.03V213.249l-1.486.073v50.372h-1.03V212.342l3.546-.175Z",
    transform: "translate(-110.325 -22.949)",
    fill: "#515255"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237479",
    "data-name": "Path 237479",
    d: "M581.579,263.759H580.32V212.835l1.259-.062Z",
    transform: "translate(-109.129 -23.015)",
    fill: "#fff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237480",
    "data-name": "Path 237480",
    d: "M582.032,263.694H581V213.249l-.228.011v50.434h-1.03V212.279l2.288-.112Z",
    transform: "translate(-109.067 -22.949)",
    fill: "#515255"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237481",
    "data-name": "Path 237481",
    d: "M557.313,263.627h-1.8V211.639l1.8-.089Z",
    transform: "translate(-62.74 -22.882)",
    fill: "#fff"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237482",
    "data-name": "Path 237482",
    d: "M557.765,263.561h-1.03V212.026l-.769.037v51.5h-1.03V211.083l2.829-.139Z",
    transform: "translate(-62.677 -22.817)",
    fill: "#515255"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237483",
    "data-name": "Path 237483",
    d: "M550.3,211.9v51.726h-6.474V211.55Z",
    transform: "translate(-45.303 -22.882)",
    fill: "#515255"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237484",
    "data-name": "Path 237484",
    d: "M536.136,258.515h-63.4V166.839l63.4-2.55Z",
    transform: "translate(32.258 -17.77)",
    fill: "#fff"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237485",
    "data-name": "Path 237485",
    d: "M536.59,258.45H535.56V164.76l-62.368,2.508V258.45h-1.03V166.279l64.427-2.591Z",
    transform: "translate(32.319 -17.705)",
    fill: "#515255"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237486",
    "data-name": "Path 237486",
    d: "M536.136,173.668l-63.4,2.263V172.47l63.4-2.38Z",
    transform: "translate(32.258 -18.398)",
    fill: "#fff"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237487",
    "data-name": "Path 237487",
    d: "M472.162,176.4l64.428-2.3v-4.609l-64.428,2.418Zm63.4-3.294-62.368,2.226V172.9l62.368-2.341Z",
    transform: "translate(32.319 -18.333)",
    fill: "#515255"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237488",
    "data-name": "Path 237488",
    d: "M536.136,184.373l-63.4,1.95v-3.46l63.4-2.068Z",
    transform: "translate(32.258 -19.556)",
    fill: "#fff"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237489",
    "data-name": "Path 237489",
    d: "M472.162,186.791l64.428-1.983V180.2l-64.428,2.1Zm63.4-2.981-62.368,1.919V183.3l62.368-2.033Z",
    transform: "translate(32.319 -19.491)",
    fill: "#515255"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237490",
    "data-name": "Path 237490",
    d: "M536.136,195.079l-63.4,1.638v-3.46l63.4-1.756Z",
    transform: "translate(32.258 -20.714)",
    fill: "#fff"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237491",
    "data-name": "Path 237491",
    d: "M472.162,197.181l64.428-1.665v-4.609l-64.428,1.785Zm63.4-2.668-62.368,1.612v-2.432l62.368-1.728Z",
    transform: "translate(32.319 -20.649)",
    fill: "#515255"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237492",
    "data-name": "Path 237492",
    d: "M536.136,205.785l-63.4,1.326V203.65l63.4-1.443Z",
    transform: "translate(32.258 -21.872)",
    fill: "#fff"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237493",
    "data-name": "Path 237493",
    d: "M472.162,207.573l64.428-1.348v-4.609l-64.428,1.466Zm63.4-2.356-62.368,1.3v-2.432l62.368-1.42Z",
    transform: "translate(32.319 -21.808)",
    fill: "#515255"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237494",
    "data-name": "Path 237494",
    d: "M536.136,216.49l-63.4,1.014v-3.461l63.4-1.131Z",
    transform: "translate(32.258 -23.03)",
    fill: "#fff"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237495",
    "data-name": "Path 237495",
    d: "M472.162,217.964l64.428-1.03v-4.61l-64.428,1.15Zm63.4-2.044-62.368,1v-2.431l62.368-1.113Z",
    transform: "translate(32.319 -22.966)",
    fill: "#515255"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237496",
    "data-name": "Path 237496",
    d: "M536.136,227.2l-63.4.7v-3.461l63.4-.819Z",
    transform: "translate(32.258 -24.188)",
    fill: "#fff"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237497",
    "data-name": "Path 237497",
    d: "M472.162,228.355l64.428-.713v-4.609l-64.428.832Zm63.4-1.731-62.368.69v-2.432l62.368-.805Z",
    transform: "translate(32.319 -24.124)",
    fill: "#515255"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237498",
    "data-name": "Path 237498",
    d: "M536.136,237.9l-63.4.389v-3.46l63.4-.507Z",
    transform: "translate(32.258 -25.346)",
    fill: "#fff"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237499",
    "data-name": "Path 237499",
    d: "M472.162,238.746l.518,0,63.91-.392v-4.609l-64.428.515Zm63.4-1.419-62.368.384v-2.433l62.368-.5Z",
    transform: "translate(32.319 -25.283)",
    fill: "#515255"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237500",
    "data-name": "Path 237500",
    d: "M536.136,248.608l-63.4.077v-3.46l63.4-.194Z",
    transform: "translate(32.258 -26.504)",
    fill: "#fff"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237501",
    "data-name": "Path 237501",
    d: "M472.162,249.137l64.428-.078V244.45l-64.428.2Zm63.4-1.107-62.368.076v-2.432l62.368-.191Z",
    transform: "translate(32.319 -26.441)",
    fill: "#515255"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237502",
    "data-name": "Path 237502",
    d: "M536.136,259.3l-63.4-.235V255.6l63.4.119Z",
    transform: "translate(32.258 -27.647)",
    fill: "#fff"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237503",
    "data-name": "Path 237503",
    d: "M536.59,259.754v-4.608l-64.428-.12v4.49Zm-1.03-3.581v2.547l-62.368-.232v-2.431Z",
    transform: "translate(32.319 -27.585)",
    fill: "#515255"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237504",
    "data-name": "Path 237504",
    d: "M536.136,266.389v3.123H483.5l-10.765-.093v-3.461Z",
    transform: "translate(32.258 -28.767)",
    fill: "#fff"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237505",
    "data-name": "Path 237505",
    d: "M535.562,266.838l-62.368-.425v2.432l62.368.54Zm1.028-1.023v3.634H472.163v-4.072Z",
    transform: "translate(32.318 -28.704)",
    fill: "#515255"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237506",
    "data-name": "Path 237506",
    d: "M475.691,258.526h-.471V164.408l.471-.019Z",
    transform: "translate(90.491 -17.781)",
    fill: "#fff"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237507",
    "data-name": "Path 237507",
    d: "M476.143,258.461h-1.5V163.848l1.5-.06Z",
    transform: "translate(90.554 -17.716)",
    fill: "#515255"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237508",
    "data-name": "Path 237508",
    d: "M479.493,258.542h-.469V164.561l.469-.019Z",
    transform: "translate(83.296 -17.798)",
    fill: "#fff"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237509",
    "data-name": "Path 237509",
    d: "M479.945,258.477h-1.5V164l1.5-.06Z",
    transform: "translate(83.359 -17.733)",
    fill: "#515255"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237510",
    "data-name": "Path 237510",
    d: "M483.282,258.559h-.468V164.714l.468-.02Z",
    transform: "translate(76.127 -17.814)",
    fill: "#fff"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237511",
    "data-name": "Path 237511",
    d: "M483.734,258.494h-1.5v-94.34l1.5-.061Z",
    transform: "translate(76.19 -17.749)",
    fill: "#515255"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237512",
    "data-name": "Path 237512",
    d: "M487.058,258.575h-.466v-93.71l.466-.019Z",
    transform: "translate(68.983 -17.831)",
    fill: "#fff"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237513",
    "data-name": "Path 237513",
    d: "M487.51,258.51h-1.5v-94.2l1.5-.061Z",
    transform: "translate(69.045 -17.766)",
    fill: "#515255"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237514",
    "data-name": "Path 237514",
    d: "M490.82,258.592h-.464V165.016l.464-.018Z",
    transform: "translate(61.863 -17.847)",
    fill: "#fff"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237515",
    "data-name": "Path 237515",
    d: "M491.273,258.527h-1.495v-94.07l1.495-.061Z",
    transform: "translate(61.925 -17.782)",
    fill: "#515255"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237516",
    "data-name": "Path 237516",
    d: "M494.569,258.608h-.462v-93.44l.462-.019Z",
    transform: "translate(54.768 -17.863)",
    fill: "#fff"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237517",
    "data-name": "Path 237517",
    d: "M495.022,258.543h-1.493V164.608l1.493-.06Z",
    transform: "translate(54.831 -17.798)",
    fill: "#515255"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237518",
    "data-name": "Path 237518",
    d: "M498.306,258.624h-.461V165.318l.461-.019Z",
    transform: "translate(47.698 -17.88)",
    fill: "#fff"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237519",
    "data-name": "Path 237519",
    d: "M498.758,258.559h-1.49v-93.8l1.49-.06Z",
    transform: "translate(47.76 -17.815)",
    fill: "#515255"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237520",
    "data-name": "Path 237520",
    d: "M502.03,258.64h-.46V165.467l.46-.019Z",
    transform: "translate(40.652 -17.896)",
    fill: "#fff"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237521",
    "data-name": "Path 237521",
    d: "M502.482,258.575h-1.488V164.908l1.488-.06Z",
    transform: "translate(40.715 -17.831)",
    fill: "#515255"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237522",
    "data-name": "Path 237522",
    d: "M505.741,258.657h-.458v-93.04l.458-.019Z",
    transform: "translate(33.63 -17.912)",
    fill: "#fff"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237523",
    "data-name": "Path 237523",
    d: "M506.193,258.592h-1.488V165.057l1.488-.06Z",
    transform: "translate(33.692 -17.847)",
    fill: "#515255"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237524",
    "data-name": "Path 237524",
    d: "M509.438,258.673h-.457V165.765l.457-.019Z",
    transform: "translate(26.634 -17.928)",
    fill: "#fff"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237525",
    "data-name": "Path 237525",
    d: "M509.89,258.608H508.4v-93.4l1.486-.061Z",
    transform: "translate(26.696 -17.863)",
    fill: "#515255"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237526",
    "data-name": "Path 237526",
    d: "M513.123,258.689h-.454V165.914l.454-.019Z",
    transform: "translate(19.661 -17.944)",
    fill: "#fff"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237527",
    "data-name": "Path 237527",
    d: "M513.576,258.624h-1.485v-93.27l1.485-.06Z",
    transform: "translate(19.723 -17.879)",
    fill: "#515255"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237528",
    "data-name": "Path 237528",
    d: "M516.8,258.7h-.453V166.061l.453-.018Z",
    transform: "translate(12.712 -17.96)",
    fill: "#fff"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237529",
    "data-name": "Path 237529",
    d: "M517.248,258.64h-1.483V165.5l1.483-.061Z",
    transform: "translate(12.775 -17.895)",
    fill: "#515255"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237530",
    "data-name": "Path 237530",
    d: "M520.456,258.721H520V166.208l.452-.018Z",
    transform: "translate(5.786 -17.976)",
    fill: "#fff"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237531",
    "data-name": "Path 237531",
    d: "M520.907,258.656h-1.481V165.648l1.481-.059Z",
    transform: "translate(5.85 -17.911)",
    fill: "#515255"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237532",
    "data-name": "Path 237532",
    d: "M524.1,258.736h-.45V166.355l.45-.018Z",
    transform: "translate(-1.115 -17.992)",
    fill: "#fff"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237533",
    "data-name": "Path 237533",
    d: "M524.555,258.671h-1.48V165.795l1.48-.059Z",
    transform: "translate(-1.052 -17.927)",
    fill: "#515255"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237534",
    "data-name": "Path 237534",
    d: "M527.737,258.752h-.449V166.5l.449-.018Z",
    transform: "translate(-7.992 -18.008)",
    fill: "#fff"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237535",
    "data-name": "Path 237535",
    d: "M528.19,258.687h-1.479V165.941l1.479-.06Z",
    transform: "translate(-7.93 -17.942)",
    fill: "#515255"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237536",
    "data-name": "Path 237536",
    d: "M531.359,258.768h-.447V166.647l.447-.019Z",
    transform: "translate(-14.846 -18.023)",
    fill: "#fff"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237537",
    "data-name": "Path 237537",
    d: "M531.812,258.7h-1.477V166.087l1.477-.06Z",
    transform: "translate(-14.783 -17.958)",
    fill: "#515255"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237538",
    "data-name": "Path 237538",
    d: "M534.969,258.784h-.446V166.792l.446-.018Z",
    transform: "translate(-21.677 -18.039)",
    fill: "#fff"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237539",
    "data-name": "Path 237539",
    d: "M535.422,258.719h-1.475V166.232l1.475-.059Z",
    transform: "translate(-21.614 -17.974)",
    fill: "#515255"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237540",
    "data-name": "Path 237540",
    d: "M538.568,258.8h-.445V166.937l.445-.019Z",
    transform: "translate(-28.485 -18.055)",
    fill: "#fff"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237541",
    "data-name": "Path 237541",
    d: "M539.019,258.734h-1.473V166.377l1.473-.059Z",
    transform: "translate(-28.421 -17.99)",
    fill: "#515255"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237542",
    "data-name": "Path 237542",
    d: "M542.152,258.815h-.442V167.081l.442-.018Z",
    transform: "translate(-35.269 -18.07)",
    fill: "#fff"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237543",
    "data-name": "Path 237543",
    d: "M542.6,258.75h-1.472V166.521l1.472-.059Z",
    transform: "translate(-35.206 -18.005)",
    fill: "#515255"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24058",
    "data-name": "Rectangle 24058",
    width: 24.539,
    height: 21.771,
    transform: "translate(740.891 218.973)",
    fill: "#fff"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237544",
    "data-name": "Path 237544",
    d: "M276.8,244.954V267.24h-1.03V245.985H252.259V267.24H251.23V244.954Z",
    transform: "translate(489.147 -26.495)",
    fill: "#515255"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24059",
    "data-name": "Rectangle 24059",
    width: 11.133,
    height: 22.522,
    transform: "translate(810.644 200.715)",
    fill: "#fff"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237545",
    "data-name": "Path 237545",
    d: "M188.049,248.032h12.163V224.48H188.049ZM199.183,247h-10.1V225.509h10.1Z",
    transform: "translate(622.079 -24.281)",
    fill: "#515255"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24060",
    "data-name": "Rectangle 24060",
    width: 14.448,
    height: 30.623,
    transform: "translate(731.633 210.122)",
    fill: "#fff"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237546",
    "data-name": "Path 237546",
    d: "M288.4,235.029v31.138h-1.03V236.059H273.956v30.107h-1.03V235.029Z",
    transform: "translate(458.191 -25.422)",
    fill: "#515255"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24061",
    "data-name": "Rectangle 24061",
    width: 35.858,
    height: 27.587,
    transform: "translate(954.142 213.158)",
    fill: "#fff"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237547",
    "data-name": "Path 237547",
    d: "M36.373,238.433v1.03H1.029v27.072H0v-28.1Z",
    transform: "translate(953.627 -25.79)",
    fill: "#515255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_84147",
    "data-name": "Group 84147",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84146",
    "data-name": "Group 84146",
    clipPath: "url(#clip-path-3)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84142",
    "data-name": "Group 84142",
    transform: "translate(953.624 215.748)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84141",
    "data-name": "Group 84141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84140",
    "data-name": "Group 84140",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24062",
    "data-name": "Rectangle 24062",
    width: 35.858,
    height: 0.903,
    transform: "translate(0.514 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24063",
    "data-name": "Rectangle 24063",
    width: 36.373,
    height: 1.933,
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24064",
    "data-name": "Rectangle 24064",
    width: 35.858,
    height: 0.903,
    transform: "translate(0.514 4.522)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24065",
    "data-name": "Rectangle 24065",
    width: 36.373,
    height: 1.933,
    transform: "translate(0 4.008)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24066",
    "data-name": "Rectangle 24066",
    width: 35.858,
    height: 0.903,
    transform: "translate(0.514 8.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24067",
    "data-name": "Rectangle 24067",
    width: 36.373,
    height: 1.933,
    transform: "translate(0 8.015)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24068",
    "data-name": "Rectangle 24068",
    width: 35.858,
    height: 0.903,
    transform: "translate(0.514 12.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24069",
    "data-name": "Rectangle 24069",
    width: 36.373,
    height: 1.932,
    transform: "translate(0 12.023)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24070",
    "data-name": "Rectangle 24070",
    width: 35.858,
    height: 0.903,
    transform: "translate(0.514 16.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24071",
    "data-name": "Rectangle 24071",
    width: 36.373,
    height: 1.933,
    transform: "translate(0 16.031)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24072",
    "data-name": "Rectangle 24072",
    width: 35.858,
    height: 0.903,
    transform: "translate(0.514 20.553)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24073",
    "data-name": "Rectangle 24073",
    width: 36.373,
    height: 1.932,
    transform: "translate(0 20.038)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24074",
    "data-name": "Rectangle 24074",
    width: 35.858,
    height: 0.437,
    transform: "translate(0.514 24.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24075",
    "data-name": "Rectangle 24075",
    width: 36.373,
    height: 0.952,
    transform: "translate(0 24.045)",
    fill: "#515255"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84145",
    "data-name": "Group 84145",
    transform: "translate(953.624 212.643)",
    opacity: 0.36,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84144",
    "data-name": "Group 84144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84143",
    "data-name": "Group 84143",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24077",
    "data-name": "Rectangle 24077",
    width: 17.566,
    height: 27.587,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237548",
    "data-name": "Path 237548",
    d: "M37.5,239.463H20.962v27.072h-1.03v-28.1h18.6v28.1H37.5Z",
    transform: "translate(-19.932 -238.433)",
    fill: "#515255"
  }))))))), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24080",
    "data-name": "Rectangle 24080",
    width: 15.84,
    height: 46.812,
    transform: "translate(915.911 193.932)",
    fill: "#fff"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237549",
    "data-name": "Path 237549",
    d: "M81.606,216.875V264.2h-1.03v-46.3H65.765v46.3H64.736V216.875Z",
    transform: "translate(850.66 -23.458)",
    fill: "#515255"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24081",
    "data-name": "Rectangle 24081",
    width: 4.193,
    height: 46.812,
    transform: "translate(931.751 193.932)",
    fill: "#fff"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237550",
    "data-name": "Path 237550",
    d: "M65.257,216.875V264.2h-1.03v-46.3H61.064v46.3H60.034V216.875Z",
    transform: "translate(871.202 -23.458)",
    fill: "#515255"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24082",
    "data-name": "Rectangle 24082",
    width: 17.064,
    height: 46.812,
    transform: "translate(944.581 193.932)",
    fill: "#fff"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237551",
    "data-name": "Path 237551",
    d: "M49.312,216.875V264.2h-1.03v-46.3H32.247v46.3h-1.03V216.875Z",
    transform: "translate(912.848 -23.458)",
    fill: "#515255"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24083",
    "data-name": "Rectangle 24083",
    width: 4.193,
    height: 46.812,
    transform: "translate(940.387 193.932)",
    fill: "#fff"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237552",
    "data-name": "Path 237552",
    d: "M55.574,216.875V264.2h-1.03v-46.3H51.381v46.3H50.351V216.875Z",
    transform: "translate(889.521 -23.458)",
    fill: "#515255"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24084",
    "data-name": "Rectangle 24084",
    width: 4.443,
    height: 46.812,
    transform: "translate(935.943 193.932)",
    fill: "#86e9b9"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24085",
    "data-name": "Rectangle 24085",
    width: 15.586,
    height: 6.05,
    transform: "translate(922.58 187.882)",
    fill: "#fff"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237553",
    "data-name": "Path 237553",
    d: "M57.544,217.171H74.159v-7.08H57.544Zm15.586-1.029H58.574v-5.021H73.13Z",
    transform: "translate(864.521 -22.724)",
    fill: "#515255"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24086",
    "data-name": "Rectangle 24086",
    width: 15.586,
    height: 6.05,
    transform: "translate(938.166 187.882)",
    fill: "#fff"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237554",
    "data-name": "Path 237554",
    d: "M40.068,217.171H56.683v-7.08H40.068Zm15.585-1.029H41.1v-5.021H55.653Z",
    transform: "translate(897.583 -22.724)",
    fill: "#515255"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24087",
    "data-name": "Rectangle 24087",
    width: 18.982,
    height: 80.596,
    transform: "translate(832.106 160.149)",
    fill: "#fff"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237555",
    "data-name": "Path 237555",
    d: "M175.2,179v81.111h-1.03V180.024H156.213v80.081h-1.03V179Z",
    transform: "translate(676.407 -19.361)",
    fill: "#515255"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24088",
    "data-name": "Rectangle 24088",
    width: 5.025,
    height: 80.596,
    transform: "translate(851.088 160.149)",
    fill: "#fff"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237556",
    "data-name": "Path 237556",
    d: "M155.6,179v81.111h-1.03V180.024h-4v80.081h-1.03V179Z",
    transform: "translate(701.025 -19.361)",
    fill: "#515255"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24089",
    "data-name": "Rectangle 24089",
    width: 39.935,
    height: 80.596,
    transform: "translate(866.462 160.149)",
    fill: "#fd930d"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237557",
    "data-name": "Path 237557",
    d: "M134.13,179v81.111H133.1V180.024H94.2v80.081h-1.03V179Z",
    transform: "translate(772.781 -19.361)",
    fill: "#515255"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24090",
    "data-name": "Rectangle 24090",
    width: 5.025,
    height: 80.596,
    transform: "translate(861.437 160.149)",
    fill: "#fff"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237558",
    "data-name": "Path 237558",
    d: "M144,179v81.111h-1.03V180.024h-4v80.081h-1.03V179Z",
    transform: "translate(722.979 -19.361)",
    fill: "#515255"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24091",
    "data-name": "Rectangle 24091",
    width: 5.325,
    height: 80.596,
    transform: "translate(856.112 160.149)",
    fill: "#fff"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237559",
    "data-name": "Path 237559",
    d: "M149.931,179v81.111H148.9V180.024h-4.294v80.081h-1.029V179Z",
    transform: "translate(712.021 -19.361)",
    fill: "#515255"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24092",
    "data-name": "Rectangle 24092",
    width: 21.371,
    height: 68.652,
    transform: "translate(716.124 172.093)",
    fill: "#fff"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237560",
    "data-name": "Path 237560",
    d: "M304.952,192.388v69.166h-1.029V193.417H283.581v68.137h-1.029V192.388Z",
    transform: "translate(433.058 -20.81)",
    fill: "#515255"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24093",
    "data-name": "Rectangle 24093",
    width: 21.37,
    height: 68.652,
    transform: "translate(694.754 172.093)",
    fill: "#fff"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237561",
    "data-name": "Path 237561",
    d: "M328.914,192.388v69.166h-1.03V193.417h-20.34v68.137h-1.03V192.388Z",
    transform: "translate(387.726 -20.81)",
    fill: "#515255"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84176",
    "data-name": "Group 84176",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84175",
    "data-name": "Group 84175",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84150",
    "data-name": "Group 84150",
    transform: "translate(694.236 180.384)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84149",
    "data-name": "Group 84149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84148",
    "data-name": "Group 84148",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24094",
    "data-name": "Rectangle 24094",
    width: 42.741,
    height: 3.623,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237562",
    "data-name": "Path 237562",
    d: "M282.552,206.914h43.77v-4.653h-43.77Zm42.74-1.029H283.581v-2.593h41.711Z",
    transform: "translate(-282.552 -202.261)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84153",
    "data-name": "Group 84153",
    transform: "translate(694.236 187.69)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84152",
    "data-name": "Group 84152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84151",
    "data-name": "Group 84151",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24096",
    "data-name": "Rectangle 24096",
    width: 42.741,
    height: 3.623,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237563",
    "data-name": "Path 237563",
    d: "M282.552,215.106h43.77v-4.653h-43.77Zm42.74-1.029H283.581v-2.593h41.711Z",
    transform: "translate(-282.552 -210.453)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84156",
    "data-name": "Group 84156",
    transform: "translate(694.236 194.996)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84155",
    "data-name": "Group 84155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84154",
    "data-name": "Group 84154",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24098",
    "data-name": "Rectangle 24098",
    width: 42.741,
    height: 3.623,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237564",
    "data-name": "Path 237564",
    d: "M282.552,223.3h43.77v-4.653h-43.77Zm42.74-1.029H283.581v-2.593h41.711Z",
    transform: "translate(-282.552 -218.645)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84159",
    "data-name": "Group 84159",
    transform: "translate(694.236 202.301)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84158",
    "data-name": "Group 84158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84157",
    "data-name": "Group 84157",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24100",
    "data-name": "Rectangle 24100",
    width: 42.741,
    height: 3.623,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237565",
    "data-name": "Path 237565",
    d: "M282.552,231.49h43.77v-4.653h-43.77Zm42.74-1.029H283.581v-2.593h41.711Z",
    transform: "translate(-282.552 -226.837)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84162",
    "data-name": "Group 84162",
    transform: "translate(694.236 209.607)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84161",
    "data-name": "Group 84161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84160",
    "data-name": "Group 84160",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24102",
    "data-name": "Rectangle 24102",
    width: 42.741,
    height: 3.623,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237566",
    "data-name": "Path 237566",
    d: "M282.552,239.682h43.77v-4.653h-43.77Zm42.74-1.03H283.581v-2.593h41.711Z",
    transform: "translate(-282.552 -235.029)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84165",
    "data-name": "Group 84165",
    transform: "translate(694.236 216.913)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84164",
    "data-name": "Group 84164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84163",
    "data-name": "Group 84163",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24104",
    "data-name": "Rectangle 24104",
    width: 42.741,
    height: 3.623,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237567",
    "data-name": "Path 237567",
    d: "M282.552,247.874h43.77v-4.653h-43.77Zm42.74-1.03H283.581V244.25h41.711Z",
    transform: "translate(-282.552 -243.221)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84168",
    "data-name": "Group 84168",
    transform: "translate(694.236 224.219)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84167",
    "data-name": "Group 84167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84166",
    "data-name": "Group 84166",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24106",
    "data-name": "Rectangle 24106",
    width: 42.741,
    height: 3.623,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237568",
    "data-name": "Path 237568",
    d: "M282.552,256.066h43.77v-4.653h-43.77Zm42.74-1.03H283.581v-2.593h41.711Z",
    transform: "translate(-282.552 -251.413)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84171",
    "data-name": "Group 84171",
    transform: "translate(694.236 231.525)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84170",
    "data-name": "Group 84170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84169",
    "data-name": "Group 84169",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24108",
    "data-name": "Rectangle 24108",
    width: 42.741,
    height: 3.623,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237569",
    "data-name": "Path 237569",
    d: "M282.552,264.258h43.77V259.6h-43.77Zm42.74-1.03H283.581v-2.593h41.711Z",
    transform: "translate(-282.552 -259.605)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84174",
    "data-name": "Group 84174",
    transform: "translate(694.236 238.831)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84173",
    "data-name": "Group 84173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84172",
    "data-name": "Group 84172",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24110",
    "data-name": "Rectangle 24110",
    width: 42.741,
    height: 1.399,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237570",
    "data-name": "Path 237570",
    d: "M325.293,268.827H283.582v.884h-1.03V267.8h43.771v1.914h-1.03Z",
    transform: "translate(-282.552 -267.797)",
    fill: "#515255"
  }))))))), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237571",
    "data-name": "Path 237571",
    d: "M258.428,129.306V254.731H196.445V189.878h15.075V129.306Z",
    transform: "translate(556.375 -13.986)",
    fill: "#fff"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237572",
    "data-name": "Path 237572",
    d: "M258.88,128.728v125.94h-1.03V129.759H211.971v60.573H196.9v64.337h-1.028V189.3h15.075V128.728Z",
    transform: "translate(556.439 -13.924)",
    fill: "#515255"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237573",
    "data-name": "Path 237573",
    d: "M236.13,129.306V254.731H196.445V189.878h15.075V129.306Z",
    transform: "translate(578.674 -13.986)",
    fill: "#fff"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237574",
    "data-name": "Path 237574",
    d: "M236.582,128.728v125.94h-1.03V129.759h-23.58v60.573H196.9v64.337h-1.029V189.3h15.075V128.728Z",
    transform: "translate(578.737 -13.924)",
    fill: "#515255"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24113",
    "data-name": "Rectangle 24113",
    width: 19.145,
    height: 56.31,
    transform: "translate(769.278 119.582)",
    fill: "#fff"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237575",
    "data-name": "Path 237575",
    d: "M225.448,190.848h20.175V133.507H225.448Zm19.145-1.029H226.477V134.537h18.116Z",
    transform: "translate(543.314 -14.441)",
    fill: "#515255"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24114",
    "data-name": "Rectangle 24114",
    width: 17.939,
    height: 61.495,
    transform: "translate(754.83 179.25)",
    fill: "#fff"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237576",
    "data-name": "Path 237576",
    d: "M261.968,200.413v62.008h-1.03V201.444H244.029v60.978H243V200.413Z",
    transform: "translate(511.316 -21.678)",
    fill: "#515255"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24115",
    "data-name": "Rectangle 24115",
    width: 12.814,
    height: 61.495,
    transform: "translate(777.556 179.25)",
    fill: "#fff"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237577",
    "data-name": "Path 237577",
    d: "M237.108,200.413v62.008h-1.03V201.444H224.294v60.978h-1.029V200.413Z",
    transform: "translate(553.777 -21.678)",
    fill: "#515255"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24116",
    "data-name": "Rectangle 24116",
    width: 19.145,
    height: 121.164,
    transform: "translate(792.933 119.581)",
    fill: "#fff"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237578",
    "data-name": "Path 237578",
    d: "M219.1,133.507V255.186h-1.03V134.538H199.953V255.186h-1.029V133.507Z",
    transform: "translate(593.495 -14.441)",
    fill: "#515255"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84181",
    "data-name": "Group 84181",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84180",
    "data-name": "Group 84180",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84179",
    "data-name": "Group 84179",
    transform: "translate(754.827 122)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84178",
    "data-name": "Group 84178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84177",
    "data-name": "Group 84177",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24117",
    "data-name": "Rectangle 24117",
    width: 19.146,
    height: 1.814,
    transform: "translate(38.102)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24118",
    "data-name": "Rectangle 24118",
    width: 19.145,
    height: 1.814,
    transform: "translate(14.448)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24119",
    "data-name": "Rectangle 24119",
    width: 19.146,
    height: 1.814,
    transform: "translate(38.102 5.19)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24120",
    "data-name": "Rectangle 24120",
    width: 19.145,
    height: 1.814,
    transform: "translate(14.448 5.19)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24121",
    "data-name": "Rectangle 24121",
    width: 19.146,
    height: 1.814,
    transform: "translate(38.102 10.381)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24122",
    "data-name": "Rectangle 24122",
    width: 19.145,
    height: 1.814,
    transform: "translate(14.448 10.381)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24123",
    "data-name": "Rectangle 24123",
    width: 19.146,
    height: 1.802,
    transform: "translate(38.102 15.583)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24124",
    "data-name": "Rectangle 24124",
    width: 19.145,
    height: 1.802,
    transform: "translate(14.448 15.583)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24125",
    "data-name": "Rectangle 24125",
    width: 19.146,
    height: 1.802,
    transform: "translate(38.102 20.774)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24126",
    "data-name": "Rectangle 24126",
    width: 19.145,
    height: 1.802,
    transform: "translate(14.448 20.774)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24127",
    "data-name": "Rectangle 24127",
    width: 19.146,
    height: 1.802,
    transform: "translate(38.102 25.965)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24128",
    "data-name": "Rectangle 24128",
    width: 19.145,
    height: 1.802,
    transform: "translate(14.448 25.965)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24129",
    "data-name": "Rectangle 24129",
    width: 19.146,
    height: 1.802,
    transform: "translate(38.102 31.155)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24130",
    "data-name": "Rectangle 24130",
    width: 19.145,
    height: 1.802,
    transform: "translate(14.448 31.155)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24131",
    "data-name": "Rectangle 24131",
    width: 19.146,
    height: 1.802,
    transform: "translate(38.102 36.346)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24132",
    "data-name": "Rectangle 24132",
    width: 19.145,
    height: 1.802,
    transform: "translate(14.448 36.346)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24133",
    "data-name": "Rectangle 24133",
    width: 19.146,
    height: 1.802,
    transform: "translate(38.102 41.537)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24134",
    "data-name": "Rectangle 24134",
    width: 19.145,
    height: 1.802,
    transform: "translate(14.448 41.537)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24135",
    "data-name": "Rectangle 24135",
    width: 19.146,
    height: 1.802,
    transform: "translate(38.102 46.728)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24136",
    "data-name": "Rectangle 24136",
    width: 19.145,
    height: 1.802,
    transform: "translate(14.448 46.728)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24137",
    "data-name": "Rectangle 24137",
    width: 19.145,
    height: 1.802,
    transform: "translate(14.448 51.918)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24138",
    "data-name": "Rectangle 24138",
    width: 19.146,
    height: 1.802,
    transform: "translate(38.102 51.918)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24139",
    "data-name": "Rectangle 24139",
    width: 19.146,
    height: 1.802,
    transform: "translate(38.102 58.825)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24140",
    "data-name": "Rectangle 24140",
    width: 12.814,
    height: 1.802,
    transform: "translate(22.726 58.825)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24141",
    "data-name": "Rectangle 24141",
    width: 17.939,
    height: 1.802,
    transform: "translate(0 58.825)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24142",
    "data-name": "Rectangle 24142",
    width: 19.146,
    height: 1.802,
    transform: "translate(38.102 64.015)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24143",
    "data-name": "Rectangle 24143",
    width: 12.814,
    height: 1.802,
    transform: "translate(22.726 64.015)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24144",
    "data-name": "Rectangle 24144",
    width: 17.939,
    height: 1.802,
    transform: "translate(0 64.015)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24145",
    "data-name": "Rectangle 24145",
    width: 19.146,
    height: 1.802,
    transform: "translate(38.102 69.206)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24146",
    "data-name": "Rectangle 24146",
    width: 12.814,
    height: 1.802,
    transform: "translate(22.726 69.206)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24147",
    "data-name": "Rectangle 24147",
    width: 17.939,
    height: 1.802,
    transform: "translate(0 69.206)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24148",
    "data-name": "Rectangle 24148",
    width: 19.146,
    height: 1.802,
    transform: "translate(38.102 74.397)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24149",
    "data-name": "Rectangle 24149",
    width: 12.814,
    height: 1.802,
    transform: "translate(22.726 74.397)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24150",
    "data-name": "Rectangle 24150",
    width: 17.939,
    height: 1.802,
    transform: "translate(0 74.397)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24151",
    "data-name": "Rectangle 24151",
    width: 19.146,
    height: 1.802,
    transform: "translate(38.102 79.587)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24152",
    "data-name": "Rectangle 24152",
    width: 12.814,
    height: 1.802,
    transform: "translate(22.726 79.587)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24153",
    "data-name": "Rectangle 24153",
    width: 17.939,
    height: 1.802,
    transform: "translate(0 79.587)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24154",
    "data-name": "Rectangle 24154",
    width: 19.146,
    height: 1.814,
    transform: "translate(38.102 84.778)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24155",
    "data-name": "Rectangle 24155",
    width: 12.814,
    height: 1.814,
    transform: "translate(22.726 84.778)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24156",
    "data-name": "Rectangle 24156",
    width: 17.939,
    height: 1.814,
    transform: "translate(0 84.778)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24157",
    "data-name": "Rectangle 24157",
    width: 19.146,
    height: 1.814,
    transform: "translate(38.102 89.969)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24158",
    "data-name": "Rectangle 24158",
    width: 12.814,
    height: 1.814,
    transform: "translate(22.726 89.969)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24159",
    "data-name": "Rectangle 24159",
    width: 17.939,
    height: 1.814,
    transform: "translate(0 89.969)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24160",
    "data-name": "Rectangle 24160",
    width: 19.146,
    height: 1.814,
    transform: "translate(38.102 95.16)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24161",
    "data-name": "Rectangle 24161",
    width: 12.814,
    height: 1.814,
    transform: "translate(22.726 95.16)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24162",
    "data-name": "Rectangle 24162",
    width: 17.939,
    height: 1.814,
    transform: "translate(0 95.16)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24163",
    "data-name": "Rectangle 24163",
    width: 19.146,
    height: 1.814,
    transform: "translate(38.102 100.35)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24164",
    "data-name": "Rectangle 24164",
    width: 12.814,
    height: 1.814,
    transform: "translate(22.726 100.35)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24165",
    "data-name": "Rectangle 24165",
    width: 17.939,
    height: 1.814,
    transform: "translate(0 100.35)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24166",
    "data-name": "Rectangle 24166",
    width: 19.146,
    height: 1.814,
    transform: "translate(38.102 105.541)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24167",
    "data-name": "Rectangle 24167",
    width: 12.814,
    height: 1.814,
    transform: "translate(22.726 105.541)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24168",
    "data-name": "Rectangle 24168",
    width: 17.939,
    height: 1.814,
    transform: "translate(0 105.541)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24169",
    "data-name": "Rectangle 24169",
    width: 19.146,
    height: 1.814,
    transform: "translate(38.102 110.732)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24170",
    "data-name": "Rectangle 24170",
    width: 12.814,
    height: 1.814,
    transform: "translate(22.726 110.732)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24171",
    "data-name": "Rectangle 24171",
    width: 17.939,
    height: 1.814,
    transform: "translate(0 110.732)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24172",
    "data-name": "Rectangle 24172",
    width: 19.146,
    height: 1.814,
    transform: "translate(38.102 115.923)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24173",
    "data-name": "Rectangle 24173",
    width: 12.814,
    height: 1.814,
    transform: "translate(22.726 115.923)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24174",
    "data-name": "Rectangle 24174",
    width: 17.939,
    height: 1.814,
    transform: "translate(0 115.923)",
    fill: "#515255"
  }))))))), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24177",
    "data-name": "Rectangle 24177",
    width: 29.008,
    height: 43.635,
    transform: "translate(635.962 197.11)",
    fill: "#fff"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237579",
    "data-name": "Path 237579",
    d: "M393.911,220.438v44.15h-1.03v-43.12H364.9v43.12h-1.03v-44.15Z",
    transform: "translate(271.574 -23.844)",
    fill: "#515255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_84189",
    "data-name": "Group 84189",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84188",
    "data-name": "Group 84188",
    clipPath: "url(#clip-path-3)"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84184",
    "data-name": "Group 84184",
    transform: "translate(635.444 199.718)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84183",
    "data-name": "Group 84183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84182",
    "data-name": "Group 84182",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24178",
    "data-name": "Rectangle 24178",
    width: 29.008,
    height: 0.903,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24179",
    "data-name": "Rectangle 24179",
    width: 30.037,
    height: 1.932,
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24180",
    "data-name": "Rectangle 24180",
    width: 29.008,
    height: 0.903,
    transform: "translate(0.515 4.522)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24181",
    "data-name": "Rectangle 24181",
    width: 30.037,
    height: 1.933,
    transform: "translate(0 4.007)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24182",
    "data-name": "Rectangle 24182",
    width: 29.008,
    height: 0.903,
    transform: "translate(0.515 8.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24183",
    "data-name": "Rectangle 24183",
    width: 30.037,
    height: 1.932,
    transform: "translate(0 8.016)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24184",
    "data-name": "Rectangle 24184",
    width: 29.008,
    height: 0.903,
    transform: "translate(0.515 12.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24185",
    "data-name": "Rectangle 24185",
    width: 30.037,
    height: 1.933,
    transform: "translate(0 12.023)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24186",
    "data-name": "Rectangle 24186",
    width: 29.008,
    height: 0.903,
    transform: "translate(0.515 16.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24187",
    "data-name": "Rectangle 24187",
    width: 30.037,
    height: 1.932,
    transform: "translate(0 16.031)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24188",
    "data-name": "Rectangle 24188",
    width: 29.008,
    height: 0.903,
    transform: "translate(0.515 20.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24189",
    "data-name": "Rectangle 24189",
    width: 30.037,
    height: 1.933,
    transform: "translate(0 20.038)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24190",
    "data-name": "Rectangle 24190",
    width: 29.008,
    height: 0.903,
    transform: "translate(0.515 24.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24191",
    "data-name": "Rectangle 24191",
    width: 30.037,
    height: 1.933,
    transform: "translate(0 24.045)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24192",
    "data-name": "Rectangle 24192",
    width: 29.008,
    height: 0.903,
    transform: "translate(0.515 28.568)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24193",
    "data-name": "Rectangle 24193",
    width: 30.037,
    height: 1.932,
    transform: "translate(0 28.054)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24194",
    "data-name": "Rectangle 24194",
    width: 29.008,
    height: 0.903,
    transform: "translate(0.515 32.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24195",
    "data-name": "Rectangle 24195",
    width: 30.037,
    height: 1.933,
    transform: "translate(0 32.061)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24196",
    "data-name": "Rectangle 24196",
    width: 29.008,
    height: 0.903,
    transform: "translate(0.515 36.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24197",
    "data-name": "Rectangle 24197",
    width: 30.037,
    height: 1.932,
    transform: "translate(0 36.068)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24198",
    "data-name": "Rectangle 24198",
    width: 29.008,
    height: 0.437,
    transform: "translate(0.515 40.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24199",
    "data-name": "Rectangle 24199",
    width: 30.037,
    height: 0.952,
    transform: "translate(0 40.076)",
    fill: "#515255"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84187",
    "data-name": "Group 84187",
    transform: "translate(635.444 196.595)",
    opacity: 0.36,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84186",
    "data-name": "Group 84186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84185",
    "data-name": "Group 84185",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24201",
    "data-name": "Rectangle 24201",
    width: 9.186,
    height: 43.635,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237580",
    "data-name": "Path 237580",
    d: "M395.284,221.468h-8.156v43.12H386.1v-44.15h10.216v44.15h-1.03Z",
    transform: "translate(-386.098 -220.438)",
    fill: "#515255"
  }))))))), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24204",
    "data-name": "Rectangle 24204",
    width: 32.597,
    height: 27.536,
    transform: "translate(598.621 213.208)",
    fill: "#fff"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237581",
    "data-name": "Path 237581",
    d: "M435.344,238.489v28.052h-1.03V239.519H402.746v27.022h-1.029V238.489Z",
    transform: "translate(196.39 -25.796)",
    fill: "#515255"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24205",
    "data-name": "Rectangle 24205",
    width: 35.755,
    height: 19.595,
    transform: "translate(598.622 221.15)",
    fill: "#fff"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237582",
    "data-name": "Path 237582",
    d: "M434.962,247.4V267.5h-1.03V248.425H399.206V267.5h-1.03V247.4Z",
    transform: "translate(199.931 -26.759)",
    fill: "#515255"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84206",
    "data-name": "Group 84206",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84205",
    "data-name": "Group 84205",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84204",
    "data-name": "Group 84204",
    transform: "translate(598.103 223.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84203",
    "data-name": "Group 84203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84202",
    "data-name": "Group 84202",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84192",
    "data-name": "Group 84192",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84191",
    "data-name": "Group 84191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84190",
    "data-name": "Group 84190",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24206",
    "data-name": "Rectangle 24206",
    width: 35.755,
    height: 2.939,
    transform: "translate(0.515 0.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237583",
    "data-name": "Path 237583",
    d: "M398.176,254.392h36.786v-3.969H398.176Zm35.755-1.03H399.205v-1.909h34.726Z",
    transform: "translate(-398.176 -250.423)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84195",
    "data-name": "Group 84195",
    transform: "translate(0 5.577)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84194",
    "data-name": "Group 84194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84193",
    "data-name": "Group 84193",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24208",
    "data-name": "Rectangle 24208",
    width: 35.755,
    height: 2.939,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237584",
    "data-name": "Path 237584",
    d: "M398.176,260.645h36.786v-3.969H398.176Zm35.755-1.03H399.205v-1.909h34.726Z",
    transform: "translate(-398.176 -256.676)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84198",
    "data-name": "Group 84198",
    transform: "translate(0 11.154)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84197",
    "data-name": "Group 84197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84196",
    "data-name": "Group 84196",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24210",
    "data-name": "Rectangle 24210",
    width: 35.755,
    height: 2.939,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237585",
    "data-name": "Path 237585",
    d: "M398.176,266.9h36.786v-3.969H398.176Zm35.755-1.029H399.205v-1.909h34.726Z",
    transform: "translate(-398.176 -262.929)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84201",
    "data-name": "Group 84201",
    transform: "translate(0 16.73)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84200",
    "data-name": "Group 84200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84199",
    "data-name": "Group 84199",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24212",
    "data-name": "Rectangle 24212",
    width: 35.755,
    height: 0.163,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24213",
    "data-name": "Rectangle 24213",
    width: 36.786,
    height: 0.679,
    transform: "translate(0 0)",
    fill: "#515255"
  })))))))))), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24217",
    "data-name": "Rectangle 24217",
    width: 3.158,
    height: 7.943,
    transform: "translate(631.22 213.207)",
    fill: "#fff"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237586",
    "data-name": "Path 237586",
    d: "M398.176,247.462h4.188V238.49h-4.188Zm3.158-1.03h-2.129v-6.913h2.129Z",
    transform: "translate(232.528 -25.796)",
    fill: "#515255"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24218",
    "data-name": "Rectangle 24218",
    width: 29.672,
    height: 27.536,
    transform: "translate(618.828 213.208)",
    fill: "#fff"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237587",
    "data-name": "Path 237587",
    d: "M413.043,238.489v28.052h-1.03V239.519H383.37v27.022h-1.03V238.489Z",
    transform: "translate(235.973 -25.796)",
    fill: "#515255"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84220",
    "data-name": "Group 84220",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84219",
    "data-name": "Group 84219",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84218",
    "data-name": "Group 84218",
    transform: "translate(614.588 228.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84217",
    "data-name": "Group 84217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84216",
    "data-name": "Group 84216",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84209",
    "data-name": "Group 84209",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84208",
    "data-name": "Group 84208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84207",
    "data-name": "Group 84207",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24219",
    "data-name": "Rectangle 24219",
    width: 33.394,
    height: 2.939,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237588",
    "data-name": "Path 237588",
    d: "M382.341,260.645h34.423v-3.969H382.341Zm33.394-1.03H383.371v-1.909h32.364Z",
    transform: "translate(-382.341 -256.676)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84212",
    "data-name": "Group 84212",
    transform: "translate(0 5.577)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84211",
    "data-name": "Group 84211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84210",
    "data-name": "Group 84210",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24221",
    "data-name": "Rectangle 24221",
    width: 33.394,
    height: 2.939,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237589",
    "data-name": "Path 237589",
    d: "M382.341,266.9h34.423v-3.969H382.341Zm33.394-1.029H383.371v-1.909h32.364Z",
    transform: "translate(-382.341 -262.929)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84215",
    "data-name": "Group 84215",
    transform: "translate(0 11.154)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84214",
    "data-name": "Group 84214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84213",
    "data-name": "Group 84213",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24223",
    "data-name": "Rectangle 24223",
    width: 33.394,
    height: 0.163,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24224",
    "data-name": "Rectangle 24224",
    width: 34.423,
    height: 0.678,
    transform: "translate(0 0)",
    fill: "#515255"
  })))))))))), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24228",
    "data-name": "Rectangle 24228",
    width: 3.158,
    height: 27.536,
    transform: "translate(645.342 213.208)",
    fill: "#fff"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237590",
    "data-name": "Path 237590",
    d: "M386.528,238.489v28.052H385.5V239.519h-2.129v27.022H382.34V238.489Z",
    transform: "translate(262.488 -25.796)",
    fill: "#515255"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84225",
    "data-name": "Group 84225",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84224",
    "data-name": "Group 84224",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84223",
    "data-name": "Group 84223",
    transform: "translate(614.588 212.693)",
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84222",
    "data-name": "Group 84222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84221",
    "data-name": "Group 84221",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24229",
    "data-name": "Rectangle 24229",
    width: 3.721,
    height: 27.536,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237591",
    "data-name": "Path 237591",
    d: "M419.332,239.519h-2.691v27.022h-1.03V238.489h4.751v28.052h-1.03Z",
    transform: "translate(-415.611 -238.489)",
    fill: "#515255"
  }))))))), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24232",
    "data-name": "Rectangle 24232",
    width: 28.895,
    height: 22.381,
    transform: "translate(688.891 218.363)",
    fill: "#fff"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237592",
    "data-name": "Path 237592",
    d: "M334.576,244.269v22.9h-1.03V245.3H305.68v21.867h-1.03v-22.9Z",
    transform: "translate(383.726 -26.421)",
    fill: "#515255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_84230",
    "data-name": "Group 84230",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84229",
    "data-name": "Group 84229",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84228",
    "data-name": "Group 84228",
    transform: "translate(694.236 217.56)",
    opacity: 0.77,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84227",
    "data-name": "Group 84227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84226",
    "data-name": "Group 84226",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24233",
    "data-name": "Rectangle 24233",
    width: 31.719,
    height: 22.67,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237593",
    "data-name": "Path 237593",
    d: "M326.63,244.977H295.941v22.155h-1.03V243.947H327.66v23.185h-1.03Z",
    transform: "translate(-294.911 -243.947)",
    fill: "#515255"
  }))))))), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24236",
    "data-name": "Rectangle 24236",
    width: 19.473,
    height: 8.866,
    transform: "translate(699.466 231.879)",
    fill: "#fff"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237594",
    "data-name": "Path 237594",
    d: "M323.863,259.424V268.8h-1.03v-8.351H304.389V268.8h-1.03v-9.381Z",
    transform: "translate(395.591 -28.06)",
    fill: "#515255"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24237",
    "data-name": "Rectangle 24237",
    width: 2.303,
    height: 8.866,
    transform: "translate(699.466 231.879)",
    fill: "#fff"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237595",
    "data-name": "Path 237595",
    d: "M325.945,259.424V268.8h-1.03v-8.351h-1.273V268.8h-1.03v-9.381Z",
    transform: "translate(376.339 -28.06)",
    fill: "#515255"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24238",
    "data-name": "Rectangle 24238",
    width: 13.61,
    height: 15.501,
    transform: "translate(675.281 225.244)",
    fill: "#fff"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237596",
    "data-name": "Path 237596",
    d: "M351.69,251.984V268h-1.03V253.014H338.081V268h-1.03V251.984Z",
    transform: "translate(337.716 -27.256)",
    fill: "#515255"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24239",
    "data-name": "Rectangle 24239",
    width: 17.302,
    height: 23.379,
    transform: "translate(814.804 217.365)",
    fill: "#fff"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237597",
    "data-name": "Path 237597",
    d: "M194.8,243.151v23.894h-1.03V244.181H177.5v22.864h-1.029V243.151Z",
    transform: "translate(637.822 -26.3)",
    fill: "#515255"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84244",
    "data-name": "Group 84244",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84243",
    "data-name": "Group 84243",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84233",
    "data-name": "Group 84233",
    transform: "translate(814.8 222.766)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84232",
    "data-name": "Group 84232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84231",
    "data-name": "Group 84231",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24240",
    "data-name": "Rectangle 24240",
    width: 11.551,
    height: 2.206,
    transform: "translate(0.001 0.001)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84236",
    "data-name": "Group 84236",
    transform: "translate(814.8 227.541)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84235",
    "data-name": "Group 84235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84234",
    "data-name": "Group 84234",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24242",
    "data-name": "Rectangle 24242",
    width: 11.551,
    height: 2.206,
    transform: "translate(0.001 0.001)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84239",
    "data-name": "Group 84239",
    transform: "translate(814.8 232.317)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84238",
    "data-name": "Group 84238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84237",
    "data-name": "Group 84237",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24244",
    "data-name": "Rectangle 24244",
    width: 11.551,
    height: 2.206,
    transform: "translate(0.001 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84242",
    "data-name": "Group 84242",
    transform: "translate(814.8 237.092)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84241",
    "data-name": "Group 84241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84240",
    "data-name": "Group 84240",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24246",
    "data-name": "Rectangle 24246",
    width: 11.551,
    height: 2.206,
    transform: "translate(0.001 0)",
    fill: "#515255"
  }))))))), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24249",
    "data-name": "Rectangle 24249",
    width: 20.914,
    height: 11.394,
    transform: "translate(624.4 229.351)",
    fill: "#515255"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24250",
    "data-name": "Rectangle 24250",
    width: 17.022,
    height: 11.394,
    transform: "translate(643.324 229.351)",
    fill: "#515255"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84249",
    "data-name": "Group 84249",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84248",
    "data-name": "Group 84248",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84247",
    "data-name": "Group 84247",
    transform: "translate(624.396 231.142)",
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84246",
    "data-name": "Group 84246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84245",
    "data-name": "Group 84245",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24251",
    "data-name": "Rectangle 24251",
    width: 35.944,
    height: 1.879,
    transform: "translate(0 0)",
    fill: "#86e9b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24252",
    "data-name": "Rectangle 24252",
    width: 35.944,
    height: 1.879,
    transform: "translate(0 3.672)",
    fill: "#86e9b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24253",
    "data-name": "Rectangle 24253",
    width: 35.944,
    height: 1.879,
    transform: "translate(0 7.343)",
    fill: "#86e9b9"
  }))))))), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24256",
    "data-name": "Rectangle 24256",
    width: 1.938,
    height: 11.394,
    transform: "translate(658.407 229.351)",
    fill: "#fff"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237598",
    "data-name": "Path 237598",
    d: "M372.026,256.589V268.5H371V257.619h-.908V268.5h-1.029v-11.91Z",
    transform: "translate(288.833 -27.754)",
    fill: "#515255"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24257",
    "data-name": "Rectangle 24257",
    width: 1.938,
    height: 11.394,
    transform: "translate(643.324 229.351)",
    fill: "#fff"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237599",
    "data-name": "Path 237599",
    d: "M388.939,256.589V268.5h-1.03V257.619H387V268.5h-1.029v-11.91Z",
    transform: "translate(256.837 -27.754)",
    fill: "#515255"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24258",
    "data-name": "Rectangle 24258",
    width: 1.938,
    height: 11.394,
    transform: "translate(641.403 229.351)",
    fill: "#fff"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237600",
    "data-name": "Path 237600",
    d: "M391.093,256.589V268.5h-1.03V257.619h-.908V268.5h-1.03v-11.91Z",
    transform: "translate(252.763 -27.754)",
    fill: "#515255"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24259",
    "data-name": "Rectangle 24259",
    width: 1.939,
    height: 11.394,
    transform: "translate(624.4 229.351)",
    fill: "#fff"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237601",
    "data-name": "Path 237601",
    d: "M410.158,256.589V268.5h-1.03V257.619h-.908V268.5h-1.03v-11.91Z",
    transform: "translate(216.696 -27.754)",
    fill: "#515255"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24260",
    "data-name": "Rectangle 24260",
    width: 17.004,
    height: 1.792,
    transform: "translate(643.341 229.351)",
    fill: "#fff"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237602",
    "data-name": "Path 237602",
    d: "M369.059,259.411h18.034v-2.822H369.059Zm17-1.03H370.089v-.763h15.974Z",
    transform: "translate(273.767 -27.754)",
    fill: "#515255"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24261",
    "data-name": "Rectangle 24261",
    width: 17.004,
    height: 1.792,
    transform: "translate(624.812 229.351)",
    fill: "#fff"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237603",
    "data-name": "Path 237603",
    d: "M389.835,259.411h18.034v-2.822H389.835Zm17-1.03H390.865v-.763h15.974Z",
    transform: "translate(234.462 -27.754)",
    fill: "#515255"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24262",
    "data-name": "Rectangle 24262",
    width: 12.612,
    height: 3.121,
    transform: "translate(642.578 226.29)",
    fill: "#fff"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237604",
    "data-name": "Path 237604",
    d: "M374.838,257.309H388.48v-4.152H374.838Zm12.612-1.029H375.867v-2.091H387.45Z",
    transform: "translate(267.226 -27.383)",
    fill: "#515255"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24263",
    "data-name": "Rectangle 24263",
    width: 12.612,
    height: 3.121,
    transform: "translate(629.966 226.29)",
    fill: "#fff"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237605",
    "data-name": "Path 237605",
    d: "M388.98,257.309h13.642v-4.152H388.98Zm12.612-1.029H390.01v-2.091h11.582Z",
    transform: "translate(240.471 -27.383)",
    fill: "#515255"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24264",
    "data-name": "Rectangle 24264",
    width: 24.653,
    height: 25.381,
    transform: "translate(680.373 215.364)",
    fill: "#fff"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237606",
    "data-name": "Path 237606",
    d: "M344.64,240.907v25.9h-1.03V241.937H319.988V266.8h-1.029v-25.9Z",
    transform: "translate(360.9 -26.058)",
    fill: "#515255"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24265",
    "data-name": "Rectangle 24265",
    width: 20.064,
    height: 25.381,
    transform: "translate(702.68 215.364)",
    fill: "#fd930d"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84254",
    "data-name": "Group 84254",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84253",
    "data-name": "Group 84253",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84252",
    "data-name": "Group 84252",
    transform: "translate(680.371 217.476)",
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84251",
    "data-name": "Group 84251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84250",
    "data-name": "Group 84250",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24266",
    "data-name": "Rectangle 24266",
    width: 42.368,
    height: 2.215,
    transform: "translate(-0.001 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24267",
    "data-name": "Rectangle 24267",
    width: 42.368,
    height: 2.215,
    transform: "translate(-0.001 4.327)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24268",
    "data-name": "Rectangle 24268",
    width: 42.368,
    height: 2.215,
    transform: "translate(-0.001 8.656)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24269",
    "data-name": "Rectangle 24269",
    width: 42.368,
    height: 2.215,
    transform: "translate(-0.001 12.983)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24270",
    "data-name": "Rectangle 24270",
    width: 42.368,
    height: 2.215,
    transform: "translate(-0.001 17.311)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24271",
    "data-name": "Rectangle 24271",
    width: 42.368,
    height: 1.63,
    transform: "translate(0 21.638)",
    fill: "#515255"
  }))))))), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24274",
    "data-name": "Rectangle 24274",
    width: 2.284,
    height: 25.381,
    transform: "translate(720.46 215.364)",
    fill: "#fff"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237607",
    "data-name": "Path 237607",
    d: "M302.407,240.907v25.9h-1.03V241.937h-1.255V266.8h-1.029v-25.9Z",
    transform: "translate(420.852 -26.058)",
    fill: "#515255"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24275",
    "data-name": "Rectangle 24275",
    width: 2.284,
    height: 25.381,
    transform: "translate(702.68 215.364)",
    fill: "#fff"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237608",
    "data-name": "Path 237608",
    d: "M322.343,240.907v25.9h-1.03V241.937h-1.255V266.8h-1.03v-25.9Z",
    transform: "translate(383.136 -26.058)",
    fill: "#515255"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24276",
    "data-name": "Rectangle 24276",
    width: 2.284,
    height: 25.381,
    transform: "translate(700.417 215.364)",
    fill: "#fff"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237609",
    "data-name": "Path 237609",
    d: "M324.881,240.907v25.9h-1.029V241.937H322.6V266.8h-1.03v-25.9Z",
    transform: "translate(378.333 -26.058)",
    fill: "#515255"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24277",
    "data-name": "Rectangle 24277",
    width: 2.285,
    height: 25.381,
    transform: "translate(680.374 215.364)",
    fill: "#fff"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237610",
    "data-name": "Path 237610",
    d: "M347.353,240.907v25.9h-1.03V241.937h-1.254V266.8h-1.03v-25.9Z",
    transform: "translate(335.82 -26.058)",
    fill: "#515255"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24278",
    "data-name": "Rectangle 24278",
    width: 20.043,
    height: 2.113,
    transform: "translate(702.701 215.364)",
    fill: "#fff"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237611",
    "data-name": "Path 237611",
    d: "M299.093,244.049h21.073v-3.142H299.093Zm20.044-1.029H300.123v-1.083h19.014Z",
    transform: "translate(403.092 -26.058)",
    fill: "#515255"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24279",
    "data-name": "Rectangle 24279",
    width: 20.043,
    height: 2.113,
    transform: "translate(680.859 215.364)",
    fill: "#fff"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237612",
    "data-name": "Path 237612",
    d: "M323.582,244.049h21.073v-3.142H323.582Zm20.043-1.029H324.611v-1.083h19.014Z",
    transform: "translate(356.763 -26.058)",
    fill: "#515255"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24280",
    "data-name": "Rectangle 24280",
    width: 14.867,
    height: 3.68,
    transform: "translate(701.802 211.756)",
    fill: "#fff"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237613",
    "data-name": "Path 237613",
    d: "M305.9,241.571h15.9v-4.709H305.9Zm14.868-1.029H306.936v-2.65h13.837Z",
    transform: "translate(395.381 -25.62)",
    fill: "#515255"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24281",
    "data-name": "Rectangle 24281",
    width: 14.867,
    height: 3.68,
    transform: "translate(686.935 211.756)",
    fill: "#fff"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237614",
    "data-name": "Path 237614",
    d: "M322.574,241.571h15.9v-4.709h-15.9Zm14.866-1.029H323.6v-2.65H337.44Z",
    transform: "translate(363.846 -25.62)",
    fill: "#515255"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24282",
    "data-name": "Rectangle 24282",
    width: 17.008,
    height: 1.628,
    transform: "translate(712.999 239.116)",
    fill: "#fff"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237615",
    "data-name": "Path 237615",
    d: "M308.986,267.54v2.143h-1.03V268.57H291.978v1.113h-1.03V267.54Z",
    transform: "translate(421.536 -28.938)",
    fill: "#515255"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24283",
    "data-name": "Rectangle 24283",
    width: 11.333,
    height: 1.628,
    transform: "translate(728.265 239.116)",
    fill: "#fff"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237616",
    "data-name": "Path 237616",
    d: "M292.558,267.54v2.143h-1.03V268.57h-10.3v1.113h-1.03V267.54Z",
    transform: "translate(447.555 -28.938)",
    fill: "#515255"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84259",
    "data-name": "Group 84259",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84258",
    "data-name": "Group 84258",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84257",
    "data-name": "Group 84257",
    transform: "translate(712.996 240.685)",
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84256",
    "data-name": "Group 84256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84255",
    "data-name": "Group 84255",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24284",
    "data-name": "Rectangle 24284",
    width: 26.597,
    height: 0.06,
    transform: "translate(0 0)",
    fill: "#515255"
  }))))))), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24287",
    "data-name": "Rectangle 24287",
    width: 6.668,
    height: 1.62,
    transform: "translate(666.656 239.124)",
    fill: "#fff"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237617",
    "data-name": "Path 237617",
    d: "M362.2,267.548v2.136h-1.03v-1.106h-5.637v1.106h-1.03v-2.136Z",
    transform: "translate(311.635 -28.939)",
    fill: "#515255"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24288",
    "data-name": "Rectangle 24288",
    width: 6.667,
    height: 1.62,
    transform: "translate(659.989 239.124)",
    fill: "#fff"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237618",
    "data-name": "Path 237618",
    d: "M369.681,267.548v2.136h-1.03v-1.106h-5.638v1.106h-1.03v-2.136Z",
    transform: "translate(297.49 -28.939)",
    fill: "#515255"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237619",
    "data-name": "Path 237619",
    d: "M472.93,256.88h-54.5V152.559l54.5-3.389Z",
    transform: "translate(143.896 -16.135)",
    fill: "#fff"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237620",
    "data-name": "Path 237620",
    d: "M473.383,256.813h-1.03V149.652l-53.466,3.325V256.813h-1.03v-104.8l55.527-3.452Z",
    transform: "translate(143.958 -16.069)",
    fill: "#515255"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237621",
    "data-name": "Path 237621",
    d: "M469.312,256.922H424.8V152.333l44.508-2.767Z",
    transform: "translate(141.832 -16.178)",
    fill: "#fff"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237622",
    "data-name": "Path 237622",
    d: "M469.766,256.856h-1.03V150.048l-43.478,2.7v104.1h-1.03V151.784l45.538-2.832Z",
    transform: "translate(141.893 -16.111)",
    fill: "#515255"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237623",
    "data-name": "Path 237623",
    d: "M469.312,258.411H424.8V165.8l44.508-2.473Z",
    transform: "translate(141.832 -17.666)",
    fill: "#fff"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237624",
    "data-name": "Path 237624",
    d: "M469.766,258.345h-1.03V163.806l-43.478,2.416v92.123h-1.03v-93.1l45.538-2.531Z",
    transform: "translate(141.893 -17.6)",
    fill: "#515255"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237625",
    "data-name": "Path 237625",
    d: "M429.308,172.015l-4.5.229v-8.666l4.5-.251Z",
    transform: "translate(181.836 -17.666)",
    fill: "#515255"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237626",
    "data-name": "Path 237626",
    d: "M435.84,172.352l-4.475.227v-8.638l4.475-.249Z",
    transform: "translate(169.453 -17.706)",
    fill: "#515255"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237627",
    "data-name": "Path 237627",
    d: "M442.332,172.687l-4.448.227V164.3l4.448-.247Z",
    transform: "translate(157.147 -17.745)",
    fill: "#515255"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237628",
    "data-name": "Path 237628",
    d: "M448.783,173.021l-4.42.225V164.66l4.42-.246Z",
    transform: "translate(144.918 -17.784)",
    fill: "#515255"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237629",
    "data-name": "Path 237629",
    d: "M455.193,173.351l-4.392.224v-8.559l4.392-.244Z",
    transform: "translate(132.766 -17.823)",
    fill: "#515255"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237630",
    "data-name": "Path 237630",
    d: "M461.565,173.68l-4.366.222V165.37l4.366-.243Z",
    transform: "translate(120.689 -17.861)",
    fill: "#515255"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237631",
    "data-name": "Path 237631",
    d: "M467.9,174.007l-4.338.221v-8.506l4.338-.241Z",
    transform: "translate(108.688 -17.899)",
    fill: "#515255"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237632",
    "data-name": "Path 237632",
    d: "M474.187,174.332l-4.311.219v-8.48l4.311-.239Z",
    transform: "translate(96.76 -17.937)",
    fill: "#515255"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237633",
    "data-name": "Path 237633",
    d: "M429.308,161.158l-4.5.254v-2.579l4.5-.26Z",
    transform: "translate(181.836 -17.152)",
    fill: "#515255"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237634",
    "data-name": "Path 237634",
    d: "M435.84,161.529l-4.475.252V159.21l4.475-.259Z",
    transform: "translate(169.453 -17.193)",
    fill: "#515255"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237635",
    "data-name": "Path 237635",
    d: "M442.332,161.9l-4.448.251v-2.563l4.448-.258Z",
    transform: "translate(157.147 -17.234)",
    fill: "#515255"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237636",
    "data-name": "Path 237636",
    d: "M448.783,162.265l-4.42.25V159.96l4.42-.256Z",
    transform: "translate(144.918 -17.274)",
    fill: "#515255"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237637",
    "data-name": "Path 237637",
    d: "M455.193,162.629l-4.392.248V160.33l4.392-.254Z",
    transform: "translate(132.766 -17.315)",
    fill: "#515255"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237638",
    "data-name": "Path 237638",
    d: "M461.565,162.992l-4.366.246V160.7l4.366-.252Z",
    transform: "translate(120.689 -17.355)",
    fill: "#515255"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237639",
    "data-name": "Path 237639",
    d: "M467.9,163.352l-4.338.245v-2.532l4.338-.251Z",
    transform: "translate(108.688 -17.394)",
    fill: "#515255"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237640",
    "data-name": "Path 237640",
    d: "M474.187,163.71l-4.311.243v-2.524l4.311-.249Z",
    transform: "translate(96.76 -17.434)",
    fill: "#515255"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237641",
    "data-name": "Path 237641",
    d: "M426.646,259.715H424.8V175.48l1.842-.092Z",
    transform: "translate(184.498 -18.971)",
    fill: "#fd930d"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237642",
    "data-name": "Path 237642",
    d: "M430.139,259.734H428.3V175.653l1.835-.091Z",
    transform: "translate(177.884 -18.99)",
    fill: "#fd930d"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237643",
    "data-name": "Path 237643",
    d: "M433.619,259.753H431.79V175.827l1.829-.092Z",
    transform: "translate(171.295 -19.008)",
    fill: "#fd930d"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237644",
    "data-name": "Path 237644",
    d: "M437.089,259.772h-1.824V176l1.824-.091Z",
    transform: "translate(164.726 -19.027)",
    fill: "#fd930d"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237645",
    "data-name": "Path 237645",
    d: "M440.547,259.79h-1.818V176.172l1.818-.091Z",
    transform: "translate(158.179 -19.046)",
    fill: "#fd930d"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237646",
    "data-name": "Path 237646",
    d: "M443.992,259.809h-1.81V176.344l1.81-.091Z",
    transform: "translate(151.654 -19.064)",
    fill: "#fd930d"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237647",
    "data-name": "Path 237647",
    d: "M447.427,259.828h-1.805V176.515l1.805-.09Z",
    transform: "translate(145.152 -19.083)",
    fill: "#fd930d"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237648",
    "data-name": "Path 237648",
    d: "M450.85,259.846h-1.8V176.685l1.8-.09Z",
    transform: "translate(138.67 -19.101)",
    fill: "#fd930d"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237649",
    "data-name": "Path 237649",
    d: "M454.262,259.864h-1.793V176.855l1.793-.09Z",
    transform: "translate(132.21 -19.12)",
    fill: "#fd930d"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237650",
    "data-name": "Path 237650",
    d: "M457.662,259.883h-1.787V177.024l1.787-.089Z",
    transform: "translate(125.772 -19.138)",
    fill: "#fd930d"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237651",
    "data-name": "Path 237651",
    d: "M461.052,259.9H459.27V177.192l1.782-.088Z",
    transform: "translate(119.355 -19.156)",
    fill: "#fd930d"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237652",
    "data-name": "Path 237652",
    d: "M464.43,259.919h-1.776V177.361l1.776-.088Z",
    transform: "translate(112.959 -19.175)",
    fill: "#fd930d"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237653",
    "data-name": "Path 237653",
    d: "M467.8,259.937h-1.769V177.528l1.769-.088Z",
    transform: "translate(106.584 -19.193)",
    fill: "#fd930d"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237654",
    "data-name": "Path 237654",
    d: "M471.153,259.956h-1.764V177.7l1.764-.088Z",
    transform: "translate(100.23 -19.211)",
    fill: "#fd930d"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237655",
    "data-name": "Path 237655",
    d: "M474.5,259.974h-1.758V177.862l1.758-.087Z",
    transform: "translate(93.897 -19.229)",
    fill: "#fd930d"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237656",
    "data-name": "Path 237656",
    d: "M416.445,161.48v95.4h-16.39V149.17Z",
    transform: "translate(216.771 -16.135)",
    fill: "#fff"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237657",
    "data-name": "Path 237657",
    d: "M416.9,161.1v95.656h-1.03V161.613l-15.361-11.538V256.754h-1.03V148.015Z",
    transform: "translate(216.833 -16.01)",
    fill: "#515255"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237658",
    "data-name": "Path 237658",
    d: "M414.753,160.747v96.3H401.4V150.719Z",
    transform: "translate(217.264 -16.302)",
    fill: "#fff"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237659",
    "data-name": "Path 237659",
    d: "M415.2,160.364v96.558h-1.03V160.88l-12.321-9.255v105.3h-1.029V149.564Z",
    transform: "translate(217.327 -16.178)",
    fill: "#515255"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237660",
    "data-name": "Path 237660",
    d: "M414.753,173.32v85.2H401.4V164.359Z",
    transform: "translate(217.264 -17.778)",
    fill: "#fff"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237661",
    "data-name": "Path 237661",
    d: "M415.2,172.929v85.477h-1.03V173.478l-12.321-8.271v93.2h-1.029v-95.13Z",
    transform: "translate(217.327 -17.661)",
    fill: "#515255"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237662",
    "data-name": "Path 237662",
    d: "M416.2,173.851l-1.435-.882v-8.611l1.435.964Z",
    transform: "translate(203.904 -17.778)",
    fill: "#515255"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237663",
    "data-name": "Path 237663",
    d: "M414.115,175.125l-1.4-.861v-8.505l1.4.94Z",
    transform: "translate(207.811 -17.929)",
    fill: "#515255"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237664",
    "data-name": "Path 237664",
    d: "M412.084,176.368l-1.367-.84v-8.4l1.367.918Z",
    transform: "translate(211.624 -18.077)",
    fill: "#515255"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237665",
    "data-name": "Path 237665",
    d: "M410.1,177.582l-1.335-.82v-8.3l1.335.9Z",
    transform: "translate(215.348 -18.221)",
    fill: "#515255"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237666",
    "data-name": "Path 237666",
    d: "M408.164,178.768l-1.3-.8v-8.2l1.3.876Z",
    transform: "translate(218.984 -18.362)",
    fill: "#515255"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237667",
    "data-name": "Path 237667",
    d: "M406.272,179.926,405,179.143v-8.109l1.274.855Z",
    transform: "translate(222.536 -18.5)",
    fill: "#515255"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237668",
    "data-name": "Path 237668",
    d: "M404.424,181.058l-1.245-.765v-8.016l1.245.836Z",
    transform: "translate(226.006 -18.634)",
    fill: "#515255"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237669",
    "data-name": "Path 237669",
    d: "M402.617,182.165l-1.216-.748v-7.925l1.216.817Z",
    transform: "translate(229.399 -18.766)",
    fill: "#515255"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237670",
    "data-name": "Path 237670",
    d: "M416.2,163.186l-1.435-.978v-2.563l1.435,1Z",
    transform: "translate(203.904 -17.268)",
    fill: "#515255"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237671",
    "data-name": "Path 237671",
    d: "M414.115,164.589l-1.4-.955V161.1l1.4.978Z",
    transform: "translate(207.811 -17.426)",
    fill: "#515255"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237672",
    "data-name": "Path 237672",
    d: "M412.084,165.958l-1.367-.932v-2.5l1.367.956Z",
    transform: "translate(211.624 -17.579)",
    fill: "#515255"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237673",
    "data-name": "Path 237673",
    d: "M410.1,167.3l-1.335-.911v-2.47l1.335.932Z",
    transform: "translate(215.348 -17.73)",
    fill: "#515255"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237674",
    "data-name": "Path 237674",
    d: "M408.164,168.6l-1.3-.889V165.27l1.3.911Z",
    transform: "translate(218.984 -17.876)",
    fill: "#515255"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237675",
    "data-name": "Path 237675",
    d: "M406.272,169.877,405,169.008v-2.413l1.274.89Z",
    transform: "translate(222.536 -18.02)",
    fill: "#515255"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237676",
    "data-name": "Path 237676",
    d: "M404.424,171.123l-1.245-.849v-2.386l1.245.87Z",
    transform: "translate(226.006 -18.16)",
    fill: "#515255"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237677",
    "data-name": "Path 237677",
    d: "M402.617,172.342l-1.216-.829v-2.359l1.216.85Z",
    transform: "translate(229.399 -18.296)",
    fill: "#515255"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237678",
    "data-name": "Path 237678",
    d: "M416.3,176.665v83.15h-.59v-83.5Z",
    transform: "translate(202.956 -19.071)",
    fill: "#515255"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237679",
    "data-name": "Path 237679",
    d: "M415.184,177.333v82.555H414.6V176.983Z",
    transform: "translate(205.059 -19.143)",
    fill: "#515255"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237680",
    "data-name": "Path 237680",
    d: "M414.081,177.991V259.96h-.573V177.646Z",
    transform: "translate(207.138 -19.215)",
    fill: "#515255"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237681",
    "data-name": "Path 237681",
    d: "M412.994,178.642v81.389h-.566V178.3Z",
    transform: "translate(209.188 -19.286)",
    fill: "#515255"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237682",
    "data-name": "Path 237682",
    d: "M411.92,179.283V260.1h-.559V178.947Z",
    transform: "translate(211.213 -19.356)",
    fill: "#515255"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237683",
    "data-name": "Path 237683",
    d: "M410.86,179.917V260.17h-.552V179.584Z",
    transform: "translate(213.212 -19.425)",
    fill: "#515255"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237684",
    "data-name": "Path 237684",
    d: "M409.814,180.543v79.694h-.545V180.215Z",
    transform: "translate(215.186 -19.493)",
    fill: "#515255"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237685",
    "data-name": "Path 237685",
    d: "M408.78,181.161v79.144h-.539V180.836Z",
    transform: "translate(217.135 -19.56)",
    fill: "#515255"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237686",
    "data-name": "Path 237686",
    d: "M407.76,181.771v78.6h-.532v-78.92Z",
    transform: "translate(219.059 -19.627)",
    fill: "#515255"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237687",
    "data-name": "Path 237687",
    d: "M406.753,182.373v78.063h-.526v-78.38Z",
    transform: "translate(220.96 -19.692)",
    fill: "#515255"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237688",
    "data-name": "Path 237688",
    d: "M405.757,182.969V260.5h-.519V182.657Z",
    transform: "translate(222.838 -19.757)",
    fill: "#515255"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237689",
    "data-name": "Path 237689",
    d: "M404.774,183.557v77.009h-.513V183.248Z",
    transform: "translate(224.692 -19.821)",
    fill: "#515255"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237690",
    "data-name": "Path 237690",
    d: "M403.8,184.137v76.492H403.3v-76.8Z",
    transform: "translate(226.523 -19.884)",
    fill: "#515255"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237691",
    "data-name": "Path 237691",
    d: "M402.843,184.711v75.981h-.5V184.41Z",
    transform: "translate(228.332 -19.947)",
    fill: "#515255"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237692",
    "data-name": "Path 237692",
    d: "M401.895,185.278v75.475H401.4V184.98Z",
    transform: "translate(230.121 -20.008)",
    fill: "#515255"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24289",
    "data-name": "Rectangle 24289",
    width: 22.598,
    height: 85.528,
    transform: "translate(407.137 155.217)",
    fill: "#fff"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237693",
    "data-name": "Path 237693",
    d: "M651.266,173.465v86.042h-1.03V174.495H628.667v85.012h-1.029V173.465Z",
    transform: "translate(-221.016 -18.763)",
    fill: "#515255"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24290",
    "data-name": "Rectangle 24290",
    width: 22.597,
    height: 1.763,
    transform: "translate(407.138 169.516)",
    fill: "#fff"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237694",
    "data-name": "Path 237694",
    d: "M627.638,192.292h23.627V189.5H627.638Zm22.6-1.03H628.668v-.734h21.567Z",
    transform: "translate(-221.015 -20.497)",
    fill: "#515255"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24291",
    "data-name": "Rectangle 24291",
    width: 22.597,
    height: 1.763,
    transform: "translate(407.138 179.454)",
    fill: "#fff"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237695",
    "data-name": "Path 237695",
    d: "M627.638,203.434h23.627v-2.793H627.638Zm22.6-1.03H628.668v-.734h21.567Z",
    transform: "translate(-221.015 -21.702)",
    fill: "#515255"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24292",
    "data-name": "Rectangle 24292",
    width: 22.597,
    height: 1.763,
    transform: "translate(407.138 189.391)",
    fill: "#fff"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237696",
    "data-name": "Path 237696",
    d: "M627.638,214.576h23.627v-2.793H627.638Zm22.6-1.029H628.668v-.734h21.567Z",
    transform: "translate(-221.015 -22.907)",
    fill: "#515255"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24293",
    "data-name": "Rectangle 24293",
    width: 22.597,
    height: 1.763,
    transform: "translate(407.138 199.328)",
    fill: "#fff"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237697",
    "data-name": "Path 237697",
    d: "M627.638,225.719h23.627v-2.793H627.638Zm22.6-1.03H628.668v-.734h21.567Z",
    transform: "translate(-221.015 -24.113)",
    fill: "#515255"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24294",
    "data-name": "Rectangle 24294",
    width: 22.597,
    height: 1.763,
    transform: "translate(407.138 209.265)",
    fill: "#fff"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237698",
    "data-name": "Path 237698",
    d: "M627.638,236.861h23.627v-2.793H627.638Zm22.6-1.03H628.668V235.1h21.567Z",
    transform: "translate(-221.015 -25.318)",
    fill: "#515255"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24295",
    "data-name": "Rectangle 24295",
    width: 22.597,
    height: 1.763,
    transform: "translate(407.138 219.202)",
    fill: "#fff"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237699",
    "data-name": "Path 237699",
    d: "M627.638,248h23.627V245.21H627.638Zm22.6-1.03H628.668v-.734h21.567Z",
    transform: "translate(-221.015 -26.523)",
    fill: "#515255"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24296",
    "data-name": "Rectangle 24296",
    width: 22.597,
    height: 1.763,
    transform: "translate(407.138 229.139)",
    fill: "#fff"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237700",
    "data-name": "Path 237700",
    d: "M627.638,259.145h23.627v-2.793H627.638Zm22.6-1.029H628.668v-.734h21.567Z",
    transform: "translate(-221.015 -27.728)",
    fill: "#515255"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24297",
    "data-name": "Rectangle 24297",
    width: 22.598,
    height: 1.669,
    transform: "translate(407.137 239.076)",
    fill: "#fff"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237701",
    "data-name": "Path 237701",
    d: "M650.234,268.524H628.667v.734h21.567Zm1.03,1.154H627.638v-2.184h23.627Z",
    transform: "translate(-221.015 -28.933)",
    fill: "#515255"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24298",
    "data-name": "Rectangle 24298",
    width: 22.597,
    height: 6.608,
    transform: "translate(407.138 155.217)",
    fill: "#fff"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237702",
    "data-name": "Path 237702",
    d: "M627.638,181.1h23.627v-7.638H627.638Zm22.6-1.029H628.668v-5.578h21.567Z",
    transform: "translate(-221.015 -18.763)",
    fill: "#515255"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237703",
    "data-name": "Path 237703",
    d: "M625.454,183.98v75.735h-7.417V175.38Z",
    transform: "translate(-186.641 -18.97)",
    fill: "#fff"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237704",
    "data-name": "Path 237704",
    d: "M625.906,183.62v75.926h-1.03V184l-6.387-7.4v82.949h-1.029v-85.72Z",
    transform: "translate(-186.578 -18.802)",
    fill: "#515255"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237705",
    "data-name": "Path 237705",
    d: "M625.454,200.671l-7.417-7.64v-1.749l7.417,7.746Z",
    transform: "translate(-186.641 -20.69)",
    fill: "#fff"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237706",
    "data-name": "Path 237706",
    d: "M625.906,201.785v-3.121l-8.448-8.821v3.24Zm-1.03-2.707v.168l-6.387-6.58v-.259Z",
    transform: "translate(-186.578 -20.534)",
    fill: "#515255"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237707",
    "data-name": "Path 237707",
    d: "M625.454,211.127l-7.417-7.047v-1.749l7.417,7.152Z",
    transform: "translate(-186.641 -21.885)",
    fill: "#fff"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237708",
    "data-name": "Path 237708",
    d: "M625.906,212.18v-3.062l-8.448-8.146v3.182Zm-1.03-2.624v.226l-6.387-6.07V203.4Z",
    transform: "translate(-186.578 -21.738)",
    fill: "#515255"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237709",
    "data-name": "Path 237709",
    d: "M625.454,221.584l-7.417-6.454v-1.749l7.417,6.559Z",
    transform: "translate(-186.641 -23.08)",
    fill: "#fff"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237710",
    "data-name": "Path 237710",
    d: "M625.906,222.576V219.57l-8.448-7.471v3.126Zm-1.03-2.543v.281l-6.387-5.558v-.372Z",
    transform: "translate(-186.578 -22.942)",
    fill: "#515255"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237711",
    "data-name": "Path 237711",
    d: "M625.454,232.041l-7.417-5.861v-1.749l7.417,5.966Z",
    transform: "translate(-186.641 -24.276)",
    fill: "#fff"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237712",
    "data-name": "Path 237712",
    d: "M625.906,232.974v-2.953l-8.448-6.795V226.3Zm-1.03-2.46v.334l-6.387-5.048v-.424Z",
    transform: "translate(-186.578 -24.145)",
    fill: "#515255"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237713",
    "data-name": "Path 237713",
    d: "M625.454,242.5l-7.417-5.268v-1.749l7.417,5.373Z",
    transform: "translate(-186.641 -25.471)",
    fill: "#fff"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237714",
    "data-name": "Path 237714",
    d: "M625.906,243.374v-2.9l-8.448-6.12v3.023ZM624.876,241v.383l-6.387-4.537v-.474Z",
    transform: "translate(-186.578 -25.348)",
    fill: "#515255"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237715",
    "data-name": "Path 237715",
    d: "M625.454,252.955l-7.417-4.675v-1.749l7.417,4.78Z",
    transform: "translate(-186.641 -26.666)",
    fill: "#fff"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237716",
    "data-name": "Path 237716",
    d: "M625.906,253.774v-2.857l-8.448-5.445v2.977Zm-1.03-2.3v.43l-6.387-4.027v-.52Z",
    transform: "translate(-186.578 -26.551)",
    fill: "#515255"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237717",
    "data-name": "Path 237717",
    d: "M625.454,263.412l-7.417-4.082v-1.749l7.417,4.187Z",
    transform: "translate(-186.641 -27.861)",
    fill: "#fff"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237718",
    "data-name": "Path 237718",
    d: "M625.906,264.176v-2.816l-8.448-4.769v2.935Zm-1.03-2.214v.472l-6.387-3.515v-.563Z",
    transform: "translate(-186.578 -27.754)",
    fill: "#515255"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237719",
    "data-name": "Path 237719",
    d: "M626.06,269.8h-2.415v-1.17Z",
    transform: "translate(-192.249 -29.056)",
    fill: "#fff"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237720",
    "data-name": "Path 237720",
    d: "M626.432,269.7H624.07l-.72-.349v.349h-1.029V267.71Z",
    transform: "translate(-191.44 -28.957)",
    fill: "#515255"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237721",
    "data-name": "Path 237721",
    d: "M625.454,190.138l-7.417-8.2v-6.553l7.417,8.6Z",
    transform: "translate(-186.641 -18.97)",
    fill: "#fff"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237722",
    "data-name": "Path 237722",
    d: "M625.906,191.307V183.62l-8.448-9.793v8.136Zm-1.03-7.3v4.63l-6.387-7.066V176.6Z",
    transform: "translate(-186.578 -18.802)",
    fill: "#515255"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237723",
    "data-name": "Path 237723",
    d: "M628.014,175.235V259.57h-1.661V174.042Z",
    transform: "translate(-196.618 -18.825)",
    fill: "#fff"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237724",
    "data-name": "Path 237724",
    d: "M628.467,174.85v84.6h-1.029V175.377l-.631-.453v84.524h-1.03V172.917Z",
    transform: "translate(-196.557 -18.704)",
    fill: "#515255"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24299",
    "data-name": "Rectangle 24299",
    width: 17.467,
    height: 52.813,
    transform: "translate(433.844 187.932)",
    fill: "#fff"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237725",
    "data-name": "Path 237725",
    d: "M621.942,210.147v53.328h-1.03v-52.3H604.476v52.3h-1.03V210.147Z",
    transform: "translate(-170.116 -22.73)",
    fill: "#515255"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24300",
    "data-name": "Rectangle 24300",
    width: 17.467,
    height: 1.363,
    transform: "translate(433.844 198.984)",
    fill: "#fff"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237726",
    "data-name": "Path 237726",
    d: "M603.445,224.934h18.5v-2.393h-18.5Zm17.467-1.03H604.475v-.334h16.437Z",
    transform: "translate(-170.116 -24.071)",
    fill: "#515255"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24301",
    "data-name": "Rectangle 24301",
    width: 17.467,
    height: 1.363,
    transform: "translate(433.844 206.666)",
    fill: "#fff"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237727",
    "data-name": "Path 237727",
    d: "M603.445,233.546h18.5v-2.393h-18.5Zm17.467-1.03H604.475v-.334h16.437Z",
    transform: "translate(-170.116 -25.003)",
    fill: "#515255"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24302",
    "data-name": "Rectangle 24302",
    width: 17.467,
    height: 1.363,
    transform: "translate(433.844 214.346)",
    fill: "#fff"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237728",
    "data-name": "Path 237728",
    d: "M603.445,242.158h18.5v-2.393h-18.5Zm17.467-1.03H604.475v-.334h16.437Z",
    transform: "translate(-170.116 -25.934)",
    fill: "#515255"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24303",
    "data-name": "Rectangle 24303",
    width: 17.467,
    height: 1.363,
    transform: "translate(433.844 222.027)",
    fill: "#fff"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237729",
    "data-name": "Path 237729",
    d: "M603.445,250.77h18.5v-2.393h-18.5Zm17.467-1.03H604.475v-.334h16.437Z",
    transform: "translate(-170.116 -26.866)",
    fill: "#515255"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24304",
    "data-name": "Rectangle 24304",
    width: 17.467,
    height: 1.363,
    transform: "translate(433.844 229.707)",
    fill: "#fff"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237730",
    "data-name": "Path 237730",
    d: "M603.445,259.383h18.5V256.99h-18.5Zm17.467-1.03H604.475v-.334h16.437Z",
    transform: "translate(-170.116 -27.797)",
    fill: "#515255"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24305",
    "data-name": "Rectangle 24305",
    width: 17.467,
    height: 1.363,
    transform: "translate(433.844 237.388)",
    fill: "#fff"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237731",
    "data-name": "Path 237731",
    d: "M603.445,267.995h18.5V265.6h-18.5Zm17.467-1.03H604.475v-.334h16.437Z",
    transform: "translate(-170.116 -28.729)",
    fill: "#515255"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24306",
    "data-name": "Rectangle 24306",
    width: 17.467,
    height: 5.107,
    transform: "translate(433.844 187.932)",
    fill: "#fff"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237732",
    "data-name": "Path 237732",
    d: "M603.445,216.285h18.5v-6.137h-18.5Zm17.467-1.03H604.475v-4.077h16.437Z",
    transform: "translate(-170.116 -22.731)",
    fill: "#515255"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237733",
    "data-name": "Path 237733",
    d: "M601.888,218.406v45.244h-5.733V211.759Z",
    transform: "translate(-143.561 -22.905)",
    fill: "#fff"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237734",
    "data-name": "Path 237734",
    d: "M602.341,218.046v45.435h-1.03V218.428l-4.7-5.452v50.5h-1.029V210.206Z",
    transform: "translate(-143.498 -22.737)",
    fill: "#515255"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237735",
    "data-name": "Path 237735",
    d: "M601.888,231.307l-5.733-5.906v-1.352l5.733,5.987Z",
    transform: "translate(-143.56 -24.234)",
    fill: "#fff"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237736",
    "data-name": "Path 237736",
    d: "M602.341,232.421v-2.748l-6.763-7.062v2.842Z",
    transform: "translate(-143.498 -24.079)",
    fill: "#515255"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237737",
    "data-name": "Path 237737",
    d: "M601.888,239.389l-5.733-5.447V232.59l5.733,5.529Z",
    transform: "translate(-143.56 -25.158)",
    fill: "#fff"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237738",
    "data-name": "Path 237738",
    d: "M602.341,240.442v-2.689l-6.763-6.521v2.784Z",
    transform: "translate(-143.498 -25.011)",
    fill: "#515255"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237739",
    "data-name": "Path 237739",
    d: "M601.888,247.472l-5.733-4.989v-1.352l5.733,5.07Z",
    transform: "translate(-143.56 -26.082)",
    fill: "#fff"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237740",
    "data-name": "Path 237740",
    d: "M602.341,248.464v-2.633l-6.763-5.982v2.729Z",
    transform: "translate(-143.498 -25.943)",
    fill: "#515255"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237741",
    "data-name": "Path 237741",
    d: "M601.888,255.554l-5.733-4.53v-1.352l5.733,4.612Z",
    transform: "translate(-143.56 -27.006)",
    fill: "#fff"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237742",
    "data-name": "Path 237742",
    d: "M602.341,256.486v-2.58l-6.763-5.44v2.676Zm-5.733-5.87,1.925,1.548-1.925-1.521Z",
    transform: "translate(-143.499 -26.875)",
    fill: "#515255"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237743",
    "data-name": "Path 237743",
    d: "M601.888,263.637l-5.733-4.072v-1.352l5.733,4.153Z",
    transform: "translate(-143.56 -27.929)",
    fill: "#fff"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237744",
    "data-name": "Path 237744",
    d: "M602.34,264.511v-2.53l-6.763-4.9v2.626Zm-1.03-2v.011l-4.7-3.341V259.1Z",
    transform: "translate(-143.497 -27.807)",
    fill: "#515255"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237745",
    "data-name": "Path 237745",
    d: "M602.048,269.6H600l-2.368-1.493v-1.352Z",
    transform: "translate(-145.04 -28.853)",
    fill: "#fff"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237746",
    "data-name": "Path 237746",
    d: "M602.448,269.483h-1.9l-2.949-1.9v.123l2.819,1.777h-1.932l-1.917-1.208v-2.58Z",
    transform: "translate(-144.49 -28.739)",
    fill: "#515255"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237747",
    "data-name": "Path 237747",
    d: "M601.888,223.166l-5.733-6.342v-5.065l5.733,6.647Z",
    transform: "translate(-143.56 -22.905)",
    fill: "#fff"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237748",
    "data-name": "Path 237748",
    d: "M602.34,224.334v-6.288l-6.763-7.841v6.649Zm-1.03-5.906v3.231l-4.7-5.2v-3.482Z",
    transform: "translate(-143.497 -22.737)",
    fill: "#515255"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237749",
    "data-name": "Path 237749",
    d: "M603.867,211.647v51.891h-1.284V210.725Z",
    transform: "translate(-151.273 -22.793)",
    fill: "#fff"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237750",
    "data-name": "Path 237750",
    d: "M604.32,211.261v52.154h-1.03V211.789l-.253-.182v51.808h-1.03V209.6Z",
    transform: "translate(-151.211 -22.671)",
    fill: "#515255"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24307",
    "data-name": "Rectangle 24307",
    width: 31.605,
    height: 163.866,
    transform: "translate(373.042 76.879)",
    fill: "#fff"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237751",
    "data-name": "Path 237751",
    d: "M688.4,85.626v164.38h-1.03V86.656H656.8v163.35h-1.03V85.626Z",
    transform: "translate(-283.243 -9.262)",
    fill: "#515255"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237752",
    "data-name": "Path 237752",
    d: "M685.309,84.609h-19.5l19.5-13.139Z",
    transform: "translate(-289.098 -7.731)",
    fill: "#fff"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237753",
    "data-name": "Path 237753",
    d: "M665.228,85.008h21.7V70.386Zm20.674-1.03H668.6l17.3-11.655Z",
    transform: "translate(-290.206 -7.613)",
    fill: "#515255"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237754",
    "data-name": "Path 237754",
    d: "M659.137,84.609V71.471l5.948,13.139Z",
    transform: "translate(-262.927 -7.731)",
    fill: "#fd930d"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237755",
    "data-name": "Path 237755",
    d: "M656.046,98.659v151.41h-2.492V86.2Z",
    transform: "translate(-248.908 -9.324)",
    fill: "#ffded7"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24308",
    "data-name": "Rectangle 24308",
    width: 31.606,
    height: 8.403,
    transform: "translate(373.041 76.879)",
    fill: "#fff"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237756",
    "data-name": "Path 237756",
    d: "M655.77,95.058H688.4V85.626H655.77Zm31.606-1.03H656.8V86.655h30.576Z",
    transform: "translate(-283.244 -9.262)",
    fill: "#515255"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24309",
    "data-name": "Rectangle 24309",
    width: 31.606,
    height: 2.49,
    transform: "translate(373.041 109.797)",
    fill: "#fff"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237757",
    "data-name": "Path 237757",
    d: "M655.77,126.057H688.4v-3.519H655.77Zm31.606-1.03H656.8v-1.46h30.576Z",
    transform: "translate(-283.244 -13.254)",
    fill: "#515255"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24310",
    "data-name": "Rectangle 24310",
    width: 31.606,
    height: 2.49,
    transform: "translate(373.041 134.418)",
    fill: "#fff"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237758",
    "data-name": "Path 237758",
    d: "M655.77,153.663H688.4v-3.519H655.77Zm31.606-1.029H656.8v-1.46h30.576Z",
    transform: "translate(-283.244 -16.24)",
    fill: "#515255"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24311",
    "data-name": "Rectangle 24311",
    width: 31.606,
    height: 2.49,
    transform: "translate(373.041 159.038)",
    fill: "#fff"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237759",
    "data-name": "Path 237759",
    d: "M655.77,181.27H688.4v-3.519H655.77Zm31.606-1.03H656.8v-1.46h30.576Z",
    transform: "translate(-283.244 -19.226)",
    fill: "#515255"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24312",
    "data-name": "Rectangle 24312",
    width: 31.606,
    height: 2.49,
    transform: "translate(373.041 183.659)",
    fill: "#fff"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237760",
    "data-name": "Path 237760",
    d: "M655.77,208.876H688.4v-3.519H655.77Zm31.606-1.029H656.8v-1.46h30.576Z",
    transform: "translate(-283.244 -22.212)",
    fill: "#515255"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24313",
    "data-name": "Rectangle 24313",
    width: 31.606,
    height: 2.49,
    transform: "translate(373.041 208.279)",
    fill: "#fff"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237761",
    "data-name": "Path 237761",
    d: "M655.77,236.483H688.4v-3.519H655.77Zm31.606-1.03H656.8v-1.46h30.576Z",
    transform: "translate(-283.244 -25.198)",
    fill: "#515255"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24314",
    "data-name": "Rectangle 24314",
    width: 31.606,
    height: 2.49,
    transform: "translate(373.041 232.9)",
    fill: "#fff"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237762",
    "data-name": "Path 237762",
    d: "M655.77,264.089H688.4V260.57H655.77Zm31.606-1.03H656.8V261.6h30.576Z",
    transform: "translate(-283.244 -28.184)",
    fill: "#515255"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237763",
    "data-name": "Path 237763",
    d: "M707.573,106.637l.56,144.451h-32.07V95.624Z",
    transform: "translate(-321.071 -10.343)",
    fill: "#fff"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237764",
    "data-name": "Path 237764",
    d: "M708.026,106.183,708.586,251h-1.03L707,106.914,676.517,96.261V251h-1.03V94.81Z",
    transform: "translate(-321.01 -10.255)",
    fill: "#515255"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237765",
    "data-name": "Path 237765",
    d: "M708.2,113.074,676.664,102.4V95.508l31.51,11.019Z",
    transform: "translate(-321.672 -10.331)",
    fill: "#fd930d"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237766",
    "data-name": "Path 237766",
    d: "M708.2,120.776l-31.56-10.335v-2.578l31.55,10.465Z",
    transform: "translate(-321.644 -11.667)",
    fill: "#fff"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237767",
    "data-name": "Path 237767",
    d: "M708.647,121.4l-.013-3.531-32.579-10.806v3.665Zm-1.041-2.787.005,1.365-30.527-10V108.49Z",
    transform: "translate(-321.577 -11.58)",
    fill: "#515255"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237768",
    "data-name": "Path 237768",
    d: "M708.193,126.136l-31.578-10.083v-2.581l31.568,10.213Z",
    transform: "translate(-321.623 -12.274)",
    fill: "#fff"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237769",
    "data-name": "Path 237769",
    d: "M708.646,126.757l-.013-3.532-32.6-10.547v3.665Zm-1.041-2.783.005,1.372-30.546-9.753v-1.5Z",
    transform: "translate(-321.558 -12.188)",
    fill: "#515255"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237770",
    "data-name": "Path 237770",
    d: "M708.192,131.5l-31.6-9.83v-2.585l31.587,9.96Z",
    transform: "translate(-321.603 -12.881)",
    fill: "#fff"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237771",
    "data-name": "Path 237771",
    d: "M708.644,132.118l-.013-3.533L676.014,118.3v3.666Zm-1.041-2.776.005,1.376-30.564-9.509v-1.5Z",
    transform: "translate(-321.537 -12.796)",
    fill: "#515255"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237772",
    "data-name": "Path 237772",
    d: "M683.328,136.446l.385,119.013H682.32l-.367-119.429Z",
    transform: "translate(-301.903 -14.714)",
    fill: "#fff"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237773",
    "data-name": "Path 237773",
    d: "M683.781,135.98l.387,119.394h-1.03l-.384-118.629-.345-.1.365,118.734h-1.029l-.367-119.427,0-.7Z",
    transform: "translate(-301.842 -14.629)",
    fill: "#515255"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237774",
    "data-name": "Path 237774",
    d: "M687.691,135.144l.334,120.173h-1.414L686.3,134.722Z",
    transform: "translate(-310.09 -14.572)",
    fill: "#fff"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237775",
    "data-name": "Path 237775",
    d: "M688.146,134.677l.334,120.555H687.45l-.333-119.79-.363-.111.312,119.9h-1.029l-.314-120.594,0-.7Z",
    transform: "translate(-310.03 -14.488)",
    fill: "#515255"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237776",
    "data-name": "Path 237776",
    d: "M692.114,133.824l.279,121.348h-1.432L690.7,133.4Z",
    transform: "translate(-318.386 -14.429)",
    fill: "#fff"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237777",
    "data-name": "Path 237777",
    d: "M692.568,133.358l.279,121.731h-1.029l-.278-120.967-.382-.116.258,121.083h-1.03l-.26-121.776v-.7Z",
    transform: "translate(-318.326 -14.344)",
    fill: "#515255"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237778",
    "data-name": "Path 237778",
    d: "M696.6,132.487l.223,122.541h-1.452l-.2-122.974Z",
    transform: "translate(-326.794 -14.284)",
    fill: "#fff"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237779",
    "data-name": "Path 237779",
    d: "M697.05,132.021l.223,122.923h-1.029l-.222-122.158-.4-.121.2,122.28h-1.029l-.2-122.973v-.695Z",
    transform: "translate(-326.733 -14.199)",
    fill: "#515255"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237780",
    "data-name": "Path 237780",
    d: "M701.14,131.132l.165,123.748h-1.472l-.143-124.187Z",
    transform: "translate(-335.315 -14.136)",
    fill: "#fff"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237781",
    "data-name": "Path 237781",
    d: "M701.593,130.666l.165,124.131h-1.029l-.165-123.367-.42-.127.143,123.493h-1.029l-.143-124.188v-.694Z",
    transform: "translate(-335.253 -14.052)",
    fill: "#515255"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237782",
    "data-name": "Path 237782",
    d: "M705.747,129.76l.1,124.972H704.36l-.082-125.418Z",
    transform: "translate(-343.952 -13.987)",
    fill: "#fff"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237783",
    "data-name": "Path 237783",
    d: "M706.2,129.294l.1,125.354h-1.029l-.1-124.59-.44-.133.082,124.723h-1.03L703.7,129.23v-.695Z",
    transform: "translate(-343.891 -13.903)",
    fill: "#515255"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24315",
    "data-name": "Rectangle 24315",
    width: 28.145,
    height: 155.546,
    transform: "translate(326.848 85.199)",
    fill: "#fff"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237784",
    "data-name": "Path 237784",
    d: "M740.621,94.955v156.06h-1.03V95.984H712.476V251.016h-1.03V94.955Z",
    transform: "translate(-385.114 -10.271)",
    fill: "#515255"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24316",
    "data-name": "Rectangle 24316",
    width: 28.145,
    height: 6.811,
    transform: "translate(326.846 85.199)",
    fill: "#fff"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237785",
    "data-name": "Path 237785",
    d: "M711.446,102.8H740.62v-7.84H711.446Zm28.145-1.03H712.475V95.984H739.59Z",
    transform: "translate(-385.113 -10.271)",
    fill: "#515255"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24317",
    "data-name": "Rectangle 24317",
    width: 28.145,
    height: 2.638,
    transform: "translate(326.846 96.196)",
    fill: "#fff"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237786",
    "data-name": "Path 237786",
    d: "M711.446,110.953H740.62v-3.668H711.446Zm28.145-1.03H712.475v-1.608H739.59Z",
    transform: "translate(-385.113 -11.604)",
    fill: "#515255"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24318",
    "data-name": "Rectangle 24318",
    width: 28.145,
    height: 2.638,
    transform: "translate(326.846 101.198)",
    fill: "#fff"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237787",
    "data-name": "Path 237787",
    d: "M711.446,116.563H740.62v-3.668H711.446Zm28.145-1.03H712.475v-1.608H739.59Z",
    transform: "translate(-385.113 -12.211)",
    fill: "#515255"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24319",
    "data-name": "Rectangle 24319",
    width: 28.145,
    height: 2.638,
    transform: "translate(326.846 106.211)",
    fill: "#fff"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237788",
    "data-name": "Path 237788",
    d: "M711.446,122.184H740.62v-3.668H711.446Zm28.145-1.03H712.475v-1.608H739.59Z",
    transform: "translate(-385.113 -12.819)",
    fill: "#515255"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237789",
    "data-name": "Path 237789",
    d: "M747.849,170.573v0h-.012v88.617h-20.48V170.573Z",
    transform: "translate(-406.532 -18.45)",
    fill: "#fff"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237790",
    "data-name": "Path 237790",
    d: "M747.786,170l.516,0-.012,89.132h-1.03V171.025h-19.45v88.107h-1.03V170Z",
    transform: "translate(-406.468 -18.388)",
    fill: "#515255"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24320",
    "data-name": "Rectangle 24320",
    width: 0.012,
    height: 88.617,
    transform: "translate(341.305 152.127)",
    fill: "#fff"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237791",
    "data-name": "Path 237791",
    d: "M727.821,170v89.132h-1.043V170.515l.013-.515Z",
    transform: "translate(-385.989 -18.388)",
    fill: "#515255"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84321",
    "data-name": "Group 84321",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84320",
    "data-name": "Group 84320",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84262",
    "data-name": "Group 84262",
    transform: "translate(320.822 152.123)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84261",
    "data-name": "Group 84261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84260",
    "data-name": "Group 84260",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_237792",
    "data-name": "Path 237792",
    d: "M747.85,170.577h0v4.806h-20.48v-4.811H747.85Z",
    transform: "translate(-727.369 -170.573)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84265",
    "data-name": "Group 84265",
    transform: "translate(341.302 152.127)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84264",
    "data-name": "Group 84264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84263",
    "data-name": "Group 84263",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24322",
    "data-name": "Rectangle 24322",
    width: 0.001,
    height: 4.806,
    transform: "translate(0 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84268",
    "data-name": "Group 84268",
    transform: "translate(320.822 161.966)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84267",
    "data-name": "Group 84267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84266",
    "data-name": "Group 84266",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24324",
    "data-name": "Rectangle 24324",
    width: 20.48,
    height: 4.795,
    transform: "translate(0 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84271",
    "data-name": "Group 84271",
    transform: "translate(341.302 161.966)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84270",
    "data-name": "Group 84270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84269",
    "data-name": "Group 84269",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24326",
    "data-name": "Rectangle 24326",
    width: 0.001,
    height: 4.795,
    transform: "translate(0 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84274",
    "data-name": "Group 84274",
    transform: "translate(320.822 171.793)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84273",
    "data-name": "Group 84273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84272",
    "data-name": "Group 84272",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24328",
    "data-name": "Rectangle 24328",
    width: 20.48,
    height: 4.811,
    transform: "translate(0 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84277",
    "data-name": "Group 84277",
    transform: "translate(341.302 171.793)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84276",
    "data-name": "Group 84276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84275",
    "data-name": "Group 84275",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24330",
    "data-name": "Rectangle 24330",
    width: 0.001,
    height: 4.811,
    transform: "translate(0 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84280",
    "data-name": "Group 84280",
    transform: "translate(320.822 181.636)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84279",
    "data-name": "Group 84279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84278",
    "data-name": "Group 84278",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24332",
    "data-name": "Rectangle 24332",
    width: 20.48,
    height: 4.811,
    transform: "translate(0 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84283",
    "data-name": "Group 84283",
    transform: "translate(341.302 181.636)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84282",
    "data-name": "Group 84282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84281",
    "data-name": "Group 84281",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24334",
    "data-name": "Rectangle 24334",
    width: 0.001,
    height: 4.811,
    transform: "translate(0 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84286",
    "data-name": "Group 84286",
    transform: "translate(320.822 191.478)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84285",
    "data-name": "Group 84285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84284",
    "data-name": "Group 84284",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24336",
    "data-name": "Rectangle 24336",
    width: 20.48,
    height: 4.811,
    transform: "translate(0 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84289",
    "data-name": "Group 84289",
    transform: "translate(341.302 191.478)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84288",
    "data-name": "Group 84288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84287",
    "data-name": "Group 84287",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24338",
    "data-name": "Rectangle 24338",
    width: 0.001,
    height: 4.811,
    transform: "translate(0 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84292",
    "data-name": "Group 84292",
    transform: "translate(320.822 201.321)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84291",
    "data-name": "Group 84291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84290",
    "data-name": "Group 84290",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24340",
    "data-name": "Rectangle 24340",
    width: 20.48,
    height: 4.811,
    transform: "translate(0 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84295",
    "data-name": "Group 84295",
    transform: "translate(341.302 201.321)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84294",
    "data-name": "Group 84294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84293",
    "data-name": "Group 84293",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24342",
    "data-name": "Rectangle 24342",
    width: 0.001,
    height: 4.811,
    transform: "translate(0 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84298",
    "data-name": "Group 84298",
    transform: "translate(320.822 211.164)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84297",
    "data-name": "Group 84297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84296",
    "data-name": "Group 84296",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24344",
    "data-name": "Rectangle 24344",
    width: 20.48,
    height: 4.811,
    transform: "translate(0 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84301",
    "data-name": "Group 84301",
    transform: "translate(341.302 211.164)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84300",
    "data-name": "Group 84300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84299",
    "data-name": "Group 84299",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24346",
    "data-name": "Rectangle 24346",
    width: 0.001,
    height: 4.811,
    transform: "translate(0 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84304",
    "data-name": "Group 84304",
    transform: "translate(320.822 221.006)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84303",
    "data-name": "Group 84303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84302",
    "data-name": "Group 84302",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24348",
    "data-name": "Rectangle 24348",
    width: 20.48,
    height: 4.811,
    transform: "translate(0 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84307",
    "data-name": "Group 84307",
    transform: "translate(341.302 221.006)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84306",
    "data-name": "Group 84306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84305",
    "data-name": "Group 84305",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24350",
    "data-name": "Rectangle 24350",
    width: 0.001,
    height: 4.811,
    transform: "translate(0 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84310",
    "data-name": "Group 84310",
    transform: "translate(320.822 230.849)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84309",
    "data-name": "Group 84309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84308",
    "data-name": "Group 84308",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24352",
    "data-name": "Rectangle 24352",
    width: 20.48,
    height: 4.811,
    transform: "translate(0 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84313",
    "data-name": "Group 84313",
    transform: "translate(341.302 230.849)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84312",
    "data-name": "Group 84312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84311",
    "data-name": "Group 84311",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24354",
    "data-name": "Rectangle 24354",
    width: 0.001,
    height: 4.811,
    transform: "translate(0 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84316",
    "data-name": "Group 84316",
    transform: "translate(320.822 240.692)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84315",
    "data-name": "Group 84315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84314",
    "data-name": "Group 84314",
    clipPath: "url(#clip-path-66)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24356",
    "data-name": "Rectangle 24356",
    width: 20.48,
    height: 0.053,
    transform: "translate(0 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84319",
    "data-name": "Group 84319",
    transform: "translate(341.302 240.692)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84318",
    "data-name": "Group 84318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84317",
    "data-name": "Group 84317",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24358",
    "data-name": "Rectangle 24358",
    width: 0.001,
    height: 0.053,
    transform: "translate(0 0)",
    fill: "#515255"
  }))))))), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237793",
    "data-name": "Path 237793",
    d: "M716.621,181.539V259.2H683.689V170.578Z",
    transform: "translate(-336.359 -18.451)",
    fill: "#fff"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237794",
    "data-name": "Path 237794",
    d: "M717.074,181.081v78.028h-1.03V181.824l-31.9-10.619v87.9h-1.03V169.777Z",
    transform: "translate(-336.298 -18.364)",
    fill: "#515255"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24361",
    "data-name": "Rectangle 24361",
    width: 6.024,
    height: 88.617,
    transform: "translate(341.305 152.127)",
    fill: "#fff"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237795",
    "data-name": "Path 237795",
    d: "M727.092,170v89.132h-1.03v-88.1h-4.994v88.1h-1.029V170Z",
    transform: "translate(-379.248 -18.388)",
    fill: "#515255"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84326",
    "data-name": "Group 84326",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84325",
    "data-name": "Group 84325",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84324",
    "data-name": "Group 84324",
    transform: "translate(340.825 154.606)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84323",
    "data-name": "Group 84323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84322",
    "data-name": "Group 84322",
    clipPath: "url(#clip-path-69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_237796",
    "data-name": "Path 237796",
    d: "M716.621,187.334l-32.937-10.527v-2.654l32.937,10.725Z",
    transform: "translate(-677.183 -173.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237797",
    "data-name": "Path 237797",
    d: "M717.073,187.953v-3.534l-33.967-11.061V177.1Zm-1.03-2.787v1.377l-31.907-10.2v-1.569Z",
    transform: "translate(-677.12 -173.358)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24362",
    "data-name": "Rectangle 24362",
    width: 5.985,
    height: 2.653,
    transform: "translate(0.515 0.709)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237798",
    "data-name": "Path 237798",
    d: "M720.039,177.258h7.015v-3.683h-7.015Zm5.986-1.029h-4.956v-1.624h4.956Z",
    transform: "translate(-720.039 -173.381)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237799",
    "data-name": "Path 237799",
    d: "M716.621,192.694l-32.937-10.146v-2.653l32.937,10.344Z",
    transform: "translate(-677.183 -174.065)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237800",
    "data-name": "Path 237800",
    d: "M717.073,193.307v-3.532l-33.967-10.667v3.735Zm-1.03-2.775v1.381l-31.907-9.829v-1.572Z",
    transform: "translate(-677.12 -173.979)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24363",
    "data-name": "Rectangle 24363",
    width: 5.985,
    height: 2.653,
    transform: "translate(0.515 5.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237801",
    "data-name": "Path 237801",
    d: "M720.039,183h7.015v-3.683h-7.015Zm5.986-1.03h-4.956v-1.624h4.956Z",
    transform: "translate(-720.039 -174.002)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237802",
    "data-name": "Path 237802",
    d: "M716.621,198.055l-32.937-9.765v-2.653l32.937,9.962Z",
    transform: "translate(-677.183 -174.686)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237803",
    "data-name": "Path 237803",
    d: "M717.073,198.66v-3.527l-33.967-10.274v3.731Zm-1.03-2.763v1.384l-31.907-9.46v-1.575Z",
    transform: "translate(-677.12 -174.602)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24364",
    "data-name": "Rectangle 24364",
    width: 5.985,
    height: 2.653,
    transform: "translate(0.515 10.951)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237804",
    "data-name": "Path 237804",
    d: "M720.039,188.743h7.015V185.06h-7.015Zm5.986-1.03h-4.956V186.09h4.956Z",
    transform: "translate(-720.039 -174.623)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237805",
    "data-name": "Path 237805",
    d: "M716.621,203.416l-32.937-9.383V191.38l32.937,9.58Z",
    transform: "translate(-677.183 -175.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237806",
    "data-name": "Path 237806",
    d: "M717.073,204.015v-3.525l-33.967-9.88v3.728Zm-1.03-2.751v1.388l-31.907-9.09v-1.579Z",
    transform: "translate(-677.12 -175.224)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24365",
    "data-name": "Rectangle 24365",
    width: 5.985,
    height: 2.653,
    transform: "translate(0.515 16.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237807",
    "data-name": "Path 237807",
    d: "M720.039,194.485h7.015V190.8h-7.015Zm5.986-1.03h-4.956v-1.624h4.956Z",
    transform: "translate(-720.039 -175.244)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237808",
    "data-name": "Path 237808",
    d: "M716.621,208.777l-32.937-9v-2.654l32.937,9.2Z",
    transform: "translate(-677.183 -175.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237809",
    "data-name": "Path 237809",
    d: "M717.073,209.369v-3.521l-33.967-9.487v3.725Zm-1.03-2.74v1.39l-31.907-8.72v-1.582Z",
    transform: "translate(-677.12 -175.846)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24366",
    "data-name": "Rectangle 24366",
    width: 5.985,
    height: 2.653,
    transform: "translate(0.515 21.194)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237810",
    "data-name": "Path 237810",
    d: "M720.039,200.227h7.015v-3.683h-7.015Zm5.986-1.029h-4.956v-1.624h4.956Z",
    transform: "translate(-720.039 -175.865)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237811",
    "data-name": "Path 237811",
    d: "M716.621,214.138l-32.937-8.62v-2.653l32.937,8.818Z",
    transform: "translate(-677.183 -176.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237812",
    "data-name": "Path 237812",
    d: "M717.073,214.722v-3.517l-33.967-9.094v3.722ZM716.043,212v1.393l-31.907-8.35v-1.585Z",
    transform: "translate(-677.12 -176.468)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24367",
    "data-name": "Rectangle 24367",
    width: 5.985,
    height: 2.653,
    transform: "translate(0.515 26.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237813",
    "data-name": "Path 237813",
    d: "M720.039,205.97h7.015v-3.683h-7.015Zm5.986-1.03h-4.956v-1.623h4.956Z",
    transform: "translate(-720.039 -176.487)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237814",
    "data-name": "Path 237814",
    d: "M716.621,219.5l-32.937-8.239v-2.653l32.937,8.436Z",
    transform: "translate(-677.183 -177.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237815",
    "data-name": "Path 237815",
    d: "M717.073,220.078v-3.515l-33.967-8.7v3.719Zm-1.03-2.716v1.4l-31.907-7.981v-1.588Z",
    transform: "translate(-677.12 -177.09)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24368",
    "data-name": "Rectangle 24368",
    width: 5.985,
    height: 2.653,
    transform: "translate(0.515 31.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237816",
    "data-name": "Path 237816",
    d: "M720.039,211.712h7.015v-3.683h-7.015Zm5.986-1.03h-4.956v-1.624h4.956Z",
    transform: "translate(-720.039 -177.108)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237817",
    "data-name": "Path 237817",
    d: "M716.621,224.859,683.684,217v-2.653l32.937,8.054Z",
    transform: "translate(-677.183 -177.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237818",
    "data-name": "Path 237818",
    d: "M717.073,225.432V221.92l-33.967-8.307v3.716Zm-1.03-2.7v1.4l-31.907-7.612v-1.591Z",
    transform: "translate(-677.12 -177.712)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24369",
    "data-name": "Rectangle 24369",
    width: 5.985,
    height: 2.653,
    transform: "translate(0.515 36.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237819",
    "data-name": "Path 237819",
    d: "M720.039,217.454h7.015v-3.683h-7.015Zm5.986-1.03h-4.956V214.8h4.956Z",
    transform: "translate(-720.039 -177.729)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237820",
    "data-name": "Path 237820",
    d: "M716.621,230.22l-32.937-7.475V220.09l32.937,7.673Z",
    transform: "translate(-677.183 -178.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237821",
    "data-name": "Path 237821",
    d: "M717.073,230.787v-3.509l-33.967-7.913v3.713Zm-1.03-2.692v1.4l-31.907-7.242v-1.594Z",
    transform: "translate(-677.12 -178.334)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24370",
    "data-name": "Rectangle 24370",
    width: 5.985,
    height: 2.653,
    transform: "translate(0.515 41.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237822",
    "data-name": "Path 237822",
    d: "M720.039,223.2h7.015v-3.683h-7.015Zm5.986-1.029h-4.956v-1.624h4.956Z",
    transform: "translate(-720.039 -178.35)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237823",
    "data-name": "Path 237823",
    d: "M716.621,235.581l-32.937-7.095v-2.653l32.937,7.292Z",
    transform: "translate(-677.183 -179.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237824",
    "data-name": "Path 237824",
    d: "M717.073,236.141v-3.507l-33.967-7.52v3.71l.407.088Zm-1.03-2.68v1.4l-31.907-6.872v-1.6Z",
    transform: "translate(-677.12 -178.956)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24371",
    "data-name": "Rectangle 24371",
    width: 5.985,
    height: 2.653,
    transform: "translate(0.515 46.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237825",
    "data-name": "Path 237825",
    d: "M720.039,228.939h7.015v-3.683h-7.015Zm5.986-1.03h-4.956v-1.623h4.956Z",
    transform: "translate(-720.039 -178.971)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237826",
    "data-name": "Path 237826",
    d: "M716.621,240.941l-32.937-6.713v-2.653l32.937,6.91Z",
    transform: "translate(-677.183 -179.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237827",
    "data-name": "Path 237827",
    d: "M717.073,241.495v-3.5l-33.967-7.127v3.708Zm-1.03-2.668v1.407l-31.907-6.5v-1.6Z",
    transform: "translate(-677.12 -179.578)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24372",
    "data-name": "Rectangle 24372",
    width: 5.985,
    height: 2.653,
    transform: "translate(0.515 51.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237828",
    "data-name": "Path 237828",
    d: "M720.039,234.681h7.015V231h-7.015Zm5.986-1.03h-4.956v-1.624h4.956Z",
    transform: "translate(-720.039 -179.592)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237829",
    "data-name": "Path 237829",
    d: "M716.621,246.3l-32.937-6.331v-2.653l32.937,6.528Z",
    transform: "translate(-677.183 -180.276)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237830",
    "data-name": "Path 237830",
    d: "M717.073,246.849v-3.5l-.415-.082-33.553-6.651v3.706Zm-1.03-2.656v1.41l-31.907-6.134v-1.6Z",
    transform: "translate(-677.12 -180.2)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24373",
    "data-name": "Rectangle 24373",
    width: 5.985,
    height: 2.653,
    transform: "translate(0.515 57.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237831",
    "data-name": "Path 237831",
    d: "M720.039,240.423h7.015V236.74h-7.015Zm5.986-1.03h-4.956V237.77h4.956Z",
    transform: "translate(-720.039 -180.213)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237832",
    "data-name": "Path 237832",
    d: "M716.621,251.663l-32.937-5.949v-2.654l32.937,6.147Z",
    transform: "translate(-677.183 -180.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237833",
    "data-name": "Path 237833",
    d: "M717.073,252.2v-3.5l-33.967-6.34v3.7l.424.077Zm-1.03-2.644v1.412l-31.907-5.763v-1.6Z",
    transform: "translate(-677.12 -180.822)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24374",
    "data-name": "Rectangle 24374",
    width: 5.985,
    height: 2.653,
    transform: "translate(0.515 62.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237834",
    "data-name": "Path 237834",
    d: "M720.039,246.165h7.015v-3.683h-7.015Zm5.986-1.029h-4.956v-1.624h4.956Z",
    transform: "translate(-720.039 -180.834)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237835",
    "data-name": "Path 237835",
    d: "M716.621,257.024l-32.937-5.569V248.8l32.937,5.766Z",
    transform: "translate(-677.183 -181.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237836",
    "data-name": "Path 237836",
    d: "M717.073,257.559v-3.5l-33.967-5.946v3.7Zm-1.03-2.633v1.414l-31.907-5.395V249.34Z",
    transform: "translate(-677.12 -181.444)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24375",
    "data-name": "Rectangle 24375",
    width: 5.985,
    height: 2.653,
    transform: "translate(0.515 67.284)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237837",
    "data-name": "Path 237837",
    d: "M720.039,251.908h7.015v-3.683h-7.015Zm5.986-1.03h-4.956v-1.624h4.956Z",
    transform: "translate(-720.039 -181.456)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237838",
    "data-name": "Path 237838",
    d: "M716.621,262.385,683.684,257.2v-2.653l32.937,5.384Z",
    transform: "translate(-677.183 -182.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237839",
    "data-name": "Path 237839",
    d: "M717.073,262.914v-3.5l-33.967-5.553v3.7Zm-1.03-2.621v1.416l-31.907-5.025v-1.608Z",
    transform: "translate(-677.12 -182.066)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24376",
    "data-name": "Rectangle 24376",
    width: 5.985,
    height: 2.653,
    transform: "translate(0.515 72.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237840",
    "data-name": "Path 237840",
    d: "M720.039,257.65h7.015v-3.683h-7.015Zm5.986-1.03h-4.956V255h4.956Z",
    transform: "translate(-720.039 -182.077)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237841",
    "data-name": "Path 237841",
    d: "M716.621,267.745l-32.937-4.805v-2.653l32.937,5Z",
    transform: "translate(-677.183 -182.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237842",
    "data-name": "Path 237842",
    d: "M717.073,268.268v-3.493l-.438-.067-33.53-5.093v3.7Zm-1.03-2.609v1.418l-31.907-4.655v-1.609Z",
    transform: "translate(-677.12 -182.687)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24377",
    "data-name": "Rectangle 24377",
    width: 5.985,
    height: 2.653,
    transform: "translate(0.515 77.527)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237843",
    "data-name": "Path 237843",
    d: "M720.039,263.392h7.015v-3.683h-7.015Zm5.986-1.029h-4.956v-1.624h4.956Z",
    transform: "translate(-720.039 -182.698)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237844",
    "data-name": "Path 237844",
    d: "M692.72,268.682v-2.653L717.6,269.52H698.954Z",
    transform: "translate(-686.219 -183.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237845",
    "data-name": "Path 237845",
    d: "M689.594,266.549v1.611l9.587,1.288h-7.735l-2.882-.387v-3.7l29.1,4.083h-7.412Z",
    transform: "translate(-682.578 -183.309)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24378",
    "data-name": "Rectangle 24378",
    width: 5.985,
    height: 2.653,
    transform: "translate(0.515 82.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237846",
    "data-name": "Path 237846",
    d: "M720.039,269.134h7.015v-3.683h-7.015Zm5.986-1.029h-4.956v-1.624h4.956Z",
    transform: "translate(-720.039 -183.319)",
    fill: "#515255"
  }))))))), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237847",
    "data-name": "Path 237847",
    d: "M788.577,31.764,744.583,3.356l43.994,2.469Z",
    transform: "translate(-462.622 -0.363)",
    fill: "#fff"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237848",
    "data-name": "Path 237848",
    d: "M790.429,32.633V5.263L744.005,2.657Zm-1.03-26.4V30.743L747.834,3.9Z",
    transform: "translate(-463.959 -0.287)",
    fill: "#515255"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237849",
    "data-name": "Path 237849",
    d: "M782.956,30.466v210.39H734.822V1.029Z",
    transform: "translate(-448.297 -0.111)",
    fill: "#fff"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237850",
    "data-name": "Path 237850",
    d: "M734.244,0l49.164,30.066V240.744h-1.03V30.642l-47.1-28.806V240.744h-1.03Z",
    transform: "translate(-448.233 0)",
    fill: "#515255"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237851",
    "data-name": "Path 237851",
    d: "M782.956,44.545l-48.134-28.25V8.687l48.134,28.875Z",
    transform: "translate(-448.297 -0.94)",
    fill: "#fff"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237852",
    "data-name": "Path 237852",
    d: "M783.408,45.334V37.161l-.251-.15L734.244,7.669V16.48l.254.149Zm-1.03-7.59v5.791l-47.1-27.645v-6.4Z",
    transform: "translate(-448.233 -0.83)",
    fill: "#515255"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237853",
    "data-name": "Path 237853",
    d: "M782.956,57.71,734.822,30.5V22.895l48.134,27.833Z",
    transform: "translate(-448.297 -2.476)",
    fill: "#fff"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237854",
    "data-name": "Path 237854",
    d: "M783.408,58.484V50.323L734.244,21.894v8.8Zm-1.03-7.567v5.8l-47.1-26.626V23.679Z",
    transform: "translate(-448.233 -2.368)",
    fill: "#515255"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237855",
    "data-name": "Path 237855",
    d: "M782.956,70.876,734.822,44.709V37.1l48.134,26.792Z",
    transform: "translate(-448.297 -4.013)",
    fill: "#fff"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237856",
    "data-name": "Path 237856",
    d: "M783.408,71.636v-8.15L734.244,36.12v8.79Zm-1.03-7.545V69.9L735.274,44.3V37.872Z",
    transform: "translate(-448.233 -3.907)",
    fill: "#515255"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237857",
    "data-name": "Path 237857",
    d: "M782.956,84.042,734.822,58.917V51.309l48.134,25.75Z",
    transform: "translate(-448.297 -5.55)",
    fill: "#fff"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237858",
    "data-name": "Path 237858",
    d: "M783.408,84.787v-8.14l-49.164-26.3v8.779Zm-1.03-7.523v5.824L735.274,58.5V52.065Z",
    transform: "translate(-448.233 -5.446)",
    fill: "#515255"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237859",
    "data-name": "Path 237859",
    d: "M782.956,97.207,734.822,73.124V65.517l48.134,24.708Z",
    transform: "translate(-448.297 -7.087)",
    fill: "#fff"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237860",
    "data-name": "Path 237860",
    d: "M783.408,97.939v-8.13L734.244,64.572v8.769Zm-1.03-7.5v5.835L735.274,72.7V66.258Z",
    transform: "translate(-448.233 -6.984)",
    fill: "#515255"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237861",
    "data-name": "Path 237861",
    d: "M782.956,110.373,734.822,87.331V79.724l48.134,23.667Z",
    transform: "translate(-448.297 -8.623)",
    fill: "#fff"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237862",
    "data-name": "Path 237862",
    d: "M783.408,111.09v-8.12L734.244,78.8v8.759Zm-1.03-7.479v5.844l-47.1-22.549V80.45Z",
    transform: "translate(-448.233 -8.523)",
    fill: "#515255"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237863",
    "data-name": "Path 237863",
    d: "M782.956,123.538l-48.134-22V93.93l48.134,22.626Z",
    transform: "translate(-448.297 -10.16)",
    fill: "#fff"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237864",
    "data-name": "Path 237864",
    d: "M783.408,124.241v-8.11l-49.164-23.11v8.75Zm-1.03-7.457v5.854l-47.1-21.53V94.643Z",
    transform: "translate(-448.233 -10.062)",
    fill: "#515255"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237865",
    "data-name": "Path 237865",
    d: "M782.956,136.7l-48.134-20.959v-7.607l48.134,21.584Z",
    transform: "translate(-448.297 -11.697)",
    fill: "#fff"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237866",
    "data-name": "Path 237866",
    d: "M783.408,137.394v-8.1l-49.164-22.045v8.739Zm-1.03-7.434v5.863l-47.1-20.51v-6.475Z",
    transform: "translate(-448.233 -11.6)",
    fill: "#515255"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237867",
    "data-name": "Path 237867",
    d: "M782.956,149.87l-48.134-19.917v-7.607l48.134,20.543Z",
    transform: "translate(-448.297 -13.233)",
    fill: "#fff"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237868",
    "data-name": "Path 237868",
    d: "M783.408,150.545v-8.093l-49.164-20.981V130.2Zm-1.03-7.412V149l-47.1-19.49V123.03Z",
    transform: "translate(-448.233 -13.139)",
    fill: "#515255"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237869",
    "data-name": "Path 237869",
    d: "M782.956,163.035,734.822,144.16v-7.607l48.134,19.5Z",
    transform: "translate(-448.297 -14.77)",
    fill: "#fff"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237870",
    "data-name": "Path 237870",
    d: "M783.408,163.7v-8.084L734.244,135.7v8.722Zm-1.03-7.39v5.88l-47.1-18.472v-6.492Z",
    transform: "translate(-448.233 -14.678)",
    fill: "#515255"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237871",
    "data-name": "Path 237871",
    d: "M782.956,176.2l-48.134-17.834V150.76l48.134,18.459Z",
    transform: "translate(-448.297 -16.307)",
    fill: "#fff"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237872",
    "data-name": "Path 237872",
    d: "M783.408,176.85v-8.076L734.244,149.92v8.715Zm-1.03-7.367v5.888l-47.1-17.452v-6.5Z",
    transform: "translate(-448.233 -16.216)",
    fill: "#515255"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237873",
    "data-name": "Path 237873",
    d: "M782.956,189.367l-48.134-16.792v-7.607l48.134,17.418Z",
    transform: "translate(-448.297 -17.844)",
    fill: "#fff"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237874",
    "data-name": "Path 237874",
    d: "M783.408,190v-8.068l-.34-.123-48.824-17.667v8.707Zm-1.03-7.346v5.9l-47.1-16.434v-6.507Z",
    transform: "translate(-448.233 -17.755)",
    fill: "#515255"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237875",
    "data-name": "Path 237875",
    d: "M782.956,202.532l-48.134-15.752v-7.606l48.134,16.376Z",
    transform: "translate(-448.297 -19.38)",
    fill: "#fff"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237876",
    "data-name": "Path 237876",
    d: "M783.408,203.156v-8.061l-49.164-16.726v8.7Zm-1.03-7.324v5.9l-47.1-15.414v-6.515Z",
    transform: "translate(-448.233 -19.293)",
    fill: "#515255"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237877",
    "data-name": "Path 237877",
    d: "M782.956,215.7l-48.134-14.71v-7.607l48.134,15.335Z",
    transform: "translate(-448.297 -20.917)",
    fill: "#fff"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237878",
    "data-name": "Path 237878",
    d: "M783.408,216.308v-8.054l-49.164-15.663v8.693Zm-1.03-7.3v5.909l-47.1-14.394V194Z",
    transform: "translate(-448.233 -20.832)",
    fill: "#515255"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237879",
    "data-name": "Path 237879",
    d: "M782.956,228.864,734.822,215.2v-7.607l48.134,14.293Z",
    transform: "translate(-448.297 -22.454)",
    fill: "#fff"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237880",
    "data-name": "Path 237880",
    d: "M783.408,229.461v-8.047l-49.164-14.6V215.5Zm-1.03-7.279V228.1l-47.1-13.376v-6.528Z",
    transform: "translate(-448.233 -22.37)",
    fill: "#515255"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237881",
    "data-name": "Path 237881",
    d: "M782.956,242.029,734.822,229.4V221.8l48.134,13.252Z",
    transform: "translate(-448.297 -23.99)",
    fill: "#fff"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237882",
    "data-name": "Path 237882",
    d: "M783.408,242.614v-8.042l-.378-.1-48.786-13.431v8.68Zm-1.03-7.257v5.923l-47.1-12.356v-6.535Z",
    transform: "translate(-448.233 -23.908)",
    fill: "#515255"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237883",
    "data-name": "Path 237883",
    d: "M782.956,255.195,734.822,243.61V236l48.134,12.21Z",
    transform: "translate(-448.297 -25.527)",
    fill: "#fff"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237884",
    "data-name": "Path 237884",
    d: "M783.408,255.769v-8.036l-49.164-12.471v8.674Zm-1.03-7.235v5.928l-47.1-11.337v-6.54Z",
    transform: "translate(-448.233 -25.447)",
    fill: "#515255"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237885",
    "data-name": "Path 237885",
    d: "M782.956,261.379v6.43h-2.519l-45.615-9.991V250.21Z",
    transform: "translate(-448.297 -27.064)",
    fill: "#fff"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237886",
    "data-name": "Path 237886",
    d: "M782.378,261.709l-47.1-10.93v6.545l47.1,10.318Zm1.03-.818v6.839h-5.441l-43.723-9.577v-8.67Z",
    transform: "translate(-448.233 -26.985)",
    fill: "#515255"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237887",
    "data-name": "Path 237887",
    d: "M785.954,269.345H762.529v-4.928Z",
    transform: "translate(-476.004 -28.601)",
    fill: "#fff"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237888",
    "data-name": "Path 237888",
    d: "M786.164,269.268h-5l-20.408-4.294v4.294h-1.03V263.7Z",
    transform: "translate(-473.714 -28.524)",
    fill: "#515255"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237889",
    "data-name": "Path 237889",
    d: "M851.036,240.856H788.794V11.663L851.036,1.029Z",
    transform: "translate(-564.511 -0.111)",
    fill: "#fff"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237890",
    "data-name": "Path 237890",
    d: "M851.489,240.782h-1.03V1.565L789.246,12.024V240.782h-1.03V11.155L851.489.345Z",
    transform: "translate(-564.449 -0.037)",
    fill: "#515255"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237891",
    "data-name": "Path 237891",
    d: "M838.613,241.407H818.618V9.541l19.995-3.417Z",
    transform: "translate(-578.687 -0.662)",
    fill: "#fff"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237892",
    "data-name": "Path 237892",
    d: "M839.066,241.333h-1.03V6.661L819.07,9.9V241.333h-1.029V9.032L839.066,5.44Z",
    transform: "translate(-578.623 -0.588)",
    fill: "#515255"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237893",
    "data-name": "Path 237893",
    d: "M851.037,8.877,788.794,19.3v-.419L851.037,8.446Z",
    transform: "translate(-564.512 -0.914)",
    fill: "#fff"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237894",
    "data-name": "Path 237894",
    d: "M788.217,19.836l63.272-10.6V7.764l-63.272,10.61Z",
    transform: "translate(-564.45 -0.84)",
    fill: "#515255"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237895",
    "data-name": "Path 237895",
    d: "M851.037,17.407l-62.243,10.2v-.419l62.243-10.212Z",
    transform: "translate(-564.512 -1.836)",
    fill: "#fff"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237896",
    "data-name": "Path 237896",
    d: "M788.217,28.138l63.272-10.368V16.3L788.217,26.677Z",
    transform: "translate(-564.45 -1.763)",
    fill: "#515255"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237897",
    "data-name": "Path 237897",
    d: "M851.037,25.937,788.794,35.91v-.418l62.243-9.986Z",
    transform: "translate(-564.512 -2.759)",
    fill: "#fff"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237898",
    "data-name": "Path 237898",
    d: "M788.217,36.441,851.489,26.3V24.828L788.217,34.979Z",
    transform: "translate(-564.45 -2.686)",
    fill: "#515255"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237899",
    "data-name": "Path 237899",
    d: "M851.037,34.467l-62.243,9.747V43.8l62.243-9.76Z",
    transform: "translate(-564.512 -3.681)",
    fill: "#fff"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237900",
    "data-name": "Path 237900",
    d: "M788.217,44.743l63.272-9.908V33.361l-63.272,9.921Z",
    transform: "translate(-564.45 -3.608)",
    fill: "#515255"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237901",
    "data-name": "Path 237901",
    d: "M851.037,43l-62.243,9.521V52.1l62.243-9.534Z",
    transform: "translate(-564.512 -4.604)",
    fill: "#fff"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237902",
    "data-name": "Path 237902",
    d: "M788.217,53.045l63.272-9.678V41.893l-63.272,9.692Z",
    transform: "translate(-564.45 -4.531)",
    fill: "#515255"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237903",
    "data-name": "Path 237903",
    d: "M851.037,51.527l-62.243,9.295V60.4L851.037,51.1Z",
    transform: "translate(-564.512 -5.527)",
    fill: "#fff"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237904",
    "data-name": "Path 237904",
    d: "M788.217,61.347,851.489,51.9V50.426l-63.272,9.461Z",
    transform: "translate(-564.45 -5.454)",
    fill: "#515255"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237905",
    "data-name": "Path 237905",
    d: "M851.037,60.057l-62.243,9.069v-.418l62.243-9.082Z",
    transform: "translate(-564.512 -6.449)",
    fill: "#fff"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237906",
    "data-name": "Path 237906",
    d: "M788.217,69.649l63.272-9.219V58.958L788.217,68.19Z",
    transform: "translate(-564.45 -6.377)",
    fill: "#515255"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237907",
    "data-name": "Path 237907",
    d: "M851.037,68.587,788.794,77.43v-.419l62.243-8.856Z",
    transform: "translate(-564.512 -7.372)",
    fill: "#fff"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237908",
    "data-name": "Path 237908",
    d: "M788.217,77.951l63.272-8.99V67.49l-63.272,9Z",
    transform: "translate(-564.45 -7.3)",
    fill: "#515255"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237909",
    "data-name": "Path 237909",
    d: "M851.037,77.117l-62.243,8.618v-.419l62.243-8.63Z",
    transform: "translate(-564.512 -8.295)",
    fill: "#fff"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237910",
    "data-name": "Path 237910",
    d: "M788.217,86.254l63.272-8.76V76.022L788.217,84.8Z",
    transform: "translate(-564.45 -8.223)",
    fill: "#515255"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237911",
    "data-name": "Path 237911",
    d: "M851.037,85.647l-62.243,8.391V93.62l62.243-8.4Z",
    transform: "translate(-564.512 -9.217)",
    fill: "#fff"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237912",
    "data-name": "Path 237912",
    d: "M788.217,94.556l63.272-8.53V84.555L788.217,93.1Z",
    transform: "translate(-564.45 -9.146)",
    fill: "#515255"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237913",
    "data-name": "Path 237913",
    d: "M851.037,94.177l-62.243,8.166v-.418l62.243-8.179Z",
    transform: "translate(-564.512 -10.14)",
    fill: "#fff"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237914",
    "data-name": "Path 237914",
    d: "M788.217,102.858l63.272-8.3V93.087L788.217,101.4Z",
    transform: "translate(-564.45 -10.069)",
    fill: "#515255"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237915",
    "data-name": "Path 237915",
    d: "M851.037,102.707l-62.243,7.94v-.419l62.243-7.952Z",
    transform: "translate(-564.512 -11.063)",
    fill: "#fff"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237916",
    "data-name": "Path 237916",
    d: "M788.217,111.16l63.272-8.071v-1.47L788.217,109.7Z",
    transform: "translate(-564.45 -10.992)",
    fill: "#515255"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237917",
    "data-name": "Path 237917",
    d: "M851.037,111.237l-62.243,7.713v-.418l62.243-7.727Z",
    transform: "translate(-564.512 -11.985)",
    fill: "#fff"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237918",
    "data-name": "Path 237918",
    d: "M788.217,119.462l63.272-7.841v-1.47l-63.272,7.854Z",
    transform: "translate(-564.45 -11.914)",
    fill: "#515255"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237919",
    "data-name": "Path 237919",
    d: "M851.037,119.766l-62.243,7.488v-.418l62.243-7.5Z",
    transform: "translate(-564.512 -12.908)",
    fill: "#fff"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237920",
    "data-name": "Path 237920",
    d: "M788.217,127.764l63.272-7.612v-1.469l-63.272,7.625Z",
    transform: "translate(-564.45 -12.837)",
    fill: "#515255"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237921",
    "data-name": "Path 237921",
    d: "M851.037,128.3l-62.243,7.262v-.419l62.243-7.275Z",
    transform: "translate(-564.512 -13.83)",
    fill: "#fff"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237922",
    "data-name": "Path 237922",
    d: "M788.217,136.067l63.272-7.382v-1.469l-63.272,7.4Z",
    transform: "translate(-564.45 -13.76)",
    fill: "#515255"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237923",
    "data-name": "Path 237923",
    d: "M851.037,136.826l-62.243,7.036v-.418l62.243-7.049Z",
    transform: "translate(-564.512 -14.753)",
    fill: "#fff"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237924",
    "data-name": "Path 237924",
    d: "M788.217,144.369l63.272-7.152v-1.468l-63.272,7.166Z",
    transform: "translate(-564.45 -14.683)",
    fill: "#515255"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237925",
    "data-name": "Path 237925",
    d: "M851.037,145.356l-62.243,6.81v-.418l62.243-6.823Z",
    transform: "translate(-564.512 -15.676)",
    fill: "#fff"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237926",
    "data-name": "Path 237926",
    d: "M788.217,152.671l63.272-6.922v-1.468l-63.272,6.936Z",
    transform: "translate(-564.45 -15.606)",
    fill: "#515255"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237927",
    "data-name": "Path 237927",
    d: "M851.037,153.886l-62.243,6.584v-.419l62.243-6.6Z",
    transform: "translate(-564.512 -16.598)",
    fill: "#fff"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237928",
    "data-name": "Path 237928",
    d: "M788.217,160.973l63.272-6.693v-1.467l-63.272,6.706Z",
    transform: "translate(-564.45 -16.529)",
    fill: "#515255"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237929",
    "data-name": "Path 237929",
    d: "M851.037,162.416l-62.243,6.359v-.419l62.243-6.371Z",
    transform: "translate(-564.512 -17.521)",
    fill: "#fff"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237930",
    "data-name": "Path 237930",
    d: "M788.217,169.276l63.272-6.464v-1.466l-63.272,6.477Z",
    transform: "translate(-564.45 -17.452)",
    fill: "#515255"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237931",
    "data-name": "Path 237931",
    d: "M851.037,170.946l-62.243,6.132v-.418l62.243-6.146Z",
    transform: "translate(-564.512 -18.444)",
    fill: "#fff"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237932",
    "data-name": "Path 237932",
    d: "M788.217,177.578l63.272-6.234v-1.466l-63.272,6.246Z",
    transform: "translate(-564.45 -18.375)",
    fill: "#515255"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237933",
    "data-name": "Path 237933",
    d: "M851.037,179.476l-62.243,5.907v-.418l62.243-5.92Z",
    transform: "translate(-564.512 -19.366)",
    fill: "#fff"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237934",
    "data-name": "Path 237934",
    d: "M788.217,185.88l63.272-6V178.41l-63.272,6.017Z",
    transform: "translate(-564.45 -19.298)",
    fill: "#515255"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237935",
    "data-name": "Path 237935",
    d: "M851.037,188.006l-62.243,5.681v-.419l62.243-5.693Z",
    transform: "translate(-564.512 -20.289)",
    fill: "#fff"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237936",
    "data-name": "Path 237936",
    d: "M788.217,194.182l63.272-5.775v-1.465l-63.272,5.787Z",
    transform: "translate(-564.45 -20.221)",
    fill: "#515255"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237937",
    "data-name": "Path 237937",
    d: "M851.037,196.536l-62.243,5.454v-.418l62.243-5.468Z",
    transform: "translate(-564.512 -21.212)",
    fill: "#fff"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237938",
    "data-name": "Path 237938",
    d: "M788.217,202.484l63.272-5.545v-1.466l-63.272,5.559Z",
    transform: "translate(-564.45 -21.143)",
    fill: "#515255"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237939",
    "data-name": "Path 237939",
    d: "M851.037,205.066l-62.243,5.229v-.418l62.243-5.242Z",
    transform: "translate(-564.512 -22.134)",
    fill: "#fff"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237940",
    "data-name": "Path 237940",
    d: "M788.217,210.787l.558-.046,62.714-5.269v-1.465l-63.272,5.329Z",
    transform: "translate(-564.45 -22.066)",
    fill: "#515255"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237941",
    "data-name": "Path 237941",
    d: "M851.037,213.6l-62.243,5v-.419l62.243-5.016Z",
    transform: "translate(-564.512 -23.057)",
    fill: "#fff"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237942",
    "data-name": "Path 237942",
    d: "M788.217,219.089,851.489,214v-1.464l-63.272,5.1Z",
    transform: "translate(-564.45 -22.989)",
    fill: "#515255"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237943",
    "data-name": "Path 237943",
    d: "M851.037,222.126,788.794,226.9v-.418l62.243-4.79Z",
    transform: "translate(-564.512 -23.979)",
    fill: "#fff"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237944",
    "data-name": "Path 237944",
    d: "M788.217,227.391l.555-.042,62.718-4.814v-1.464l-.554.043-62.718,4.827Z",
    transform: "translate(-564.45 -23.912)",
    fill: "#515255"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237945",
    "data-name": "Path 237945",
    d: "M851.037,230.656l-62.243,4.551v-.418l62.243-4.564Z",
    transform: "translate(-564.512 -24.902)",
    fill: "#fff"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237946",
    "data-name": "Path 237946",
    d: "M788.217,235.694l.552-.04,62.72-4.587V229.6l-63.272,4.639Z",
    transform: "translate(-564.45 -24.835)",
    fill: "#515255"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237947",
    "data-name": "Path 237947",
    d: "M851.037,239.186l-62.243,4.325v-.419l62.243-4.338Z",
    transform: "translate(-564.512 -25.825)",
    fill: "#fff"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237948",
    "data-name": "Path 237948",
    d: "M788.217,244l63.272-4.4v-1.464l-.55.039-62.722,4.371Z",
    transform: "translate(-564.45 -25.758)",
    fill: "#515255"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237949",
    "data-name": "Path 237949",
    d: "M851.037,247.715l-62.243,4.1V251.4l62.243-4.112Z",
    transform: "translate(-564.512 -26.747)",
    fill: "#fff"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237950",
    "data-name": "Path 237950",
    d: "M788.217,252.3l.549-.036,62.724-4.131v-1.464l-63.272,4.18Z",
    transform: "translate(-564.45 -26.681)",
    fill: "#515255"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237951",
    "data-name": "Path 237951",
    d: "M851.037,256.245l-62.243,3.873V259.7l62.243-3.887Z",
    transform: "translate(-564.512 -27.67)",
    fill: "#fff"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237952",
    "data-name": "Path 237952",
    d: "M788.217,260.6l.547-.034,62.725-3.9V255.2l-63.272,3.951Z",
    transform: "translate(-564.45 -27.604)",
    fill: "#515255"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237953",
    "data-name": "Path 237953",
    d: "M851.037,264.775l-62.243,3.648V268l62.243-3.661Z",
    transform: "translate(-564.512 -28.593)",
    fill: "#fff"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237954",
    "data-name": "Path 237954",
    d: "M851.489,265.194l-62.728,3.676-.545.032v-1.45l63.273-3.722Z",
    transform: "translate(-564.449 -28.526)",
    fill: "#515255"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237955",
    "data-name": "Path 237955",
    d: "M776.293,47.607l-35.6-20.586v-5l35.6,20.894Z",
    transform: "translate(-446.869 -2.382)",
    fill: "#fd930d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_84334",
    "data-name": "Group 84334",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84333",
    "data-name": "Group 84333",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84329",
    "data-name": "Group 84329",
    transform: "translate(223.764 0.308)",
    opacity: 0.75,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84328",
    "data-name": "Group 84328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84327",
    "data-name": "Group 84327",
    clipPath: "url(#clip-path-71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_237956",
    "data-name": "Path 237956",
    d: "M788.794,11.663,851.037,1.03V240.856H788.794Z",
    transform: "translate(-788.279 -0.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237957",
    "data-name": "Path 237957",
    d: "M850.459,1.566,789.246,12.023V240.782h-1.03V11.155L851.49.346V240.782h-1.03Z",
    transform: "translate(-788.217 -0.345)",
    fill: "#515255"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84332",
    "data-name": "Group 84332",
    transform: "translate(266.089 82.266)",
    opacity: 0.67,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84331",
    "data-name": "Group 84331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84330",
    "data-name": "Group 84330",
    clipPath: "url(#clip-path-72)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24382",
    "data-name": "Rectangle 24382",
    width: 19.917,
    height: 157.963,
    transform: "translate(0.515 0.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237958",
    "data-name": "Path 237958",
    d: "M808.134,93.274H789.246V250.722h-1.029V92.244h20.947V250.722h-1.03Z",
    transform: "translate(-788.216 -92.244)",
    fill: "#515255"
  }))))))), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237959",
    "data-name": "Path 237959",
    d: "M917.949,245.385H851.142V57.842L917.949,42.9Z",
    transform: "translate(-687.028 -4.641)",
    fill: "#fff"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237960",
    "data-name": "Path 237960",
    d: "M918.4,245.307h-1.03V43.469L851.593,58.177v187.13h-1.029V57.352L918.4,42.184Z",
    transform: "translate(-686.964 -4.563)",
    fill: "#515255"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237961",
    "data-name": "Path 237961",
    d: "M917.949,61.284,851.141,75.413V67.5l66.807-14.518Z",
    transform: "translate(-687.027 -5.731)",
    fill: "#fff"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237962",
    "data-name": "Path 237962",
    d: "M850.564,75.971,918.4,61.624V52.269L850.564,67.01ZM917.37,60.79,851.593,74.7V67.84L917.37,53.547Z",
    transform: "translate(-686.964 -5.654)",
    fill: "#515255"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237963",
    "data-name": "Path 237963",
    d: "M917.949,74.777,851.141,88.343V80.432l66.807-13.955Z",
    transform: "translate(-687.027 -7.191)",
    fill: "#fff"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237964",
    "data-name": "Path 237964",
    d: "M850.564,88.9l.617-.125L918.4,75.122V65.768L850.564,79.937ZM917.37,74.28,851.593,87.636V80.774L917.37,67.035Z",
    transform: "translate(-686.964 -7.114)",
    fill: "#515255"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237965",
    "data-name": "Path 237965",
    d: "M917.949,88.27l-66.807,13V93.362l66.807-13.391Z",
    transform: "translate(-687.027 -8.65)",
    fill: "#fff"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237966",
    "data-name": "Path 237966",
    d: "M850.564,101.822l.613-.12L918.4,88.619V79.267l-67.837,13.6ZM917.37,87.77l-65.777,12.8V93.708L917.37,80.524Z",
    transform: "translate(-686.964 -8.574)",
    fill: "#515255"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237967",
    "data-name": "Path 237967",
    d: "M917.949,101.763,851.141,114.2v-7.91l66.807-12.828Z",
    transform: "translate(-687.027 -10.109)",
    fill: "#fff"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237968",
    "data-name": "Path 237968",
    d: "M850.564,114.746l67.837-12.63V92.765L850.564,105.79ZM917.37,101.26l-65.777,12.247v-6.865L917.37,94.012Z",
    transform: "translate(-686.964 -10.034)",
    fill: "#515255"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237969",
    "data-name": "Path 237969",
    d: "M917.949,115.256l-66.807,11.876v-7.911l66.807-12.265Z",
    transform: "translate(-687.027 -11.569)",
    fill: "#fff"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237970",
    "data-name": "Path 237970",
    d: "M850.564,127.671,918.4,115.612v-9.348l-67.837,12.454ZM917.37,114.75l-65.777,11.693v-6.868L917.37,107.5Z",
    transform: "translate(-686.964 -11.494)",
    fill: "#515255"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237971",
    "data-name": "Path 237971",
    d: "M917.949,128.749l-66.807,11.312v-7.911l66.807-11.7Z",
    transform: "translate(-687.027 -13.028)",
    fill: "#fff"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237972",
    "data-name": "Path 237972",
    d: "M850.564,140.6,918.4,129.11v-9.347l-67.837,11.881ZM917.37,128.24l-65.777,11.138v-6.869l65.777-11.52Z",
    transform: "translate(-686.964 -12.954)",
    fill: "#515255"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237973",
    "data-name": "Path 237973",
    d: "M917.949,142.242l-66.807,10.748v-7.91l66.807-11.138Z",
    transform: "translate(-687.027 -14.488)",
    fill: "#fff"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237974",
    "data-name": "Path 237974",
    d: "M850.564,153.522,918.4,142.608v-9.346L850.564,144.57ZM917.37,141.73l-65.777,10.583v-6.871l65.777-10.965Z",
    transform: "translate(-686.964 -14.414)",
    fill: "#515255"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237975",
    "data-name": "Path 237975",
    d: "M917.949,155.735l-66.807,10.186V158.01l66.807-10.574Z",
    transform: "translate(-687.027 -15.947)",
    fill: "#fff"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237976",
    "data-name": "Path 237976",
    d: "M850.564,166.447,918.4,156.1v-9.344L850.564,157.5ZM917.37,155.22l-65.777,10.029v-6.872l65.777-10.411Z",
    transform: "translate(-686.964 -15.874)",
    fill: "#515255"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237977",
    "data-name": "Path 237977",
    d: "M917.949,169.228l-66.807,9.622V170.94l66.807-10.011Z",
    transform: "translate(-687.027 -17.407)",
    fill: "#fff"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237978",
    "data-name": "Path 237978",
    d: "M850.564,179.373,918.4,169.6v-9.343l-67.837,10.165ZM917.37,168.71l-65.777,9.474v-6.872l65.777-9.857Z",
    transform: "translate(-686.964 -17.334)",
    fill: "#515255"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237979",
    "data-name": "Path 237979",
    d: "M917.949,182.721l-66.807,9.058v-7.91l66.807-9.448Z",
    transform: "translate(-687.027 -18.866)",
    fill: "#fff"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237980",
    "data-name": "Path 237980",
    d: "M850.564,192.3l67.837-9.2v-9.342l-67.837,9.593Zm66.806-10.1-65.777,8.919v-6.874l65.777-9.3Z",
    transform: "translate(-686.964 -18.795)",
    fill: "#515255"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237981",
    "data-name": "Path 237981",
    d: "M917.949,196.215l-66.807,8.5V196.8l66.807-8.884Z",
    transform: "translate(-687.027 -20.326)",
    fill: "#fff"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237982",
    "data-name": "Path 237982",
    d: "M850.564,205.223,918.4,196.6v-9.339l-67.837,9.02Zm66.806-9.534-65.777,8.365v-6.875l65.777-8.746Z",
    transform: "translate(-686.964 -20.255)",
    fill: "#515255"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237983",
    "data-name": "Path 237983",
    d: "M917.949,209.708l-66.807,7.932v-7.911l66.807-8.321Z",
    transform: "translate(-687.027 -21.785)",
    fill: "#fff"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237984",
    "data-name": "Path 237984",
    d: "M850.564,218.148l67.837-8.055v-9.339L850.564,209.2Zm66.806-8.969-65.777,7.81v-6.876l65.777-8.192Z",
    transform: "translate(-686.964 -21.714)",
    fill: "#515255"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237985",
    "data-name": "Path 237985",
    d: "M917.949,223.2l-66.807,7.368v-7.91l66.807-7.758Z",
    transform: "translate(-687.027 -23.245)",
    fill: "#fff"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237986",
    "data-name": "Path 237986",
    d: "M850.564,231.074l67.837-7.483v-9.338l-67.837,7.878Zm66.806-8.4-65.777,7.255v-6.877l65.777-7.638Z",
    transform: "translate(-686.964 -23.175)",
    fill: "#515255"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237987",
    "data-name": "Path 237987",
    d: "M917.949,236.694,851.141,243.5v-7.911l66.807-7.194Z",
    transform: "translate(-687.027 -24.704)",
    fill: "#fff"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237988",
    "data-name": "Path 237988",
    d: "M850.564,244l67.837-6.91v-9.338l-67.837,7.305Zm66.806-7.84-65.777,6.7v-6.879L917.37,228.9Z",
    transform: "translate(-686.964 -24.635)",
    fill: "#515255"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237989",
    "data-name": "Path 237989",
    d: "M917.949,250.187l-66.807,6.242v-7.911l66.807-6.631Z",
    transform: "translate(-687.027 -26.164)",
    fill: "#fff"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237990",
    "data-name": "Path 237990",
    d: "M850.564,256.925l67.837-6.338V241.25l-.566.056-67.27,6.676Zm66.806-7.276-65.777,6.146v-6.879l65.777-6.528Z",
    transform: "translate(-686.964 -26.095)",
    fill: "#515255"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237991",
    "data-name": "Path 237991",
    d: "M917.949,263.68,862.8,268.368H851.142v-6.92l66.807-6.067Z",
    transform: "translate(-687.028 -27.623)",
    fill: "#fff"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237992",
    "data-name": "Path 237992",
    d: "M918.4,264.084l-49.59,4.216H856.653l60.717-5.161v-7.262l-65.777,5.973v6.45h-1.029v-7.39l67.837-6.162Z",
    transform: "translate(-686.964 -27.555)",
    fill: "#515255"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237993",
    "data-name": "Path 237993",
    d: "M862.717,269.827H851.142l11.575-.953Z",
    transform: "translate(-631.795 -29.083)",
    fill: "#fff"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237994",
    "data-name": "Path 237994",
    d: "M868.926,269.759H867.9v-.4l-4.789.4H850.564l18.362-1.513Z",
    transform: "translate(-637.489 -29.015)",
    fill: "#515255"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237995",
    "data-name": "Path 237995",
    d: "M854.255,245.45h-.434V43.6l.434-.1Z",
    transform: "translate(-625.723 -4.705)",
    fill: "#fff"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237996",
    "data-name": "Path 237996",
    d: "M854.707,245.372h-1.464V43.109l1.464-.326Z",
    transform: "translate(-625.661 -4.628)",
    fill: "#515255"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237997",
    "data-name": "Path 237997",
    d: "M857.409,245.527h-.432V44.305l.432-.1Z",
    transform: "translate(-631.692 -4.782)",
    fill: "#fff"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237998",
    "data-name": "Path 237998",
    d: "M857.861,245.449H856.4V43.815l1.462-.326Z",
    transform: "translate(-631.629 -4.704)",
    fill: "#515255"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237999",
    "data-name": "Path 237999",
    d: "M860.551,245.6h-.431V45.008l.431-.1Z",
    transform: "translate(-637.637 -4.858)",
    fill: "#fff"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238000",
    "data-name": "Path 238000",
    d: "M861,245.525h-1.46V44.518l1.46-.326Z",
    transform: "translate(-637.574 -4.78)",
    fill: "#515255"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238001",
    "data-name": "Path 238001",
    d: "M863.681,245.678h-.429V45.708l.429-.1Z",
    transform: "translate(-643.56 -4.934)",
    fill: "#fff"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238002",
    "data-name": "Path 238002",
    d: "M864.132,245.6h-1.458V45.217l1.458-.326Z",
    transform: "translate(-643.496 -4.856)",
    fill: "#515255"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238003",
    "data-name": "Path 238003",
    d: "M866.8,245.754h-.427V46.4l.427-.1Z",
    transform: "translate(-649.458 -5.009)",
    fill: "#fff"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238004",
    "data-name": "Path 238004",
    d: "M867.249,245.676h-1.456V45.915l1.456-.326Z",
    transform: "translate(-649.394 -4.931)",
    fill: "#515255"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238005",
    "data-name": "Path 238005",
    d: "M869.9,245.829h-.425V47.1l.425-.1Z",
    transform: "translate(-655.334 -5.084)",
    fill: "#fff"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238006",
    "data-name": "Path 238006",
    d: "M870.355,245.751H868.9V46.61l1.455-.326Z",
    transform: "translate(-655.271 -5.006)",
    fill: "#515255"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238007",
    "data-name": "Path 238007",
    d: "M873,245.9h-.424V47.791L873,47.7Z",
    transform: "translate(-661.186 -5.159)",
    fill: "#fff"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238008",
    "data-name": "Path 238008",
    d: "M873.447,245.826h-1.453V47.3l1.453-.326Z",
    transform: "translate(-661.123 -5.081)",
    fill: "#515255"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238009",
    "data-name": "Path 238009",
    d: "M876.076,245.978h-.422V48.48l.422-.094Z",
    transform: "translate(-667.016 -5.234)",
    fill: "#fff"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238010",
    "data-name": "Path 238010",
    d: "M876.528,245.9h-1.451V47.989l1.451-.324Z",
    transform: "translate(-666.953 -5.156)",
    fill: "#515255"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238011",
    "data-name": "Path 238011",
    d: "M879.145,246.053h-.42V49.166l.42-.094Z",
    transform: "translate(-672.823 -5.308)",
    fill: "#fff"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238012",
    "data-name": "Path 238012",
    d: "M879.6,245.975h-1.45V48.676l1.45-.325Z",
    transform: "translate(-672.76 -5.23)",
    fill: "#515255"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238013",
    "data-name": "Path 238013",
    d: "M882.2,246.126h-.418V49.85l.418-.095Z",
    transform: "translate(-678.607 -5.382)",
    fill: "#fff"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238014",
    "data-name": "Path 238014",
    d: "M882.654,246.048h-1.449V49.359l1.449-.325Z",
    transform: "translate(-678.545 -5.304)",
    fill: "#515255"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238015",
    "data-name": "Path 238015",
    d: "M885.246,246.2h-.417V50.531l.417-.094Z",
    transform: "translate(-684.369 -5.456)",
    fill: "#fff"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238016",
    "data-name": "Path 238016",
    d: "M885.7,246.122h-1.448V50.04l1.448-.324Z",
    transform: "translate(-684.307 -5.378)",
    fill: "#515255"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238017",
    "data-name": "Path 238017",
    d: "M888.279,246.273h-.415V51.209l.415-.094Z",
    transform: "translate(-690.108 -5.529)",
    fill: "#fff"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238018",
    "data-name": "Path 238018",
    d: "M888.732,246.2h-1.446V50.718l1.446-.323Z",
    transform: "translate(-690.046 -5.451)",
    fill: "#515255"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238019",
    "data-name": "Path 238019",
    d: "M891.3,246.347h-.414V51.884l.414-.093Z",
    transform: "translate(-695.827 -5.602)",
    fill: "#fff"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238020",
    "data-name": "Path 238020",
    d: "M891.753,246.269H890.31V51.394l1.444-.323Z",
    transform: "translate(-695.763 -5.524)",
    fill: "#515255"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238021",
    "data-name": "Path 238021",
    d: "M894.311,246.42H893.9V52.557l.412-.092Z",
    transform: "translate(-701.522 -5.675)",
    fill: "#fff"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238022",
    "data-name": "Path 238022",
    d: "M894.763,246.342h-1.442V52.067l1.442-.323Z",
    transform: "translate(-701.459 -5.597)",
    fill: "#515255"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238023",
    "data-name": "Path 238023",
    d: "M897.309,246.492h-.41V53.227l.41-.091Z",
    transform: "translate(-707.195 -5.747)",
    fill: "#fff"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238024",
    "data-name": "Path 238024",
    d: "M897.761,246.414h-1.44V52.737l1.44-.322Z",
    transform: "translate(-707.132 -5.669)",
    fill: "#515255"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238025",
    "data-name": "Path 238025",
    d: "M900.3,246.564h-.409V53.895l.409-.091Z",
    transform: "translate(-712.847 -5.82)",
    fill: "#fff"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238026",
    "data-name": "Path 238026",
    d: "M900.748,246.486h-1.439V53.405l1.439-.321Z",
    transform: "translate(-712.784 -5.742)",
    fill: "#515255"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238027",
    "data-name": "Path 238027",
    d: "M903.27,246.636h-.407V54.56l.407-.09Z",
    transform: "translate(-718.476 -5.892)",
    fill: "#fff"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238028",
    "data-name": "Path 238028",
    d: "M903.724,246.558h-1.438V54.071l1.438-.322Z",
    transform: "translate(-718.414 -5.814)",
    fill: "#515255"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238029",
    "data-name": "Path 238029",
    d: "M906.234,246.708h-.406V55.224l.406-.091Z",
    transform: "translate(-724.084 -5.963)",
    fill: "#fff"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238030",
    "data-name": "Path 238030",
    d: "M906.687,246.63h-1.436V54.733l1.436-.321Z",
    transform: "translate(-724.023 -5.885)",
    fill: "#515255"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238031",
    "data-name": "Path 238031",
    d: "M909.187,246.78h-.4V55.883l.4-.09Z",
    transform: "translate(-729.672 -6.035)",
    fill: "#fff"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238032",
    "data-name": "Path 238032",
    d: "M909.639,246.7h-1.434V55.393l1.434-.32Z",
    transform: "translate(-729.609 -5.957)",
    fill: "#515255"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238033",
    "data-name": "Path 238033",
    d: "M912.128,246.851h-.4V56.541l.4-.09Z",
    transform: "translate(-735.237 -6.106)",
    fill: "#fff"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238034",
    "data-name": "Path 238034",
    d: "M912.581,246.773h-1.433V56.05l1.433-.32Z",
    transform: "translate(-735.176 -6.028)",
    fill: "#515255"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238035",
    "data-name": "Path 238035",
    d: "M915.059,246.922h-.4V57.2l.4-.09Z",
    transform: "translate(-740.782 -6.177)",
    fill: "#fff"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238036",
    "data-name": "Path 238036",
    d: "M915.511,246.844h-1.431V56.706l1.431-.32Z",
    transform: "translate(-740.72 -6.099)",
    fill: "#515255"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238037",
    "data-name": "Path 238037",
    d: "M917.977,246.992h-.4V57.849l.4-.09Z",
    transform: "translate(-746.305 -6.247)",
    fill: "#fff"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238038",
    "data-name": "Path 238038",
    d: "M918.43,246.914H917V57.358l1.43-.319Z",
    transform: "translate(-746.243 -6.17)",
    fill: "#515255"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238039",
    "data-name": "Path 238039",
    d: "M920.884,247.063h-.4V58.5l.4-.089Z",
    transform: "translate(-751.807 -6.318)",
    fill: "#fff"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238040",
    "data-name": "Path 238040",
    d: "M921.338,246.985H919.91V58.009l1.428-.32Z",
    transform: "translate(-751.746 -6.24)",
    fill: "#515255"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238041",
    "data-name": "Path 238041",
    d: "M923.781,247.133h-.4V59.147l.4-.089Z",
    transform: "translate(-757.289 -6.388)",
    fill: "#fff"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238042",
    "data-name": "Path 238042",
    d: "M924.234,247.055h-1.426V58.656l1.426-.318Z",
    transform: "translate(-757.227 -6.31)",
    fill: "#515255"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238043",
    "data-name": "Path 238043",
    d: "M917.949,54.718,851.141,69.162v-.4L917.949,54.3Z",
    transform: "translate(-687.027 -5.874)",
    fill: "#fff"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238044",
    "data-name": "Path 238044",
    d: "M850.564,69.722,918.4,55.057V53.588L850.564,68.273Z",
    transform: "translate(-686.965 -5.796)",
    fill: "#515255"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238045",
    "data-name": "Path 238045",
    d: "M917.949,68.444l-66.807,13.87v-.4l66.807-13.889Z",
    transform: "translate(-687.027 -7.358)",
    fill: "#fff"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238046",
    "data-name": "Path 238046",
    d: "M850.564,82.87,918.4,68.787V67.32l-67.837,14.1Z",
    transform: "translate(-686.965 -7.282)",
    fill: "#515255"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238047",
    "data-name": "Path 238047",
    d: "M917.949,82.17l-66.807,13.3v-.4l66.807-13.316Z",
    transform: "translate(-687.027 -8.843)",
    fill: "#fff"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238048",
    "data-name": "Path 238048",
    d: "M850.564,96.018l67.837-13.5V81.051L850.564,94.572Z",
    transform: "translate(-686.965 -8.767)",
    fill: "#515255"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238049",
    "data-name": "Path 238049",
    d: "M917.949,95.9l-66.807,12.724v-.4l66.807-12.743Z",
    transform: "translate(-687.027 -10.328)",
    fill: "#fff"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238050",
    "data-name": "Path 238050",
    d: "M850.564,109.166,918.4,96.246V94.782l-67.837,12.94Z",
    transform: "translate(-686.965 -10.252)",
    fill: "#515255"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238051",
    "data-name": "Path 238051",
    d: "M917.949,109.621l-66.807,12.15v-.4l66.807-12.17Z",
    transform: "translate(-687.027 -11.812)",
    fill: "#fff"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238052",
    "data-name": "Path 238052",
    d: "M850.564,122.314,918.4,109.976v-1.462l-67.837,12.357Z",
    transform: "translate(-686.965 -11.737)",
    fill: "#515255"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238053",
    "data-name": "Path 238053",
    d: "M917.949,123.347l-66.807,11.578v-.4l66.807-11.6Z",
    transform: "translate(-687.027 -13.297)",
    fill: "#fff"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238054",
    "data-name": "Path 238054",
    d: "M850.564,135.462,918.4,123.706v-1.46l-67.837,11.776Z",
    transform: "translate(-686.965 -13.223)",
    fill: "#515255"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238055",
    "data-name": "Path 238055",
    d: "M917.949,137.072l-66.807,11v-.4l66.807-11.024Z",
    transform: "translate(-687.027 -14.782)",
    fill: "#fff"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238056",
    "data-name": "Path 238056",
    d: "M850.564,148.61,918.4,137.436v-1.459l-67.837,11.193Z",
    transform: "translate(-686.965 -14.708)",
    fill: "#515255"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238057",
    "data-name": "Path 238057",
    d: "M917.949,150.8,851.141,161.23v-.4l66.807-10.451Z",
    transform: "translate(-687.027 -16.266)",
    fill: "#fff"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238058",
    "data-name": "Path 238058",
    d: "M850.564,161.758,918.4,151.166v-1.457L850.564,160.32Z",
    transform: "translate(-686.965 -16.193)",
    fill: "#515255"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238059",
    "data-name": "Path 238059",
    d: "M917.949,164.524l-66.807,9.858v-.4l66.807-9.878Z",
    transform: "translate(-687.027 -17.751)",
    fill: "#fff"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238060",
    "data-name": "Path 238060",
    d: "M850.564,174.906,918.4,164.9V163.44l-67.837,10.03Z",
    transform: "translate(-686.965 -17.678)",
    fill: "#515255"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238061",
    "data-name": "Path 238061",
    d: "M917.949,178.249l-66.807,9.286v-.4l66.807-9.3Z",
    transform: "translate(-687.027 -19.235)",
    fill: "#fff"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238062",
    "data-name": "Path 238062",
    d: "M850.564,188.054l67.837-9.428v-1.455l-67.837,9.448Z",
    transform: "translate(-686.965 -19.164)",
    fill: "#515255"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238063",
    "data-name": "Path 238063",
    d: "M917.949,191.975l-66.807,8.712v-.4l66.807-8.732Z",
    transform: "translate(-687.027 -20.72)",
    fill: "#fff"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238064",
    "data-name": "Path 238064",
    d: "M850.564,201.2l67.837-8.847V190.9l-67.837,8.867Z",
    transform: "translate(-686.965 -20.649)",
    fill: "#515255"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238065",
    "data-name": "Path 238065",
    d: "M917.949,205.7l-66.807,8.139v-.4l66.807-8.158Z",
    transform: "translate(-687.027 -22.205)",
    fill: "#fff"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238066",
    "data-name": "Path 238066",
    d: "M850.564,214.351l.577-.07,67.26-8.194v-1.453l-67.837,8.285Z",
    transform: "translate(-686.965 -22.134)",
    fill: "#515255"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238067",
    "data-name": "Path 238067",
    d: "M917.949,219.426l-66.807,7.566v-.4l66.807-7.585Z",
    transform: "translate(-687.027 -23.689)",
    fill: "#fff"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238068",
    "data-name": "Path 238068",
    d: "M850.564,227.5l.573-.065,67.264-7.617v-1.452l-67.837,7.7Z",
    transform: "translate(-686.965 -23.619)",
    fill: "#515255"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238069",
    "data-name": "Path 238069",
    d: "M917.949,233.152l-66.807,6.993v-.4l66.807-7.013Z",
    transform: "translate(-687.027 -25.174)",
    fill: "#fff"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238070",
    "data-name": "Path 238070",
    d: "M850.564,240.647l.568-.06,67.269-7.041V232.1l-67.837,7.121Z",
    transform: "translate(-686.965 -25.105)",
    fill: "#515255"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238071",
    "data-name": "Path 238071",
    d: "M917.949,246.878l-66.807,6.42v-.4l66.807-6.439Z",
    transform: "translate(-687.027 -26.659)",
    fill: "#fff"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238072",
    "data-name": "Path 238072",
    d: "M850.564,253.8l67.837-6.519v-1.449l-67.837,6.539Z",
    transform: "translate(-686.965 -26.59)",
    fill: "#515255"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238073",
    "data-name": "Path 238073",
    d: "M917.949,260.6l-66.807,5.847v-.4l66.807-5.866Z",
    transform: "translate(-687.027 -28.143)",
    fill: "#fff"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238074",
    "data-name": "Path 238074",
    d: "M850.564,266.944l67.837-5.937v-1.449l-67.837,5.957Z",
    transform: "translate(-686.965 -28.075)",
    fill: "#515255"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238075",
    "data-name": "Path 238075",
    d: "M846.814,59.637V245.385H811.128V42.9Z",
    transform: "translate(-580.206 -4.641)",
    fill: "#fff"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238076",
    "data-name": "Path 238076",
    d: "M847.266,59.211V245.287h-1.03V59.865L811.58,43.616V245.287h-1.03V42Z",
    transform: "translate(-580.143 -4.542)",
    fill: "#515255"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84339",
    "data-name": "Group 84339",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84338",
    "data-name": "Group 84338",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84337",
    "data-name": "Group 84337",
    transform: "translate(230.403 46.454)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84336",
    "data-name": "Group 84336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84335",
    "data-name": "Group 84335",
    clipPath: "url(#clip-path-74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238077",
    "data-name": "Path 238077",
    d: "M846.813,77.11,811.128,61.285v-8.3l35.686,16.261Z",
    transform: "translate(-810.613 -52.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238078",
    "data-name": "Path 238078",
    d: "M847.266,77.8V68.818L810.55,52.088v9.434Zm-1.03-8.324v6.741L811.58,60.852V53.689Z",
    transform: "translate(-810.55 -52.088)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238079",
    "data-name": "Path 238079",
    d: "M846.813,89.972l-35.686-15.2v-8.3l35.686,15.629Z",
    transform: "translate(-810.613 -53.645)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238080",
    "data-name": "Path 238080",
    d: "M847.266,90.657v-8.98L810.55,65.6v9.427Zm-1.03-8.307V89.1L811.58,74.342V67.171Z",
    transform: "translate(-810.55 -53.549)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238081",
    "data-name": "Path 238081",
    d: "M846.813,102.834,811.128,88.271v-8.3l35.686,15Z",
    transform: "translate(-810.613 -55.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238082",
    "data-name": "Path 238082",
    d: "M847.266,103.506V94.534L810.55,79.1v9.42Zm-1.03-8.288v6.756L811.58,87.83V80.652Z",
    transform: "translate(-810.55 -55.01)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238083",
    "data-name": "Path 238083",
    d: "M846.813,115.7l-35.686-13.933v-8.3l35.686,14.367Z",
    transform: "translate(-810.613 -56.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238084",
    "data-name": "Path 238084",
    d: "M847.266,116.358v-8.966L810.55,92.609v9.413l.327.128Zm-1.03-8.27v6.763L811.58,101.32V94.134Z",
    transform: "translate(-810.55 -56.471)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238085",
    "data-name": "Path 238085",
    d: "M846.813,128.558l-35.686-13.3v-8.3l35.686,13.737Z",
    transform: "translate(-810.613 -58.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238086",
    "data-name": "Path 238086",
    d: "M847.266,129.209V120.25L810.55,106.117v9.406Zm-1.03-8.252v6.769L811.58,114.808v-7.192Z",
    transform: "translate(-810.55 -57.932)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238087",
    "data-name": "Path 238087",
    d: "M846.813,141.42l-35.686-12.671v-8.3l35.686,13.106Z",
    transform: "translate(-810.613 -59.482)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238088",
    "data-name": "Path 238088",
    d: "M847.266,142.06v-8.952l-.338-.124L810.55,119.623v9.4Zm-1.03-8.233V140.6L811.58,128.3v-7.2Z",
    transform: "translate(-810.55 -59.393)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238089",
    "data-name": "Path 238089",
    d: "M846.813,154.282l-35.686-12.04v-8.3l35.686,12.475Z",
    transform: "translate(-810.613 -60.942)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238090",
    "data-name": "Path 238090",
    d: "M847.266,154.911v-8.946L810.55,133.13v9.394Zm-1.03-8.216v6.782L811.58,141.784v-7.2Z",
    transform: "translate(-810.55 -60.854)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238091",
    "data-name": "Path 238091",
    d: "M846.813,167.144l-35.686-11.409v-8.3l35.686,11.844Z",
    transform: "translate(-810.613 -62.401)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238092",
    "data-name": "Path 238092",
    d: "M847.266,167.764v-8.941L810.55,146.637v9.388Zm-1.03-8.2v6.787L811.58,155.274v-7.21Z",
    transform: "translate(-810.55 -62.315)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238093",
    "data-name": "Path 238093",
    d: "M846.813,180.006l-35.686-10.778v-8.3l35.686,11.213Z",
    transform: "translate(-810.613 -63.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238094",
    "data-name": "Path 238094",
    d: "M847.266,180.614v-8.935L810.55,160.143v9.382Zm-1.03-8.179v6.792L811.58,168.761v-7.215Z",
    transform: "translate(-810.55 -63.776)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238095",
    "data-name": "Path 238095",
    d: "M846.813,192.868l-35.686-10.147v-8.3L846.813,185Z",
    transform: "translate(-810.613 -65.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238096",
    "data-name": "Path 238096",
    d: "M847.266,193.466v-8.93L810.55,173.649v9.378Zm-1.03-8.161v6.8l-34.656-9.854v-7.22Z",
    transform: "translate(-810.55 -65.237)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238097",
    "data-name": "Path 238097",
    d: "M846.813,205.73l-35.686-9.516v-8.3l35.686,9.951Z",
    transform: "translate(-810.613 -66.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238098",
    "data-name": "Path 238098",
    d: "M847.266,206.319v-8.925L810.55,187.155v9.373Zm-1.03-8.143v6.8l-34.656-9.241v-7.226Z",
    transform: "translate(-810.55 -66.697)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238099",
    "data-name": "Path 238099",
    d: "M846.813,218.592l-35.686-8.885v-8.3l35.686,9.32Z",
    transform: "translate(-810.613 -68.239)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238100",
    "data-name": "Path 238100",
    d: "M847.266,219.171V210.25l-36.716-9.589v9.368Zm-1.03-8.126v6.807l-34.656-8.629v-7.23Z",
    transform: "translate(-810.55 -68.158)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238101",
    "data-name": "Path 238101",
    d: "M846.813,231.454,811.128,223.2v-8.3l35.686,8.689Z",
    transform: "translate(-810.613 -69.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238102",
    "data-name": "Path 238102",
    d: "M847.266,232.022v-8.916l-.393-.1-36.323-8.844v9.363Zm-1.03-8.107v6.812l-34.656-8.016v-7.235Z",
    transform: "translate(-810.55 -69.619)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238103",
    "data-name": "Path 238103",
    d: "M846.813,244.317l-35.686-7.623v-8.3l35.686,8.058Z",
    transform: "translate(-810.613 -71.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238104",
    "data-name": "Path 238104",
    d: "M847.266,244.876v-8.912l-36.716-8.29v9.359Zm-1.03-8.089V243.6l-34.656-7.4v-7.238Z",
    transform: "translate(-810.55 -71.08)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238105",
    "data-name": "Path 238105",
    d: "M846.813,257.179l-35.686-6.992v-8.3l35.686,7.426Z",
    transform: "translate(-810.613 -72.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238106",
    "data-name": "Path 238106",
    d: "M847.266,257.728v-8.909l-36.716-7.641v9.355Zm-1.03-8.071v6.82l-34.656-6.79v-7.242Z",
    transform: "translate(-810.55 -72.541)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238107",
    "data-name": "Path 238107",
    d: "M811.127,263.68v-8.3l35.686,6.8v6.191h-9.385Z",
    transform: "translate(-810.612 -74.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238108",
    "data-name": "Path 238108",
    d: "M846.236,262.527l-34.656-6.6v7.245l28.721,5.119h-5.868l-23.882-4.257v-9.353l36.716,6.993v6.617h-1.03Z",
    transform: "translate(-810.549 -74.002)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238109",
    "data-name": "Path 238109",
    d: "M844.952,268.874l5.52.953h-5.52Z",
    transform: "translate(-844.437 -75.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238110",
    "data-name": "Path 238110",
    d: "M842.59,269.411v.342h-1.03v-1.565l9.06,1.565h-6.049Z",
    transform: "translate(-841.56 -75.462)",
    fill: "#515255"
  }))))))), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238111",
    "data-name": "Path 238111",
    d: "M849.673,43.689v201.77h-.233V43.58Z",
    transform: "translate(-617.235 -4.714)",
    fill: "#fff"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238112",
    "data-name": "Path 238112",
    d: "M850.127,43.263v202.1h-1.263V42.672Z",
    transform: "translate(-617.174 -4.616)",
    fill: "#515255"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238113",
    "data-name": "Path 238113",
    d: "M847.979,44.482V245.544h-.232V44.374Z",
    transform: "translate(-614.03 -4.8)",
    fill: "#fff"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238114",
    "data-name": "Path 238114",
    d: "M848.432,44.057V245.446H847.17V43.466Z",
    transform: "translate(-613.968 -4.701)",
    fill: "#515255"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238115",
    "data-name": "Path 238115",
    d: "M846.292,45.273V245.63h-.231V45.165Z",
    transform: "translate(-610.84 -4.885)",
    fill: "#fff"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238116",
    "data-name": "Path 238116",
    d: "M846.744,44.848V245.531h-1.261V44.257Z",
    transform: "translate(-610.777 -4.787)",
    fill: "#515255"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238117",
    "data-name": "Path 238117",
    d: "M844.612,46.06V245.715h-.229V45.952Z",
    transform: "translate(-607.662 -4.97)",
    fill: "#fff"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238118",
    "data-name": "Path 238118",
    d: "M845.065,45.635V245.617h-1.259V45.044Z",
    transform: "translate(-607.601 -4.872)",
    fill: "#515255"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238119",
    "data-name": "Path 238119",
    d: "M842.94,46.843V245.8h-.229V46.736Z",
    transform: "translate(-604.501 -5.055)",
    fill: "#fff"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238120",
    "data-name": "Path 238120",
    d: "M843.393,46.419V245.7h-1.259V45.829Z",
    transform: "translate(-604.438 -4.957)",
    fill: "#515255"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238121",
    "data-name": "Path 238121",
    d: "M841.276,47.624v198.26h-.227V47.517Z",
    transform: "translate(-601.352 -5.14)",
    fill: "#fff"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238122",
    "data-name": "Path 238122",
    d: "M841.728,47.2V245.786H840.47V46.609Z",
    transform: "translate(-601.289 -5.041)",
    fill: "#515255"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238123",
    "data-name": "Path 238123",
    d: "M839.619,48.4V245.969h-.227V48.294Z",
    transform: "translate(-598.218 -5.224)",
    fill: "#fff"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238124",
    "data-name": "Path 238124",
    d: "M840.07,47.975v197.9h-1.257V47.386Z",
    transform: "translate(-598.154 -5.126)",
    fill: "#515255"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238125",
    "data-name": "Path 238125",
    d: "M837.968,49.174V246.052h-.226V49.068Z",
    transform: "translate(-595.097 -5.307)",
    fill: "#fff"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238126",
    "data-name": "Path 238126",
    d: "M838.42,48.749V245.954h-1.256V48.159Z",
    transform: "translate(-595.034 -5.209)",
    fill: "#515255"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238127",
    "data-name": "Path 238127",
    d: "M836.325,49.944V246.135H836.1V49.839Z",
    transform: "translate(-591.988 -5.391)",
    fill: "#fff"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238128",
    "data-name": "Path 238128",
    d: "M836.778,49.518V246.037h-1.255V48.93Z",
    transform: "translate(-591.927 -5.292)",
    fill: "#515255"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238129",
    "data-name": "Path 238129",
    d: "M834.689,50.71V246.218h-.224V50.606Z",
    transform: "translate(-588.895 -5.474)",
    fill: "#fff"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238130",
    "data-name": "Path 238130",
    d: "M835.142,50.285V246.121h-1.253V49.7Z",
    transform: "translate(-588.833 -5.376)",
    fill: "#515255"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238131",
    "data-name": "Path 238131",
    d: "M833.06,51.473V246.3h-.223V51.369Z",
    transform: "translate(-585.815 -5.556)",
    fill: "#fff"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238132",
    "data-name": "Path 238132",
    d: "M833.514,51.048V246.2h-1.253V50.461Z",
    transform: "translate(-585.753 -5.458)",
    fill: "#515255"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238133",
    "data-name": "Path 238133",
    d: "M831.439,52.234v194.15h-.221V52.13Z",
    transform: "translate(-582.748 -5.639)",
    fill: "#fff"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238134",
    "data-name": "Path 238134",
    d: "M831.892,51.808V246.285H830.64V51.221Z",
    transform: "translate(-582.686 -5.54)",
    fill: "#515255"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238135",
    "data-name": "Path 238135",
    d: "M829.825,52.99V246.465H829.6V52.886Z",
    transform: "translate(-579.695 -5.72)",
    fill: "#fff"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238136",
    "data-name": "Path 238136",
    d: "M830.277,52.565v193.8h-1.25V51.978Z",
    transform: "translate(-579.633 -5.622)",
    fill: "#515255"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238137",
    "data-name": "Path 238137",
    d: "M828.217,53.743v192.8H828V53.641Z",
    transform: "translate(-576.655 -5.802)",
    fill: "#fff"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238138",
    "data-name": "Path 238138",
    d: "M828.67,53.318v193.13h-1.25V52.732Z",
    transform: "translate(-576.593 -5.704)",
    fill: "#515255"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238139",
    "data-name": "Path 238139",
    d: "M826.617,54.494V246.628H826.4V54.391Z",
    transform: "translate(-573.629 -5.883)",
    fill: "#fff"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238140",
    "data-name": "Path 238140",
    d: "M827.069,54.068V246.53h-1.248V53.482Z",
    transform: "translate(-573.565 -5.785)",
    fill: "#515255"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238141",
    "data-name": "Path 238141",
    d: "M825.023,55.24V246.708H824.8V55.138Z",
    transform: "translate(-570.614 -5.964)",
    fill: "#fff"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238142",
    "data-name": "Path 238142",
    d: "M825.476,54.815v191.8h-1.248V54.23Z",
    transform: "translate(-570.552 -5.866)",
    fill: "#515255"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238143",
    "data-name": "Path 238143",
    d: "M823.437,55.984v190.8h-.218V55.883Z",
    transform: "translate(-567.613 -6.045)",
    fill: "#fff"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238144",
    "data-name": "Path 238144",
    d: "M823.889,55.559V246.691h-1.247V54.974Z",
    transform: "translate(-567.551 -5.946)",
    fill: "#515255"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238145",
    "data-name": "Path 238145",
    d: "M821.856,56.724V246.869h-.216V56.624Z",
    transform: "translate(-564.625 -6.125)",
    fill: "#fff"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238146",
    "data-name": "Path 238146",
    d: "M822.31,56.3V246.771h-1.247V55.715Z",
    transform: "translate(-564.563 -6.026)",
    fill: "#515255"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238147",
    "data-name": "Path 238147",
    d: "M820.283,57.461V246.949h-.215V57.361Z",
    transform: "translate(-561.649 -6.204)",
    fill: "#fff"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238148",
    "data-name": "Path 238148",
    d: "M820.736,57.036V246.851H819.49V56.453Z",
    transform: "translate(-561.587 -6.106)",
    fill: "#515255"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238149",
    "data-name": "Path 238149",
    d: "M818.717,58.2V247.029H818.5V58.1Z",
    transform: "translate(-558.687 -6.284)",
    fill: "#fff"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238150",
    "data-name": "Path 238150",
    d: "M819.169,57.77V246.93h-1.244V57.188Z",
    transform: "translate(-558.625 -6.186)",
    fill: "#515255"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238151",
    "data-name": "Path 238151",
    d: "M817.156,58.927V247.108h-.213V58.827Z",
    transform: "translate(-555.736 -6.363)",
    fill: "#fff"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238152",
    "data-name": "Path 238152",
    d: "M817.61,58.5V247.009h-1.243V57.919Z",
    transform: "translate(-555.675 -6.265)",
    fill: "#515255"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238153",
    "data-name": "Path 238153",
    d: "M815.6,59.655V247.186h-.212V59.555Z",
    transform: "translate(-552.8 -6.442)",
    fill: "#fff"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238154",
    "data-name": "Path 238154",
    d: "M816.056,59.229V247.088h-1.241V58.647Z",
    transform: "translate(-552.737 -6.344)",
    fill: "#515255"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238155",
    "data-name": "Path 238155",
    d: "M814.058,60.379V247.264h-.211V60.279Z",
    transform: "translate(-549.875 -6.52)",
    fill: "#fff"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238156",
    "data-name": "Path 238156",
    d: "M814.51,59.954V247.167h-1.241V59.372Z",
    transform: "translate(-549.812 -6.422)",
    fill: "#515255"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238157",
    "data-name": "Path 238157",
    d: "M812.518,61.1V247.343h-.21V61Z",
    transform: "translate(-546.963 -6.598)",
    fill: "#fff"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238158",
    "data-name": "Path 238158",
    d: "M812.97,60.676V247.245h-1.24V60.094Z",
    transform: "translate(-546.9 -6.5)",
    fill: "#515255"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238159",
    "data-name": "Path 238159",
    d: "M846.813,70.9,811.128,54.718V54.3l35.686,16.2Z",
    transform: "translate(-580.206 -5.874)",
    fill: "#fff"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238160",
    "data-name": "Path 238160",
    d: "M847.266,71.6V70.074L810.55,53.407v1.546Z",
    transform: "translate(-580.144 -5.777)",
    fill: "#515255"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238161",
    "data-name": "Path 238161",
    d: "M846.813,83.98,811.128,68.444V68.03l35.686,15.557Z",
    transform: "translate(-580.206 -7.358)",
    fill: "#fff"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238162",
    "data-name": "Path 238162",
    d: "M847.266,84.67V83.154L810.55,67.148v1.538Z",
    transform: "translate(-580.144 -7.263)",
    fill: "#515255"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238163",
    "data-name": "Path 238163",
    d: "M846.813,97.064,811.128,82.17v-.416L846.813,96.67Z",
    transform: "translate(-580.206 -8.843)",
    fill: "#fff"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238164",
    "data-name": "Path 238164",
    d: "M847.266,97.743V96.234l-.317-.132-36.4-15.214v1.531Z",
    transform: "translate(-580.144 -8.749)",
    fill: "#515255"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238165",
    "data-name": "Path 238165",
    d: "M846.813,110.148,811.128,95.9V95.48l35.686,14.274Z",
    transform: "translate(-580.206 -10.328)",
    fill: "#fff"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238166",
    "data-name": "Path 238166",
    d: "M847.266,110.815v-1.5L810.55,94.628v1.524Z",
    transform: "translate(-580.144 -10.235)",
    fill: "#515255"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238167",
    "data-name": "Path 238167",
    d: "M846.813,123.231l-35.686-13.61v-.415l35.686,13.632Z",
    transform: "translate(-580.206 -11.812)",
    fill: "#fff"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238168",
    "data-name": "Path 238168",
    d: "M847.266,123.888v-1.495L810.55,108.367v1.518Z",
    transform: "translate(-580.144 -11.722)",
    fill: "#515255"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238169",
    "data-name": "Path 238169",
    d: "M846.813,136.315l-35.686-12.968v-.415l35.686,12.99Z",
    transform: "translate(-580.206 -13.297)",
    fill: "#fff"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238170",
    "data-name": "Path 238170",
    d: "M847.266,136.961v-1.488L810.55,122.107v1.511Z",
    transform: "translate(-580.144 -13.208)",
    fill: "#515255"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238171",
    "data-name": "Path 238171",
    d: "M846.813,149.4l-35.686-12.326v-.416l35.686,12.348Z",
    transform: "translate(-580.206 -14.781)",
    fill: "#fff"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238172",
    "data-name": "Path 238172",
    d: "M847.266,150.034v-1.482L810.55,135.846v1.505Z",
    transform: "translate(-580.144 -14.694)",
    fill: "#515255"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238173",
    "data-name": "Path 238173",
    d: "M846.813,162.483,811.128,150.8v-.415l35.686,11.706Z",
    transform: "translate(-580.206 -16.266)",
    fill: "#fff"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238174",
    "data-name": "Path 238174",
    d: "M847.266,163.107V161.63L810.55,149.587v1.5Z",
    transform: "translate(-580.144 -16.18)",
    fill: "#515255"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238175",
    "data-name": "Path 238175",
    d: "M846.813,175.566l-35.686-11.043v-.415l35.686,11.064Z",
    transform: "translate(-580.206 -17.751)",
    fill: "#fff"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238176",
    "data-name": "Path 238176",
    d: "M847.266,176.18v-1.471L810.55,163.325v1.494Z",
    transform: "translate(-580.144 -17.666)",
    fill: "#515255"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238177",
    "data-name": "Path 238177",
    d: "M846.813,188.65l-35.686-10.4v-.416l35.686,10.423Z",
    transform: "translate(-580.206 -19.235)",
    fill: "#fff"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238178",
    "data-name": "Path 238178",
    d: "M847.266,189.253v-1.465L810.55,177.065v1.488Z",
    transform: "translate(-580.144 -19.152)",
    fill: "#515255"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238179",
    "data-name": "Path 238179",
    d: "M846.813,201.734l-35.686-9.758v-.416l35.686,9.781Z",
    transform: "translate(-580.206 -20.72)",
    fill: "#fff"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238180",
    "data-name": "Path 238180",
    d: "M847.266,202.327v-1.461L810.55,190.8v1.483Z",
    transform: "translate(-580.144 -20.638)",
    fill: "#515255"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238181",
    "data-name": "Path 238181",
    d: "M846.813,214.818,811.128,205.7v-.415l35.686,9.139Z",
    transform: "translate(-580.206 -22.205)",
    fill: "#fff"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238182",
    "data-name": "Path 238182",
    d: "M847.266,215.4v-1.455l-36.716-9.4v1.478Z",
    transform: "translate(-580.144 -22.124)",
    fill: "#515255"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238183",
    "data-name": "Path 238183",
    d: "M846.813,227.9l-35.686-8.475v-.415l35.686,8.5Z",
    transform: "translate(-580.206 -23.689)",
    fill: "#fff"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238184",
    "data-name": "Path 238184",
    d: "M847.266,228.474v-1.452l-36.716-8.742v1.474Z",
    transform: "translate(-580.144 -23.61)",
    fill: "#515255"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238185",
    "data-name": "Path 238185",
    d: "M846.813,240.985l-35.686-7.833v-.416l35.686,7.855Z",
    transform: "translate(-580.206 -25.174)",
    fill: "#fff"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238186",
    "data-name": "Path 238186",
    d: "M847.266,241.548V240.1l-36.716-8.082v1.47Z",
    transform: "translate(-580.144 -25.096)",
    fill: "#515255"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238187",
    "data-name": "Path 238187",
    d: "M846.813,254.069l-35.686-7.192v-.415l35.686,7.213Z",
    transform: "translate(-580.206 -26.659)",
    fill: "#fff"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238188",
    "data-name": "Path 238188",
    d: "M847.266,254.622v-1.443l-36.716-7.422v1.466Z",
    transform: "translate(-580.144 -26.582)",
    fill: "#515255"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238189",
    "data-name": "Path 238189",
    d: "M846.813,267.153l-35.686-6.55v-.415l35.686,6.571Z",
    transform: "translate(-580.206 -28.143)",
    fill: "#fff"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238190",
    "data-name": "Path 238190",
    d: "M847.266,267.7v-1.44l-36.716-6.761v1.463Z",
    transform: "translate(-580.144 -28.068)",
    fill: "#515255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_84344",
    "data-name": "Group 84344",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84343",
    "data-name": "Group 84343",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84342",
    "data-name": "Group 84342",
    transform: "translate(230.403 37.454)",
    opacity: 0.75,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84341",
    "data-name": "Group 84341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84340",
    "data-name": "Group 84340",
    clipPath: "url(#clip-path-76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238191",
    "data-name": "Path 238191",
    d: "M811.127,42.9l35.686,16.733V245.386H811.127Z",
    transform: "translate(-810.612 -42.094)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238192",
    "data-name": "Path 238192",
    d: "M846.236,59.866,811.58,43.616V245.287h-1.03V42l36.716,17.215V245.287h-1.03Z",
    transform: "translate(-810.549 -41.996)",
    fill: "#515255"
  }))))))), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238193",
    "data-name": "Path 238193",
    d: "M847.277,79.789,815.409,65.915V44.649l31.868,14.87Z",
    transform: "translate(-584.487 -4.829)",
    fill: "#fd930d"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238194",
    "data-name": "Path 238194",
    d: "M1031.6,177.458l-92.672,10.723V96.614L1031.6,85.893Z",
    transform: "translate(-878.962 -9.291)",
    fill: "#fff"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238195",
    "data-name": "Path 238195",
    d: "M938.346,188.688l93.7-10.841v-92.6l-93.7,10.841Zm92.672-11.759-91.642,10.6V97l91.642-10.6Z",
    transform: "translate(-878.899 -9.22)",
    fill: "#515255"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238196",
    "data-name": "Path 238196",
    d: "M1019.486,181.5l-67.845,7.85V119.02l67.845-7.849Z",
    transform: "translate(-878.193 -12.025)",
    fill: "#fff"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238197",
    "data-name": "Path 238197",
    d: "M951.064,189.862l68.875-7.969V110.523l-68.875,7.969Zm67.845-8.886-66.815,7.73v-69.3l66.815-7.73Z",
    transform: "translate(-878.131 -11.955)",
    fill: "#515255"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238198",
    "data-name": "Path 238198",
    d: "M1003.5,112.011l-40.458,4.681V112.75l40.458-4.68Z",
    transform: "translate(-872.372 -11.689)",
    fill: "#515255"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238199",
    "data-name": "Path 238199",
    d: "M1019.486,120.721l-67.845,7.85v-3.735l67.845-7.849Z",
    transform: "translate(-878.193 -12.654)",
    fill: "#515255"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238200",
    "data-name": "Path 238200",
    d: "M1019.486,131.772l-67.845,7.85v-3.735l67.845-7.849Z",
    transform: "translate(-878.193 -13.849)",
    fill: "#515255"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238201",
    "data-name": "Path 238201",
    d: "M1019.486,142.822l-67.845,7.85v-3.735l67.845-7.849Z",
    transform: "translate(-878.193 -15.044)",
    fill: "#515255"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238202",
    "data-name": "Path 238202",
    d: "M1019.486,153.872l-67.845,7.85v-3.735l67.845-7.849Z",
    transform: "translate(-878.193 -16.24)",
    fill: "#515255"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238203",
    "data-name": "Path 238203",
    d: "M1019.486,164.923l-67.845,7.85v-3.735l67.845-7.849Z",
    transform: "translate(-878.193 -17.435)",
    fill: "#515255"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238204",
    "data-name": "Path 238204",
    d: "M1019.486,175.973l-67.845,7.85v-3.735l67.845-7.849Z",
    transform: "translate(-878.193 -18.63)",
    fill: "#515255"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238205",
    "data-name": "Path 238205",
    d: "M948.186,119.569l-2.594.3V112.4l2.594-.3Z",
    transform: "translate(-801.499 -12.125)",
    fill: "#515255"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238206",
    "data-name": "Path 238206",
    d: "M1031.529,129.211l-2.594.3v-7.469l2.594-.3Z",
    transform: "translate(-959.17 -13.168)",
    fill: "#515255"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238207",
    "data-name": "Path 238207",
    d: "M948.186,130.619l-2.594.3v-7.469l2.594-.3Z",
    transform: "translate(-801.499 -13.32)",
    fill: "#515255"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238208",
    "data-name": "Path 238208",
    d: "M1031.529,140.262l-2.594.3v-7.469l2.594-.3Z",
    transform: "translate(-959.17 -14.363)",
    fill: "#515255"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238209",
    "data-name": "Path 238209",
    d: "M948.186,141.669l-2.594.3V134.5l2.594-.3Z",
    transform: "translate(-801.499 -14.516)",
    fill: "#515255"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238210",
    "data-name": "Path 238210",
    d: "M1031.529,151.312l-2.594.3v-7.469l2.594-.3Z",
    transform: "translate(-959.17 -15.559)",
    fill: "#515255"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238211",
    "data-name": "Path 238211",
    d: "M948.186,152.72l-2.594.3V145.55l2.594-.3Z",
    transform: "translate(-801.499 -15.711)",
    fill: "#515255"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238212",
    "data-name": "Path 238212",
    d: "M1031.529,162.362l-2.594.3v-7.469l2.594-.3Z",
    transform: "translate(-959.17 -16.754)",
    fill: "#515255"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238213",
    "data-name": "Path 238213",
    d: "M948.186,163.77l-2.594.3V156.6l2.594-.3Z",
    transform: "translate(-801.499 -16.906)",
    fill: "#515255"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238214",
    "data-name": "Path 238214",
    d: "M1031.529,173.413l-2.594.3v-7.469l2.594-.3Z",
    transform: "translate(-959.17 -17.949)",
    fill: "#515255"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238215",
    "data-name": "Path 238215",
    d: "M933.681,190.46l-43.224-13V85.893l43.224,13Z",
    transform: "translate(-737.822 -9.291)",
    fill: "#fff"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238216",
    "data-name": "Path 238216",
    d: "M934.133,191.069V98.428L889.879,85.116v92.641ZM933.1,99.194v90.49l-42.195-12.692V86.5Z",
    transform: "translate(-737.759 -9.207)",
    fill: "#515255"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238217",
    "data-name": "Path 238217",
    d: "M930.207,129.149,893.9,118.227v-5.6l36.308,10.921Z",
    transform: "translate(-737.418 -12.182)",
    fill: "#515255"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238218",
    "data-name": "Path 238218",
    d: "M898.179,130.317l-4.281-1.288v-5.6l4.281,1.288Z",
    transform: "translate(-705.39 -13.351)",
    fill: "#515255"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238219",
    "data-name": "Path 238219",
    d: "M928.507,132.3l-36.654-11.026v-1.867l36.654,11.025Z",
    transform: "translate(-733.893 -12.915)",
    fill: "#fff"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238220",
    "data-name": "Path 238220",
    d: "M928.959,132.906v-2.942l-37.684-11.335v2.942Zm-1.03-2.177v.792L892.3,120.806v-.792Z",
    transform: "translate(-733.829 -12.831)",
    fill: "#515255"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238221",
    "data-name": "Path 238221",
    d: "M930.44,140.129l-36.308-10.921v-5.6l36.308,10.921Z",
    transform: "translate(-737.858 -13.37)",
    fill: "#515255"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238222",
    "data-name": "Path 238222",
    d: "M898.412,141.3l-4.281-1.288v-5.6l4.281,1.288Z",
    transform: "translate(-705.83 -14.538)",
    fill: "#515255"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238223",
    "data-name": "Path 238223",
    d: "M928.739,143.278l-36.653-11.026v-1.867l36.653,11.025Z",
    transform: "translate(-734.333 -14.103)",
    fill: "#fff"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238224",
    "data-name": "Path 238224",
    d: "M929.192,143.886v-2.942l-37.684-11.336v2.943Zm-1.03-2.177v.792l-35.624-10.716v-.792Z",
    transform: "translate(-734.27 -14.019)",
    fill: "#515255"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238225",
    "data-name": "Path 238225",
    d: "M930.672,151.109l-36.308-10.921v-5.6l36.308,10.921Z",
    transform: "translate(-738.298 -14.557)",
    fill: "#515255"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238226",
    "data-name": "Path 238226",
    d: "M898.645,152.278l-4.281-1.288v-5.6l4.281,1.288Z",
    transform: "translate(-706.27 -15.726)",
    fill: "#515255"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238227",
    "data-name": "Path 238227",
    d: "M928.972,154.259l-36.654-11.026v-1.867l36.654,11.025Z",
    transform: "translate(-734.773 -15.291)",
    fill: "#fff"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238228",
    "data-name": "Path 238228",
    d: "M929.425,154.867v-2.942L891.741,140.59v2.942Zm-1.03-2.177v.792L892.77,142.767v-.792Z",
    transform: "translate(-734.711 -15.207)",
    fill: "#515255"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238229",
    "data-name": "Path 238229",
    d: "M930.9,162.09,894.6,151.168v-5.6L930.9,156.488Z",
    transform: "translate(-738.738 -15.745)",
    fill: "#515255"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238230",
    "data-name": "Path 238230",
    d: "M898.877,163.258,894.6,161.97v-5.6l4.281,1.288Z",
    transform: "translate(-706.71 -16.914)",
    fill: "#515255"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238231",
    "data-name": "Path 238231",
    d: "M929.2,165.239l-36.654-11.026v-1.867L929.2,163.372Z",
    transform: "translate(-735.213 -16.479)",
    fill: "#fff"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238232",
    "data-name": "Path 238232",
    d: "M929.658,165.847v-2.942L891.973,151.57v2.942Zm-1.03-2.177v.792L893,153.747v-.792Z",
    transform: "translate(-735.151 -16.395)",
    fill: "#515255"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238233",
    "data-name": "Path 238233",
    d: "M931.138,173.07l-36.308-10.921v-5.6l36.308,10.921Z",
    transform: "translate(-739.178 -16.933)",
    fill: "#515255"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238234",
    "data-name": "Path 238234",
    d: "M899.11,174.238l-4.281-1.288v-5.6l4.281,1.288Z",
    transform: "translate(-707.151 -18.101)",
    fill: "#515255"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238235",
    "data-name": "Path 238235",
    d: "M929.437,176.219l-36.654-11.026v-1.867l36.654,11.025Z",
    transform: "translate(-735.654 -17.666)",
    fill: "#fff"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238236",
    "data-name": "Path 238236",
    d: "M929.89,176.828v-2.942l-37.684-11.335v2.942Zm-1.03-2.177v.792l-35.624-10.715v-.792Z",
    transform: "translate(-735.591 -17.582)",
    fill: "#515255"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238237",
    "data-name": "Path 238237",
    d: "M911.59,170.69v86.962H839.665V156.3Z",
    transform: "translate(-670.433 -16.907)",
    fill: "#fff"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238238",
    "data-name": "Path 238238",
    d: "M912.042,170.191v87.384h-1.03V171.036l-70.895-14.18V257.575h-1.03V155.6Z",
    transform: "translate(-670.37 -16.831)",
    fill: "#515255"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238239",
    "data-name": "Path 238239",
    d: "M905.9,189.547V260.1H845.635V178.931Z",
    transform: "translate(-670.069 -19.354)",
    fill: "#fff"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238240",
    "data-name": "Path 238240",
    d: "M906.355,189.041v70.983h-1.03V189.9L846.088,179.47v80.554h-1.03V178.243Z",
    transform: "translate(-670.008 -19.28)",
    fill: "#515255"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238241",
    "data-name": "Path 238241",
    d: "M905.9,192.936,845.635,182.6v-3.667L905.9,189.547Z",
    transform: "translate(-670.07 -19.354)",
    fill: "#515255"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238242",
    "data-name": "Path 238242",
    d: "M905.9,201.112l-60.268-9.743V187.7L905.9,197.723Z",
    transform: "translate(-670.07 -20.303)",
    fill: "#fff"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238243",
    "data-name": "Path 238243",
    d: "M906.355,201.643v-4.43l-61.3-10.194v4.713Zm-1.031-3.558v2.348l-59.238-9.577v-2.621Z",
    transform: "translate(-670.007 -20.229)",
    fill: "#515255"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238244",
    "data-name": "Path 238244",
    d: "M905.9,209.288l-60.268-9.149v-3.667L905.9,205.9Z",
    transform: "translate(-670.07 -21.251)",
    fill: "#fff"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238245",
    "data-name": "Path 238245",
    d: "M906.355,209.814v-4.428l-61.3-9.589v4.712Zm-1.031-3.547v2.349l-59.238-8.992V197Z",
    transform: "translate(-670.007 -21.178)",
    fill: "#515255"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238246",
    "data-name": "Path 238246",
    d: "M905.9,217.464l-60.268-8.554v-3.668l60.268,8.834Z",
    transform: "translate(-670.07 -22.2)",
    fill: "#fff"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238247",
    "data-name": "Path 238247",
    d: "M906.355,217.984v-4.427l-.441-.064-60.856-8.92v4.711Zm-1.031-3.537V216.8l-59.238-8.408v-2.626Z",
    transform: "translate(-670.007 -22.128)",
    fill: "#515255"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238248",
    "data-name": "Path 238248",
    d: "M905.9,225.64l-60.268-7.961v-3.667l60.268,8.239Z",
    transform: "translate(-670.07 -23.149)",
    fill: "#fff"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238249",
    "data-name": "Path 238249",
    d: "M906.355,226.156v-4.425l-.446-.062-60.852-8.319v4.709l.448.06Zm-1.031-3.527v2.353l-59.238-7.825v-2.626Z",
    transform: "translate(-670.007 -23.077)",
    fill: "#515255"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238250",
    "data-name": "Path 238250",
    d: "M905.9,233.816l-60.268-7.366v-3.668l60.268,7.645Z",
    transform: "translate(-670.07 -24.097)",
    fill: "#fff"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238251",
    "data-name": "Path 238251",
    d: "M906.355,234.326V229.9l-.451-.057-60.846-7.719v4.708Zm-1.031-3.517v2.354l-59.238-7.24V223.3Z",
    transform: "translate(-670.007 -24.026)",
    fill: "#515255"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238252",
    "data-name": "Path 238252",
    d: "M905.9,241.992l-60.268-6.772v-3.667L905.9,238.6Z",
    transform: "translate(-670.07 -25.046)",
    fill: "#fff"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238253",
    "data-name": "Path 238253",
    d: "M906.355,242.5v-4.424l-61.3-7.17v4.706Zm-1.031-3.507v2.354l-59.238-6.656v-2.629Z",
    transform: "translate(-670.007 -24.976)",
    fill: "#515255"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238254",
    "data-name": "Path 238254",
    d: "M905.9,250.167l-60.268-6.178v-3.667l60.268,6.456Z",
    transform: "translate(-670.07 -25.994)",
    fill: "#fff"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238255",
    "data-name": "Path 238255",
    d: "M906.355,250.668v-4.422l-61.3-6.567v4.705Zm-1.031-3.5v2.356l-59.238-6.072v-2.629Z",
    transform: "translate(-670.007 -25.925)",
    fill: "#515255"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238256",
    "data-name": "Path 238256",
    d: "M905.9,258.343l-60.268-5.583v-3.668l60.268,5.862Z",
    transform: "translate(-670.07 -26.943)",
    fill: "#fff"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238257",
    "data-name": "Path 238257",
    d: "M906.355,258.839v-4.421l-61.3-5.962v4.7Zm-1.031-3.486v2.357l-59.238-5.488v-2.63Z",
    transform: "translate(-670.007 -26.874)",
    fill: "#515255"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238258",
    "data-name": "Path 238258",
    d: "M905.9,266.519l-60.268-4.989v-3.667L905.9,263.13Z",
    transform: "translate(-670.07 -27.892)",
    fill: "#fff"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238259",
    "data-name": "Path 238259",
    d: "M906.355,267.01v-4.42l-.47-.041-60.828-5.316v4.7Zm-1.031-3.476v2.358l-59.238-4.9v-2.633Z",
    transform: "translate(-670.007 -27.824)",
    fill: "#515255"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238260",
    "data-name": "Path 238260",
    d: "M908.595,269.585H870.527v-2.952Z",
    transform: "translate(-694.962 -28.84)",
    fill: "#fff"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238261",
    "data-name": "Path 238261",
    d: "M908.3,269.517h-13.32l-30.893-2.4v2.4H863.06v-3.508Z",
    transform: "translate(-688.01 -28.773)",
    fill: "#515255"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238262",
    "data-name": "Path 238262",
    d: "M857.907,189.013v72.134h-2.195V188.626Z",
    transform: "translate(-631.061 -20.403)",
    fill: "#fff"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238263",
    "data-name": "Path 238263",
    d: "M858.359,188.506v72.567h-1.03v-71.7l-1.165-.205v71.908h-1.03V187.939Z",
    transform: "translate(-630.998 -20.328)",
    fill: "#515255"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238264",
    "data-name": "Path 238264",
    d: "M871.92,186.555V260.88h-2.269V186.156Z",
    transform: "translate(-657.506 -20.136)",
    fill: "#fff"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238265",
    "data-name": "Path 238265",
    d: "M872.373,186.049v74.756h-1.03V186.913l-1.24-.218v74.11h-1.03V185.468Z",
    transform: "translate(-657.444 -20.061)",
    fill: "#515255"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238266",
    "data-name": "Path 238266",
    d: "M886.414,184.015V260.6h-2.348v-77Z",
    transform: "translate(-684.855 -19.859)",
    fill: "#fff"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238267",
    "data-name": "Path 238267",
    d: "M886.865,183.509v77.021h-1.03V184.372l-1.318-.232v76.389h-1.029V182.914Z",
    transform: "translate(-684.791 -19.785)",
    fill: "#515255"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238268",
    "data-name": "Path 238268",
    d: "M901.41,181.386v78.932h-2.43v-79.36Z",
    transform: "translate(-713.151 -19.573)",
    fill: "#fff"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238269",
    "data-name": "Path 238269",
    d: "M901.862,180.88v79.364h-1.03v-78.5l-1.4-.246v78.746H898.4V180.271Z",
    transform: "translate(-713.089 -19.499)",
    fill: "#515255"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238270",
    "data-name": "Path 238270",
    d: "M848.332,190.777v70.551h-2.7V190.3Z",
    transform: "translate(-612.499 -20.584)",
    fill: "#515255"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238271",
    "data-name": "Path 238271",
    d: "M860.953,188.567v72.521h-2.78V188.077Z",
    transform: "translate(-636.303 -20.343)",
    fill: "#515255"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238272",
    "data-name": "Path 238272",
    d: "M875.053,186.1v74.722h-2.875V185.591Z",
    transform: "translate(-662.892 -20.074)",
    fill: "#515255"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238273",
    "data-name": "Path 238273",
    d: "M889.671,183.538v77H886.7V183.013Z",
    transform: "translate(-690.46 -19.796)",
    fill: "#515255"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238274",
    "data-name": "Path 238274",
    d: "M904.782,180.892v79.36H901.7v-79.9Z",
    transform: "translate(-718.955 -19.508)",
    fill: "#515255"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238275",
    "data-name": "Path 238275",
    d: "M969.83,257.651H920.313v-99.27L969.83,156.3Z",
    transform: "translate(-800.598 -16.907)",
    fill: "#fff"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238276",
    "data-name": "Path 238276",
    d: "M970.283,257.586h-1.03V156.777l-48.487,2.033v98.777h-1.03V157.821l50.547-2.119Z",
    transform: "translate(-800.535 -16.841)",
    fill: "#515255"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238277",
    "data-name": "Path 238277",
    d: "M1086.488,184.984v70.148h-194.4V133.016Z",
    transform: "translate(-892.081 -14.388)",
    fill: "#fff"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238278",
    "data-name": "Path 238278",
    d: "M1086.425,184.523v70.544h-1.03V185.314l-193.887-51.83v-1.066Z",
    transform: "translate(-891.504 -14.323)",
    fill: "#515255"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238279",
    "data-name": "Path 238279",
    d: "M1086.488,193.766v1.652l-194.4-48.271v-2.32Z",
    transform: "translate(-892.081 -15.665)",
    fill: "#515255"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238280",
    "data-name": "Path 238280",
    d: "M1086.488,207v13.072l-194.4-39.093v-18.35Z",
    transform: "translate(-892.081 -17.591)",
    fill: "#515255"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238281",
    "data-name": "Path 238281",
    d: "M1086.488,216.3v5.124l-194.4-39.093v-7.192Z",
    transform: "translate(-892.081 -18.944)",
    fill: "#fff"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238282",
    "data-name": "Path 238282",
    d: "M1086.017,215.736l.408.087v6.17L891.509,182.8v-1.051L1085.4,220.734v-4.077L891.509,175.606v-1.053Z",
    transform: "translate(-891.505 -18.88)",
    fill: "#515255"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238283",
    "data-name": "Path 238283",
    d: "M898.353,224.383l-1.174-.236V210.921l1.174.268Z",
    transform: "translate(-708.49 -22.814)",
    fill: "#fff"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238284",
    "data-name": "Path 238284",
    d: "M898.806,224.934V210.7l-2.2-.5V224.49Zm-1.03-13.412v12.155l-.144-.029V211.488Z",
    transform: "translate(-708.427 -22.736)",
    fill: "#515255"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238285",
    "data-name": "Path 238285",
    d: "M905.252,222.981l-1.2-.242V209.346l1.2.275Z",
    transform: "translate(-721.514 -22.644)",
    fill: "#fff"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238286",
    "data-name": "Path 238286",
    d: "M905.7,223.532v-14.4l-2.233-.509v14.46Zm-1.03-13.579v12.321l-.174-.035V209.913Z",
    transform: "translate(-721.452 -22.566)",
    fill: "#515255"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238287",
    "data-name": "Path 238287",
    d: "M912.327,221.543l-1.234-.248V207.73l1.234.282Z",
    transform: "translate(-734.872 -22.469)",
    fill: "#fff"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238288",
    "data-name": "Path 238288",
    d: "M912.779,222.093v-14.57l-2.264-.517v14.632Zm-1.03-13.749v12.492l-.205-.041V208.3Z",
    transform: "translate(-734.809 -22.391)",
    fill: "#515255"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238289",
    "data-name": "Path 238289",
    d: "M919.585,220.068l-1.266-.255v-13.74l1.266.289Z",
    transform: "translate(-748.575 -22.29)",
    fill: "#fff"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238290",
    "data-name": "Path 238290",
    d: "M920.037,220.618V205.873l-2.3-.524v14.807Zm-1.03-13.924v12.667l-.236-.048V206.639Z",
    transform: "translate(-748.512 -22.212)",
    fill: "#515255"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238291",
    "data-name": "Path 238291",
    d: "M927.035,218.554l-1.3-.261V204.372l1.3.3Z",
    transform: "translate(-762.637 -22.106)",
    fill: "#fff"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238292",
    "data-name": "Path 238292",
    d: "M927.486,219.1V204.18l-2.33-.532v14.988ZM926.455,205v12.846l-.27-.054V204.939Z",
    transform: "translate(-762.573 -22.028)",
    fill: "#515255"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238293",
    "data-name": "Path 238293",
    d: "M934.682,217l-1.335-.268V202.625l1.335.305Z",
    transform: "translate(-777.074 -21.917)",
    fill: "#fff"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238294",
    "data-name": "Path 238294",
    d: "M935.134,217.55V202.441l-2.365-.54v15.174Zm-1.03-14.288v13.031l-.3-.062V203.192Z",
    transform: "translate(-777.011 -21.839)",
    fill: "#515255"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238295",
    "data-name": "Path 238295",
    d: "M942.535,215.4l-1.371-.276v-14.3l1.371.313Z",
    transform: "translate(-791.898 -21.723)",
    fill: "#fff"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238296",
    "data-name": "Path 238296",
    d: "M942.988,215.954v-15.3l-2.4-.548v15.364Zm-1.031-14.477V214.7l-.342-.069V201.4Z",
    transform: "translate(-791.836 -21.645)",
    fill: "#515255"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238297",
    "data-name": "Path 238297",
    d: "M950.6,213.765l-1.409-.284V198.99l1.409.322Z",
    transform: "translate(-807.129 -21.524)",
    fill: "#fff"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238298",
    "data-name": "Path 238298",
    d: "M951.056,214.314V198.822l-2.439-.557v15.559Zm-1.03-14.672v13.414l-.379-.076V199.556Z",
    transform: "translate(-807.067 -21.445)",
    fill: "#515255"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238299",
    "data-name": "Path 238299",
    d: "M958.9,212.08l-1.448-.291V197.1l1.448.33Z",
    transform: "translate(-822.78 -21.319)",
    fill: "#fff"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238300",
    "data-name": "Path 238300",
    d: "M959.347,212.63V196.937l-2.479-.565v15.76Zm-1.03-14.871v13.614l-.418-.084V197.663Z",
    transform: "translate(-822.717 -21.241)",
    fill: "#515255"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238301",
    "data-name": "Path 238301",
    d: "M967.42,210.348l-1.489-.3v-14.9l1.489.34Z",
    transform: "translate(-838.872 -21.108)",
    fill: "#fff"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238302",
    "data-name": "Path 238302",
    d: "M967.872,210.9V195l-2.519-.574v15.967Zm-1.03-15.077V209.64l-.459-.092V195.716Z",
    transform: "translate(-838.809 -21.03)",
    fill: "#515255"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238303",
    "data-name": "Path 238303",
    d: "M976.188,208.566l-1.532-.308V193.146l1.532.35Z",
    transform: "translate(-855.421 -20.892)",
    fill: "#fff"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238304",
    "data-name": "Path 238304",
    d: "M976.64,209.116V193.007l-2.562-.584V208.6Zm-1.03-15.288v14.03l-.5-.1V193.713Z",
    transform: "translate(-855.358 -20.813)",
    fill: "#515255"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238305",
    "data-name": "Path 238305",
    d: "M985.209,206.734l-1.577-.317V191.086l1.577.36Z",
    transform: "translate(-872.448 -20.669)",
    fill: "#fff"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238306",
    "data-name": "Path 238306",
    d: "M985.662,207.284V190.957l-2.607-.595v16.4Zm-1.03-15.505v14.248l-.547-.11V191.653Z",
    transform: "translate(-872.385 -20.59)",
    fill: "#515255"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238307",
    "data-name": "Path 238307",
    d: "M994.5,204.847l-1.623-.326V188.965l1.623.371Z",
    transform: "translate(-889.974 -20.439)",
    fill: "#fff"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238308",
    "data-name": "Path 238308",
    d: "M994.948,205.4V188.847l-2.653-.606v16.623Zm-1.03-15.729V204.14l-.593-.119V189.532Z",
    transform: "translate(-889.912 -20.361)",
    fill: "#515255"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238309",
    "data-name": "Path 238309",
    d: "M1004.057,202.9l-1.671-.336V186.782l1.671.381Z",
    transform: "translate(-908.021 -20.203)",
    fill: "#fff"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238310",
    "data-name": "Path 238310",
    d: "M1004.51,203.455V186.674l-2.7-.616v16.854Zm-1.03-15.959v14.7l-.642-.129V187.349Z",
    transform: "translate(-907.959 -20.125)",
    fill: "#515255"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238311",
    "data-name": "Path 238311",
    d: "M1013.909,200.9l-1.722-.346V184.531l1.722.393Z",
    transform: "translate(-926.614 -19.96)",
    fill: "#fff"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238312",
    "data-name": "Path 238312",
    d: "M1014.362,201.454V184.436l-2.752-.628V200.9Zm-1.03-16.2V200.2l-.693-.139V185.1Z",
    transform: "translate(-926.552 -19.882)",
    fill: "#515255"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238313",
    "data-name": "Path 238313",
    d: "M1024.063,198.841l-1.776-.357V182.213l1.776.4Z",
    transform: "translate(-945.776 -19.709)",
    fill: "#fff"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238314",
    "data-name": "Path 238314",
    d: "M1024.516,199.392V182.128l-2.806-.64v17.339Zm-1.03-16.442v15.184l-.746-.151v-15.2Z",
    transform: "translate(-945.713 -19.631)",
    fill: "#515255"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238315",
    "data-name": "Path 238315",
    d: "M1034.534,196.715l-1.831-.368V179.822l1.831.417Z",
    transform: "translate(-965.535 -19.45)",
    fill: "#fff"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238316",
    "data-name": "Path 238316",
    d: "M1034.986,197.265V179.75l-2.861-.653V196.69Zm-1.03-16.693v15.437l-.8-.161V180.389Z",
    transform: "translate(-965.472 -19.372)",
    fill: "#515255"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238317",
    "data-name": "Path 238317",
    d: "M1045.337,194.521l-1.89-.38V177.354l1.89.432Z",
    transform: "translate(-985.92 -19.183)",
    fill: "#fff"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238318",
    "data-name": "Path 238318",
    d: "M1045.789,195.071V177.3l-2.92-.666v17.855Zm-1.03-16.954v15.7l-.86-.173V177.921Z",
    transform: "translate(-985.857 -19.105)",
    fill: "#515255"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238319",
    "data-name": "Path 238319",
    d: "M1056.486,192.257l-1.95-.392V174.808l1.95.445Z",
    transform: "translate(-1006.958 -18.908)",
    fill: "#fff"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238320",
    "data-name": "Path 238320",
    d: "M1056.939,192.807V174.763l-2.981-.68v18.125Zm-1.03-17.222V191.55l-.921-.185V175.375Z",
    transform: "translate(-1006.896 -18.83)",
    fill: "#515255"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238321",
    "data-name": "Path 238321",
    d: "M1068,189.919l-2.016-.4V172.178l2.016.46Z",
    transform: "translate(-1028.684 -18.624)",
    fill: "#fff"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238322",
    "data-name": "Path 238322",
    d: "M1068.454,190.47V172.149l-3.046-.695v18.4Zm-1.03-17.5v16.242l-.985-.2V172.745Z",
    transform: "translate(-1028.622 -18.545)",
    fill: "#515255"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238323",
    "data-name": "Path 238323",
    d: "M1079.9,187.5l-2.082-.419V169.46l2.082.475Z",
    transform: "translate(-1051.131 -18.33)",
    fill: "#fff"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238324",
    "data-name": "Path 238324",
    d: "M1080.35,188.054V169.447l-3.113-.71v18.691Zm-1.03-17.786V186.8l-1.052-.211V170.028Z",
    transform: "translate(-1051.07 -18.251)",
    fill: "#515255"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238325",
    "data-name": "Path 238325",
    d: "M1092.2,185.007l-2.154-.433V166.651l2.154.491Z",
    transform: "translate(-1074.337 -18.026)",
    fill: "#fff"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238326",
    "data-name": "Path 238326",
    d: "M1092.65,185.557v-18.9l-3.184-.726v18.989Zm-1.03-18.082V184.3l-1.124-.226V167.218Z",
    transform: "translate(-1074.274 -17.948)",
    fill: "#515255"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238327",
    "data-name": "Path 238327",
    d: "M1104.919,182.424l-2.228-.448V163.746l2.228.508Z",
    transform: "translate(-1098.338 -17.712)",
    fill: "#fff"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238328",
    "data-name": "Path 238328",
    d: "M1105.372,182.974V163.765l-3.258-.744v19.3Zm-1.03-18.388v17.13l-1.2-.241V164.312Z",
    transform: "translate(-1098.276 -17.633)",
    fill: "#515255"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238329",
    "data-name": "Path 238329",
    d: "M1086.488,237.277v13.072L892.085,221.7V203.353Z",
    transform: "translate(-892.081 -21.996)",
    fill: "#515255"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238330",
    "data-name": "Path 238330",
    d: "M1086.488,246.578V251.7l-194.4-28.646v-7.192Z",
    transform: "translate(-892.081 -23.349)",
    fill: "#fff"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238331",
    "data-name": "Path 238331",
    d: "M1085.991,246.007l.434.069v6.159L891.508,223.512v-1.041L1085.4,251.042v-4.087L891.508,216.322v-1.043Z",
    transform: "translate(-891.504 -23.286)",
    fill: "#515255"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238332",
    "data-name": "Path 238332",
    d: "M898.353,253.672l-1.174-.173V240.273l1.174.205Z",
    transform: "translate(-708.49 -25.989)",
    fill: "#fff"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238333",
    "data-name": "Path 238333",
    d: "M898.806,254.194V239.971l-2.2-.385V253.87Zm-1.03-13.358V253l-.144-.021V240.811Z",
    transform: "translate(-708.427 -25.915)",
    fill: "#515255"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238334",
    "data-name": "Path 238334",
    d: "M905.252,252.639l-1.2-.177V239.069l1.2.21Z",
    transform: "translate(-721.514 -25.859)",
    fill: "#fff"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238335",
    "data-name": "Path 238335",
    d: "M905.7,253.161V238.772l-2.233-.39v14.45Zm-1.03-13.524v12.331l-.174-.026V239.606Z",
    transform: "translate(-721.452 -25.785)",
    fill: "#515255"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238336",
    "data-name": "Path 238336",
    d: "M912.327,251.58l-1.234-.182V237.833l1.234.216Z",
    transform: "translate(-734.872 -25.725)",
    fill: "#fff"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238337",
    "data-name": "Path 238337",
    d: "M912.779,252.1V237.542l-2.264-.4v14.622Zm-1.03-13.694v12.5l-.205-.03V238.371Z",
    transform: "translate(-734.809 -25.651)",
    fill: "#515255"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238338",
    "data-name": "Path 238338",
    d: "M919.585,250.493l-1.266-.186V236.566l1.266.221Z",
    transform: "translate(-748.575 -25.588)",
    fill: "#fff"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238339",
    "data-name": "Path 238339",
    d: "M920.037,251.015V236.28l-2.3-.4v14.8Zm-1.03-13.87v12.677l-.236-.035V237.1Z",
    transform: "translate(-748.512 -25.514)",
    fill: "#515255"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238340",
    "data-name": "Path 238340",
    d: "M927.035,249.378l-1.3-.192V235.266l1.3.227Z",
    transform: "translate(-762.637 -25.447)",
    fill: "#fff"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238341",
    "data-name": "Path 238341",
    d: "M927.486,249.9V234.985l-2.33-.406v14.977Zm-1.031-14.049v12.856l-.27-.039V235.8Z",
    transform: "translate(-762.573 -25.373)",
    fill: "#515255"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238342",
    "data-name": "Path 238342",
    d: "M934.682,248.233l-1.335-.2V233.931l1.335.233Z",
    transform: "translate(-777.074 -25.303)",
    fill: "#fff"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238343",
    "data-name": "Path 238343",
    d: "M935.134,248.756v-15.1l-2.365-.412v15.163Zm-1.03-14.234v13.04l-.3-.045V234.469Z",
    transform: "translate(-777.011 -25.229)",
    fill: "#515255"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238344",
    "data-name": "Path 238344",
    d: "M942.535,247.057l-1.371-.2v-14.3l1.371.24Z",
    transform: "translate(-791.898 -25.155)",
    fill: "#fff"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238345",
    "data-name": "Path 238345",
    d: "M942.988,247.579V232.291l-2.4-.419v15.353Zm-1.031-14.423v13.23l-.342-.05V233.1Z",
    transform: "translate(-791.836 -25.08)",
    fill: "#515255"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238346",
    "data-name": "Path 238346",
    d: "M950.6,245.85l-1.409-.208V231.151l1.409.246Z",
    transform: "translate(-807.129 -25.002)",
    fill: "#fff"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238347",
    "data-name": "Path 238347",
    d: "M951.056,246.372V230.889l-2.439-.425v15.548Zm-1.03-14.617v13.425l-.379-.056V231.688Z",
    transform: "translate(-807.067 -24.928)",
    fill: "#515255"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238348",
    "data-name": "Path 238348",
    d: "M958.9,244.609l-1.448-.213V229.7l1.448.252Z",
    transform: "translate(-822.78 -24.846)",
    fill: "#fff"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238349",
    "data-name": "Path 238349",
    d: "M959.347,245.131V229.449l-2.479-.433v15.75Zm-1.03-14.817v13.625l-.418-.062V230.24Z",
    transform: "translate(-822.717 -24.771)",
    fill: "#515255"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238350",
    "data-name": "Path 238350",
    d: "M967.42,243.333l-1.489-.219v-14.9l1.489.26Z",
    transform: "translate(-838.872 -24.685)",
    fill: "#fff"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238351",
    "data-name": "Path 238351",
    d: "M967.872,243.855V227.968l-2.519-.441v15.957Zm-1.03-15.022v13.83l-.459-.068V228.752Z",
    transform: "translate(-838.809 -24.61)",
    fill: "#515255"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238352",
    "data-name": "Path 238352",
    d: "M976.188,242.021l-1.532-.226V226.684l1.532.267Z",
    transform: "translate(-855.421 -24.519)",
    fill: "#fff"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238353",
    "data-name": "Path 238353",
    d: "M976.64,242.542v-16.1L974.078,226v16.169Zm-1.03-15.233V241.35l-.5-.074V227.221Z",
    transform: "translate(-855.358 -24.445)",
    fill: "#515255"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238354",
    "data-name": "Path 238354",
    d: "M985.209,240.67l-1.577-.232V225.108l1.577.276Z",
    transform: "translate(-872.448 -24.349)",
    fill: "#fff"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238355",
    "data-name": "Path 238355",
    d: "M985.662,241.193V224.877l-2.607-.456v16.387Zm-1.03-15.451V240l-.547-.08V225.646Z",
    transform: "translate(-872.385 -24.274)",
    fill: "#515255"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238356",
    "data-name": "Path 238356",
    d: "M994.5,239.281l-1.623-.239V223.486l1.623.284Z",
    transform: "translate(-889.974 -24.173)",
    fill: "#fff"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238357",
    "data-name": "Path 238357",
    d: "M994.948,239.8v-16.54l-2.653-.464v16.612Zm-1.03-15.675v14.482l-.593-.087v-14.5Z",
    transform: "translate(-889.912 -24.099)",
    fill: "#515255"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238358",
    "data-name": "Path 238358",
    d: "M1004.057,237.85l-1.671-.246V221.816l1.671.292Z",
    transform: "translate(-908.021 -23.993)",
    fill: "#fff"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238359",
    "data-name": "Path 238359",
    d: "M1004.51,238.372V221.6l-2.7-.472v16.844Zm-1.03-15.9v14.713l-.642-.095v-14.73Z",
    transform: "translate(-907.959 -23.918)",
    fill: "#515255"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238360",
    "data-name": "Path 238360",
    d: "M1013.909,236.376l-1.722-.254V220.1l1.722.3Z",
    transform: "translate(-926.614 -23.807)",
    fill: "#fff"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238361",
    "data-name": "Path 238361",
    d: "M1014.362,236.9V219.891l-2.752-.481v17.082Zm-1.03-16.142v14.95l-.693-.1V220.634Z",
    transform: "translate(-926.552 -23.732)",
    fill: "#515255"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238362",
    "data-name": "Path 238362",
    d: "M1024.063,234.857l-1.776-.261V218.324l1.776.309Z",
    transform: "translate(-945.776 -23.615)",
    fill: "#fff"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238363",
    "data-name": "Path 238363",
    d: "M1024.516,235.378V218.127l-2.806-.49v17.328Zm-1.03-16.387v15.194l-.746-.11V218.861Z",
    transform: "translate(-945.713 -23.541)",
    fill: "#515255"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238364",
    "data-name": "Path 238364",
    d: "M1034.534,233.29l-1.831-.27V216.5l1.831.319Z",
    transform: "translate(-965.535 -23.417)",
    fill: "#fff"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238365",
    "data-name": "Path 238365",
    d: "M1034.986,233.812v-17.5l-2.861-.5v17.582Zm-1.03-16.639V232.62l-.8-.119V217.033Z",
    transform: "translate(-965.472 -23.343)",
    fill: "#515255"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238366",
    "data-name": "Path 238366",
    d: "M1045.337,231.674l-1.89-.278V214.609l1.89.33Z",
    transform: "translate(-985.92 -23.213)",
    fill: "#fff"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238367",
    "data-name": "Path 238367",
    d: "M1045.789,232.2V214.432l-2.92-.51v17.844Zm-1.03-16.9V231l-.86-.127V215.147Z",
    transform: "translate(-985.857 -23.139)",
    fill: "#515255"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238368",
    "data-name": "Path 238368",
    d: "M1056.486,230.007l-1.95-.287V212.662l1.95.34Z",
    transform: "translate(-1006.958 -23.003)",
    fill: "#fff"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238369",
    "data-name": "Path 238369",
    d: "M1056.939,230.529V212.5l-2.981-.521v18.114Zm-1.03-17.168v15.975l-.921-.136v-16Z",
    transform: "translate(-1006.896 -22.928)",
    fill: "#515255"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238370",
    "data-name": "Path 238370",
    d: "M1068,228.284l-2.016-.3V210.651L1068,211Z",
    transform: "translate(-1028.684 -22.785)",
    fill: "#fff"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238371",
    "data-name": "Path 238371",
    d: "M1068.454,228.807V210.5l-3.046-.532v18.392Zm-1.03-17.445v16.252l-.985-.144v-16.28Z",
    transform: "translate(-1028.622 -22.711)",
    fill: "#515255"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238372",
    "data-name": "Path 238372",
    d: "M1079.9,226.5l-2.082-.307V208.574l2.082.363Z",
    transform: "translate(-1051.131 -22.56)",
    fill: "#fff"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238373",
    "data-name": "Path 238373",
    d: "M1080.35,227.027v-18.6l-3.113-.543v18.681Zm-1.03-17.731v16.538l-1.052-.154V209.111Z",
    transform: "translate(-1051.07 -22.486)",
    fill: "#515255"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238374",
    "data-name": "Path 238374",
    d: "M1092.2,224.666l-2.154-.318V206.426l2.154.375Z",
    transform: "translate(-1074.337 -22.328)",
    fill: "#fff"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238375",
    "data-name": "Path 238375",
    d: "M1092.65,225.187V206.295l-3.184-.556v18.979Zm-1.03-18.028v16.835l-1.124-.166V206.964Z",
    transform: "translate(-1074.274 -22.254)",
    fill: "#515255"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238376",
    "data-name": "Path 238376",
    d: "M1104.919,222.763l-2.228-.328V204.2l2.228.389Z",
    transform: "translate(-1098.338 -22.088)",
    fill: "#fff"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238377",
    "data-name": "Path 238377",
    d: "M1105.372,223.285v-19.2l-3.258-.569V222.8Zm-1.03-18.333v17.141l-1.2-.177V204.742Z",
    transform: "translate(-1098.276 -22.013)",
    fill: "#515255"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238378",
    "data-name": "Path 238378",
    d: "M1086.805,267.413h-68.58l-123.2-12.636v-8.225Z",
    transform: "translate(-895.017 -26.668)",
    fill: "#515255"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238379",
    "data-name": "Path 238379",
    d: "M1091.745,268.02H1063.9L940.7,255.383V252.16Z",
    transform: "translate(-940.691 -27.275)",
    fill: "#fff"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238380",
    "data-name": "Path 238380",
    d: "M1091.147,267.957h-9.863l-146.12-15.342v-1.035Z",
    transform: "translate(-935.159 -27.212)",
    fill: "#515255"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238381",
    "data-name": "Path 238381",
    d: "M1094.51,268.348h-10.094L966.259,256.229v-1.035Z",
    transform: "translate(-966.254 -27.603)",
    fill: "#515255"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238382",
    "data-name": "Path 238382",
    d: "M916.232,267.775v1.917h-1.448v-2.074Z",
    transform: "translate(-742.068 -28.947)",
    fill: "#fff"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238383",
    "data-name": "Path 238383",
    d: "M916.683,267.243v2.379h-1.029v-1.455l-.418-.046v1.5h-1.029v-2.649Z",
    transform: "translate(-742.005 -28.877)",
    fill: "#515255"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238384",
    "data-name": "Path 238384",
    d: "M950.711,264.031v5.254h-1.526v-5.42Z",
    transform: "translate(-807.228 -28.541)",
    fill: "#fff"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238385",
    "data-name": "Path 238385",
    d: "M951.164,263.5v5.717h-1.03v-4.793l-.5-.053v4.846h-1.03v-5.994Z",
    transform: "translate(-807.166 -28.471)",
    fill: "#515255"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238386",
    "data-name": "Path 238386",
    d: "M987.083,267.618l-1.611-.165v-7.545l1.611.176Z",
    transform: "translate(-875.962 -28.113)",
    fill: "#fff"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238387",
    "data-name": "Path 238387",
    d: "M986.5,260.476l-.581-.063v6.506l.581.06Zm1.03-.924v8.567l-2.641-.271v-8.583Z",
    transform: "translate(-875.898 -28.043)",
    fill: "#515255"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238388",
    "data-name": "Path 238388",
    d: "M1035.455,262.635l-1.728-.177v-7.812l1.728.188Z",
    transform: "translate(-967.37 -27.544)",
    fill: "#fff"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238389",
    "data-name": "Path 238389",
    d: "M1035.908,263.135V254.3l-2.757-.3v8.851Zm-1.03-7.911v6.77l-.7-.072v-6.773Z",
    transform: "translate(-967.308 -27.474)",
    fill: "#515255"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238390",
    "data-name": "Path 238390",
    d: "M1098.238,256.168l-1.884-.194v-8.16l1.884.205Z",
    transform: "translate(-1086.006 -26.805)",
    fill: "#fff"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238391",
    "data-name": "Path 238391",
    d: "M1098.69,256.668v-9.181l-2.914-.317v9.2Zm-1.03-8.257v7.117l-.854-.088v-7.121Z",
    transform: "translate(-1085.943 -26.735)",
    fill: "#515255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_84349",
    "data-name": "Group 84349",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84348",
    "data-name": "Group 84348",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84347",
    "data-name": "Group 84347",
    transform: "translate(469.314 209.407)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84346",
    "data-name": "Group 84346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84345",
    "data-name": "Group 84345",
    clipPath: "url(#clip-path-78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238392",
    "data-name": "Path 238392",
    d: "M571.96,235.481l5.187.821,4.876,9.522v20.391H571.859Z",
    transform: "translate(-571.344 -234.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238393",
    "data-name": "Path 238393",
    d: "M581.444,245.875l-4.7-9.178-4.335-.687-.1,30.132h-1.03l.1-31.337,6.039.957,5.052,9.865v20.515h-1.03Z",
    transform: "translate(-571.281 -234.805)",
    fill: "#515255"
  }))))), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238394",
    "data-name": "Path 238394",
    d: "M29.736,258.416a13.359,13.359,0,0,1,13,10.28H16.739a13.359,13.359,0,0,1,13-10.28",
    transform: "translate(932.336 -27.951)",
    fill: "#fff"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238395",
    "data-name": "Path 238395",
    d: "M29.672,258.868A12.787,12.787,0,0,0,17.2,268.634H16.146a13.871,13.871,0,0,1,27.051,0H42.142a12.787,12.787,0,0,0-12.471-9.766",
    transform: "translate(932.4 -27.889)",
    fill: "#515255"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238396",
    "data-name": "Path 238396",
    d: "M20.135,265.665a13.53,13.53,0,0,1,9.053,3.815H11.082a13.53,13.53,0,0,1,9.053-3.815",
    transform: "translate(950.925 -28.736)",
    fill: "#fff"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238397",
    "data-name": "Path 238397",
    d: "M20.043,266.117a12.8,12.8,0,0,0-8.266,3.3H10.232a14.235,14.235,0,0,1,9.811-4.331,14.235,14.235,0,0,1,9.811,4.331H28.309a12.8,12.8,0,0,0-8.266-3.3",
    transform: "translate(951.017 -28.673)",
    fill: "#515255"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84474",
    "data-name": "Group 84474",
    transform: "translate(990 100)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84473",
    "data-name": "Group 84473",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84472",
    "data-name": "Group 84472",
    clipPath: "url(#clip-path-79)"
  }, _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24392",
    "data-name": "Rectangle 24392",
    width: 27.515,
    height: 24.412,
    transform: "translate(160.101 116.802)",
    fill: "#fff"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238398",
    "data-name": "Path 238398",
    d: "M279.9,116.226v24.988h-1.155V117.381h-26.36v23.833H251.23V116.226Z",
    transform: "translate(-91.705 0)",
    fill: "#515255"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24393",
    "data-name": "Rectangle 24393",
    width: 12.483,
    height: 25.254,
    transform: "translate(238.314 96.329)",
    fill: "#fff"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238399",
    "data-name": "Path 238399",
    d: "M188.049,122.16h13.638V95.751H188.049ZM200.533,121H189.2V96.9h11.329Z",
    transform: "translate(49.687 0)",
    fill: "#515255"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24394",
    "data-name": "Rectangle 24394",
    width: 16.2,
    height: 34.337,
    transform: "translate(149.72 106.877)",
    fill: "#fff"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238400",
    "data-name": "Path 238400",
    d: "M290.281,106.3v34.914h-1.155V107.455H274.081v33.759h-1.155V106.3Z",
    transform: "translate(-123.784 0)",
    fill: "#515255"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24395",
    "data-name": "Rectangle 24395",
    width: 40.207,
    height: 30.933,
    transform: "translate(399.216 110.281)",
    fill: "#fff"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238401",
    "data-name": "Path 238401",
    d: "M40.784,109.7v1.155H1.154v30.355H0V109.7Z",
    transform: "translate(398.639 0)",
    fill: "#515255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_84359",
    "data-name": "Group 84359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84358",
    "data-name": "Group 84358",
    clipPath: "url(#clip-path-79)"
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84354",
    "data-name": "Group 84354",
    transform: "translate(398.639 113.185)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84353",
    "data-name": "Group 84353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84352",
    "data-name": "Group 84352",
    clipPath: "url(#clip-path-81)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24396",
    "data-name": "Rectangle 24396",
    width: 40.207,
    height: 1.012,
    transform: "translate(0.577 0.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24397",
    "data-name": "Rectangle 24397",
    width: 40.784,
    height: 2.167,
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24398",
    "data-name": "Rectangle 24398",
    width: 40.207,
    height: 1.012,
    transform: "translate(0.577 5.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24399",
    "data-name": "Rectangle 24399",
    width: 40.784,
    height: 2.167,
    transform: "translate(0 4.494)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24400",
    "data-name": "Rectangle 24400",
    width: 40.207,
    height: 1.012,
    transform: "translate(0.577 9.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24401",
    "data-name": "Rectangle 24401",
    width: 40.784,
    height: 2.167,
    transform: "translate(0 8.987)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24402",
    "data-name": "Rectangle 24402",
    width: 40.207,
    height: 1.012,
    transform: "translate(0.577 14.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24403",
    "data-name": "Rectangle 24403",
    width: 40.784,
    height: 2.166,
    transform: "translate(0 13.481)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24404",
    "data-name": "Rectangle 24404",
    width: 40.207,
    height: 1.012,
    transform: "translate(0.577 18.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24405",
    "data-name": "Rectangle 24405",
    width: 40.784,
    height: 2.167,
    transform: "translate(0 17.975)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24406",
    "data-name": "Rectangle 24406",
    width: 40.207,
    height: 1.012,
    transform: "translate(0.577 23.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24407",
    "data-name": "Rectangle 24407",
    width: 40.784,
    height: 2.166,
    transform: "translate(0 22.469)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24408",
    "data-name": "Rectangle 24408",
    width: 40.207,
    height: 0.49,
    transform: "translate(0.577 27.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24409",
    "data-name": "Rectangle 24409",
    width: 40.784,
    height: 1.067,
    transform: "translate(0 26.962)",
    fill: "#515255"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84357",
    "data-name": "Group 84357",
    transform: "translate(398.639 109.704)",
    opacity: 0.36,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84356",
    "data-name": "Group 84356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84355",
    "data-name": "Group 84355",
    clipPath: "url(#clip-path-82)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24411",
    "data-name": "Rectangle 24411",
    width: 19.697,
    height: 30.933,
    transform: "translate(0.577 0.577)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238402",
    "data-name": "Path 238402",
    d: "M39.629,110.859H21.087v30.355H19.932V109.7H40.784v31.51H39.629Z",
    transform: "translate(-19.932 -109.704)",
    fill: "#515255"
  }))))))), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24414",
    "data-name": "Rectangle 24414",
    width: 17.761,
    height: 52.49,
    transform: "translate(356.348 88.724)",
    fill: "#fff"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238403",
    "data-name": "Path 238403",
    d: "M83.652,88.146v53.068H82.5V89.3H65.89v51.913H64.736V88.146Z",
    transform: "translate(291.035 0)",
    fill: "#515255"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24415",
    "data-name": "Rectangle 24415",
    width: 4.702,
    height: 52.49,
    transform: "translate(374.109 88.724)",
    fill: "#fff"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238404",
    "data-name": "Path 238404",
    d: "M65.89,88.146v53.068H64.735V89.3H61.188v51.913H60.035V88.146Z",
    transform: "translate(313.498 0)",
    fill: "#515255"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24416",
    "data-name": "Rectangle 24416",
    width: 19.134,
    height: 52.49,
    transform: "translate(388.495 88.724)",
    fill: "#fff"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238405",
    "data-name": "Path 238405",
    d: "M51.507,88.146v53.068H50.352V89.3H32.372v51.913H31.216V88.146Z",
    transform: "translate(356.7 0)",
    fill: "#515255"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24417",
    "data-name": "Rectangle 24417",
    width: 4.702,
    height: 52.49,
    transform: "translate(383.793 88.724)",
    fill: "#fff"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238406",
    "data-name": "Path 238406",
    d: "M56.207,88.146v53.068H55.052V89.3H51.505v51.913H50.351V88.146Z",
    transform: "translate(332.864 0)",
    fill: "#515255"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24418",
    "data-name": "Rectangle 24418",
    width: 4.982,
    height: 52.49,
    transform: "translate(378.81 88.724)",
    fill: "#515255"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24419",
    "data-name": "Rectangle 24419",
    width: 17.476,
    height: 6.784,
    transform: "translate(363.826 81.94)",
    fill: "#fff"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238407",
    "data-name": "Path 238407",
    d: "M57.544,89.3h18.63V81.362H57.544ZM75.02,88.147H58.7v-5.63H75.02Z",
    transform: "translate(305.705 0)",
    fill: "#515255"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24420",
    "data-name": "Rectangle 24420",
    width: 17.476,
    height: 6.784,
    transform: "translate(381.302 81.94)",
    fill: "#fff"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238408",
    "data-name": "Path 238408",
    d: "M40.068,89.3H58.7V81.362H40.068Zm17.475-1.154H41.222v-5.63H57.543Z",
    transform: "translate(340.657 0)",
    fill: "#515255"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24421",
    "data-name": "Rectangle 24421",
    width: 21.284,
    height: 90.371,
    transform: "translate(262.379 50.843)",
    fill: "#86e9b9"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238409",
    "data-name": "Path 238409",
    d: "M177.622,50.266v90.948h-1.155V51.42h-20.13v89.794h-1.155V50.266Z",
    transform: "translate(106.618 0)",
    fill: "#515255"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24422",
    "data-name": "Rectangle 24422",
    width: 5.635,
    height: 90.371,
    transform: "translate(283.663 50.843)",
    fill: "#fff"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238410",
    "data-name": "Path 238410",
    d: "M156.338,50.266v90.948h-1.155V51.42H150.7v89.794h-1.155V50.266Z",
    transform: "translate(133.538 0)",
    fill: "#515255"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24423",
    "data-name": "Rectangle 24423",
    width: 44.778,
    height: 90.371,
    transform: "translate(300.902 50.843)",
    fill: "#fff"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238411",
    "data-name": "Path 238411",
    d: "M139.1,50.266v90.948h-1.155V51.42H94.321v89.794H93.166V50.266Z",
    transform: "translate(207.159 0)",
    fill: "#515255"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24424",
    "data-name": "Rectangle 24424",
    width: 5.634,
    height: 90.371,
    transform: "translate(295.268 50.843)",
    fill: "#fff"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238412",
    "data-name": "Path 238412",
    d: "M144.733,50.266v90.948h-1.155V51.42H139.1v89.794h-1.155V50.266Z",
    transform: "translate(156.747 0)",
    fill: "#515255"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24425",
    "data-name": "Rectangle 24425",
    width: 5.971,
    height: 90.371,
    transform: "translate(289.297 50.843)",
    fill: "#fff"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238413",
    "data-name": "Path 238413",
    d: "M150.7,50.266v90.948h-1.155V51.42h-4.815v89.794h-1.154V50.266Z",
    transform: "translate(145.143 0)",
    fill: "#515255"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24426",
    "data-name": "Rectangle 24426",
    width: 23.963,
    height: 76.978,
    transform: "translate(132.331 64.236)",
    fill: "#fff"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238414",
    "data-name": "Path 238414",
    d: "M307.668,63.659v77.555h-1.154v-76.4H283.706v76.4h-1.154V63.659Z",
    transform: "translate(-150.798 0)",
    fill: "#515255"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24427",
    "data-name": "Rectangle 24427",
    width: 23.962,
    height: 76.978,
    transform: "translate(108.369 64.236)",
    fill: "#fff"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238415",
    "data-name": "Path 238415",
    d: "M331.631,63.659v77.555h-1.155v-76.4H307.669v76.4h-1.155V63.659Z",
    transform: "translate(-198.722 0)",
    fill: "#515255"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84388",
    "data-name": "Group 84388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84387",
    "data-name": "Group 84387",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84362",
    "data-name": "Group 84362",
    transform: "translate(107.792 73.532)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84361",
    "data-name": "Group 84361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84360",
    "data-name": "Group 84360",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24428",
    "data-name": "Rectangle 24428",
    width: 47.925,
    height: 4.062,
    transform: "translate(0.577 0.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238416",
    "data-name": "Path 238416",
    d: "M282.552,78.749h49.079V73.532H282.552ZM330.476,77.6h-46.77V74.687h46.77Z",
    transform: "translate(-282.552 -73.532)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84365",
    "data-name": "Group 84365",
    transform: "translate(107.792 81.724)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84364",
    "data-name": "Group 84364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84363",
    "data-name": "Group 84363",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24430",
    "data-name": "Rectangle 24430",
    width: 47.925,
    height: 4.062,
    transform: "translate(0.577 0.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238417",
    "data-name": "Path 238417",
    d: "M282.552,86.941h49.079V81.724H282.552Zm47.924-1.154h-46.77V82.879h46.77Z",
    transform: "translate(-282.552 -81.724)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84368",
    "data-name": "Group 84368",
    transform: "translate(107.792 89.916)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84367",
    "data-name": "Group 84367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84366",
    "data-name": "Group 84366",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24432",
    "data-name": "Rectangle 24432",
    width: 47.925,
    height: 4.062,
    transform: "translate(0.577 0.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238418",
    "data-name": "Path 238418",
    d: "M282.552,95.133h49.079V89.916H282.552Zm47.924-1.154h-46.77V91.071h46.77Z",
    transform: "translate(-282.552 -89.916)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84371",
    "data-name": "Group 84371",
    transform: "translate(107.792 98.108)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84370",
    "data-name": "Group 84370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84369",
    "data-name": "Group 84369",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24434",
    "data-name": "Rectangle 24434",
    width: 47.925,
    height: 4.062,
    transform: "translate(0.577 0.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238419",
    "data-name": "Path 238419",
    d: "M282.552,103.325h49.079V98.108H282.552Zm47.924-1.154h-46.77V99.263h46.77Z",
    transform: "translate(-282.552 -98.108)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84374",
    "data-name": "Group 84374",
    transform: "translate(107.792 106.3)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84373",
    "data-name": "Group 84373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84372",
    "data-name": "Group 84372",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24436",
    "data-name": "Rectangle 24436",
    width: 47.925,
    height: 4.062,
    transform: "translate(0.577 0.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238420",
    "data-name": "Path 238420",
    d: "M282.552,111.517h49.079V106.3H282.552Zm47.924-1.155h-46.77v-2.908h46.77Z",
    transform: "translate(-282.552 -106.3)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84377",
    "data-name": "Group 84377",
    transform: "translate(107.792 114.492)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84376",
    "data-name": "Group 84376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84375",
    "data-name": "Group 84375",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24438",
    "data-name": "Rectangle 24438",
    width: 47.925,
    height: 4.062,
    transform: "translate(0.577 0.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238421",
    "data-name": "Path 238421",
    d: "M282.552,119.709h49.079v-5.217H282.552Zm47.924-1.155h-46.77v-2.908h46.77Z",
    transform: "translate(-282.552 -114.492)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84380",
    "data-name": "Group 84380",
    transform: "translate(107.792 122.684)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84379",
    "data-name": "Group 84379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84378",
    "data-name": "Group 84378",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24440",
    "data-name": "Rectangle 24440",
    width: 47.925,
    height: 4.062,
    transform: "translate(0.577 0.577)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238422",
    "data-name": "Path 238422",
    d: "M282.552,127.9h49.079v-5.217H282.552Zm47.924-1.155h-46.77v-2.908h46.77Z",
    transform: "translate(-282.552 -122.684)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84383",
    "data-name": "Group 84383",
    transform: "translate(107.792 130.876)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84382",
    "data-name": "Group 84382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84381",
    "data-name": "Group 84381",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24442",
    "data-name": "Rectangle 24442",
    width: 47.925,
    height: 4.062,
    transform: "translate(0.577 0.577)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238423",
    "data-name": "Path 238423",
    d: "M282.552,136.093h49.079v-5.217H282.552Zm47.924-1.155h-46.77V132.03h46.77Z",
    transform: "translate(-282.552 -130.876)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84386",
    "data-name": "Group 84386",
    transform: "translate(107.792 139.068)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84385",
    "data-name": "Group 84385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84384",
    "data-name": "Group 84384",
    clipPath: "url(#clip-path-92)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24444",
    "data-name": "Rectangle 24444",
    width: 47.925,
    height: 1.569,
    transform: "translate(0.577 0.577)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238424",
    "data-name": "Path 238424",
    d: "M330.476,140.223h-46.77v.991h-1.155v-2.146h49.08v2.146h-1.155Z",
    transform: "translate(-282.552 -139.068)",
    fill: "#515255"
  }))))))), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238425",
    "data-name": "Path 238425",
    d: "M265.946.577V141.214h-69.5V68.5h16.9V.577Z",
    transform: "translate(-22.968 0)",
    fill: "#fff"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238426",
    "data-name": "Path 238426",
    d: "M266.522,0V141.213h-1.155V1.155H213.924V69.073h-16.9v72.14h-1.153V67.918h16.9V0Z",
    transform: "translate(-22.966 0)",
    fill: "#515255"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238427",
    "data-name": "Path 238427",
    d: "M240.943.577V141.214h-44.5V68.5h16.9V.577Z",
    transform: "translate(2.035 0)",
    fill: "#fff"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238428",
    "data-name": "Path 238428",
    d: "M241.52,0V141.213h-1.155V1.155h-26.44V69.073h-16.9v72.14h-1.154V67.918h16.9V0Z",
    transform: "translate(2.036 0)",
    fill: "#515255"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24447",
    "data-name": "Rectangle 24447",
    width: 21.467,
    height: 63.14,
    transform: "translate(191.931 5.356)",
    fill: "#fff"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238429",
    "data-name": "Path 238429",
    d: "M225.448,69.073H248.07V4.778H225.448Zm21.467-1.154H226.6V5.933h20.313Z",
    transform: "translate(-34.095 0)",
    fill: "#515255"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24448",
    "data-name": "Rectangle 24448",
    width: 20.115,
    height: 68.953,
    transform: "translate(175.731 72.261)",
    fill: "#fff"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238430",
    "data-name": "Path 238430",
    d: "M264.269,71.685v69.529h-1.155V72.84h-18.96v68.374H243V71.685Z",
    transform: "translate(-67.845 0)",
    fill: "#515255"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24449",
    "data-name": "Rectangle 24449",
    width: 14.368,
    height: 68.953,
    transform: "translate(201.213 72.261)",
    fill: "#fff"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238431",
    "data-name": "Path 238431",
    d: "M238.787,71.685v69.529h-1.155V72.84H224.419v68.374h-1.154V71.685Z",
    transform: "translate(-22.629 0)",
    fill: "#515255"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24450",
    "data-name": "Rectangle 24450",
    width: 21.467,
    height: 135.859,
    transform: "translate(218.455 5.355)",
    fill: "#fff"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238432",
    "data-name": "Path 238432",
    d: "M221.545,4.779V141.214H220.39V5.934H200.077V141.214h-1.154V4.779Z",
    transform: "translate(18.954 0)",
    fill: "#515255"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84393",
    "data-name": "Group 84393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84392",
    "data-name": "Group 84392",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84391",
    "data-name": "Group 84391",
    transform: "translate(175.731 8.068)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84390",
    "data-name": "Group 84390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84389",
    "data-name": "Group 84389",
    clipPath: "url(#clip-path-94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24451",
    "data-name": "Rectangle 24451",
    width: 21.468,
    height: 2.034,
    transform: "translate(42.723)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24452",
    "data-name": "Rectangle 24452",
    width: 21.467,
    height: 2.034,
    transform: "translate(16.2)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24453",
    "data-name": "Rectangle 24453",
    width: 21.468,
    height: 2.034,
    transform: "translate(42.723 5.82)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24454",
    "data-name": "Rectangle 24454",
    width: 21.467,
    height: 2.034,
    transform: "translate(16.2 5.82)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24455",
    "data-name": "Rectangle 24455",
    width: 21.468,
    height: 2.034,
    transform: "translate(42.723 11.64)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24456",
    "data-name": "Rectangle 24456",
    width: 21.467,
    height: 2.034,
    transform: "translate(16.2 11.64)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24457",
    "data-name": "Rectangle 24457",
    width: 21.468,
    height: 2.021,
    transform: "translate(42.723 17.473)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24458",
    "data-name": "Rectangle 24458",
    width: 21.467,
    height: 2.021,
    transform: "translate(16.2 17.473)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24459",
    "data-name": "Rectangle 24459",
    width: 21.468,
    height: 2.021,
    transform: "translate(42.723 23.294)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24460",
    "data-name": "Rectangle 24460",
    width: 21.467,
    height: 2.021,
    transform: "translate(16.2 23.294)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24461",
    "data-name": "Rectangle 24461",
    width: 21.468,
    height: 2.021,
    transform: "translate(42.723 29.114)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24462",
    "data-name": "Rectangle 24462",
    width: 21.467,
    height: 2.021,
    transform: "translate(16.2 29.114)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24463",
    "data-name": "Rectangle 24463",
    width: 21.468,
    height: 2.021,
    transform: "translate(42.723 34.934)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24464",
    "data-name": "Rectangle 24464",
    width: 21.467,
    height: 2.021,
    transform: "translate(16.2 34.934)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24465",
    "data-name": "Rectangle 24465",
    width: 21.468,
    height: 2.021,
    transform: "translate(42.723 40.754)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24466",
    "data-name": "Rectangle 24466",
    width: 21.467,
    height: 2.021,
    transform: "translate(16.2 40.754)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24467",
    "data-name": "Rectangle 24467",
    width: 21.468,
    height: 2.021,
    transform: "translate(42.723 46.575)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24468",
    "data-name": "Rectangle 24468",
    width: 21.467,
    height: 2.021,
    transform: "translate(16.2 46.575)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24469",
    "data-name": "Rectangle 24469",
    width: 21.468,
    height: 2.021,
    transform: "translate(42.723 52.395)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24470",
    "data-name": "Rectangle 24470",
    width: 21.467,
    height: 2.021,
    transform: "translate(16.2 52.395)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24471",
    "data-name": "Rectangle 24471",
    width: 21.467,
    height: 2.021,
    transform: "translate(16.2 58.215)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24472",
    "data-name": "Rectangle 24472",
    width: 21.468,
    height: 2.021,
    transform: "translate(42.723 58.215)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24473",
    "data-name": "Rectangle 24473",
    width: 21.468,
    height: 2.021,
    transform: "translate(42.723 65.959)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24474",
    "data-name": "Rectangle 24474",
    width: 14.368,
    height: 2.021,
    transform: "translate(25.482 65.959)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24475",
    "data-name": "Rectangle 24475",
    width: 20.115,
    height: 2.021,
    transform: "translate(0 65.959)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24476",
    "data-name": "Rectangle 24476",
    width: 21.468,
    height: 2.021,
    transform: "translate(42.723 71.779)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24477",
    "data-name": "Rectangle 24477",
    width: 14.368,
    height: 2.021,
    transform: "translate(25.482 71.779)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24478",
    "data-name": "Rectangle 24478",
    width: 20.115,
    height: 2.021,
    transform: "translate(0 71.779)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24479",
    "data-name": "Rectangle 24479",
    width: 21.468,
    height: 2.021,
    transform: "translate(42.723 77.6)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24480",
    "data-name": "Rectangle 24480",
    width: 14.368,
    height: 2.021,
    transform: "translate(25.482 77.6)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24481",
    "data-name": "Rectangle 24481",
    width: 20.115,
    height: 2.021,
    transform: "translate(0 77.6)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24482",
    "data-name": "Rectangle 24482",
    width: 21.468,
    height: 2.021,
    transform: "translate(42.723 83.42)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24483",
    "data-name": "Rectangle 24483",
    width: 14.368,
    height: 2.021,
    transform: "translate(25.482 83.42)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24484",
    "data-name": "Rectangle 24484",
    width: 20.115,
    height: 2.021,
    transform: "translate(0 83.42)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24485",
    "data-name": "Rectangle 24485",
    width: 21.468,
    height: 2.021,
    transform: "translate(42.723 89.24)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24486",
    "data-name": "Rectangle 24486",
    width: 14.368,
    height: 2.021,
    transform: "translate(25.482 89.24)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24487",
    "data-name": "Rectangle 24487",
    width: 20.115,
    height: 2.021,
    transform: "translate(0 89.24)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24488",
    "data-name": "Rectangle 24488",
    width: 21.468,
    height: 2.034,
    transform: "translate(42.723 95.06)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24489",
    "data-name": "Rectangle 24489",
    width: 14.368,
    height: 2.034,
    transform: "translate(25.482 95.06)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24490",
    "data-name": "Rectangle 24490",
    width: 20.115,
    height: 2.034,
    transform: "translate(0 95.06)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24491",
    "data-name": "Rectangle 24491",
    width: 21.468,
    height: 2.034,
    transform: "translate(42.723 100.881)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24492",
    "data-name": "Rectangle 24492",
    width: 14.368,
    height: 2.034,
    transform: "translate(25.482 100.881)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24493",
    "data-name": "Rectangle 24493",
    width: 20.115,
    height: 2.034,
    transform: "translate(0 100.881)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24494",
    "data-name": "Rectangle 24494",
    width: 21.468,
    height: 2.034,
    transform: "translate(42.723 106.701)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24495",
    "data-name": "Rectangle 24495",
    width: 14.368,
    height: 2.034,
    transform: "translate(25.482 106.701)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24496",
    "data-name": "Rectangle 24496",
    width: 20.115,
    height: 2.034,
    transform: "translate(0 106.701)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24497",
    "data-name": "Rectangle 24497",
    width: 21.468,
    height: 2.034,
    transform: "translate(42.723 112.521)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24498",
    "data-name": "Rectangle 24498",
    width: 14.368,
    height: 2.034,
    transform: "translate(25.482 112.521)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24499",
    "data-name": "Rectangle 24499",
    width: 20.115,
    height: 2.034,
    transform: "translate(0 112.521)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24500",
    "data-name": "Rectangle 24500",
    width: 21.468,
    height: 2.034,
    transform: "translate(42.723 118.341)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24501",
    "data-name": "Rectangle 24501",
    width: 14.368,
    height: 2.034,
    transform: "translate(25.482 118.341)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24502",
    "data-name": "Rectangle 24502",
    width: 20.115,
    height: 2.034,
    transform: "translate(0 118.341)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24503",
    "data-name": "Rectangle 24503",
    width: 21.468,
    height: 2.034,
    transform: "translate(42.723 124.162)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24504",
    "data-name": "Rectangle 24504",
    width: 14.368,
    height: 2.034,
    transform: "translate(25.482 124.162)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24505",
    "data-name": "Rectangle 24505",
    width: 20.115,
    height: 2.034,
    transform: "translate(0 124.162)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24506",
    "data-name": "Rectangle 24506",
    width: 21.468,
    height: 2.034,
    transform: "translate(42.723 129.982)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24507",
    "data-name": "Rectangle 24507",
    width: 14.368,
    height: 2.034,
    transform: "translate(25.482 129.982)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24508",
    "data-name": "Rectangle 24508",
    width: 20.115,
    height: 2.034,
    transform: "translate(0 129.982)",
    fill: "#515255"
  }))))))), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24511",
    "data-name": "Rectangle 24511",
    width: 32.526,
    height: 48.927,
    transform: "translate(42.446 92.287)",
    fill: "#fff"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238433",
    "data-name": "Path 238433",
    d: "M397.554,91.71v49.5H396.4V92.865h-31.37v48.35h-1.155V91.71Z",
    transform: "translate(-322.004 0)",
    fill: "#515255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_84401",
    "data-name": "Group 84401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84400",
    "data-name": "Group 84400",
    clipPath: "url(#clip-path-79)"
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84396",
    "data-name": "Group 84396",
    transform: "translate(41.869 95.211)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84395",
    "data-name": "Group 84395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84394",
    "data-name": "Group 84394",
    clipPath: "url(#clip-path-96)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24512",
    "data-name": "Rectangle 24512",
    width: 32.526,
    height: 1.012,
    transform: "translate(0.577 0.577)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24513",
    "data-name": "Rectangle 24513",
    width: 33.68,
    height: 2.166,
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24514",
    "data-name": "Rectangle 24514",
    width: 32.526,
    height: 1.012,
    transform: "translate(0.577 5.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24515",
    "data-name": "Rectangle 24515",
    width: 33.68,
    height: 2.167,
    transform: "translate(0 4.493)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24516",
    "data-name": "Rectangle 24516",
    width: 32.526,
    height: 1.012,
    transform: "translate(0.577 9.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24517",
    "data-name": "Rectangle 24517",
    width: 33.68,
    height: 2.166,
    transform: "translate(0 8.988)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24518",
    "data-name": "Rectangle 24518",
    width: 32.526,
    height: 1.012,
    transform: "translate(0.577 14.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24519",
    "data-name": "Rectangle 24519",
    width: 33.68,
    height: 2.167,
    transform: "translate(0 13.481)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24520",
    "data-name": "Rectangle 24520",
    width: 32.526,
    height: 1.012,
    transform: "translate(0.577 18.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24521",
    "data-name": "Rectangle 24521",
    width: 33.68,
    height: 2.166,
    transform: "translate(0 17.975)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24522",
    "data-name": "Rectangle 24522",
    width: 32.526,
    height: 1.012,
    transform: "translate(0.577 23.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24523",
    "data-name": "Rectangle 24523",
    width: 33.68,
    height: 2.167,
    transform: "translate(0 22.468)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24524",
    "data-name": "Rectangle 24524",
    width: 32.526,
    height: 1.012,
    transform: "translate(0.577 27.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24525",
    "data-name": "Rectangle 24525",
    width: 33.68,
    height: 2.167,
    transform: "translate(0 26.961)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24526",
    "data-name": "Rectangle 24526",
    width: 32.526,
    height: 1.012,
    transform: "translate(0.577 32.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24527",
    "data-name": "Rectangle 24527",
    width: 33.68,
    height: 2.166,
    transform: "translate(0 31.456)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24528",
    "data-name": "Rectangle 24528",
    width: 32.526,
    height: 1.012,
    transform: "translate(0.577 36.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24529",
    "data-name": "Rectangle 24529",
    width: 33.68,
    height: 2.167,
    transform: "translate(0 35.949)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24530",
    "data-name": "Rectangle 24530",
    width: 32.526,
    height: 1.012,
    transform: "translate(0.577 41.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24531",
    "data-name": "Rectangle 24531",
    width: 33.68,
    height: 2.166,
    transform: "translate(0 40.443)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24532",
    "data-name": "Rectangle 24532",
    width: 32.526,
    height: 0.49,
    transform: "translate(0.578 45.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24533",
    "data-name": "Rectangle 24533",
    width: 33.68,
    height: 1.067,
    transform: "translate(0 44.936)",
    fill: "#515255"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84399",
    "data-name": "Group 84399",
    transform: "translate(41.869 91.709)",
    opacity: 0.36,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84398",
    "data-name": "Group 84398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84397",
    "data-name": "Group 84397",
    clipPath: "url(#clip-path-97)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24535",
    "data-name": "Rectangle 24535",
    width: 10.3,
    height: 48.927,
    transform: "translate(0.578 0.577)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238434",
    "data-name": "Path 238434",
    d: "M396.4,92.864h-9.145v48.35H386.1v-49.5h11.455v49.5H396.4Z",
    transform: "translate(-386.098 -91.71)",
    fill: "#515255"
  }))))))), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24538",
    "data-name": "Rectangle 24538",
    width: 36.551,
    height: 30.876,
    transform: "translate(0.577 110.338)",
    fill: "#fff"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238435",
    "data-name": "Path 238435",
    d: "M439.423,109.76v31.454h-1.155v-30.3h-35.4v30.3h-1.154V109.76Z",
    transform: "translate(-401.717 0)",
    fill: "#515255"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24539",
    "data-name": "Rectangle 24539",
    width: 40.092,
    height: 21.971,
    transform: "translate(0.578 119.243)",
    fill: "#fff"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238436",
    "data-name": "Path 238436",
    d: "M439.423,118.666v22.548h-1.155V119.821H399.331v21.393h-1.155V118.666Z",
    transform: "translate(-398.176 0)",
    fill: "#515255"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84418",
    "data-name": "Group 84418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84417",
    "data-name": "Group 84417",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84416",
    "data-name": "Group 84416",
    transform: "translate(0 121.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84415",
    "data-name": "Group 84415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84414",
    "data-name": "Group 84414",
    clipPath: "url(#clip-path-99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84404",
    "data-name": "Group 84404",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84403",
    "data-name": "Group 84403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84402",
    "data-name": "Group 84402",
    clipPath: "url(#clip-path-100)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24540",
    "data-name": "Rectangle 24540",
    width: 40.092,
    height: 3.295,
    transform: "translate(0.578 0.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238437",
    "data-name": "Path 238437",
    d: "M398.176,126.144h41.247v-4.45H398.176Zm40.092-1.155H399.33v-2.141h38.938Z",
    transform: "translate(-398.176 -121.694)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84407",
    "data-name": "Group 84407",
    transform: "translate(0 6.253)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84406",
    "data-name": "Group 84406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84405",
    "data-name": "Group 84405",
    clipPath: "url(#clip-path-100)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24542",
    "data-name": "Rectangle 24542",
    width: 40.092,
    height: 3.295,
    transform: "translate(0.578 0.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238438",
    "data-name": "Path 238438",
    d: "M398.176,132.4h41.247v-4.45H398.176Zm40.092-1.155H399.33V129.1h38.938Z",
    transform: "translate(-398.176 -127.947)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84410",
    "data-name": "Group 84410",
    transform: "translate(0 12.507)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84409",
    "data-name": "Group 84409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84408",
    "data-name": "Group 84408",
    clipPath: "url(#clip-path-100)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24544",
    "data-name": "Rectangle 24544",
    width: 40.092,
    height: 3.295,
    transform: "translate(0.578 0.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238439",
    "data-name": "Path 238439",
    d: "M398.176,138.65h41.247V134.2H398.176Zm40.092-1.154H399.33v-2.141h38.938Z",
    transform: "translate(-398.176 -134.2)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84413",
    "data-name": "Group 84413",
    transform: "translate(0 18.759)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84412",
    "data-name": "Group 84412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84411",
    "data-name": "Group 84411",
    clipPath: "url(#clip-path-103)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24546",
    "data-name": "Rectangle 24546",
    width: 40.092,
    height: 0.183,
    transform: "translate(0.577 0.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24547",
    "data-name": "Rectangle 24547",
    width: 41.247,
    height: 0.761,
    transform: "translate(0 0)",
    fill: "#515255"
  })))))))))), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24551",
    "data-name": "Rectangle 24551",
    width: 3.541,
    height: 8.906,
    transform: "translate(37.129 110.337)",
    fill: "#fff"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238440",
    "data-name": "Path 238440",
    d: "M398.176,119.821h4.7v-10.06h-4.7Zm3.541-1.155H399.33v-7.751h2.387Z",
    transform: "translate(-361.625 0)",
    fill: "#515255"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24552",
    "data-name": "Rectangle 24552",
    width: 33.271,
    height: 30.876,
    transform: "translate(23.234 110.338)",
    fill: "#fff"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238441",
    "data-name": "Path 238441",
    d: "M416.767,109.76v31.454h-1.155v-30.3H383.495v30.3H382.34V109.76Z",
    transform: "translate(-359.684 0)",
    fill: "#515255"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84432",
    "data-name": "Group 84432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84431",
    "data-name": "Group 84431",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84430",
    "data-name": "Group 84430",
    transform: "translate(18.484 127.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84429",
    "data-name": "Group 84429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84428",
    "data-name": "Group 84428",
    clipPath: "url(#clip-path-105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84421",
    "data-name": "Group 84421",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84420",
    "data-name": "Group 84420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84419",
    "data-name": "Group 84419",
    clipPath: "url(#clip-path-106)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24553",
    "data-name": "Rectangle 24553",
    width: 37.444,
    height: 3.295,
    transform: "translate(0.578 0.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238442",
    "data-name": "Path 238442",
    d: "M382.341,132.4h38.6v-4.45h-38.6Zm37.444-1.155H383.5V129.1h36.289Z",
    transform: "translate(-382.341 -127.947)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84424",
    "data-name": "Group 84424",
    transform: "translate(0 6.253)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84423",
    "data-name": "Group 84423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84422",
    "data-name": "Group 84422",
    clipPath: "url(#clip-path-106)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24555",
    "data-name": "Rectangle 24555",
    width: 37.444,
    height: 3.295,
    transform: "translate(0.578 0.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238443",
    "data-name": "Path 238443",
    d: "M382.341,138.65h38.6V134.2h-38.6Zm37.444-1.154H383.5v-2.141h36.289Z",
    transform: "translate(-382.341 -134.2)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84427",
    "data-name": "Group 84427",
    transform: "translate(0 12.506)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84426",
    "data-name": "Group 84426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84425",
    "data-name": "Group 84425",
    clipPath: "url(#clip-path-108)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24557",
    "data-name": "Rectangle 24557",
    width: 37.444,
    height: 0.183,
    transform: "translate(0.578 0.577)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24558",
    "data-name": "Rectangle 24558",
    width: 38.598,
    height: 0.76,
    transform: "translate(0 0)",
    fill: "#515255"
  })))))))))), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24562",
    "data-name": "Rectangle 24562",
    width: 3.541,
    height: 30.876,
    transform: "translate(52.964 110.338)",
    fill: "#fff"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238444",
    "data-name": "Path 238444",
    d: "M387.036,109.76v31.454h-1.155v-30.3h-2.387v30.3H382.34V109.76Z",
    transform: "translate(-329.953 0)",
    fill: "#515255"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84437",
    "data-name": "Group 84437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84436",
    "data-name": "Group 84436",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84435",
    "data-name": "Group 84435",
    transform: "translate(18.484 109.76)",
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84434",
    "data-name": "Group 84434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84433",
    "data-name": "Group 84433",
    clipPath: "url(#clip-path-110)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24563",
    "data-name": "Rectangle 24563",
    width: 4.172,
    height: 30.876,
    transform: "translate(0.578 0.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238445",
    "data-name": "Path 238445",
    d: "M419.783,110.915h-3.017v30.3h-1.155V109.76h5.327v31.454h-1.155Z",
    transform: "translate(-415.611 -109.76)",
    fill: "#515255"
  }))))))), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24566",
    "data-name": "Rectangle 24566",
    width: 32.4,
    height: 25.096,
    transform: "translate(101.795 116.118)",
    fill: "#fff"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238446",
    "data-name": "Path 238446",
    d: "M338.206,115.54v25.674h-1.155V116.695H305.8v24.519H304.65V115.54Z",
    transform: "translate(-203.433 0)",
    fill: "#515255"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_84442",
    "data-name": "Group 84442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84441",
    "data-name": "Group 84441",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84440",
    "data-name": "Group 84440",
    transform: "translate(107.792 115.218)",
    opacity: 0.77,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84439",
    "data-name": "Group 84439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84438",
    "data-name": "Group 84438",
    clipPath: "url(#clip-path-112)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24567",
    "data-name": "Rectangle 24567",
    width: 35.566,
    height: 25.419,
    transform: "translate(0.577 0.577)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238447",
    "data-name": "Path 238447",
    d: "M330.477,116.373H296.066v24.842h-1.155v-26h36.721v26h-1.155Z",
    transform: "translate(-294.911 -115.218)",
    fill: "#515255"
  }))))))), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24570",
    "data-name": "Rectangle 24570",
    width: 21.835,
    height: 9.941,
    transform: "translate(113.652 131.273)",
    fill: "#fff"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238448",
    "data-name": "Path 238448",
    d: "M326.349,130.695v10.519h-1.155V131.85h-20.68v9.364h-1.155V130.695Z",
    transform: "translate(-190.286 0)",
    fill: "#515255"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24571",
    "data-name": "Rectangle 24571",
    width: 2.582,
    height: 9.941,
    transform: "translate(113.652 131.273)",
    fill: "#fff"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238449",
    "data-name": "Path 238449",
    d: "M326.349,130.695v10.519h-1.155V131.85h-1.428v9.364h-1.155V130.695Z",
    transform: "translate(-209.538 0)",
    fill: "#515255"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24572",
    "data-name": "Rectangle 24572",
    width: 15.261,
    height: 17.381,
    transform: "translate(86.534 123.833)",
    fill: "#fff"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238450",
    "data-name": "Path 238450",
    d: "M353.466,123.255v17.959h-1.155v-16.8h-14.1v16.8h-1.155V123.255Z",
    transform: "translate(-251.094 0)",
    fill: "#515255"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24573",
    "data-name": "Rectangle 24573",
    width: 19.4,
    height: 26.215,
    transform: "translate(242.979 114.999)",
    fill: "#fff"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238451",
    "data-name": "Path 238451",
    d: "M197.022,114.422v26.792h-1.155V115.577H177.622v25.637h-1.154V114.422Z",
    transform: "translate(65.934 0)",
    fill: "#515255"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84456",
    "data-name": "Group 84456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84455",
    "data-name": "Group 84455",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84445",
    "data-name": "Group 84445",
    transform: "translate(242.978 121.055)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84444",
    "data-name": "Group 84444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84443",
    "data-name": "Group 84443",
    clipPath: "url(#clip-path-114)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24574",
    "data-name": "Rectangle 24574",
    width: 12.952,
    height: 2.474,
    transform: "translate(0.001 0.001)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84448",
    "data-name": "Group 84448",
    transform: "translate(242.978 126.409)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84447",
    "data-name": "Group 84447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84446",
    "data-name": "Group 84446",
    clipPath: "url(#clip-path-114)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24576",
    "data-name": "Rectangle 24576",
    width: 12.952,
    height: 2.474,
    transform: "translate(0.001 0.001)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84451",
    "data-name": "Group 84451",
    transform: "translate(242.978 131.764)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84450",
    "data-name": "Group 84450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84449",
    "data-name": "Group 84449",
    clipPath: "url(#clip-path-114)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24578",
    "data-name": "Rectangle 24578",
    width: 12.952,
    height: 2.474,
    transform: "translate(0.001 0)",
    fill: "#515255"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84454",
    "data-name": "Group 84454",
    transform: "translate(242.978 137.118)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84453",
    "data-name": "Group 84453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84452",
    "data-name": "Group 84452",
    clipPath: "url(#clip-path-114)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24580",
    "data-name": "Rectangle 24580",
    width: 12.952,
    height: 2.474,
    transform: "translate(0.001 0)",
    fill: "#515255"
  }))))))), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24583",
    "data-name": "Rectangle 24583",
    width: 23.451,
    height: 12.776,
    transform: "translate(29.482 128.438)",
    fill: "#d2e5c7"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24584",
    "data-name": "Rectangle 24584",
    width: 19.086,
    height: 12.776,
    transform: "translate(50.701 128.438)",
    fill: "#e4f5ff"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84461",
    "data-name": "Group 84461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84460",
    "data-name": "Group 84460",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84459",
    "data-name": "Group 84459",
    transform: "translate(29.482 130.447)",
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84458",
    "data-name": "Group 84458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84457",
    "data-name": "Group 84457",
    clipPath: "url(#clip-path-119)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24585",
    "data-name": "Rectangle 24585",
    width: 40.303,
    height: 2.107,
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24586",
    "data-name": "Rectangle 24586",
    width: 40.303,
    height: 2.107,
    transform: "translate(0 4.117)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24587",
    "data-name": "Rectangle 24587",
    width: 40.303,
    height: 2.107,
    transform: "translate(0 8.233)",
    fill: "#515255"
  }))))))), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24590",
    "data-name": "Rectangle 24590",
    width: 2.173,
    height: 12.776,
    transform: "translate(67.614 128.438)",
    fill: "#fff"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238452",
    "data-name": "Path 238452",
    d: "M372.386,127.86v13.354h-1.155v-12.2h-1.018v12.2h-1.154V127.86Z",
    transform: "translate(-302.023 0)",
    fill: "#515255"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24591",
    "data-name": "Rectangle 24591",
    width: 2.173,
    height: 12.776,
    transform: "translate(50.701 128.438)",
    fill: "#fff"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238453",
    "data-name": "Path 238453",
    d: "M389.3,127.86v13.354h-1.155v-12.2h-1.018v12.2h-1.154V127.86Z",
    transform: "translate(-335.848 0)",
    fill: "#515255"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24592",
    "data-name": "Rectangle 24592",
    width: 2.173,
    height: 12.776,
    transform: "translate(48.547 128.438)",
    fill: "#fff"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238454",
    "data-name": "Path 238454",
    d: "M391.453,127.86v13.354H390.3v-12.2H389.28v12.2h-1.155V127.86Z",
    transform: "translate(-340.155 0)",
    fill: "#515255"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24593",
    "data-name": "Rectangle 24593",
    width: 2.174,
    height: 12.776,
    transform: "translate(29.482 128.438)",
    fill: "#fff"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238455",
    "data-name": "Path 238455",
    d: "M410.518,127.86v13.354h-1.155v-12.2h-1.018v12.2H407.19V127.86Z",
    transform: "translate(-378.284 0)",
    fill: "#515255"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24594",
    "data-name": "Rectangle 24594",
    width: 19.066,
    height: 2.009,
    transform: "translate(50.72 128.438)",
    fill: "#fff"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238456",
    "data-name": "Path 238456",
    d: "M369.059,131.024H389.28V127.86H369.059Zm19.066-1.155H370.214v-.855h17.911Z",
    transform: "translate(-318.916 0)",
    fill: "#515255"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24595",
    "data-name": "Rectangle 24595",
    width: 19.066,
    height: 2.009,
    transform: "translate(29.944 128.438)",
    fill: "#fff"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238457",
    "data-name": "Path 238457",
    d: "M389.835,131.024h20.221V127.86H389.835Zm19.066-1.155H390.99v-.855H408.9Z",
    transform: "translate(-360.468 0)",
    fill: "#515255"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24596",
    "data-name": "Rectangle 24596",
    width: 14.142,
    height: 3.5,
    transform: "translate(49.865 125.006)",
    fill: "#fff"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238458",
    "data-name": "Path 238458",
    d: "M374.838,129.083h15.3v-4.655h-15.3Zm14.142-1.154H375.992v-2.345H388.98Z",
    transform: "translate(-325.55 0)",
    fill: "#515255"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24597",
    "data-name": "Rectangle 24597",
    width: 14.142,
    height: 3.5,
    transform: "translate(35.723 125.006)",
    fill: "#fff"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238459",
    "data-name": "Path 238459",
    d: "M388.98,129.083h15.3v-4.655h-15.3Zm14.142-1.154H390.135v-2.345h12.987Z",
    transform: "translate(-353.834 0)",
    fill: "#515255"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24598",
    "data-name": "Rectangle 24598",
    width: 27.643,
    height: 28.459,
    transform: "translate(92.244 112.755)",
    fill: "#fff"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238460",
    "data-name": "Path 238460",
    d: "M347.755,112.178v29.036H346.6V113.333H320.113v27.881h-1.154V112.178Z",
    transform: "translate(-227.291 0)",
    fill: "#515255"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24599",
    "data-name": "Rectangle 24599",
    width: 22.497,
    height: 28.459,
    transform: "translate(117.256 112.755)",
    fill: "#515255"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84466",
    "data-name": "Group 84466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84465",
    "data-name": "Group 84465",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84464",
    "data-name": "Group 84464",
    transform: "translate(92.245 115.124)",
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84463",
    "data-name": "Group 84463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84462",
    "data-name": "Group 84462",
    clipPath: "url(#clip-path-121)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24600",
    "data-name": "Rectangle 24600",
    width: 47.507,
    height: 2.484,
    transform: "translate(-0.001 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24601",
    "data-name": "Rectangle 24601",
    width: 47.507,
    height: 2.484,
    transform: "translate(-0.001 4.852)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24602",
    "data-name": "Rectangle 24602",
    width: 47.507,
    height: 2.484,
    transform: "translate(-0.001 9.705)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24603",
    "data-name": "Rectangle 24603",
    width: 47.507,
    height: 2.484,
    transform: "translate(-0.001 14.557)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24604",
    "data-name": "Rectangle 24604",
    width: 47.507,
    height: 2.484,
    transform: "translate(-0.001 19.41)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24605",
    "data-name": "Rectangle 24605",
    width: 47.507,
    height: 1.828,
    transform: "translate(0 24.262)",
    fill: "#515255"
  }))))))), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24608",
    "data-name": "Rectangle 24608",
    width: 2.561,
    height: 28.459,
    transform: "translate(137.192 112.755)",
    fill: "#fff"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238461",
    "data-name": "Path 238461",
    d: "M302.809,112.178v29.036h-1.155V113.333h-1.407v27.881h-1.154V112.178Z",
    transform: "translate(-162.478 0)",
    fill: "#515255"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24609",
    "data-name": "Rectangle 24609",
    width: 2.561,
    height: 28.459,
    transform: "translate(117.256 112.755)",
    fill: "#fff"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238462",
    "data-name": "Path 238462",
    d: "M322.745,112.178v29.036H321.59V113.333h-1.407v27.881h-1.155V112.178Z",
    transform: "translate(-202.351 0)",
    fill: "#515255"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24610",
    "data-name": "Rectangle 24610",
    width: 2.561,
    height: 28.459,
    transform: "translate(114.718 112.755)",
    fill: "#fff"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238463",
    "data-name": "Path 238463",
    d: "M325.283,112.178v29.036h-1.154V113.333h-1.407v27.881h-1.155V112.178Z",
    transform: "translate(-207.428 0)",
    fill: "#515255"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24611",
    "data-name": "Rectangle 24611",
    width: 2.562,
    height: 28.459,
    transform: "translate(92.245 112.755)",
    fill: "#fff"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238464",
    "data-name": "Path 238464",
    d: "M347.755,112.178v29.036H346.6V113.333h-1.406v27.881h-1.155V112.178Z",
    transform: "translate(-252.372 0)",
    fill: "#515255"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24612",
    "data-name": "Rectangle 24612",
    width: 22.474,
    height: 2.369,
    transform: "translate(117.279 112.755)",
    fill: "#fff"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238465",
    "data-name": "Path 238465",
    d: "M299.093,115.7h23.629v-3.523H299.093Zm22.475-1.154h-21.32v-1.214h21.32Z",
    transform: "translate(-182.392 0)",
    fill: "#515255"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24613",
    "data-name": "Rectangle 24613",
    width: 22.474,
    height: 2.369,
    transform: "translate(92.789 112.755)",
    fill: "#fff"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238466",
    "data-name": "Path 238466",
    d: "M323.582,115.7h23.629v-3.523H323.582Zm22.474-1.154h-21.32v-1.214h21.32Z",
    transform: "translate(-231.37 0)",
    fill: "#515255"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24614",
    "data-name": "Rectangle 24614",
    width: 16.67,
    height: 4.126,
    transform: "translate(116.271 108.71)",
    fill: "#fff"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238467",
    "data-name": "Path 238467",
    d: "M305.9,113.413H323.73v-5.28H305.9Zm16.671-1.154H307.061v-2.971h15.515Z",
    transform: "translate(-190.212 0)",
    fill: "#515255"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24615",
    "data-name": "Rectangle 24615",
    width: 16.67,
    height: 4.126,
    transform: "translate(99.601 108.71)",
    fill: "#fff"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238468",
    "data-name": "Path 238468",
    d: "M322.574,113.413H340.4v-5.28H322.574Zm16.669-1.154H323.728v-2.971h15.515Z",
    transform: "translate(-223.55 0)",
    fill: "#515255"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24616",
    "data-name": "Rectangle 24616",
    width: 19.071,
    height: 1.826,
    transform: "translate(128.827 139.388)",
    fill: "#fff"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238469",
    "data-name": "Path 238469",
    d: "M311.173,138.811v2.4h-1.155v-1.248H292.1v1.248h-1.155v-2.4Z",
    transform: "translate(-162.699 0)",
    fill: "#515255"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24617",
    "data-name": "Rectangle 24617",
    width: 12.708,
    height: 1.826,
    transform: "translate(145.944 139.388)",
    fill: "#fff"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238470",
    "data-name": "Path 238470",
    d: "M294.057,138.811v2.4H292.9v-1.248H281.349v1.248h-1.155v-2.4Z",
    transform: "translate(-134.829 0)",
    fill: "#515255"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84471",
    "data-name": "Group 84471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84470",
    "data-name": "Group 84470",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84469",
    "data-name": "Group 84469",
    transform: "translate(128.827 141.147)",
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84468",
    "data-name": "Group 84468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84467",
    "data-name": "Group 84467",
    clipPath: "url(#clip-path-123)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24618",
    "data-name": "Rectangle 24618",
    width: 29.823,
    height: 0.067,
    transform: "translate(0 0)",
    fill: "#515255"
  }))))))), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24621",
    "data-name": "Rectangle 24621",
    width: 7.477,
    height: 1.817,
    transform: "translate(76.863 139.397)",
    fill: "#fff"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238471",
    "data-name": "Path 238471",
    d: "M363.137,138.819v2.4h-1.155v-1.24h-6.321v1.24h-1.155v-2.4Z",
    transform: "translate(-278.221 0)",
    fill: "#515255"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24622",
    "data-name": "Rectangle 24622",
    width: 7.476,
    height: 1.817,
    transform: "translate(69.387 139.397)",
    fill: "#fff"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238472",
    "data-name": "Path 238472",
    d: "M370.615,138.819v2.4H369.46v-1.24h-6.322v1.24h-1.155v-2.4Z",
    transform: "translate(-293.174 0)",
    fill: "#515255"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectedBuilding);
export default __webpack_public_path__ + "static/media/protectedBuilding.0eac8d8d77cc9a1786f4cb0dab68fc1d.svg";
export { ForwardRef as ReactComponent };